// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  @import "~@ids/tokens/itau_bba/tokens.css";
  /*
  ** Voxel Foundation Module Handler
  */
  /*
  ** Voxel Foundation Formats
  */
  /* stylelint-disable declaration-no-important */
  /*
  ** Voxel Foundation Media Query Mixins
  */
  /* stylelint-disable plugin/no-low-performance-animation-properties */
  /*
  ** Voxel Foundation Motion Mixins
  */
  /* Box sizing rules */
  /* Remove default padding, list styles on ul, ol elements with a class attribute */
  /* Remove default margin */
  /* Set core body defaults */
  /* Do not apply blue highlight on active elements on mobile Chrome */
  /* A elements that don't have a class get default styles */
  /* Make images easier to work with */
  /* Natural flow and rhythm in articles by default */
  /* Inherit fonts for inputs and buttons */
  /* Remove all animations and transitions for people that prefer not to see them */
  /*
  ** Voxel Foundation Reboot
  */
  /*
  ** Voxel Foundation Background
  */
  /*
  ** Voxel Foundation Border
  */
  /*
  ** Voxel Foundation Typography
  */
  /*
  ** Voxel Foundation Colors
  */
  /*
  ** Public Foundation CSS API
  */
  /*
  ** Public Foundation CSS API
  */
  /*
  ** Voxel Foundation Opacity
  */
  /*
  ** Voxel Foundation Spacing
  */
  /*
  ** Voxel Foundation Layout
  */
  /*
  ** Public Foundation CSS API
  */
  /*
  ** Voxel Foundation Containers Mixins
  */
  /*
  ** Voxel Foundation Text Align
  */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable no-descending-specificity */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable plugin/no-low-performance-animation-properties */
  /* stylelint-disable declaration-no-important */
  /* stylelint-disable no-descending-specificity */
  /* stylelint-disable no-descending-specificity */
  /* stylelint-disable selector-no-qualifying-type */
  /* stylelint-disable declaration-no-important */
  @import "@ids/styles/css/components/text/text.css";
}
:host .ids-sr-only {
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
  position: fixed;
}
:host .ids-reset-element {
  background: none;
  background-color: none;
  border: 0;
  color: inherit;
  cursor: inherit;
  font: inherit;
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
  outline: none;
  padding: 0;
  text-decoration: none;
  text-transform: none;
}
:host .ids-reset-input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
}
@media (pointer: coarse) {
  :host .ids-reset-input {
    outline: 0 !important;
  }
  :host .ids-reset-input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-reset-input:focus-visible, :host .ids-reset-input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-reset-input:focus-visible, :host .ids-reset-input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-reset-input:focus-visible, :host .ids-reset-input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-dummy-width {
  left: 0 !important;
  margin: 0 !important;
  max-width: 100vw !important;
  opacity: 0 !important;
  padding: 0 !important;
  pointer-events: none !important;
  position: fixed !important;
  visibility: hidden !important;
  white-space: nowrap !important;
  width: auto !important;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
:host ul,
:host ol {
  list-style: none;
  padding: 0;
}
:host html,
:host body,
:host div,
:host span,
:host applet,
:host object,
:host iframe,
:host h1,
:host h2,
:host h3,
:host h4,
:host h5,
:host h6,
:host p,
:host blockquote,
:host pre,
:host a,
:host abbr,
:host acronym,
:host address,
:host big,
:host cite,
:host code,
:host del,
:host dfn,
:host em,
:host img,
:host ins,
:host kbd,
:host q,
:host s,
:host samp,
:host small,
:host strike,
:host strong,
:host sub,
:host sup,
:host tt,
:host var,
:host b,
:host u,
:host i,
:host center,
:host dl,
:host dt,
:host dd,
:host ol,
:host ul,
:host li,
:host fieldset,
:host form,
:host label,
:host legend,
:host table,
:host caption,
:host tbody,
:host tfoot,
:host thead,
:host tr,
:host th,
:host td,
:host article,
:host aside,
:host canvas,
:host details,
:host embed,
:host figure,
:host figcaption,
:host footer,
:host header,
:host hgroup,
:host main,
:host menu,
:host nav,
:host output,
:host ruby,
:host section,
:host summary,
:host time,
:host mark,
:host audio,
:host video {
  border: 0;
  font: inherit;
  font-size: 100%;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}
:host body,
:host h1,
:host h2,
:host h3,
:host h4,
:host p,
:host ul,
:host ol,
:host li,
:host figure,
:host figcaption,
:host blockquote,
:host dl,
:host dd {
  margin: 0;
}
:host body {
  height: initial;
  line-height: 1.5;
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizespeed;
}
:host input,
:host textarea,
:host button,
:host select,
:host a {
  -webkit-tap-highlight-color: transparent;
}
:host a:not([class]) {
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}
:host img {
  max-width: 100%;
}
:host article > * + * {
  margin-top: 1em;
}
:host input,
:host button,
:host textarea,
:host select {
  font: inherit;
}
@media (prefers-reduced-motion: reduce) {
  :host * {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
    scroll-behavior: auto;
    transition-duration: 0.01ms;
  }
}
@supports not selector(:focus-visible) {
  :host .js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }
}
@supports not selector(:popover-open) {
  :host [popover]:not(.\\:popover-open) {
    display: none;
  }
}
:host body {
  color: var(--ids_color_text_body_01);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
}
:host h1 {
  font: var(--ids_textStyle_f01_s24_h32_wbd);
}
:host h2 {
  font: var(--ids_textStyle_f01_s20_h28_wrg);
}
:host h3 {
  font: var(--ids_textStyle_f01_s20_h28_wrg);
}
:host h4 {
  font: var(--ids_textStyle_f01_s16_h24_wbd);
}
:host .ids-color-bg-base {
  background: var(--ids_color_bg_base) !important;
}
:host .ids-color-bg-variant-01 {
  background: var(--ids_color_bg_variant_01) !important;
}
:host .ids-color-bg-variant-02 {
  background: var(--ids_color_bg_variant_02) !important;
}
:host .ids-color-bg-brand-primary {
  background: var(--ids_color_bg_brand_primary) !important;
}
:host .ids-color-bg-brand-secondary {
  background: var(--ids_color_bg_brand_secondary) !important;
}
:host .ids-color-bg-brand-gradient {
  background: var(--ids_color_bg_brand_gradient) !important;
}
:host .ids-border {
  border-color: var(--ids_color_border_medium) !important;
  border-style: solid !important;
  border-width: var(--ids_size_border_medium) !important;
}
:host .ids-border-top {
  border-color: var(--ids_color_border_medium) !important;
  border-style: solid !important;
  border-top-width: var(--ids_size_border_medium) !important;
}
:host .ids-border-bottom {
  border-bottom-width: var(--ids_size_border_medium) !important;
  border-color: var(--ids_color_border_medium) !important;
  border-style: solid !important;
}
:host .ids-border-left {
  border-color: var(--ids_color_border_medium) !important;
  border-left-width: var(--ids_size_border_medium) !important;
  border-style: solid !important;
}
:host .ids-border-right {
  border-color: var(--ids_color_border_medium) !important;
  border-right-width: var(--ids_size_border_medium) !important;
  border-style: solid !important;
}
:host .ids-border-small {
  border-style: solid !important;
  border-width: var(--ids_size_border_small) !important;
}
:host .ids-border-small-top {
  border-style: solid !important;
  border-top-width: var(--ids_size_border_small) !important;
}
:host .ids-border-small-bottom {
  border-bottom-width: var(--ids_size_border_small) !important;
  border-style: solid !important;
}
:host .ids-border-small-left {
  border-left-width: var(--ids_size_border_small) !important;
  border-style: solid !important;
}
:host .ids-border-small-right {
  border-right-width: var(--ids_size_border_small) !important;
  border-style: solid !important;
}
:host .ids-border-large {
  border-style: solid !important;
  border-width: var(--ids_size_border_large) !important;
}
:host .ids-border-large-top {
  border-style: solid !important;
  border-top-width: var(--ids_size_border_large) !important;
}
:host .ids-border-large-bottom {
  border-bottom-width: var(--ids_size_border_large) !important;
  border-style: solid !important;
}
:host .ids-border-large-left {
  border-left-width: var(--ids_size_border_large) !important;
  border-style: solid !important;
}
:host .ids-border-large-right {
  border-right-width: var(--ids_size_border_large) !important;
  border-style: solid !important;
}
:host .ids-border-color-soft {
  border-color: var(--ids_color_border_soft) !important;
}
:host .ids-border-color-medium {
  border-color: var(--ids_color_border_medium) !important;
}
:host .ids-border-color-strong {
  border-color: var(--ids_color_border_strong) !important;
}
:host .ids-border-radius-layout-01 {
  border-radius: var(--ids_size_cornerRadius_layout_01) !important;
}
:host .ids-border-radius-layout-02 {
  border-radius: var(--ids_size_cornerRadius_layout_02) !important;
}
:host .ids-no-border {
  border: none !important;
}
:host .ids-no-border-top {
  border-top: none !important;
}
:host .ids-no-border-bottom {
  border-bottom: none !important;
}
:host .ids-no-border-left {
  border-left: none !important;
}
:host .ids-no-border-right {
  border-right: none !important;
}
:host .ids-insight {
  color: var(--ids_color_text_heading_01) !important;
  font: var(--ids_textStyle_f01_s24_h32_wrg) !important;
}
:host .ids-insight.-bold {
  font: var(--ids_textStyle_f01_s24_h32_wbd) !important;
}
:host .ids-insight.-variant {
  color: var(--ids_color_text_highlight) !important;
}
:host .ids-insight.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-overline-text {
  font: var(--ids_textStyle_f02_s16_h24_wrg) !important;
}
:host .ids-overline-text.-variant {
  color: var(--ids_color_text_highlight) !important;
}
:host .ids-overline-text.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-title {
  color: var(--ids_color_text_heading_01) !important;
  font: var(--ids_textStyle_f01_s32_h48_wrg) !important;
}
:host .ids-title.-bold {
  font: var(--ids_textStyle_f01_s32_h48_wbd) !important;
}
:host .ids-title.-variant {
  color: var(--ids_color_text_highlight) !important;
}
:host .ids-title.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-title.-small {
  font: var(--ids_textStyle_f02_s24_h32_wrg) !important;
}
:host .ids-title.-large {
  font: var(--ids_textStyle_f01_s40_h64_wrg) !important;
}
:host .ids-title.-large.-bold {
  font: var(--ids_textStyle_f01_s40_h64_wbd) !important;
}
:host .ids-title.-xlarge {
  font: var(--ids_textStyle_f01_s48_h80_wrg) !important;
}
:host .ids-title.-xlarge.-bold {
  font: var(--ids_textStyle_f01_s48_h80_wbd) !important;
}
:host .ids-title.-xxlarge {
  font: var(--ids_textStyle_f01_s64_h100_wrg) !important;
}
:host .ids-title.-xxlarge.-bold {
  font: var(--ids_textStyle_f01_s64_h100_wbd) !important;
}
:host .ids-subtitle {
  color: var(--ids_color_text_heading_02) !important;
  font: var(--ids_textStyle_f02_s24_h32_wrg) !important;
}
:host .ids-subtitle.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-subtitle.-small {
  font: var(--ids_textStyle_f02_s16_h24_wrg) !important;
}
:host .ids-subtitle.-large {
  font: var(--ids_textStyle_f02_s32_h48_wrg) !important;
}
:host .ids-subtitle.-xlarge {
  font: var(--ids_textStyle_f02_s40_h64_wrg) !important;
}
:host .ids-subtitle.-xxlarge {
  font: var(--ids_textStyle_f02_s48_h80_wrg) !important;
}
:host .ids-section-title {
  color: var(--ids_color_text_heading_01);
  font: var(--ids_textStyle_f01_s20_h28_wrg) !important;
}
:host .ids-section-title.-small {
  font: var(--ids_textStyle_f01_s16_h24_wbd) !important;
}
:host .ids-section-title.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-section-title-1 {
  color: var(--ids_color_text_heading_01) !important;
  font: var(--ids_textStyle_f01_s20_h28_wrg) !important;
}
:host .ids-section-title-1.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-section-title-2 {
  color: var(--ids_color_text_heading_01) !important;
  font: var(--ids_textStyle_f01_s16_h24_wbd) !important;
}
:host .ids-section-title-2.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-body-text {
  color: var(--ids_color_text_body_01) !important;
  font: var(--ids_textStyle_f02_s16_h24_wrg) !important;
}
:host .ids-body-text.-bold {
  font: var(--ids_textStyle_f02_s16_h24_wbd) !important;
}
:host .ids-body-text.-variant {
  color: var(--ids_color_text_body_02) !important;
}
:host .ids-body-text.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-body-text.-xsmall {
  font: var(--ids_textStyle_f02_s12_h18_wrg) !important;
}
:host .ids-body-text.-xsmall.-bold {
  font: var(--ids_textStyle_f02_s12_h18_wbd) !important;
}
:host .ids-body-text.-small {
  font: var(--ids_textStyle_f02_s14_h20_wrg) !important;
}
:host .ids-body-text.-small.-bold {
  font: var(--ids_textStyle_f02_s14_h20_wbd) !important;
}
:host .ids-body-text.-large {
  font: var(--ids_textStyle_f02_s18_h26_wrg) !important;
}
:host .ids-body-text.-large.-bold {
  font: var(--ids_textStyle_f02_s18_h26_wbd) !important;
}
:host .ids-label {
  color: var(--ids_color_feedback_neutral);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
}
:host .ids-label.-bold {
  font: var(--ids_textStyle_f02_s16_h24_wbd) !important;
}
:host .ids-label.-information {
  color: var(--ids_color_feedback_information) !important;
}
:host .ids-label.-success {
  color: var(--ids_color_feedback_success) !important;
}
:host .ids-label.-alert {
  color: var(--ids_color_feedback_alert) !important;
}
:host .ids-label.-error {
  color: var(--ids_color_feedback_error) !important;
}
:host .ids-label.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary) !important;
}
:host .ids-label.-disabled {
  color: var(--ids_color_action_disabled_variant) !important;
}
:host .ids-label.-xsmall {
  font: var(--ids_textStyle_f02_s12_h18_wrg) !important;
}
:host .ids-label.-xsmall.-bold {
  font: var(--ids_textStyle_f02_s12_h18_wbd) !important;
}
:host .ids-label.-small {
  font: var(--ids_textStyle_f02_s14_h20_wrg) !important;
}
:host .ids-label.-small.-bold {
  font: var(--ids_textStyle_f02_s14_h20_wbd) !important;
}
:host .ids-label.-large {
  font: var(--ids_textStyle_f02_s20_h26_wrg) !important;
}
:host .ids-label.-large.-bold {
  font: var(--ids_textStyle_f02_s20_h26_wbd) !important;
}
:host .ids-label.-xlarge {
  font: var(--ids_textStyle_f02_s24_h32_wrg) !important;
}
:host .ids-label.-xlarge.-bold {
  font: var(--ids_textStyle_f02_s24_h32_wbd) !important;
}
:host .ids-text-icon-small {
  font: var(--ids_textStyle_icon_small) !important;
}
:host .ids-text-icon {
  font: var(--ids_textStyle_icon_medium) !important;
}
:host .ids-text-icon-large {
  font: var(--ids_textStyle_icon_large) !important;
}
:host .ids-text-title-01 {
  font: var(--ids_textStyle_title_01_base) !important;
}
:host .ids-text-title-01-variant {
  font: var(--ids_textStyle_title_01_variant) !important;
}
:host .ids-text-section-01 {
  font: var(--ids_textStyle_section_01) !important;
}
:host .ids-text-section-02 {
  font: var(--ids_textStyle_section_02) !important;
}
:host .ids-text-overline {
  font: var(--ids_textStyle_overline) !important;
}
:host .ids-text-subtitle-01 {
  font: var(--ids_textStyle_subtitle_01) !important;
}
:host .ids-text-insight {
  font: var(--ids_textStyle_insight_regular) !important;
}
:host .ids-text-insight-bold {
  font: var(--ids_textStyle_insight_bold) !important;
}
:host .ids-text-body-01 {
  font: var(--ids_textStyle_body_01_regular) !important;
}
:host .ids-text-body-01-bold {
  font: var(--ids_textStyle_body_01_bold) !important;
}
:host .ids-text-body-02 {
  font: var(--ids_textStyle_body_02_regular) !important;
}
:host .ids-text-body-02-bold {
  font: var(--ids_textStyle_body_02_bold) !important;
}
:host .ids-text-caption {
  font: var(--ids_textStyle_caption_regular) !important;
}
:host .ids-text-caption-bold {
  font: var(--ids_textStyle_caption_bold) !important;
}
:host .ids-text-label-xsmall {
  font: var(--ids_textStyle_label_xsmall_regular) !important;
}
:host .ids-text-label-xsmall-bold {
  font: var(--ids_textStyle_label_xsmall_bold) !important;
}
:host .ids-text-label-small {
  font: var(--ids_textStyle_label_small_regular) !important;
}
:host .ids-text-label-small-bold {
  font: var(--ids_textStyle_label_small_bold) !important;
}
:host .ids-text-label-medium {
  font: var(--ids_textStyle_label_medium_regular) !important;
}
:host .ids-text-label-medium-bold {
  font: var(--ids_textStyle_label_medium_bold) !important;
}
:host .ids-text-label-large {
  font: var(--ids_textStyle_label_large_regular) !important;
}
:host .ids-text-label-large-bold {
  font: var(--ids_textStyle_label_large_bold) !important;
}
:host .ids-text-label-xlarge {
  font: var(--ids_textStyle_label_xlarge_regular) !important;
}
:host .ids-text-label-xlarge-bold {
  font: var(--ids_textStyle_label_xlarge_bold) !important;
}
:host .ids-color-text-heading-1 {
  color: var(--ids_color_text_heading_01) !important;
}
:host .ids-color-text-heading-2 {
  color: var(--ids_color_text_heading_02) !important;
}
:host .ids-color-text-body-1 {
  color: var(--ids_color_text_body_01) !important;
}
:host .ids-color-text-body-2 {
  color: var(--ids_color_text_body_02) !important;
}
:host .ids-color-text-highlight {
  color: var(--ids_color_text_highlight) !important;
}
:host .ids-d-block {
  /* stylelint-disable-next-line declaration-no-important */
  display: block !important;
}
:host .ids-d-flex {
  /* stylelint-disable-next-line declaration-no-important */
  display: flex !important;
}
:host .ids-d-grid {
  /* stylelint-disable-next-line declaration-no-important */
  display: grid !important;
}
:host .ids-d-inline-block {
  /* stylelint-disable-next-line declaration-no-important */
  display: inline-block !important;
}
:host .ids-d-inline-flex {
  /* stylelint-disable-next-line declaration-no-important */
  display: inline-flex !important;
}
:host .ids-d-inline-grid {
  /* stylelint-disable-next-line declaration-no-important */
  display: inline-grid !important;
}
:host .ids-d-none {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
:host .ids-d-table-cell {
  /* stylelint-disable-next-line declaration-no-important */
  display: table-cell !important;
}
:host .ids-d-table-row {
  /* stylelint-disable-next-line declaration-no-important */
  display: table-row !important;
}
:host .ids-d-table {
  /* stylelint-disable-next-line declaration-no-important */
  display: table !important;
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: flex !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: grid !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-inline-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-block !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-inline-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-flex !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-inline-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-grid !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-none {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-table-cell {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-cell !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-table-row {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-row !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-d-sm-table {
    /* stylelint-disable-next-line declaration-no-important */
    display: table !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: flex !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: grid !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-inline-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-block !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-inline-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-flex !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-inline-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-grid !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-none {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-table-cell {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-cell !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-table-row {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-row !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-d-md-table {
    /* stylelint-disable-next-line declaration-no-important */
    display: table !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: flex !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: grid !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-inline-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-block !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-inline-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-flex !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-inline-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-grid !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-none {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-table-cell {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-cell !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-table-row {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-row !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-d-lg-table {
    /* stylelint-disable-next-line declaration-no-important */
    display: table !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: flex !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: grid !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-inline-block {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-block !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-inline-flex {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-flex !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-inline-grid {
    /* stylelint-disable-next-line declaration-no-important */
    display: inline-grid !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-none {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-table-cell {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-cell !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-table-row {
    /* stylelint-disable-next-line declaration-no-important */
    display: table-row !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-d-xl-table {
    /* stylelint-disable-next-line declaration-no-important */
    display: table !important;
  }
}
:host .ids-flex-row {
  /* stylelint-disable-next-line declaration-no-important */
  flex-direction: row !important;
}
:host .ids-flex-row-reverse {
  /* stylelint-disable-next-line declaration-no-important */
  flex-direction: row-reverse !important;
}
:host .ids-flex-column {
  /* stylelint-disable-next-line declaration-no-important */
  flex-direction: column !important;
}
:host .ids-flex-column-reverse {
  /* stylelint-disable-next-line declaration-no-important */
  flex-direction: column-reverse !important;
}
:host .ids-flex-nowrap {
  /* stylelint-disable-next-line declaration-no-important */
  flex-wrap: nowrap !important;
}
:host .ids-flex-wrap {
  /* stylelint-disable-next-line declaration-no-important */
  flex-wrap: wrap !important;
}
:host .ids-flex-wrap-reverse {
  /* stylelint-disable-next-line declaration-no-important */
  flex-wrap: wrap-reverse !important;
}
:host .ids-flex-grow-0 {
  /* stylelint-disable-next-line declaration-no-important */
  flex-grow: 0 !important;
}
:host .ids-flex-grow-1 {
  /* stylelint-disable-next-line declaration-no-important */
  flex-grow: 1 !important;
}
:host .ids-flex-shrink-0 {
  /* stylelint-disable-next-line declaration-no-important */
  flex-shrink: 0 !important;
}
:host .ids-flex-shrink-1 {
  /* stylelint-disable-next-line declaration-no-important */
  flex-shrink: 1 !important;
}
:host .ids-flex-fill {
  /* stylelint-disable-next-line declaration-no-important */
  flex: 1 1 auto !important;
}
:host .ids-justify-content-start {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: flex-start !important;
}
:host .ids-justify-content-end {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: flex-end !important;
}
:host .ids-justify-content-center {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: center !important;
}
:host .ids-justify-content-between {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: space-between !important;
}
:host .ids-justify-content-around {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: space-around !important;
}
:host .ids-justify-content-evenly {
  /* stylelint-disable-next-line declaration-no-important */
  justify-content: space-evenly !important;
}
:host .ids-align-items-start {
  /* stylelint-disable-next-line declaration-no-important */
  align-items: flex-start !important;
}
:host .ids-align-items-end {
  /* stylelint-disable-next-line declaration-no-important */
  align-items: flex-end !important;
}
:host .ids-align-items-center {
  /* stylelint-disable-next-line declaration-no-important */
  align-items: center !important;
}
:host .ids-align-items-baseline {
  /* stylelint-disable-next-line declaration-no-important */
  align-items: baseline !important;
}
:host .ids-align-items-stretch {
  /* stylelint-disable-next-line declaration-no-important */
  align-items: stretch !important;
}
:host .ids-align-self-start {
  /* stylelint-disable-next-line declaration-no-important */
  align-self: flex-start !important;
}
:host .ids-align-self-end {
  /* stylelint-disable-next-line declaration-no-important */
  align-self: flex-end !important;
}
:host .ids-align-self-center {
  /* stylelint-disable-next-line declaration-no-important */
  align-self: center !important;
}
:host .ids-align-self-baseline {
  /* stylelint-disable-next-line declaration-no-important */
  align-self: baseline !important;
}
:host .ids-align-self-stretch {
  /* stylelint-disable-next-line declaration-no-important */
  align-self: stretch !important;
}
:host .ids-align-content-start {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: flex-start !important;
}
:host .ids-align-content-end {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: flex-end !important;
}
:host .ids-align-content-center {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: center !important;
}
:host .ids-align-content-between {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: space-between !important;
}
:host .ids-align-content-around {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: space-around !important;
}
:host .ids-align-content-evenly {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: space-evenly !important;
}
:host .ids-align-content-stretch {
  /* stylelint-disable-next-line declaration-no-important */
  align-content: stretch !important;
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-row {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-row-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row-reverse !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-column {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-column-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-nowrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-wrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-wrap-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap-reverse !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-grow-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 0 !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-grow-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-shrink-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 0 !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-shrink-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-flex-sm-fill {
    /* stylelint-disable-next-line declaration-no-important */
    flex: 1 1 auto !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-start {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-start !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-end {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-end !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-center {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: center !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-between {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-between !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-around {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-around !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-justify-content-sm-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-items-sm-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-start !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-items-sm-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-end !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-items-sm-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: center !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-items-sm-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: baseline !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-items-sm-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: stretch !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-self-sm-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-start !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-self-sm-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-end !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-self-sm-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: center !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-self-sm-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: baseline !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-self-sm-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: stretch !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-start !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-end !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: center !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-between {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-between !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-around {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-around !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-align-content-sm-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: stretch !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-row {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-row-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row-reverse !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-column {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-column-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-nowrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-wrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-wrap-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap-reverse !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-grow-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 0 !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-grow-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-shrink-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 0 !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-shrink-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-flex-md-fill {
    /* stylelint-disable-next-line declaration-no-important */
    flex: 1 1 auto !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-start {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-start !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-end {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-end !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-center {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: center !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-between {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-between !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-around {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-around !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-justify-content-md-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-items-md-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-start !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-items-md-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-end !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-items-md-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: center !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-items-md-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: baseline !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-items-md-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: stretch !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-self-md-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-start !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-self-md-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-end !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-self-md-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: center !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-self-md-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: baseline !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-self-md-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: stretch !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-start !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-end !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: center !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-between {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-between !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-around {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-around !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-align-content-md-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: stretch !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-row {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-row-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row-reverse !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-column {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-column-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-nowrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-wrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-wrap-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap-reverse !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-grow-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 0 !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-grow-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-shrink-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 0 !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-shrink-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-flex-lg-fill {
    /* stylelint-disable-next-line declaration-no-important */
    flex: 1 1 auto !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-start {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-start !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-end {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-end !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-center {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: center !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-between {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-between !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-around {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-around !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-justify-content-lg-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-items-lg-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-start !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-items-lg-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-end !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-items-lg-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: center !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-items-lg-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: baseline !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-items-lg-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: stretch !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-self-lg-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-start !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-self-lg-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-end !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-self-lg-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: center !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-self-lg-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: baseline !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-self-lg-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: stretch !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-start !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-end !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: center !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-between {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-between !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-around {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-around !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-align-content-lg-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: stretch !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-row {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-row-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row-reverse !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-column {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-column-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: column-reverse !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-nowrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: nowrap !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-wrap {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-wrap-reverse {
    /* stylelint-disable-next-line declaration-no-important */
    flex-wrap: wrap-reverse !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-grow-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 0 !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-grow-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-grow: 1 !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-shrink-0 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 0 !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-shrink-1 {
    /* stylelint-disable-next-line declaration-no-important */
    flex-shrink: 1 !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-flex-xl-fill {
    /* stylelint-disable-next-line declaration-no-important */
    flex: 1 1 auto !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-start {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-start !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-end {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: flex-end !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-center {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: center !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-between {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-between !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-around {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-around !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-justify-content-xl-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    justify-content: space-evenly !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-items-xl-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-start !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-items-xl-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: flex-end !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-items-xl-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: center !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-items-xl-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: baseline !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-items-xl-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-items: stretch !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-self-xl-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-start !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-self-xl-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: flex-end !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-self-xl-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: center !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-self-xl-baseline {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: baseline !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-self-xl-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-self: stretch !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-start {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-start !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-end {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: flex-end !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-center {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: center !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-between {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-between !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-around {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-around !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-evenly {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: space-evenly !important;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-align-content-xl-stretch {
    /* stylelint-disable-next-line declaration-no-important */
    align-content: stretch !important;
  }
}
:host .ids-opacity-empty {
  opacity: var(--ids_opacity_empty) !important;
}
:host .ids-opacity-soft {
  opacity: var(--ids_opacity_soft) !important;
}
:host .ids-opacity-medium {
  opacity: var(--ids_opacity_medium) !important;
}
:host .ids-opacity-strong {
  opacity: var(--ids_opacity_strong) !important;
}
:host .ids-opacity-none {
  opacity: var(--ids_opacity_none) !important;
}
:host .ids-margin-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
:host .ids-p-0 {
  padding: 0 !important;
}
:host .ids-px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
:host .ids-py-0 {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
:host .ids-pt-0 {
  padding-top: 0 !important;
}
:host .ids-pb-0 {
  padding-bottom: 0 !important;
}
:host .ids-pl-0 {
  padding-left: 0 !important;
}
:host .ids-pr-0 {
  padding-right: 0 !important;
}
:host .ids-p-1 {
  padding: var(--ids_spacing_1x) !important;
}
:host .ids-px-1 {
  padding-left: var(--ids_spacing_1x) !important;
  padding-right: var(--ids_spacing_1x) !important;
}
:host .ids-py-1 {
  padding-bottom: var(--ids_spacing_1x) !important;
  padding-top: var(--ids_spacing_1x) !important;
}
:host .ids-pt-1 {
  padding-top: var(--ids_spacing_1x) !important;
}
:host .ids-pb-1 {
  padding-bottom: var(--ids_spacing_1x) !important;
}
:host .ids-pl-1 {
  padding-left: var(--ids_spacing_1x) !important;
}
:host .ids-pr-1 {
  padding-right: var(--ids_spacing_1x) !important;
}
:host .ids-p-2 {
  padding: var(--ids_spacing_2x) !important;
}
:host .ids-px-2 {
  padding-left: var(--ids_spacing_2x) !important;
  padding-right: var(--ids_spacing_2x) !important;
}
:host .ids-py-2 {
  padding-bottom: var(--ids_spacing_2x) !important;
  padding-top: var(--ids_spacing_2x) !important;
}
:host .ids-pt-2 {
  padding-top: var(--ids_spacing_2x) !important;
}
:host .ids-pb-2 {
  padding-bottom: var(--ids_spacing_2x) !important;
}
:host .ids-pl-2 {
  padding-left: var(--ids_spacing_2x) !important;
}
:host .ids-pr-2 {
  padding-right: var(--ids_spacing_2x) !important;
}
:host .ids-p-3 {
  padding: var(--ids_spacing_3x) !important;
}
:host .ids-px-3 {
  padding-left: var(--ids_spacing_3x) !important;
  padding-right: var(--ids_spacing_3x) !important;
}
:host .ids-py-3 {
  padding-bottom: var(--ids_spacing_3x) !important;
  padding-top: var(--ids_spacing_3x) !important;
}
:host .ids-pt-3 {
  padding-top: var(--ids_spacing_3x) !important;
}
:host .ids-pb-3 {
  padding-bottom: var(--ids_spacing_3x) !important;
}
:host .ids-pl-3 {
  padding-left: var(--ids_spacing_3x) !important;
}
:host .ids-pr-3 {
  padding-right: var(--ids_spacing_3x) !important;
}
:host .ids-p-4 {
  padding: var(--ids_spacing_4x) !important;
}
:host .ids-px-4 {
  padding-left: var(--ids_spacing_4x) !important;
  padding-right: var(--ids_spacing_4x) !important;
}
:host .ids-py-4 {
  padding-bottom: var(--ids_spacing_4x) !important;
  padding-top: var(--ids_spacing_4x) !important;
}
:host .ids-pt-4 {
  padding-top: var(--ids_spacing_4x) !important;
}
:host .ids-pb-4 {
  padding-bottom: var(--ids_spacing_4x) !important;
}
:host .ids-pl-4 {
  padding-left: var(--ids_spacing_4x) !important;
}
:host .ids-pr-4 {
  padding-right: var(--ids_spacing_4x) !important;
}
:host .ids-p-5 {
  padding: var(--ids_spacing_5x) !important;
}
:host .ids-px-5 {
  padding-left: var(--ids_spacing_5x) !important;
  padding-right: var(--ids_spacing_5x) !important;
}
:host .ids-py-5 {
  padding-bottom: var(--ids_spacing_5x) !important;
  padding-top: var(--ids_spacing_5x) !important;
}
:host .ids-pt-5 {
  padding-top: var(--ids_spacing_5x) !important;
}
:host .ids-pb-5 {
  padding-bottom: var(--ids_spacing_5x) !important;
}
:host .ids-pl-5 {
  padding-left: var(--ids_spacing_5x) !important;
}
:host .ids-pr-5 {
  padding-right: var(--ids_spacing_5x) !important;
}
:host .ids-p-6 {
  padding: var(--ids_spacing_6x) !important;
}
:host .ids-px-6 {
  padding-left: var(--ids_spacing_6x) !important;
  padding-right: var(--ids_spacing_6x) !important;
}
:host .ids-py-6 {
  padding-bottom: var(--ids_spacing_6x) !important;
  padding-top: var(--ids_spacing_6x) !important;
}
:host .ids-pt-6 {
  padding-top: var(--ids_spacing_6x) !important;
}
:host .ids-pb-6 {
  padding-bottom: var(--ids_spacing_6x) !important;
}
:host .ids-pl-6 {
  padding-left: var(--ids_spacing_6x) !important;
}
:host .ids-pr-6 {
  padding-right: var(--ids_spacing_6x) !important;
}
:host .ids-p-7 {
  padding: var(--ids_spacing_8x) !important;
}
:host .ids-px-7 {
  padding-left: var(--ids_spacing_8x) !important;
  padding-right: var(--ids_spacing_8x) !important;
}
:host .ids-py-7 {
  padding-bottom: var(--ids_spacing_8x) !important;
  padding-top: var(--ids_spacing_8x) !important;
}
:host .ids-pt-7 {
  padding-top: var(--ids_spacing_8x) !important;
}
:host .ids-pb-7 {
  padding-bottom: var(--ids_spacing_8x) !important;
}
:host .ids-pl-7 {
  padding-left: var(--ids_spacing_8x) !important;
}
:host .ids-pr-7 {
  padding-right: var(--ids_spacing_8x) !important;
}
:host .ids-p-8 {
  padding: var(--ids_spacing_10x) !important;
}
:host .ids-px-8 {
  padding-left: var(--ids_spacing_10x) !important;
  padding-right: var(--ids_spacing_10x) !important;
}
:host .ids-py-8 {
  padding-bottom: var(--ids_spacing_10x) !important;
  padding-top: var(--ids_spacing_10x) !important;
}
:host .ids-pt-8 {
  padding-top: var(--ids_spacing_10x) !important;
}
:host .ids-pb-8 {
  padding-bottom: var(--ids_spacing_10x) !important;
}
:host .ids-pl-8 {
  padding-left: var(--ids_spacing_10x) !important;
}
:host .ids-pr-8 {
  padding-right: var(--ids_spacing_10x) !important;
}
:host .ids-p-9 {
  padding: var(--ids_spacing_12x) !important;
}
:host .ids-px-9 {
  padding-left: var(--ids_spacing_12x) !important;
  padding-right: var(--ids_spacing_12x) !important;
}
:host .ids-py-9 {
  padding-bottom: var(--ids_spacing_12x) !important;
  padding-top: var(--ids_spacing_12x) !important;
}
:host .ids-pt-9 {
  padding-top: var(--ids_spacing_12x) !important;
}
:host .ids-pb-9 {
  padding-bottom: var(--ids_spacing_12x) !important;
}
:host .ids-pl-9 {
  padding-left: var(--ids_spacing_12x) !important;
}
:host .ids-pr-9 {
  padding-right: var(--ids_spacing_12x) !important;
}
:host .ids-p-10 {
  padding: var(--ids_spacing_14x) !important;
}
:host .ids-px-10 {
  padding-left: var(--ids_spacing_14x) !important;
  padding-right: var(--ids_spacing_14x) !important;
}
:host .ids-py-10 {
  padding-bottom: var(--ids_spacing_14x) !important;
  padding-top: var(--ids_spacing_14x) !important;
}
:host .ids-pt-10 {
  padding-top: var(--ids_spacing_14x) !important;
}
:host .ids-pb-10 {
  padding-bottom: var(--ids_spacing_14x) !important;
}
:host .ids-pl-10 {
  padding-left: var(--ids_spacing_14x) !important;
}
:host .ids-pr-10 {
  padding-right: var(--ids_spacing_14x) !important;
}
:host .ids-m-0 {
  margin: 0 !important;
}
:host .ids-mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
:host .ids-my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
:host .ids-mt-0 {
  margin-top: 0 !important;
}
:host .ids-mb-0 {
  margin-bottom: 0 !important;
}
:host .ids-ml-0 {
  margin-left: 0 !important;
}
:host .ids-mr-0 {
  margin-right: 0 !important;
}
:host .ids-m-1 {
  margin: var(--ids_spacing_1x) !important;
}
:host .ids-mx-1 {
  margin-left: var(--ids_spacing_1x) !important;
  margin-right: var(--ids_spacing_1x) !important;
}
:host .ids-my-1 {
  margin-bottom: var(--ids_spacing_1x) !important;
  margin-top: var(--ids_spacing_1x) !important;
}
:host .ids-mt-1 {
  margin-top: var(--ids_spacing_1x) !important;
}
:host .ids-mb-1 {
  margin-bottom: var(--ids_spacing_1x) !important;
}
:host .ids-ml-1 {
  margin-left: var(--ids_spacing_1x) !important;
}
:host .ids-mr-1 {
  margin-right: var(--ids_spacing_1x) !important;
}
:host .ids-m-2 {
  margin: var(--ids_spacing_2x) !important;
}
:host .ids-mx-2 {
  margin-left: var(--ids_spacing_2x) !important;
  margin-right: var(--ids_spacing_2x) !important;
}
:host .ids-my-2 {
  margin-bottom: var(--ids_spacing_2x) !important;
  margin-top: var(--ids_spacing_2x) !important;
}
:host .ids-mt-2 {
  margin-top: var(--ids_spacing_2x) !important;
}
:host .ids-mb-2 {
  margin-bottom: var(--ids_spacing_2x) !important;
}
:host .ids-ml-2 {
  margin-left: var(--ids_spacing_2x) !important;
}
:host .ids-mr-2 {
  margin-right: var(--ids_spacing_2x) !important;
}
:host .ids-m-3 {
  margin: var(--ids_spacing_3x) !important;
}
:host .ids-mx-3 {
  margin-left: var(--ids_spacing_3x) !important;
  margin-right: var(--ids_spacing_3x) !important;
}
:host .ids-my-3 {
  margin-bottom: var(--ids_spacing_3x) !important;
  margin-top: var(--ids_spacing_3x) !important;
}
:host .ids-mt-3 {
  margin-top: var(--ids_spacing_3x) !important;
}
:host .ids-mb-3 {
  margin-bottom: var(--ids_spacing_3x) !important;
}
:host .ids-ml-3 {
  margin-left: var(--ids_spacing_3x) !important;
}
:host .ids-mr-3 {
  margin-right: var(--ids_spacing_3x) !important;
}
:host .ids-m-4 {
  margin: var(--ids_spacing_4x) !important;
}
:host .ids-mx-4 {
  margin-left: var(--ids_spacing_4x) !important;
  margin-right: var(--ids_spacing_4x) !important;
}
:host .ids-my-4 {
  margin-bottom: var(--ids_spacing_4x) !important;
  margin-top: var(--ids_spacing_4x) !important;
}
:host .ids-mt-4 {
  margin-top: var(--ids_spacing_4x) !important;
}
:host .ids-mb-4 {
  margin-bottom: var(--ids_spacing_4x) !important;
}
:host .ids-ml-4 {
  margin-left: var(--ids_spacing_4x) !important;
}
:host .ids-mr-4 {
  margin-right: var(--ids_spacing_4x) !important;
}
:host .ids-m-5 {
  margin: var(--ids_spacing_5x) !important;
}
:host .ids-mx-5 {
  margin-left: var(--ids_spacing_5x) !important;
  margin-right: var(--ids_spacing_5x) !important;
}
:host .ids-my-5 {
  margin-bottom: var(--ids_spacing_5x) !important;
  margin-top: var(--ids_spacing_5x) !important;
}
:host .ids-mt-5 {
  margin-top: var(--ids_spacing_5x) !important;
}
:host .ids-mb-5 {
  margin-bottom: var(--ids_spacing_5x) !important;
}
:host .ids-ml-5 {
  margin-left: var(--ids_spacing_5x) !important;
}
:host .ids-mr-5 {
  margin-right: var(--ids_spacing_5x) !important;
}
:host .ids-m-6 {
  margin: var(--ids_spacing_6x) !important;
}
:host .ids-mx-6 {
  margin-left: var(--ids_spacing_6x) !important;
  margin-right: var(--ids_spacing_6x) !important;
}
:host .ids-my-6 {
  margin-bottom: var(--ids_spacing_6x) !important;
  margin-top: var(--ids_spacing_6x) !important;
}
:host .ids-mt-6 {
  margin-top: var(--ids_spacing_6x) !important;
}
:host .ids-mb-6 {
  margin-bottom: var(--ids_spacing_6x) !important;
}
:host .ids-ml-6 {
  margin-left: var(--ids_spacing_6x) !important;
}
:host .ids-mr-6 {
  margin-right: var(--ids_spacing_6x) !important;
}
:host .ids-m-7 {
  margin: var(--ids_spacing_8x) !important;
}
:host .ids-mx-7 {
  margin-left: var(--ids_spacing_8x) !important;
  margin-right: var(--ids_spacing_8x) !important;
}
:host .ids-my-7 {
  margin-bottom: var(--ids_spacing_8x) !important;
  margin-top: var(--ids_spacing_8x) !important;
}
:host .ids-mt-7 {
  margin-top: var(--ids_spacing_8x) !important;
}
:host .ids-mb-7 {
  margin-bottom: var(--ids_spacing_8x) !important;
}
:host .ids-ml-7 {
  margin-left: var(--ids_spacing_8x) !important;
}
:host .ids-mr-7 {
  margin-right: var(--ids_spacing_8x) !important;
}
:host .ids-m-8 {
  margin: var(--ids_spacing_10x) !important;
}
:host .ids-mx-8 {
  margin-left: var(--ids_spacing_10x) !important;
  margin-right: var(--ids_spacing_10x) !important;
}
:host .ids-my-8 {
  margin-bottom: var(--ids_spacing_10x) !important;
  margin-top: var(--ids_spacing_10x) !important;
}
:host .ids-mt-8 {
  margin-top: var(--ids_spacing_10x) !important;
}
:host .ids-mb-8 {
  margin-bottom: var(--ids_spacing_10x) !important;
}
:host .ids-ml-8 {
  margin-left: var(--ids_spacing_10x) !important;
}
:host .ids-mr-8 {
  margin-right: var(--ids_spacing_10x) !important;
}
:host .ids-m-9 {
  margin: var(--ids_spacing_12x) !important;
}
:host .ids-mx-9 {
  margin-left: var(--ids_spacing_12x) !important;
  margin-right: var(--ids_spacing_12x) !important;
}
:host .ids-my-9 {
  margin-bottom: var(--ids_spacing_12x) !important;
  margin-top: var(--ids_spacing_12x) !important;
}
:host .ids-mt-9 {
  margin-top: var(--ids_spacing_12x) !important;
}
:host .ids-mb-9 {
  margin-bottom: var(--ids_spacing_12x) !important;
}
:host .ids-ml-9 {
  margin-left: var(--ids_spacing_12x) !important;
}
:host .ids-mr-9 {
  margin-right: var(--ids_spacing_12x) !important;
}
:host .ids-m-10 {
  margin: var(--ids_spacing_14x) !important;
}
:host .ids-mx-10 {
  margin-left: var(--ids_spacing_14x) !important;
  margin-right: var(--ids_spacing_14x) !important;
}
:host .ids-my-10 {
  margin-bottom: var(--ids_spacing_14x) !important;
  margin-top: var(--ids_spacing_14x) !important;
}
:host .ids-mt-10 {
  margin-top: var(--ids_spacing_14x) !important;
}
:host .ids-mb-10 {
  margin-bottom: var(--ids_spacing_14x) !important;
}
:host .ids-ml-10 {
  margin-left: var(--ids_spacing_14x) !important;
}
:host .ids-mr-10 {
  margin-right: var(--ids_spacing_14x) !important;
}
:host [class*=ids-container] {
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
}
:host .ids-container {
  max-width: 48rem;
  padding: 0 1.5rem;
}
@media screen and (min-width: 20rem) {
  :host .ids-container-xs {
    max-width: 48rem;
    padding: 0 var(--ids_layout_padding_xs, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_sm, 1.5rem);
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-container-sm {
    max-width: 48rem;
    padding: 0 var(--ids_layout_padding_sm, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container-sm {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_sm, 1.5rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-container {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_md, 3rem);
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-container-md {
    max-width: 48rem;
    padding: 0 var(--ids_layout_padding_md, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container-md {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_md, 1.5rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-container-md {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_md, 3rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-container {
    max-width: 80rem;
    padding: 0 var(--ids_layout_padding_lg, 3.5rem);
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-container-lg {
    max-width: 48rem;
    padding: 0 var(--ids_layout_padding_lg, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container-lg {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_lg, 1.5rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-container-lg {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_lg, 3rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-container-lg {
    max-width: 80rem;
    padding: 0 var(--ids_layout_padding_lg, 3.5rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-container {
    max-width: 100rem;
    padding: 0 var(--ids_layout_padding_xl, 4.5rem);
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-container-xl {
    max-width: 48rem;
    padding: 0 var(--ids_layout_padding_xl, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container-xl {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_xl, 1.5rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-container-xl {
    max-width: 64rem;
    padding: 0 var(--ids_layout_padding_xl, 3rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-container-xl {
    max-width: 80rem;
    padding: 0 var(--ids_layout_padding_xl, 3.5rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-container-xl {
    max-width: 100rem;
    padding: 0 var(--ids_layout_padding_xl, 4.5rem);
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-container-fluid {
    padding-left: var(--ids_layout_padding_xs, 1.5rem);
    padding-right: var(--ids_layout_padding_xs, 1.5rem);
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-container-fluid {
    padding-left: var(--ids_layout_padding_sm, 1.5rem);
    padding-right: var(--ids_layout_padding_sm, 1.5rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-container-fluid {
    padding-left: var(--ids_layout_padding_md, 3rem);
    padding-right: var(--ids_layout_padding_md, 3rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-container-fluid {
    padding-left: var(--ids_layout_padding_lg, 3.5rem);
    padding-right: var(--ids_layout_padding_lg, 3.5rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-container-fluid {
    padding-left: var(--ids_layout_padding_xl, 4.5rem);
    padding-right: var(--ids_layout_padding_xl, 4.5rem);
  }
}
:host [class*=ids-row] {
  display: grid;
  margin: 0;
  width: 100%;
}
:host .ids-row {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
@media screen and (min-width: 48rem) {
  :host .ids-row {
    gap: var(--ids_layout_gutter_sm, 1rem);
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-row {
    gap: var(--ids_layout_gutter_md, 2rem);
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-row {
    gap: var(--ids_layout_gutter_lg, 2rem);
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-row {
    gap: var(--ids_layout_gutter_xl, 2rem);
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
:host .ids-row-4 {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
:host .ids-row-8 {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
@media screen and (min-width: 48rem) {
  :host .ids-row-8 {
    gap: var(--ids_layout_gutter_sm, 1rem);
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
}
:host .ids-row-fixed-4 {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
@media screen and (min-width: 48rem) {
  :host .ids-row-fixed-4 {
    gap: var(--ids_layout_gutter_sm, 1rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-row-fixed-4 {
    gap: var(--ids_layout_gutter_md, 2rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-row-fixed-4 {
    gap: var(--ids_layout_gutter_lg, 2rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-row-fixed-4 {
    gap: var(--ids_layout_gutter_xl, 2rem);
  }
}
:host .ids-row-fixed-8 {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
@media screen and (min-width: 48rem) {
  :host .ids-row-fixed-8 {
    gap: var(--ids_layout_gutter_sm, 1rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-row-fixed-8 {
    gap: var(--ids_layout_gutter_md, 2rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-row-fixed-8 {
    gap: var(--ids_layout_gutter_lg, 2rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-row-fixed-8 {
    gap: var(--ids_layout_gutter_xl, 2rem);
  }
}
:host .ids-row-fixed-12 {
  gap: var(--ids_layout_gutter_xs, 1rem);
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
@media screen and (min-width: 48rem) {
  :host .ids-row-fixed-12 {
    gap: var(--ids_layout_gutter_sm, 1rem);
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-row-fixed-12 {
    gap: var(--ids_layout_gutter_md, 2rem);
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-row-fixed-12 {
    gap: var(--ids_layout_gutter_lg, 2rem);
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-row-fixed-12 {
    gap: var(--ids_layout_gutter_xl, 2rem);
  }
}
:host [class*=ids-grid-],
:host .ids-grid {
  display: grid;
  margin: 0;
  width: 100%;
  gap: var(--ids_size_general_16x);
  grid-auto-columns: 1fr;
}
:host .ids-grid-2 {
  grid-template-columns: repeat(2, 1fr);
}
:host .ids-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
:host .ids-grid-small {
  gap: var(--ids_size_general_8x);
}
@media (min-width: 20rem) {
  :host .ids-grid-small {
    gap: var(--ids_size_general_12x);
  }
}
:host .ids-grid-large {
  gap: var(--ids_size_general_32x);
}
:host .ids-no-gutters {
  gap: 0 !important;
}
:host .ids-gutters-xs {
  gap: var(--ids_layout_gutter_xs, 1rem) !important;
}
:host .ids-gutters-sm {
  gap: var(--ids_layout_gutter_sm, 1rem) !important;
}
:host .ids-gutters-md {
  gap: var(--ids_layout_gutter_md, 2rem) !important;
}
:host .ids-gutters-lg {
  gap: var(--ids_layout_gutter_lg, 2rem) !important;
}
:host .ids-gutters-xl {
  gap: var(--ids_layout_gutter_xl, 2rem) !important;
}
:host [class*=ids-col-] {
  grid-column-end: auto;
  margin: 0;
  width: auto;
}
:host .ids-col {
  grid-column-end: auto;
  margin: 0;
  width: auto;
}
:host .ids-col-1, :host [class*=ids-row-fixed] .ids-col-1 {
  grid-column-end: span 1;
}
:host .ids-col-offset-1 {
  grid-column-start: 1;
}
:host .ids-col-2, :host [class*=ids-row-fixed] .ids-col-2 {
  grid-column-end: span 2;
}
:host .ids-col-offset-2 {
  grid-column-start: 2;
}
:host .ids-col-3, :host [class*=ids-row-fixed] .ids-col-3 {
  grid-column-end: span 3;
}
:host .ids-col-offset-3 {
  grid-column-start: 3;
}
:host .ids-col-4, :host [class*=ids-row-fixed] .ids-col-4 {
  grid-column-end: span 4;
}
:host .ids-col-offset-4 {
  grid-column-start: 4;
}
:host .ids-col-5, :host [class*=ids-row-fixed] .ids-col-5 {
  grid-column-end: span 5;
}
:host .ids-col-offset-5 {
  grid-column-start: 5;
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-5 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-5 {
    grid-column-start: 4;
  }
}
:host .ids-col-6, :host [class*=ids-row-fixed] .ids-col-6 {
  grid-column-end: span 6;
}
:host .ids-col-offset-6 {
  grid-column-start: 6;
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-6 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-6 {
    grid-column-start: 4;
  }
}
:host .ids-col-7, :host [class*=ids-row-fixed] .ids-col-7 {
  grid-column-end: span 7;
}
:host .ids-col-offset-7 {
  grid-column-start: 7;
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-7 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-7 {
    grid-column-start: 4;
  }
}
:host .ids-col-8, :host [class*=ids-row-fixed] .ids-col-8 {
  grid-column-end: span 8;
}
:host .ids-col-offset-8 {
  grid-column-start: 8;
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-8 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-8 {
    grid-column-start: 4;
  }
}
:host .ids-col-9, :host [class*=ids-row-fixed] .ids-col-9 {
  grid-column-end: span 9;
}
:host .ids-col-offset-9 {
  grid-column-start: 9;
}
@media screen and (max-width: 47.99rem) {
  :host .ids-col-9 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-9 {
    grid-column-start: 8;
  }
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-9 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-9 {
    grid-column-start: 4;
  }
}
:host .ids-col-10, :host [class*=ids-row-fixed] .ids-col-10 {
  grid-column-end: span 10;
}
:host .ids-col-offset-10 {
  grid-column-start: 10;
}
@media screen and (max-width: 47.99rem) {
  :host .ids-col-10 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-10 {
    grid-column-start: 8;
  }
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-10 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-10 {
    grid-column-start: 4;
  }
}
:host .ids-col-11, :host [class*=ids-row-fixed] .ids-col-11 {
  grid-column-end: span 11;
}
:host .ids-col-offset-11 {
  grid-column-start: 11;
}
@media screen and (max-width: 47.99rem) {
  :host .ids-col-11 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-11 {
    grid-column-start: 8;
  }
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-11 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-11 {
    grid-column-start: 4;
  }
}
:host .ids-col-12, :host [class*=ids-row-fixed] .ids-col-12 {
  grid-column-end: span 12;
}
:host .ids-col-offset-12 {
  grid-column-start: 12;
}
@media screen and (max-width: 47.99rem) {
  :host .ids-col-12 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-12 {
    grid-column-start: 8;
  }
}
@media screen and (max-width: 19.99rem) {
  :host .ids-col-12 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-12 {
    grid-column-start: 4;
  }
}
@media screen and (min-width: 20rem) {
  :host .ids-col-xs-1, :host [class*=ids-row-fixed] .ids-col-xs-1 {
    grid-column-end: span 1;
  }
  :host .ids-col-offset-xs-1, :host [class*=ids-row-fixed] .ids-col-offset-xs-1 {
    grid-column-start: 1;
  }
  :host .ids-col-xs-2, :host [class*=ids-row-fixed] .ids-col-xs-2 {
    grid-column-end: span 2;
  }
  :host .ids-col-offset-xs-2, :host [class*=ids-row-fixed] .ids-col-offset-xs-2 {
    grid-column-start: 2;
  }
  :host .ids-col-xs-3, :host [class*=ids-row-fixed] .ids-col-xs-3 {
    grid-column-end: span 3;
  }
  :host .ids-col-offset-xs-3, :host [class*=ids-row-fixed] .ids-col-offset-xs-3 {
    grid-column-start: 3;
  }
  :host .ids-col-xs-4, :host [class*=ids-row-fixed] .ids-col-xs-4 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-xs-4, :host [class*=ids-row-fixed] .ids-col-offset-xs-4 {
    grid-column-start: 4;
  }
}
@media screen and (min-width: 48rem) {
  :host .ids-col-sm-1, :host [class*=ids-row-fixed] .ids-col-sm-1 {
    grid-column-end: span 1;
  }
  :host .ids-col-offset-sm-1, :host [class*=ids-row-fixed] .ids-col-offset-sm-1 {
    grid-column-start: 1;
  }
  :host .ids-col-sm-2, :host [class*=ids-row-fixed] .ids-col-sm-2 {
    grid-column-end: span 2;
  }
  :host .ids-col-offset-sm-2, :host [class*=ids-row-fixed] .ids-col-offset-sm-2 {
    grid-column-start: 2;
  }
  :host .ids-col-sm-3, :host [class*=ids-row-fixed] .ids-col-sm-3 {
    grid-column-end: span 3;
  }
  :host .ids-col-offset-sm-3, :host [class*=ids-row-fixed] .ids-col-offset-sm-3 {
    grid-column-start: 3;
  }
  :host .ids-col-sm-4, :host [class*=ids-row-fixed] .ids-col-sm-4 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-sm-4, :host [class*=ids-row-fixed] .ids-col-offset-sm-4 {
    grid-column-start: 4;
  }
  :host .ids-col-sm-5, :host [class*=ids-row-fixed] .ids-col-sm-5 {
    grid-column-end: span 5;
  }
  :host .ids-col-offset-sm-5, :host [class*=ids-row-fixed] .ids-col-offset-sm-5 {
    grid-column-start: 5;
  }
  :host .ids-col-sm-6, :host [class*=ids-row-fixed] .ids-col-sm-6 {
    grid-column-end: span 6;
  }
  :host .ids-col-offset-sm-6, :host [class*=ids-row-fixed] .ids-col-offset-sm-6 {
    grid-column-start: 6;
  }
  :host .ids-col-sm-7, :host [class*=ids-row-fixed] .ids-col-sm-7 {
    grid-column-end: span 7;
  }
  :host .ids-col-offset-sm-7, :host [class*=ids-row-fixed] .ids-col-offset-sm-7 {
    grid-column-start: 7;
  }
  :host .ids-col-sm-8, :host [class*=ids-row-fixed] .ids-col-sm-8 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-sm-8, :host [class*=ids-row-fixed] .ids-col-offset-sm-8 {
    grid-column-start: 8;
  }
}
@media screen and (min-width: 64rem) {
  :host .ids-col-md-1, :host [class*=ids-row-fixed] .ids-col-md-1 {
    grid-column-end: span 1;
  }
  :host .ids-col-offset-md-1, :host [class*=ids-row-fixed] .ids-col-offset-md-1 {
    grid-column-start: 1;
  }
  :host .ids-col-md-2, :host [class*=ids-row-fixed] .ids-col-md-2 {
    grid-column-end: span 2;
  }
  :host .ids-col-offset-md-2, :host [class*=ids-row-fixed] .ids-col-offset-md-2 {
    grid-column-start: 2;
  }
  :host .ids-col-md-3, :host [class*=ids-row-fixed] .ids-col-md-3 {
    grid-column-end: span 3;
  }
  :host .ids-col-offset-md-3, :host [class*=ids-row-fixed] .ids-col-offset-md-3 {
    grid-column-start: 3;
  }
  :host .ids-col-md-4, :host [class*=ids-row-fixed] .ids-col-md-4 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-md-4, :host [class*=ids-row-fixed] .ids-col-offset-md-4 {
    grid-column-start: 4;
  }
  :host .ids-col-md-5, :host [class*=ids-row-fixed] .ids-col-md-5 {
    grid-column-end: span 5;
  }
  :host .ids-col-offset-md-5, :host [class*=ids-row-fixed] .ids-col-offset-md-5 {
    grid-column-start: 5;
  }
  :host .ids-col-md-6, :host [class*=ids-row-fixed] .ids-col-md-6 {
    grid-column-end: span 6;
  }
  :host .ids-col-offset-md-6, :host [class*=ids-row-fixed] .ids-col-offset-md-6 {
    grid-column-start: 6;
  }
  :host .ids-col-md-7, :host [class*=ids-row-fixed] .ids-col-md-7 {
    grid-column-end: span 7;
  }
  :host .ids-col-offset-md-7, :host [class*=ids-row-fixed] .ids-col-offset-md-7 {
    grid-column-start: 7;
  }
  :host .ids-col-md-8, :host [class*=ids-row-fixed] .ids-col-md-8 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-md-8, :host [class*=ids-row-fixed] .ids-col-offset-md-8 {
    grid-column-start: 8;
  }
  :host .ids-col-md-9, :host [class*=ids-row-fixed] .ids-col-md-9 {
    grid-column-end: span 9;
  }
  :host .ids-col-offset-md-9, :host [class*=ids-row-fixed] .ids-col-offset-md-9 {
    grid-column-start: 9;
  }
  :host .ids-col-md-10, :host [class*=ids-row-fixed] .ids-col-md-10 {
    grid-column-end: span 10;
  }
  :host .ids-col-offset-md-10, :host [class*=ids-row-fixed] .ids-col-offset-md-10 {
    grid-column-start: 10;
  }
  :host .ids-col-md-11, :host [class*=ids-row-fixed] .ids-col-md-11 {
    grid-column-end: span 11;
  }
  :host .ids-col-offset-md-11, :host [class*=ids-row-fixed] .ids-col-offset-md-11 {
    grid-column-start: 11;
  }
  :host .ids-col-md-12, :host [class*=ids-row-fixed] .ids-col-md-12 {
    grid-column-end: span 12;
  }
  :host .ids-col-offset-md-12, :host [class*=ids-row-fixed] .ids-col-offset-md-12 {
    grid-column-start: 12;
  }
}
@media screen and (min-width: 80rem) {
  :host .ids-col-lg-1, :host [class*=ids-row-fixed] .ids-col-lg-1 {
    grid-column-end: span 1;
  }
  :host .ids-col-offset-lg-1, :host [class*=ids-row-fixed] .ids-col-offset-lg-1 {
    grid-column-start: 1;
  }
  :host .ids-col-lg-2, :host [class*=ids-row-fixed] .ids-col-lg-2 {
    grid-column-end: span 2;
  }
  :host .ids-col-offset-lg-2, :host [class*=ids-row-fixed] .ids-col-offset-lg-2 {
    grid-column-start: 2;
  }
  :host .ids-col-lg-3, :host [class*=ids-row-fixed] .ids-col-lg-3 {
    grid-column-end: span 3;
  }
  :host .ids-col-offset-lg-3, :host [class*=ids-row-fixed] .ids-col-offset-lg-3 {
    grid-column-start: 3;
  }
  :host .ids-col-lg-4, :host [class*=ids-row-fixed] .ids-col-lg-4 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-lg-4, :host [class*=ids-row-fixed] .ids-col-offset-lg-4 {
    grid-column-start: 4;
  }
  :host .ids-col-lg-5, :host [class*=ids-row-fixed] .ids-col-lg-5 {
    grid-column-end: span 5;
  }
  :host .ids-col-offset-lg-5, :host [class*=ids-row-fixed] .ids-col-offset-lg-5 {
    grid-column-start: 5;
  }
  :host .ids-col-lg-6, :host [class*=ids-row-fixed] .ids-col-lg-6 {
    grid-column-end: span 6;
  }
  :host .ids-col-offset-lg-6, :host [class*=ids-row-fixed] .ids-col-offset-lg-6 {
    grid-column-start: 6;
  }
  :host .ids-col-lg-7, :host [class*=ids-row-fixed] .ids-col-lg-7 {
    grid-column-end: span 7;
  }
  :host .ids-col-offset-lg-7, :host [class*=ids-row-fixed] .ids-col-offset-lg-7 {
    grid-column-start: 7;
  }
  :host .ids-col-lg-8, :host [class*=ids-row-fixed] .ids-col-lg-8 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-lg-8, :host [class*=ids-row-fixed] .ids-col-offset-lg-8 {
    grid-column-start: 8;
  }
  :host .ids-col-lg-9, :host [class*=ids-row-fixed] .ids-col-lg-9 {
    grid-column-end: span 9;
  }
  :host .ids-col-offset-lg-9, :host [class*=ids-row-fixed] .ids-col-offset-lg-9 {
    grid-column-start: 9;
  }
  :host .ids-col-lg-10, :host [class*=ids-row-fixed] .ids-col-lg-10 {
    grid-column-end: span 10;
  }
  :host .ids-col-offset-lg-10, :host [class*=ids-row-fixed] .ids-col-offset-lg-10 {
    grid-column-start: 10;
  }
  :host .ids-col-lg-11, :host [class*=ids-row-fixed] .ids-col-lg-11 {
    grid-column-end: span 11;
  }
  :host .ids-col-offset-lg-11, :host [class*=ids-row-fixed] .ids-col-offset-lg-11 {
    grid-column-start: 11;
  }
  :host .ids-col-lg-12, :host [class*=ids-row-fixed] .ids-col-lg-12 {
    grid-column-end: span 12;
  }
  :host .ids-col-offset-lg-12, :host [class*=ids-row-fixed] .ids-col-offset-lg-12 {
    grid-column-start: 12;
  }
}
@media screen and (min-width: 100rem) {
  :host .ids-col-xl-1, :host [class*=ids-row-fixed] .ids-col-xl-1 {
    grid-column-end: span 1;
  }
  :host .ids-col-offset-xl-1, :host [class*=ids-row-fixed] .ids-col-offset-xl-1 {
    grid-column-start: 1;
  }
  :host .ids-col-xl-2, :host [class*=ids-row-fixed] .ids-col-xl-2 {
    grid-column-end: span 2;
  }
  :host .ids-col-offset-xl-2, :host [class*=ids-row-fixed] .ids-col-offset-xl-2 {
    grid-column-start: 2;
  }
  :host .ids-col-xl-3, :host [class*=ids-row-fixed] .ids-col-xl-3 {
    grid-column-end: span 3;
  }
  :host .ids-col-offset-xl-3, :host [class*=ids-row-fixed] .ids-col-offset-xl-3 {
    grid-column-start: 3;
  }
  :host .ids-col-xl-4, :host [class*=ids-row-fixed] .ids-col-xl-4 {
    grid-column-end: span 4;
  }
  :host .ids-col-offset-xl-4, :host [class*=ids-row-fixed] .ids-col-offset-xl-4 {
    grid-column-start: 4;
  }
  :host .ids-col-xl-5, :host [class*=ids-row-fixed] .ids-col-xl-5 {
    grid-column-end: span 5;
  }
  :host .ids-col-offset-xl-5, :host [class*=ids-row-fixed] .ids-col-offset-xl-5 {
    grid-column-start: 5;
  }
  :host .ids-col-xl-6, :host [class*=ids-row-fixed] .ids-col-xl-6 {
    grid-column-end: span 6;
  }
  :host .ids-col-offset-xl-6, :host [class*=ids-row-fixed] .ids-col-offset-xl-6 {
    grid-column-start: 6;
  }
  :host .ids-col-xl-7, :host [class*=ids-row-fixed] .ids-col-xl-7 {
    grid-column-end: span 7;
  }
  :host .ids-col-offset-xl-7, :host [class*=ids-row-fixed] .ids-col-offset-xl-7 {
    grid-column-start: 7;
  }
  :host .ids-col-xl-8, :host [class*=ids-row-fixed] .ids-col-xl-8 {
    grid-column-end: span 8;
  }
  :host .ids-col-offset-xl-8, :host [class*=ids-row-fixed] .ids-col-offset-xl-8 {
    grid-column-start: 8;
  }
  :host .ids-col-xl-9, :host [class*=ids-row-fixed] .ids-col-xl-9 {
    grid-column-end: span 9;
  }
  :host .ids-col-offset-xl-9, :host [class*=ids-row-fixed] .ids-col-offset-xl-9 {
    grid-column-start: 9;
  }
  :host .ids-col-xl-10, :host [class*=ids-row-fixed] .ids-col-xl-10 {
    grid-column-end: span 10;
  }
  :host .ids-col-offset-xl-10, :host [class*=ids-row-fixed] .ids-col-offset-xl-10 {
    grid-column-start: 10;
  }
  :host .ids-col-xl-11, :host [class*=ids-row-fixed] .ids-col-xl-11 {
    grid-column-end: span 11;
  }
  :host .ids-col-offset-xl-11, :host [class*=ids-row-fixed] .ids-col-offset-xl-11 {
    grid-column-start: 11;
  }
  :host .ids-col-xl-12, :host [class*=ids-row-fixed] .ids-col-xl-12 {
    grid-column-end: span 12;
  }
  :host .ids-col-offset-xl-12, :host [class*=ids-row-fixed] .ids-col-offset-xl-12 {
    grid-column-start: 12;
  }
}
:host .ids-col-auto {
  grid-row: 1/2;
}
:host .ids-animation-fade-in-start {
  opacity: 0;
}
:host .ids-animation-fade-in-moderate-end {
  opacity: 1;
  transition: opacity 200ms cubic-bezier(0.42, 0, 0.58, 1);
}
:host .ids-animation-fade-out-start {
  opacity: 1;
}
:host .ids-animation-fade-out-moderate-output-end {
  opacity: 0;
  transition: opacity 275ms cubic-bezier(0.42, 0, 0.58, 1);
}
:host .ids-animation-scale-x-down {
  transform: scaleX(var(--ids-scale-x-down, 0));
}
:host .ids-animation-scale-x-up {
  transform: scaleX(var(--ids-scale-x-up, 100%));
}
:host .ids-animation-time-transform-slow {
  transition: transform 2000ms cubic-bezier(0, 0, 0.58, 1);
}
:host .ids-animation-width-down {
  width: var(--ids-width-down, 0);
}
:host .ids-animation-width-up {
  width: var(--ids-width-up, 100%);
}
:host .ids-animation-time-width-slow {
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: width 2000ms cubic-bezier(0, 0, 0.58, 1);
}
:host .ids-motion-none,
:host .ids-motion-none::before,
:host .ids-motion-none::after,
:host .ids-motion-none *,
:host .ids-motion-none *::before,
:host .ids-motion-none *::after {
  /* stylelint-disable-next-line declaration-no-important */
  animation: none !important;
  /* stylelint-disable-next-line declaration-no-important */
  transition: none !important;
}
:host .ids-text-align-center {
  text-align: center !important;
}
:host .ids-text-align-end {
  text-align: end !important;
}
:host .ids-text-align-justify {
  text-align: justify !important;
}
:host .ids-text-align-left {
  text-align: left !important;
}
:host .ids-text-align-right {
  text-align: right !important;
}
:host .ids-text-align-start {
  text-align: start !important;
}
:host .ids-banner-highlight {
  align-items: center;
  background: var(--ids_color_bg_variant_01);
  border: 0;
  border-radius: var(--ids_size_cornerRadius_card_02);
  color: var(--ids_color_text_body_01);
  display: flex;
  font: var(--ids_textStyle_f02_s12_h18_wrg);
  min-height: var(--ids_size_general_68x);
  padding: var(--ids_size_general_16x);
  width: 100%;
}
:host button.ids-banner-highlight {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host button.ids-banner-highlight {
    /* stylelint-disable selector-not-notation */
  }
  :host button.ids-banner-highlight:hover:not(:disabled):not([aria-disabled=true]), :host button.ids-banner-highlight:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_bg_variant_02);
  }
}
:host button.ids-banner-highlight:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_bg_variant_02);
}
:host a.ids-banner-highlight {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host a.ids-banner-highlight {
    /* stylelint-disable selector-not-notation */
  }
  :host a.ids-banner-highlight:hover:not(:disabled):not([aria-disabled=true]), :host a.ids-banner-highlight:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_bg_variant_02);
  }
}
:host a.ids-banner-highlight:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_bg_variant_02);
}
:host input.ids-banner-highlight {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host input.ids-banner-highlight {
    /* stylelint-disable selector-not-notation */
  }
  :host input.ids-banner-highlight:hover:not(:disabled):not([aria-disabled=true]), :host input.ids-banner-highlight:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_bg_variant_02);
  }
}
:host input.ids-banner-highlight:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_bg_variant_02);
}
:host .ids-banner-highlight.-hover {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-banner-highlight.-hover {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-banner-highlight.-hover:hover:not(:disabled):not([aria-disabled=true]), :host .ids-banner-highlight.-hover:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_bg_variant_02);
  }
}
:host .ids-banner-highlight.-hover:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_bg_variant_02);
}
:host .ids-banner-highlight__container {
  display: grid;
  flex: 1;
  padding-left: var(--ids_size_general_16x);
  padding-right: var(--ids_size_general_16x);
  text-align: left;
}
:host .ids-banner-highlight__title {
  font: var(--ids_textStyle_f02_s14_h20_wbd);
}
:host .ids-banner-highlight--on-variant {
  background-color: var(--ids_color_bg_base);
}
:host .ids-banner-highlight--on-brand {
  background-color: var(--ids_color_action_neutral_contrast);
}
@media (min-width: 48rem) {
  :host .ids-banner-highlight {
    font: var(--ids_textStyle_f02_s14_h20_wrg);
  }
  :host .ids-banner-highlight__title {
    font: var(--ids_textStyle_f02_s16_h24_wbd);
  }
}
:host .ids-brand {
  background-color: transparent;
  border-radius: var(--ids_size_general_8x);
  height: var(--ids_size_general_32x);
  max-width: none;
  width: var(--ids_size_general_32x);
}
:host .ids-brand.-small {
  height: var(--ids_size_general_24x);
  width: var(--ids_size_general_24x);
}
:host .ids-brand.-large {
  height: var(--ids_size_general_48x);
  width: var(--ids_size_general_48x);
}
:host .ids-brand.-xlarge {
  height: var(--ids_size_general_64x);
  width: var(--ids_size_general_64x);
}
:host .ids-brand.-horizontal {
  width: var(--ids_size_general_96x);
}
:host .ids-brand.-horizontal.-small {
  width: var(--ids_size_general_72x);
}
:host .ids-brand.-horizontal.-large {
  width: 10.5rem;
}
:host .ids-brand.-horizontal.-xlarge {
  width: 12rem;
}
:host .ids-brand.-rounded {
  border-radius: 50%;
  padding: var(--ids_size_general_2x);
}
:host .ids-brand.-rounded.-large, :host .ids-brand.-rounded.-xlarge {
  padding: var(--ids_size_general_4x);
}
:host .ids-brand.-variant {
  background-color: var(--ids_color_bg_variant_01);
}
:host .ids-brand.-on-brand {
  background-color: var(--ids_color_bg_base);
}
:host .ids-bottom-sheet-backdrop {
  background-color: var(--ids_color_contrast_onLight_medium);
}
:host .ids-bottom-sheet {
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: height 250ms ease-out;
  width: 100%;
}
:host .ids-bottom-sheet__content {
  background-color: var(--ids_color_bg_base);
  border-radius: var(--ids_size_general_16x) var(--ids_size_general_16x) 0 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}
:host .ids-bottom-sheet__toggle-indicator {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
  background-color: var(--ids_color_action_neutral_base);
  border: none;
  border-radius: var(--ids_size_general_16x);
  cursor: pointer;
  display: block;
  height: var(--ids_size_general_5x);
  margin: var(--ids_size_general_8x) auto var(--ids_size_general_12x);
  outline-offset: var(--ids_size_general_3x);
  width: var(--ids_size_general_44x);
}
@media (pointer: coarse) {
  :host .ids-bottom-sheet__toggle-indicator {
    outline: 0 !important;
  }
  :host .ids-bottom-sheet__toggle-indicator:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-bottom-sheet__toggle-indicator:focus-visible, :host .ids-bottom-sheet__toggle-indicator:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-bottom-sheet__toggle-indicator:focus-visible, :host .ids-bottom-sheet__toggle-indicator:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-bottom-sheet__toggle-indicator:focus-visible, :host .ids-bottom-sheet__toggle-indicator:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-bottom-sheet__header {
  display: flex;
  justify-content: space-between;
  padding: 0 var(--ids_size_general_8x) var(--ids_size_general_12x) var(--ids_size_general_24x);
}
:host .ids-bottom-sheet__presentation {
  align-items: center;
  display: flex;
  flex: 1;
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  justify-content: space-between;
}
:host .ids-bottom-sheet__presentation > * {
  font: var(--ids_textStyle_f02_s16_h24_wrg);
}
:host .ids-bottom-sheet__footer {
  gap: var(--ids_size_general_16x);
  display: flex;
  padding: var(--ids_size_general_24x);
}
:host .js-no-flexbox-gap .ids-bottom-sheet__footer {
  margin: calc(var(--ids_size_general_16x) / -2) !important;
}
:host .js-no-flexbox-gap .ids-bottom-sheet__footer > * {
  margin: calc(var(--ids_size_general_16x) / 2) !important;
}
:host .ids-bottom-sheet__body {
  flex: 1;
  overflow-y: auto;
  padding: 0 var(--ids_size_general_24x);
}
:host .ids-bottom-sheet__body:last-child {
  padding-bottom: var(--ids_size_general_24x);
}
:host .ids-bottom-sheet__body--suspended-footer::after {
  content: "";
  display: block;
  height: var(--ids_size_general_96x);
}
:host .ids-bottom-sheet__body--suspended-footer + .ids-bottom-sheet__footer {
  background-color: var(--ids_color_bg_base);
  bottom: 0;
  outline: var(--ids_size_border_small) solid var(--ids_color_action_disabled_base);
  position: fixed;
  width: 100%;
}
:host .ids-box-field {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  align-items: center;
  background-color: var(--ids_color_bg_variant_01);
  border: var(--ids_size_border_small) solid var(--ids_color_border_medium);
  border-radius: var(--ids_size_cornerRadius_button);
  color: var(--ids_color_action_neutral_variant);
  display: flex;
  min-height: var(--ids_size_general_48x);
  position: relative;
}
:host .ids-box-field input:not(.ids-box-field__input), :host .ids-box-field__input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  background-color: transparent;
  border-radius: var(--ids_size_cornerRadius_button);
  caret-color: var(--ids_color_action_primary_base);
  color: inherit;
  flex: 1;
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  outline-offset: var(--ids_size_general_1x);
  padding: var(--ids_size_general_10x) var(--ids_size_general_16x);
}
@media (pointer: coarse) {
  :host .ids-box-field input:not(.ids-box-field__input), :host .ids-box-field__input {
    outline: 0 !important;
  }
  :host .ids-box-field input:not(.ids-box-field__input):focus, :host .ids-box-field__input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-box-field input:not(.ids-box-field__input):focus-visible, :host .ids-box-field input:not(.ids-box-field__input):focus.focus-visible, :host .ids-box-field__input:focus-visible, :host .ids-box-field__input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-box-field input:not(.ids-box-field__input):focus-visible, :host .ids-box-field input:not(.ids-box-field__input):focus.focus-visible, :host .ids-box-field__input:focus-visible, :host .ids-box-field__input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-box-field input:not(.ids-box-field__input):focus-visible, :host .ids-box-field input:not(.ids-box-field__input):focus.focus-visible, :host .ids-box-field__input:focus-visible, :host .ids-box-field__input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-box-field__prefix {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  left: calc(var(--ids_size_general_16x) + var(--ids_size_border_small));
  line-height: 1;
  pointer-events: none;
  position: absolute;
}
:host .ids-box-field__prefix + input:not(.ids-box-field__input),
:host .ids-box-field__prefix + .ids-box-field__input {
  padding-left: var(--ids_size_general_48x);
}
:host .ids-box-field__suffix {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  position: absolute;
  right: calc(var(--ids_size_general_8x) + var(--ids_size_border_small));
}
:host .ids-box-field--on-brand {
  background-color: var(--ids_color_action_neutral_base);
  border-color: var(--ids_color_contrast_onDark_medium);
  color: var(--ids_color_contrast_onDark);
}
:host .ids-box-field--suffix input:not(.ids-box-field__input),
:host .ids-box-field--suffix .ids-box-field__input {
  padding-right: 3.75rem;
}
:host .ids-chart .apexcharts-tooltip {
  background-color: var(--ids_color_bg_base) !important;
  border: var(--ids_size_border_small) solid var(--ids_color_border_soft) !important;
}
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-title {
  background-color: var(--ids_color_bg_variant_02) !important;
  border-bottom: none !important;
  color: var(--ids_color_action_neutral_base) !important;
}
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-z-label,
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-x-label,
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-y-label {
  color: var(--ids_color_action_neutral_base) !important;
}
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-z-value,
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-x-value,
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-text-y-value {
  color: var(--ids_color_action_neutral_variant) !important;
}
:host .ids-chart .apexcharts-tooltip .apexcharts-tooltip-series-group {
  background-color: var(--ids_color_bg_base) !important;
}
:host .ids-calendar-day {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  color: var(--ids_color_text_body_02);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  height: 2.5rem;
  line-height: 1;
  text-align: center;
  vertical-align: middle;
  width: 2.5rem;
  background: none;
  border-color: transparent;
  border-radius: 0.25rem;
  border-style: solid;
}
@media (pointer: coarse) {
  :host .ids-calendar-day {
    outline: 0 !important;
  }
  :host .ids-calendar-day:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-calendar-day:focus-visible, :host .ids-calendar-day:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-calendar-day:focus-visible, :host .ids-calendar-day:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-calendar-day:focus-visible, :host .ids-calendar-day:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-calendar-day:disabled, :host .ids-calendar-day[aria-disabled=true] {
  color: var(--ids_color_action_disabled_variant);
  cursor: not-allowed;
  opacity: 0.5;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-calendar-day {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-calendar-day:hover:not(:disabled):not([aria-disabled=true]), :host .ids-calendar-day:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background-color: var(--ids_color_bg_variant_02);
    color: var(--ids_color_text_body_01);
    font-weight: bold;
  }
}
:host .ids-calendar-day:active:not(:disabled):not([aria-disabled=true]) {
  background-color: var(--ids_color_bg_variant_02);
  color: var(--ids_color_text_body_01);
  font-weight: bold;
}
:host .ids-calendar-day--current {
  background-color: var(--ids_color_bg_base);
  border-color: var(--ids_color_border_medium);
  border-radius: 31.25rem;
  border-width: var(--ids_size_general_2x);
  height: 2.5rem;
  position: relative;
}
:host .ids-calendar-day--current:disabled, :host .ids-calendar-day--current[aria-disabled=true] {
  color: var(--ids_color_action_disabled_variant);
  cursor: not-allowed;
  opacity: 0.5;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-calendar-day--current {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-calendar-day--current:hover:not(:disabled):not([aria-disabled=true]), :host .ids-calendar-day--current:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background-color: var(--ids_color_bg_variant_01);
    border-color: var(--ids_color_border_strong);
  }
}
:host .ids-calendar-day--current:active:not(:disabled):not([aria-disabled=true]) {
  background-color: var(--ids_color_bg_variant_01);
  border-color: var(--ids_color_border_strong);
}
:host .ids-calendar-day--selected {
  background-color: var(--ids_color_action_neutral_base);
  color: var(--ids_color_action_primary_contrast);
}
:host .ids-calendar-day--selected:disabled, :host .ids-calendar-day--selected[aria-disabled=true] {
  color: var(--ids_color_action_disabled_variant);
  cursor: not-allowed;
  opacity: 0.5;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-calendar-day--selected {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-calendar-day--selected:hover:not(:disabled):not([aria-disabled=true]), :host .ids-calendar-day--selected:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background-color: var(--ids_color_action_primary_variant);
    color: var(--ids_color_contrast_onBrand_primary);
  }
}
:host .ids-calendar-day--selected:active:not(:disabled):not([aria-disabled=true]) {
  background-color: var(--ids_color_action_primary_variant);
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-calendar {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  display: table;
  border-collapse: separate;
  border-spacing: 0;
  opacity: 1;
  width: 100%;
}
:host .ids-calendar th,
:host .ids-calendar td {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  display: table-cell;
  align-items: center;
  color: var(--ids_color_text_body_02);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  height: 2.5rem;
  line-height: 1;
  text-align: center;
  vertical-align: middle;
  width: 2.5rem;
}
:host .ids-calendar th {
  font: var(--ids_textStyle_f02_s16_h24_wbd);
  text-decoration: none;
}
:host .ids-calendar tr, :host .ids-calendar td {
  background-color: white;
  vertical-align: top;
}
:host .ids-calendar:disabled, :host .ids-calendar[aria-disabled=true], :host .ids-calendar--out-focus {
  opacity: 0.2;
}
@media (min-width: 360px) {
  :host .ids-calendar {
    border-spacing: 0 var(--ids_spacing_1x);
    margin-bottom: -0.25rem;
    margin-top: -0.25rem;
  }
}
:host .ids-card-base {
  background: var(--ids_color_bg_base);
  border: var(--ids_size_border_small) solid var(--ids_color_border_soft);
  border-radius: var(--ids_size_cornerRadius_card_01);
}
:host .ids-card-base:active, :host .ids-card-base:hover {
  background: var(--ids_color_action_neutral_base_soft);
}
:host .ids-card-base--selected {
  border: var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);
}
:host .ids-card-base--primary {
  background: var(--ids_color_action_primary_base);
  border: var(--ids_size_border_small) solid var(--ids_color_action_primary_variant);
  color: var(--ids_color_action_primary_contrast);
}
:host .ids-card-base--primary:active, :host .ids-card-base--primary:hover {
  background: var(--ids_color_action_primary_variant);
}
:host .ids-card-base--secondary {
  background: var(--ids_color_action_secondary_base);
  border: var(--ids_size_border_small) solid var(--ids_color_action_secondary_variant);
}
:host .ids-card-base--secondary:active, :host .ids-card-base--secondary:hover {
  background: var(--ids_color_action_secondary_variant);
}
:host .ids-card {
  background: var(--ids_color_bg_base);
  border: var(--ids_size_border_small) solid var(--ids_color_border_soft);
  border-radius: var(--ids_size_cornerRadius_card_01);
  border: var(--ids_size_border_small) solid var(--ids_color_border_soft);
}
:host .ids-card.-no-border {
  border: none;
}
:host button.ids-card {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host button.ids-card {
    /* stylelint-disable selector-not-notation */
  }
  :host button.ids-card:hover:not(:disabled):not([aria-disabled=true]), :host button.ids-card:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_neutral_base_soft);
  }
}
:host button.ids-card:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_neutral_base_soft);
}
:host a.ids-card {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host a.ids-card {
    /* stylelint-disable selector-not-notation */
  }
  :host a.ids-card:hover:not(:disabled):not([aria-disabled=true]), :host a.ids-card:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_neutral_base_soft);
  }
}
:host a.ids-card:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_neutral_base_soft);
}
:host input.ids-card {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host input.ids-card {
    /* stylelint-disable selector-not-notation */
  }
  :host input.ids-card:hover:not(:disabled):not([aria-disabled=true]), :host input.ids-card:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_neutral_base_soft);
  }
}
:host input.ids-card:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_neutral_base_soft);
}
:host .ids-card.-hover {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-card.-hover {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-card.-hover:hover:not(:disabled):not([aria-disabled=true]), :host .ids-card.-hover:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_neutral_base_soft);
  }
}
:host .ids-card.-hover:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_neutral_base_soft);
}
:host .ids-card.-selected {
  border: var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);
}
:host .ids-card.-variant {
  background: var(--ids_color_bg_variant_01);
}
:host .ids-card.-primary {
  background: var(--ids_color_action_primary_base);
  color: var(--ids_color_action_primary_contrast);
  border: var(--ids_size_border_small) solid var(--ids_color_action_primary_variant);
}
:host button.ids-card.-primary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host button.ids-card.-primary {
    /* stylelint-disable selector-not-notation */
  }
  :host button.ids-card.-primary:hover:not(:disabled):not([aria-disabled=true]), :host button.ids-card.-primary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_primary_variant);
  }
}
:host button.ids-card.-primary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_primary_variant);
}
:host a.ids-card.-primary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host a.ids-card.-primary {
    /* stylelint-disable selector-not-notation */
  }
  :host a.ids-card.-primary:hover:not(:disabled):not([aria-disabled=true]), :host a.ids-card.-primary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_primary_variant);
  }
}
:host a.ids-card.-primary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_primary_variant);
}
:host input.ids-card.-primary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host input.ids-card.-primary {
    /* stylelint-disable selector-not-notation */
  }
  :host input.ids-card.-primary:hover:not(:disabled):not([aria-disabled=true]), :host input.ids-card.-primary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_primary_variant);
  }
}
:host input.ids-card.-primary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_primary_variant);
}
:host .ids-card.-primary.-hover {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-card.-primary.-hover {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-card.-primary.-hover:hover:not(:disabled):not([aria-disabled=true]), :host .ids-card.-primary.-hover:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_primary_variant);
  }
}
:host .ids-card.-primary.-hover:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_primary_variant);
}
:host .ids-card.-secondary {
  background: var(--ids_color_action_secondary_base);
  border: var(--ids_size_border_small) solid var(--ids_color_action_secondary_variant);
}
:host button.ids-card.-secondary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host button.ids-card.-secondary {
    /* stylelint-disable selector-not-notation */
  }
  :host button.ids-card.-secondary:hover:not(:disabled):not([aria-disabled=true]), :host button.ids-card.-secondary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_secondary_variant);
  }
}
:host button.ids-card.-secondary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_secondary_variant);
}
:host a.ids-card.-secondary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host a.ids-card.-secondary {
    /* stylelint-disable selector-not-notation */
  }
  :host a.ids-card.-secondary:hover:not(:disabled):not([aria-disabled=true]), :host a.ids-card.-secondary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_secondary_variant);
  }
}
:host a.ids-card.-secondary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_secondary_variant);
}
:host input.ids-card.-secondary {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host input.ids-card.-secondary {
    /* stylelint-disable selector-not-notation */
  }
  :host input.ids-card.-secondary:hover:not(:disabled):not([aria-disabled=true]), :host input.ids-card.-secondary:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_secondary_variant);
  }
}
:host input.ids-card.-secondary:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_secondary_variant);
}
:host .ids-card.-secondary.-hover {
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  :host .ids-card.-secondary.-hover {
    /* stylelint-disable selector-not-notation */
  }
  :host .ids-card.-secondary.-hover:hover:not(:disabled):not([aria-disabled=true]), :host .ids-card.-secondary.-hover:focus-visible:not(:disabled):not([aria-disabled=true]) {
    background: var(--ids_color_action_secondary_variant);
  }
}
:host .ids-card.-secondary.-hover:active:not(:disabled):not([aria-disabled=true]) {
  background: var(--ids_color_action_secondary_variant);
}
:host .ids-checkbox {
  align-items: center;
  color: var(--ids_color_action_neutral_base);
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 0;
  min-height: var(--ids_size_general_48x);
  min-width: var(--ids_size_general_48x);
  position: relative;
}
:host .ids-checkbox__input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  appearance: none;
  margin: 0;
  appearance: none;
  background-color: transparent;
  border-radius: 0;
  cursor: pointer;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
@media (pointer: coarse) {
  :host .ids-checkbox__input {
    outline: 0 !important;
  }
  :host .ids-checkbox__input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-checkbox__input:focus-visible, :host .ids-checkbox__input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-checkbox__input:focus-visible, :host .ids-checkbox__input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-checkbox__input:focus-visible, :host .ids-checkbox__input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-checkbox__input:disabled {
  cursor: not-allowed;
}
:host .ids-checkbox__icon::before {
  content: "checkbox_vazio";
}
:host .ids-checkbox__input:indeterminate + .ids-checkbox__icon::before {
  content: "checkbox_indeterminado";
}
:host .ids-checkbox--invalid .ids-checkbox__icon {
  color: var(--ids_color_feedback_error);
}
:host .ids-checkbox__input[aria-invalid=true] + .ids-checkbox__icon {
  color: var(--ids_color_feedback_error);
}
:host .ids-checkbox__input:disabled + .ids-checkbox__icon {
  color: var(--ids_color_action_disabled_variant);
}
:host .ids-checkbox__input:checked + .ids-checkbox__icon::before {
  content: "checkbox";
}
:host .ids-checkbox__input:not(:disabled):hover + .ids-checkbox__icon {
  color: var(--ids_color_action_neutral_variant);
}
:host .ids-checkbox__input:indeterminate:not(:disabled) + .ids-checkbox__icon, :host .ids-checkbox__input:checked:not(:disabled) + .ids-checkbox__icon {
  color: var(--ids_color_action_primary_base);
}
:host .ids-checkbox__input:indeterminate:not(:disabled):hover + .ids-checkbox__icon, :host .ids-checkbox__input:checked:not(:disabled):hover + .ids-checkbox__icon {
  color: var(--ids_color_action_primary_variant);
}
:host .ids-datepicker .ids-form-field {
  overflow: initial;
}
:host .ids-datepicker__controller {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--ids_spacing_2x);
}
:host .ids-datepicker__controller > *:first-child {
  min-width: 7.625rem;
}
:host .ids-datepicker__controller > *:last-child {
  min-width: 5.25rem;
}
@media (min-width: 360px) {
  :host .ids-datepicker__controller {
    padding: var(--ids_spacing_2x) 1.5rem var(--ids_spacing_2x) var(--ids_spacing_4x);
  }
}
:host .ids-datepicker__body {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  display: block;
}
@media (min-width: 360px) {
  :host .ids-datepicker__body {
    padding: 0 var(--ids_spacing_4x) var(--ids_spacing_4x);
  }
}
@media (min-width: 64rem) {
  :host .ids-datepicker {
    margin-top: var(--ids_spacing_4x);
  }
}
:host .ids-divider {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  border: 0;
  display: block;
  margin: 0;
  border-bottom: var(--ids_size_border_small) solid var(--ids_color_border_medium);
  width: 100%;
}
:host .ids-divider.-regular {
  border-width: var(--ids_size_border_medium);
}
:host .ids-divider.-bold {
  border-width: var(--ids_size_border_large);
}
:host .ids-divider.-soft {
  border-color: var(--ids_color_border_soft);
}
:host .ids-divider.-strong {
  border-color: var(--ids_color_border_strong);
}
:host .ids-divider.-primary {
  border-color: var(--ids_color_action_primary_base);
}
:host .ids-divider.-primary.-strong {
  border-color: var(--ids_color_action_primary_variant);
}
:host .ids-divider.-error {
  border-color: var(--ids_color_feedback_error);
}
:host .ids-divider.-on-brand {
  border-color: var(--ids_color_contrast_onBrand_primary_medium);
}
:host .ids-divider.-on-brand.-soft {
  border-color: var(--ids_color_contrast_onBrand_primary_soft);
}
:host .ids-divider.-on-brand.-strong {
  border-color: var(--ids_color_contrast_onBrand_primary_strong);
}
:host .ids-form-field {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  --ids-form-field-text-width: 0rem;
  --ids-form-field-prefix-width: 0rem;
  --ids-form-field-suffix-width: 0rem;
  --ids-form-field-container-gap: 0rem;
  --ids-form-field-input-padding-right:
    calc(
      var(--ids-form-field-suffix-width) +
      var(--ids-form-field-container-gap)
    );
  --ids-form-field-label-lines: 1;
  --ids-form-field-label-min-height:
    calc(
      var(--ids-form-field-label-lines) *
      1.25rem +
      0.6875rem
    );
  align-items: flex-end;
  border-radius: var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;
  display: grid;
  gap: var(--ids_spacing_1x);
  min-height: calc(3.6875rem + var(--ids-form-field-label-min-height));
  outline-offset: var(--ids_size_general_3x);
  overflow: hidden;
  width: 100%;
}
:host .ids-form-field .ids-input {
  outline: 0 !important;
  padding-left: var(--ids_spacing_2x);
  padding-right: var(--ids-form-field-input-padding-right);
}
:host .ids-form-field .ids-input:focus {
  outline: 0 !important;
}
@media (pointer: fine) {
  :host .ids-form-field .ids-input:focus-visible, :host .ids-form-field .ids-input:focus.focus-visible {
    outline: 0 !important;
  }
}
:host .ids-form-field .ids-form-message {
  padding-left: var(--ids_spacing_2x);
}
:host .ids-form-field__container {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  align-items: flex-end;
  border-radius: var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;
  display: flex;
  min-height: calc(2.1875rem + var(--ids-form-field-label-min-height));
  position: relative;
}
:host .ids-form-field__container::before {
  content: initial;
}
:host .ids-form-field__label {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  bottom: 0.375rem;
  color: var(--ids_color_action_neutral_base);
  display: block;
  font: var(--ids_textStyle_f02_s14_h20_wrg);
  min-height: var(--ids-form-field-label-min-height);
  padding: var(--ids_size_general_8x) var(--ids-form-field-input-padding-right) 0.1875rem var(--ids_spacing_2x);
  pointer-events: none;
  position: absolute;
  text-align: start;
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: bottom 250ms ease;
  width: 100%;
  z-index: 1;
}
:host .ids-form-field__prefix {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  bottom: 0.8125rem;
  color: var(--ids_color_action_neutral_base);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  left: var(--ids_spacing_2x);
  line-height: 1;
  pointer-events: none;
  position: absolute;
}
:host .ids-form-field__prefix + .ids-input {
  padding-left: calc(var(--ids_size_general_8x) + var(--ids-form-field-prefix-width) + var(--ids_size_general_4x));
}
:host .ids-form-field__suffix {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  bottom: 0.625rem;
  display: inline-flex;
  line-height: 1;
  pointer-events: none;
  position: absolute;
  right: 0;
}
:host button.ids-form-field__suffix {
  pointer-events: initial;
}
:host .ids-form-field__suffix:has(button) {
  pointer-events: initial;
}
:host .ids-form-field__content {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  align-items: flex-end;
  border-radius: var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;
  display: grid;
  flex: 1;
  min-height: calc(2.1875rem + var(--ids-form-field-label-min-height));
  padding-top: calc(var(--ids-form-field-label-min-height) + var(--ids_size_general_8x));
}
:host .ids-form-field__status-message {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  align-items: flex-start;
  color: var(--ids_color_action_neutral_base);
  display: flex;
  font: var(--ids_textStyle_f02_s14_h20_wrg);
  min-height: 1.25rem;
}
:host .ids-form-field--suffix {
  --ids-form-field-container-gap: var(--ids_spacing_2x);
  --ids-form-field-suffix-width: var(--ids_size_general_24x);
}
:host .ids-form-field--suffix .ids-input[list]::-webkit-list-button, :host .ids-form-field--suffix .ids-input[list]::-webkit-calendar-picker-indicator {
  opacity: 0;
}
:host .ids-form-field--suffix .ids-input[type=search]::-webkit-search-decoration, :host .ids-form-field--suffix .ids-input[type=search]::-webkit-search-cancel-button, :host .ids-form-field--suffix .ids-input[type=search]::-webkit-search-results-button, :host .ids-form-field--suffix .ids-input[type=search]::-webkit-search-results-decoration {
  display: none;
}
:host .ids-form-field--button-suffix {
  --ids-form-field-suffix-width: var(--ids_size_general_48x);
}
:host .ids-form-field--button-suffix .ids-form-field__suffix {
  bottom: 0;
  pointer-events: initial;
  right: var(--ids_size_general_1x);
}
:host .ids-form-field--large .ids-form-field__label {
  font: var(--ids_textStyle_f02_s14_h20_wrg);
}
:host .ids-form-field--large .ids-input {
  font: var(--ids_textStyle_f02_s24_h32_wbd);
}
:host .ids-form-field--center {
  text-align: center;
}
:host .ids-form-field--center .ids-form-field__container,
:host .ids-form-field--center .ids-form-field__content,
:host .ids-form-field--center .ids-form-field__status-message {
  justify-content: center;
}
:host .ids-form-field--center .ids-form-field__content {
  flex: none;
  max-width: 100%;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}
:host .ids-form-field--center .ids-form-field__label,
:host .ids-form-field--center .ids-input {
  text-align: center;
}
:host .ids-form-field--center .ids-form-field__label {
  padding-left: 0;
  padding-right: 0;
}
:host .ids-form-field--center .ids-input {
  min-width: 2.5rem;
  padding-right: calc(var(--ids_size_general_8x) + var(--ids-form-field-suffix-width));
  width: calc(var(--ids-form-field-text-width) + var(--ids_size_general_16x) + var(--ids-form-field-prefix-width) + var(--ids_size_general_4x) + var(--ids-form-field-suffix-width));
}
:host .ids-form-field--center.ids-form-field--large .ids-form-field__prefix {
  bottom: 0.5rem;
  font: var(--ids_textStyle_f02_s16_h24_wrg);
}
:host .ids-form-field--center.ids-form-field--large .ids-input {
  font: var(--ids_textStyle_f02_s32_h48_wrg);
  padding-bottom: 0;
}
:host .ids-form-field--focus:not(.ids-form-field--disabled) .ids-form-field__label {
  bottom: calc(100% - var(--ids-form-field-label-min-height) - var(--ids_size_general_8x));
  pointer-events: initial;
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: bottom 175ms ease;
}
:host .ids-form-field--value .ids-form-field__label {
  bottom: calc(100% - var(--ids-form-field-label-min-height) - var(--ids_size_general_8x));
  pointer-events: initial;
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: bottom 175ms ease;
}
:host .ids-form-field--placeholder .ids-form-field__label {
  bottom: calc(100% - var(--ids-form-field-label-min-height) - var(--ids_size_general_8x));
  pointer-events: initial;
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: bottom 175ms ease;
}
@media (pointer: fine) {
  :host .ids-form-field--visible-focus:not(.ids-form-field--disabled) {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
  }
}
:host .ids-form-field--disabled:not(.ids-form-field--center) .ids-form-field__container {
  background-color: var(--ids_color_action_disabled_base);
}
:host .ids-form-field--disabled .ids-input {
  background: inherit;
}
:host .ids-form-field--disabled .ids-icon,
:host .ids-form-field--disabled .ids-form-field__label,
:host .ids-form-field--disabled .ids-form-field__suffix,
:host .ids-form-field--disabled .ids-form-field__prefix,
:host .ids-form-field--disabled .ids-form-field__status-message,
:host .ids-form-field--disabled .ids-form-field__status-message .ids-form-message {
  color: var(--ids_color_action_disabled_variant);
}
:host .ids-form-field--error .ids-form-field__label {
  color: var(--ids_color_feedback_error);
}
:host .ids-form-field--error .ids-input,
:host .ids-form-field--error .ids-input:not(:read-only:where(input, textarea), :disabled):focus {
  --ids-input-border-color: var(--ids_color_feedback_error);
  caret-color: var(--ids-input-border-color);
}
:host .ids-form-field--no-message {
  min-height: 3.8125rem;
}
:host .ids-form-field--no-border .ids-input:not(:focus) {
  border-bottom: 0;
}
:host .ids-form-field--no-border .ids-input:not(:focus):focus {
  box-shadow: none;
}
:host .ids-form-field--no-border .ids-input:not(:focus)[aria-expanded=true] {
  box-shadow: 0 0 0.125rem 0 rgba(86, 80, 76, 0.16), 0 0.125rem 0.5rem 0 rgba(86, 80, 76, 0.16);
}
:host .ids-form-field--no-label {
  min-height: initial;
}
:host .ids-form-field--no-label .ids-input {
  padding-top: var(--ids_size_general_1x);
}
:host .ids-form-field--no-label .ids-form-field__content {
  padding-top: 0;
}
:host .ids-form-field--no-label .ids-form-field__content,
:host .ids-form-field--no-label .ids-form-field__container {
  min-height: 2.25rem;
}
:host .ids-form-field--no-label.ids-form-field--no-message:not(.ids-form-field--no-border) {
  min-height: 3rem;
  padding-bottom: var(--ids_size_general_6x);
}
:host .ids-form-field--no-label.ids-form-field--no-message:not(.ids-form-field--no-border) .ids-input {
  padding-top: 0.4375rem;
}
:host .ids-form-field--no-label.ids-form-field--no-border .ids-input {
  padding-bottom: var(--ids_size_general_12x);
  padding-top: var(--ids_size_general_12x);
}
:host .ids-form-field--no-label.ids-form-field--no-border .ids-form-field__suffix {
  bottom: var(--ids_size_general_12x);
}
:host .ids-form-field--no-label.ids-form-field--no-border .ids-form-field__content,
:host .ids-form-field--no-label.ids-form-field--no-border .ids-form-field__container {
  min-height: 3rem;
}
:host .ids-form-selection {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: var(--ids_size_general_8x);
  position: relative;
}
:host .ids-form-selection .ids-checkbox,
:host .ids-form-selection .ids-radio-button,
:host .ids-form-selection .ids-switch {
  position: static;
}
:host .ids-form-selection .ids-checkbox__input,
:host .ids-form-selection .ids-radio-button__input,
:host .ids-form-selection .ids-switch__input {
  left: -0.1875rem;
  outline-offset: 0;
  width: calc(100% + var(--ids_size_general_6x));
}
:host .ids-form-selection__label {
  direction: ltr;
  padding-right: var(--ids_size_general_3x);
}
:host .ids-form-selection__input {
  line-height: 1;
}
:host .ids-form-selection--disabled {
  color: var(--ids_color_action_disabled_variant);
  cursor: not-allowed;
}
:host .ids-form-selection--invalid {
  font-weight: bold;
}
:host .ids-form-selection--on-brand {
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-form-selection--rtl {
  direction: rtl;
  justify-content: flex-end;
}
:host .ids-icon {
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-direction: column;
  flex-shrink: 0;
  font: var(--ids_textStyle_icon_medium);
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
  font-style: normal;
  font-variant-ligatures: discretionary-ligatures;
  justify-content: center;
  letter-spacing: 0;
  min-height: var(--ids_size_general_24x);
  min-width: var(--ids_size_general_24x);
  text-rendering: optimizelegibility;
  text-transform: initial;
}
:host .ids-icon--primary {
  color: var(--ids_color_action_primary_base);
}
:host .ids-icon--secondary {
  color: var(--ids_color_action_secondary_base);
}
:host .ids-icon--neutral {
  color: var(--ids_color_action_neutral_base);
}
:host .ids-icon--success {
  color: var(--ids_color_feedback_success);
}
:host .ids-icon--alert {
  color: var(--ids_color_feedback_alert);
}
:host .ids-icon--information {
  color: var(--ids_color_feedback_information);
}
:host .ids-icon--error {
  color: var(--ids_color_feedback_error);
}
:host .ids-icon--on-brand {
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-icon--small {
  font: var(--ids_textStyle_icon_small);
  min-height: var(--ids_size_general_16x);
  min-width: var(--ids_size_general_16x);
}
:host .ids-icon--large {
  font: var(--ids_textStyle_icon_large);
  min-height: var(--ids_size_general_32x);
  min-width: var(--ids_size_general_32x);
}
:host .ids-icon--xlarge {
  font: var(--ids_textStyle_icon_xLarge);
  min-height: var(--ids_size_general_48x);
  min-width: var(--ids_size_general_48x);
}
:host .ids-image {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
}
:host .ids-image.one-by-one, :host .ids-image.-square {
  aspect-ratio: 1/1;
}
@supports not (aspect-ratio: 1/1) {
  :host .ids-image.one-by-one, :host .ids-image.-square {
    --ids-aspect-ratio: 1;
    --ids-height: auto;
    height: var(--ids-height);
  }
}
:host .ids-image.-two-by-three, :host .ids-image.-portrait {
  aspect-ratio: 2/3;
}
@supports not (aspect-ratio: 1/1) {
  :host .ids-image.-two-by-three, :host .ids-image.-portrait {
    --ids-aspect-ratio: 0.6666666667;
    --ids-height: auto;
    height: var(--ids-height);
  }
}
:host .ids-image.-three-by-two, :host .ids-image.-landscape {
  aspect-ratio: 3/2;
}
@supports not (aspect-ratio: 1/1) {
  :host .ids-image.-three-by-two, :host .ids-image.-landscape {
    --ids-aspect-ratio: 1.5;
    --ids-height: auto;
    height: var(--ids-height);
  }
}
:host .ids-image.-sixteen-by-nine, :host .ids-image.-widescreen {
  aspect-ratio: 16/9;
}
@supports not (aspect-ratio: 1/1) {
  :host .ids-image.-sixteen-by-nine, :host .ids-image.-widescreen {
    --ids-aspect-ratio: 1.7777777778;
    --ids-height: auto;
    height: var(--ids-height);
  }
}
:host .ids-image.-three-by-one, :host .ids-image.-panoramic {
  aspect-ratio: 3/1;
}
@supports not (aspect-ratio: 1/1) {
  :host .ids-image.-three-by-one, :host .ids-image.-panoramic {
    --ids-aspect-ratio: 3;
    --ids-height: auto;
    height: var(--ids-height);
  }
}
:host .ids-input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  --ids-input-border-color: var(--ids_color_border_medium);
  border-bottom: var(--ids_size_border_small) solid var(--ids-input-border-color);
  border-radius: var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;
  caret-color: var(--ids_color_action_primary_base);
  color: var(--ids_color_action_neutral_variant);
  font: var(--ids_textStyle_f02_s20_h26_wrg);
  min-height: 2.1875rem;
  outline-offset: var(--ids_size_general_3x);
  padding-bottom: var(--ids_spacing_2x);
  text-align: start;
  transition: border-color 250ms;
}
@media (pointer: coarse) {
  :host .ids-input {
    outline: 0 !important;
  }
  :host .ids-input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-input:focus-visible, :host .ids-input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-input:focus-visible, :host .ids-input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-input:focus-visible, :host .ids-input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-input option {
  color: var(--ids_color_action_neutral_variant);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
}
:host .ids-input option:checked {
  font: var(--ids_textStyle_f02_s16_h24_wbd);
}
:host .ids-input option:disabled {
  color: var(--ids_color_action_disabled_variant);
}
:host textarea.ids-input {
  min-height: var(--ids_size_general_52x);
  resize: vertical;
}
:host select.ids-input {
  appearance: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host input.ids-input:read-only, :host textarea.ids-input:read-only, :host .ids-input:disabled {
  background-color: var(--ids_color_action_disabled_base);
  color: var(--ids_color_action_disabled_variant);
  resize: none;
}
:host select.ids-input:not(:disabled):focus, :host div.ids-input:not(:disabled):focus, :host .ids-input:not(:disabled):not(:read-only):focus, :host .ids-input.-focus {
  --ids-input-border-color: var(--ids_color_action_primary_base);
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  box-shadow: inset 0 calc(var(--ids_size_border_small) * -2) var(--ids-input-border-color);
}
:host .ids-input.-small, :host .ids-input--small {
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  padding-bottom: calc(var(--ids_spacing_1x) + var(--ids_size_border_small));
  padding-top: var(--ids_spacing_1x);
}
:host .ids-input.-large, :host .ids-input--large {
  font: var(--ids_textStyle_label_xlarge_bold);
}
:host .ids-input.-center, :host .ids-input--center {
  text-align: center;
}
@media (pointer: coarse) {
  :host .ids-input {
    overflow: hidden;
    resize: none;
  }
}
:host .ids-link {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--ids_color_text_link_base);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
@media (pointer: coarse) {
  :host .ids-link {
    outline: 0 !important;
  }
  :host .ids-link:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-link:focus-visible, :host .ids-link:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-link:focus-visible, :host .ids-link:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-link:focus-visible, :host .ids-link:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-link:hover, :host .ids-link:focus {
  color: var(--ids_color_text_link_variant);
}
:host .ids-link.-xsmall {
  font: var(--ids_textStyle_f02_s12_h18_wrg);
}
:host .ids-link.-small {
  font: var(--ids_textStyle_f02_s14_h20_wrg);
}
:host .ids-link.-bold {
  font-weight: 700;
}
:host .ids-link.-internal {
  color: inherit;
}
:host .ids-link.-on-brand {
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-listbox {
  background-color: var(--ids_color_bg_base);
  border-radius: 0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);
  box-shadow: 0 0 var(--ids_size_general_2x) 0 rgba(86, 80, 76, 0.16), 0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86, 80, 76, 0.16);
  overflow-y: auto;
  width: 100%;
}
:host .ids-listbox--top {
  border-radius: var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01) 0 0;
  box-shadow: 0 0 var(--ids_size_general_2x) 0 rgba(86, 80, 76, 0.16), 0 -0.125rem var(--ids_size_general_8x) 0 rgba(86, 80, 76, 0.16);
}
:host .ids-listbox-wrapper {
  box-sizing: content-box;
  margin: 0 -0.5rem;
  overflow: hidden;
  padding: 0 var(--ids_size_general_8x);
}
:host .ids-listbox-wrapper .ids-listbox {
  margin-bottom: var(--ids_size_general_8x);
}
:host .ids-listbox-wrapper .ids-listbox--top {
  margin-bottom: 0;
  margin-top: var(--ids_size_general_8x);
}
:host .ids-modal-wrapper {
  display: flex;
  isolation: isolate;
  max-height: 96vh;
  min-width: 272px;
}
:host .ids-modal-wrapper__container {
  padding: 0 var(--ids_spacing_2x);
  width: 100%;
}
@media (min-width: 360px) {
  :host .ids-modal-wrapper {
    max-height: 92vh;
  }
  :host .ids-modal-wrapper__container {
    padding: 0 var(--ids_spacing_6x);
  }
}
:host .ids-modal {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background-color: var(--ids_color_bg_base);
  border-radius: var(--ids_size_general_8x);
  color: var(--ids_color_text_body_01);
  container-name: idsmodal;
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  max-height: 100%;
  max-width: 100%;
  min-width: 272px;
  overflow: hidden;
}
:host .ids-modal--shadow {
  box-shadow: 0 var(--ids_size_general_4x) var(--ids_size_general_8x) 0 rgba(0, 0, 0, 0.08);
}
:host .ids-modal__body {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  outline-offset: -0.0625rem;
  overflow-y: auto;
}
:host .ids-modal-header {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  gap: var(--ids_spacing_2x);
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--ids_spacing_2x);
  padding-left: var(--ids_spacing_3x);
}
:host .js-no-flexbox-gap .ids-modal-header {
  margin: calc(var(--ids_spacing_2x) / -2) !important;
}
:host .js-no-flexbox-gap .ids-modal-header > * {
  margin: calc(var(--ids_spacing_2x) / 2) !important;
}
:host .ids-modal-header__title {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  margin: 0;
  font: var(--ids_textStyle_f01_s20_h28_wrg);
}
:host .ids-modal-header__description {
  font: var(--ids_textStyle_f02_s14_h20_wrg);
  margin-top: var(--ids_spacing_1x);
}
:host .ids-modal-footer {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  border-top: var(--ids_size_border_medium) solid var(--ids_color_border_soft);
  gap: var(--ids_spacing_3x);
  background-color: var(--ids_color_bg_base);
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-end;
  padding: var(--ids_spacing_4x);
  position: relative;
}
:host .js-no-flexbox-gap .ids-modal-footer {
  margin: calc(var(--ids_spacing_3x) / -2) !important;
}
:host .js-no-flexbox-gap .ids-modal-footer > * {
  margin: calc(var(--ids_spacing_3x) / 2) !important;
}
:host .ids-modal-footer--inline {
  flex-direction: row;
  /* stylelint-disable-next-line selector-no-qualifying-type */
}
:host .ids-modal-footer--inline > a.ids-main-button,
:host .ids-modal-footer--inline > button.ids-main-button,
:host .ids-modal-footer--inline > * {
  flex: 1;
}
@container idsmodal (inline-size > 34.5rem) {
  :host .ids-modal-footer {
    flex-direction: row;
  }
}
@supports not (container-name: idsmodal) {
  @media (min-width: 37.5rem) {
    :host .ids-modal-footer {
      flex-direction: row;
    }
  }
}
:host .ids-overlay {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1001;
}
:host .ids-backdrop {
  background-color: var(--ids_color_action_neutral_variant_medium);
  display: flex;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
}
:host .ids-backdrop.-no-bg {
  background-color: transparent;
  pointer-events: none;
}
:host .ids-backdrop.-no-bg + * .ids-modal-wrapper {
  max-height: initial;
}
:host .ids-backdrop.-no-bg + * .ids-modal-wrapper__container {
  padding: 0;
}
:host .ids-input-password {
  background-color: transparent;
  border: none;
  caret-color: transparent;
  height: var(--ids_size_general_48x);
  opacity: 0.01;
  padding: var(--ids_size_general_20x) var(--ids_size_general_28x);
  position: absolute;
  text-decoration: none;
  top: 0;
  width: 100%;
}
:host .ids-input-password::selection {
  background-color: transparent;
  color: inherit;
}
:host .ids-password {
  display: inline-block;
  vertical-align: middle;
}
@media (pointer: fine) {
  :host .ids-password.ids-password--visible-focus {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
  }
}
:host .ids-password__form-message {
  color: var(--ids_color_action_neutral_base);
  padding-bottom: var(--ids_spacing_1x);
}
:host .ids-password__label {
  font: var(--ids_textStyle_f02_s14_h20_wrg);
}
:host .ids-password__container {
  gap: var(--ids_spacing_2x);
  display: flex;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}
:host .js-no-flexbox-gap .ids-password__container {
  margin: calc(var(--ids_spacing_2x) / -2) !important;
}
:host .js-no-flexbox-gap .ids-password__container > * {
  margin: calc(var(--ids_spacing_2x) / 2) !important;
}
:host .ids-password__fake-input {
  align-items: center;
  background-color: transparent;
  border: var(--ids_size_border_small) solid var(--ids_color_border_medium);
  border-radius: var(--ids_size_cornerRadius_passwordCode);
  color: var(--ids_color_action_neutral_base);
  display: flex;
  font: var(--ids_textStyle_f02_s24_h32_wrg);
  height: var(--ids_size_general_48x);
  justify-content: center;
  pointer-events: none;
  width: var(--ids_size_general_32x);
}
:host .ids-password__fake-input--value::before {
  background-color: var(--ids_color_action_neutral_base);
  border-radius: 50%;
  content: "";
  display: block;
  height: var(--ids_size_general_12x);
  width: var(--ids_size_general_12x);
}
:host .ids-password__fake-input--error {
  border-color: var(--ids_color_border_strong);
  border-width: var(--ids_size_border_medium);
}
:host .ids-password__fake-input--active {
  border-color: transparent;
  outline: var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);
}
:host .ids-password--disabled .ids-password__fake-input {
  background-color: transparent;
  border-color: var(--ids_color_border_soft);
}
:host .ids-password--disabled .ids-password__fake-input--active {
  border-color: var(--ids_color_border_soft);
  outline: none;
}
:host .ids-password--disabled .ids-password__form-message {
  color: var(--ids_color_action_disabled_variant);
}
:host .ids-password--on-brand .ids-password__fake-input {
  border-color: rgba(var(--ids_opacity_strong), 80%);
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-password--on-brand .ids-password__fake-input--value::before {
  background-color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-password--on-brand .ids-password__fake-input--active {
  border-color: transparent;
  outline-color: rgba(var(--ids_opacity_strong), 80%);
}
:host .ids-password--on-brand .ids-password__form-message {
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-password--on-brand.ids-password--disabled .ids-password__fake-input {
  border-color: var(--ids_color_contrast_onBrand_primary_medium);
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-password--on-brand.ids-password--disabled .ids-password__fake-input--active {
  outline-color: var(--ids_color_contrast_onBrand_primary_medium);
}
:host .ids-password--on-brand.ids-password--disabled .ids-password__form-message {
  color: var(--ids_color_contrast_onBrand_primary_medium);
}
:host .ids-password--on-brand.ids-password--error .ids-password__fake-input {
  border-color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-password--on-brand.ids-password--error .ids-password__fake-input--active {
  border-color: var(--ids_color_contrast_onBrand_primary);
  outline: none;
}
:host .ids-radio-button {
  align-items: center;
  color: var(--ids_color_action_neutral_base);
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 0;
  min-height: var(--ids_size_general_48x);
  min-width: var(--ids_size_general_48x);
  position: relative;
}
:host .ids-radio-button__input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  appearance: none;
  margin: 0;
  appearance: none;
  background-color: transparent;
  border-radius: 0;
  cursor: pointer;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
@media (pointer: coarse) {
  :host .ids-radio-button__input {
    outline: 0 !important;
  }
  :host .ids-radio-button__input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-radio-button__input:focus-visible, :host .ids-radio-button__input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-radio-button__input:focus-visible, :host .ids-radio-button__input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-radio-button__input:focus-visible, :host .ids-radio-button__input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-radio-button__input:disabled {
  cursor: not-allowed;
}
:host .ids-radio-button__icon::before {
  content: "radio_button_outline";
}
:host .ids-radio-button--invalid .ids-radio-button__icon {
  color: var(--ids_color_feedback_error);
}
:host .ids-radio-button__input:disabled + .ids-radio-button__icon {
  color: var(--ids_color_action_disabled_variant);
  cursor: not-allowed;
}
:host .ids-radio-button__input:checked + .ids-radio-button__icon::before {
  content: "radio_button_selected";
}
:host .ids-radio-button__input[aria-invalid=true] + .ids-radio-button__icon {
  color: var(--ids_color_feedback_error);
}
:host .ids-radio-button__input:not(:disabled):hover + .ids-radio-button__icon {
  color: var(--ids_color_action_neutral_variant);
}
:host .ids-radio-button__input:checked:not(:disabled) + .ids-radio-button__icon {
  color: var(--ids_color_action_primary_base);
}
:host .ids-radio-button__input:checked:not(:disabled):hover + .ids-radio-button__icon {
  color: var(--ids_color_action_primary_variant);
}
:host .ids-radio-button--invalid {
  color: var(--ids_color_feedback_error);
}
:host .ids-slider {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  --slider-color-primary: var(--ids_color_action_primary_base);
  appearance: none;
  background-color: transparent;
  border: 0;
  box-sizing: content-box;
  color: transparent;
  height: var(--ids_size_general_8x);
  outline-offset: var(--ids_size_general_3x);
  padding-bottom: calc(2.125rem + var(--ids_spacing_1x));
  padding-top: calc(var(--ids_size_general_24x) + var(--ids_spacing_2x));
  width: 100%;
}
@media (pointer: coarse) {
  :host .ids-slider {
    outline: 0 !important;
  }
  :host .ids-slider:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-slider:focus-visible, :host .ids-slider:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-slider:focus-visible, :host .ids-slider:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-slider:focus-visible, :host .ids-slider:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-slider::-moz-range-track {
  border-radius: calc(var(--ids_size_general_8x) / 2);
  height: var(--ids_size_general_8x);
  background-color: var(--ids_color_border_soft);
}
:host .ids-slider::-webkit-slider-runnable-track {
  border-radius: calc(var(--ids_size_general_8x) / 2);
  height: var(--ids_size_general_8x);
  background: radial-gradient(circle at calc(var(--slider-percent) - calc(var(--ids_size_general_8x) / 2)), var(--slider-color-primary) calc((var(--ids_size_general_8x) / 2) - 0.5px), transparent calc(var(--ids_size_general_8x) / 2)), linear-gradient(to right, var(--slider-color-primary) 0%, var(--slider-color-primary) calc(var(--slider-percent) - calc(var(--ids_size_general_8x) / 2)), var(--ids_color_border_soft) calc(var(--slider-percent) - calc(var(--ids_size_general_8x) / 2)), var(--ids_color_border_soft) 100%);
}
:host .ids-slider::-moz-range-progress {
  border-radius: calc(var(--ids_size_general_8x) / 2);
  height: var(--ids_size_general_8x);
  background-color: var(--slider-color-primary);
}
:host .ids-slider::-webkit-slider-thumb {
  appearance: none;
  background-color: var(--ids_color_action_primary_base);
  border: 0;
  cursor: pointer;
  height: 2.125rem;
  margin-top: calc(var(--ids_spacing_1x) + var(--ids_size_general_8x));
  mask-image: url('data:image/svg+xml;utf8,<svg width="28" height="34" viewBox="0 0 28 34" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M28 19.9825C28 27.7241 21.7136 34 13.959 34C6.20439 34 0 27.7241 0 19.9825C0 11 6.99999 7.98663 14 0C21 7.98663 28 11 28 19.9825Z" /></svg>');
  transform: translateX(calc(var(--ids_size_general_28x) / -2)) translateX(var(--slider-percent));
  -webkit-transition: box-shadow 0.2s linear;
  transition: box-shadow 0.2s linear;
  width: var(--ids_size_general_28x);
}
:host .ids-slider::-moz-range-thumb {
  appearance: none;
  background-color: var(--ids_color_action_primary_base);
  border: 0;
  cursor: pointer;
  height: 2.125rem;
  margin-top: calc(var(--ids_spacing_1x) + var(--ids_size_general_8x));
  mask-image: url('data:image/svg+xml;utf8,<svg width="28" height="34" viewBox="0 0 28 34" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M28 19.9825C28 27.7241 21.7136 34 13.959 34C6.20439 34 0 27.7241 0 19.9825C0 11 6.99999 7.98663 14 0C21 7.98663 28 11 28 19.9825Z" /></svg>');
  transform: translateX(calc(var(--ids_size_general_28x) / -2)) translateX(var(--slider-percent));
  -moz-transition: box-shadow 0.2s linear;
  transition: box-shadow 0.2s linear;
  width: var(--ids_size_general_28x);
  transform: translateY(calc(0.8125rem + var(--ids_size_general_8x) + var(--ids_spacing_1x))) translateX(calc(var(--ids_size_general_28x) / -2)) translateX(var(--slider-percent));
}
:host .ids-slider:active::-webkit-slider-thumb, :host .ids-slider:focus::-webkit-slider-thumb, :host .ids-slider:hover::-webkit-slider-thumb {
  background-color: var(--ids_color_action_primary_variant);
  outline: 0;
}
:host .ids-slider:active::-moz-range-thumb, :host .ids-slider:focus::-moz-range-thumb, :host .ids-slider:hover::-moz-range-thumb {
  background-color: var(--ids_color_action_primary_variant);
}
:host .ids-slider:disabled {
  --slider-color-primary: ids_color_action_disabled_variant;
  pointer-events: none;
}
:host .ids-slider:disabled::-moz-range-thumb {
  box-shadow: none;
}
:host .ids-slider:disabled::-webkit-slider-thumb {
  box-shadow: none;
}
:host .ids-slider:disabled:focus, :host .ids-slider:disabled:active, :host .ids-slider:disabled:hover {
  color: transparent;
}
:host .ids-slider:disabled.ids-slider--light {
  opacity: 0.6;
}
:host .ids-slider + .ids-slider-range {
  margin-top: calc(var(--ids_size_general_24x) * -1);
  transform: translateY(calc(-1 * calc(calc(2.125rem + var(--ids_spacing_1x)) + var(--ids_size_general_8x)) - var(--ids_spacing_2x)));
}
@keyframes ids-snackbar-fade-in {
  from {
    bottom: 0;
    opacity: var(--ids_motion_opacity_0);
  }
  to {
    bottom: var(--ids-snackbar-bottom);
    opacity: var(--ids_motion_opacity_100);
  }
}
@keyframes ids-snackbar-fade-out {
  from {
    bottom: var(--ids-snackbar-bottom);
    opacity: var(--ids_motion_opacity_100);
  }
  to {
    bottom: 0;
    opacity: var(--ids_motion_opacity_0);
  }
}
:host .ids-snackbar {
  --ids-snackbar-bottom: rem(24);
  --ids-snackbar-duration: 4s;
  align-items: center;
  background: var(--ids_color_feedback_neutral);
  border-radius: var(--ids_size_cornerRadius_snackbar);
  color: var(--ids_color_feedback_neutral_contrast);
  font: var(--ids_textStyle_f02_s14_h20_wrg);
  gap: var(--ids_size_general_12x);
  max-width: 45rem;
  min-width: 17rem;
  padding: var(--ids_size_general_16x);
  /* stylelint-disable-next-line selector-pseudo-class-no-unknown */
}
:host .ids-snackbar:popover-open {
  animation: ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard), ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - 0.18s);
  display: flex;
  inset: auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);
  margin: 0 auto;
  position: fixed;
}
:host .ids-snackbar.\\:popover-open {
  animation: ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard), ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - 0.18s);
  display: flex;
  inset: auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);
  margin: 0 auto;
  position: fixed;
}
:host .ids-snackbar.-warning {
  background: var(--ids_color_feedback_alert);
  color: var(--ids_color_feedback_alert_contrast);
}
:host .ids-snackbar.-success {
  background: var(--ids_color_feedback_success);
  color: var(--ids_color_feedback_success_contrast);
}
:host .ids-snackbar.-error {
  background: var(--ids_color_feedback_error);
  color: var(--ids_color_feedback_error_contrast);
}
:host .ids-snackbar.-information {
  background: var(--ids_color_feedback_information);
  color: var(--ids_color_feedback_information_contrast);
}
:host .ids-snackbar.-on-brand {
  background: var(--ids_color_bg_base);
  color: var(--ids_color_feedback_neutral);
}
@media screen and (min-width: 64rem) {
  :host .ids-snackbar {
    max-width: 100rem;
  }
}
:host .ids-switch {
  align-items: center;
  color: var(--ids_color_text_body_01);
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 0;
  min-height: var(--ids_size_general_48x);
  min-width: var(--ids_size_general_48x);
  position: relative;
}
:host .ids-switch__input {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  background: transparent;
  border: 0;
  display: block;
  width: 100%;
  appearance: none;
  margin: 0;
  appearance: none;
  background-color: transparent;
  border-radius: 0;
  cursor: pointer;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  border: 0;
}
@media (pointer: coarse) {
  :host .ids-switch__input {
    outline: 0 !important;
  }
  :host .ids-switch__input:focus {
    outline: 0 !important;
  }
}
@media (pointer: coarse) and (pointer: fine) {
  :host .ids-switch__input:focus-visible, :host .ids-switch__input:focus.focus-visible {
    outline: 0 !important;
  }
}
@media (pointer: fine) {
  :host .ids-switch__input:focus-visible, :host .ids-switch__input:focus.focus-visible {
    /* stylelint-disable-next-line declaration-no-important */
    outline: revert !important;
  }
}
@media (pointer: fine) and (pointer: fine) {
  :host .ids-switch__input:focus-visible, :host .ids-switch__input:focus.focus-visible {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
}
:host .ids-switch__input:disabled {
  cursor: not-allowed;
}
:host .ids-switch__icon {
  background: transparent;
  border: var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);
  border-radius: var(--ids_size_general_14x);
  display: flex;
  flex-direction: column;
  height: var(--ids_size_general_24x);
  inset: 0;
  justify-content: center;
  pointer-events: none;
  position: relative;
  transition: transform 0.2s, background-color 0.2s;
  width: var(--ids_size_general_40x);
}
:host .ids-switch__icon::before {
  background: var(--ids_color_action_neutral_base);
  border-radius: 50%;
  content: "";
  height: var(--ids_size_general_18x);
  left: var(--ids_size_general_2x);
  position: absolute;
  transition: transform 0.2s, background-color 0.2s;
  width: var(--ids_size_general_18x);
}
:host .ids-switch--on-brand .ids-switch__icon {
  background: transparent;
  border-color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-switch--on-brand .ids-switch__icon::before {
  background: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-switch__input[aria-pressed=true] + .ids-switch__icon, :host .ids-switch__input:checked + .ids-switch__icon {
  background: var(--ids_color_action_primary_base);
  border-color: var(--ids_color_action_primary_base);
}
:host .ids-switch__input[aria-pressed=true] + .ids-switch__icon::before, :host .ids-switch__input:checked + .ids-switch__icon::before {
  background: var(--ids_color_contrast_onBrand_primary);
  transform: translateX(var(--ids_size_general_16x));
}
:host .ids-switch__input:disabled + .ids-switch__icon {
  border-color: var(--ids_color_action_disabled_base);
  cursor: not-allowed;
}
:host .ids-switch__input:disabled + .ids-switch__icon::before {
  background: var(--ids_color_action_disabled_base);
}
:host .ids-switch__input[aria-pressed=true]:disabled + .ids-switch__icon, :host .ids-switch__input:checked:disabled + .ids-switch__icon {
  background: var(--ids_color_action_disabled_base);
  border-color: var(--ids_color_action_disabled_base);
}
:host .ids-switch__input[aria-pressed=true]:disabled + .ids-switch__icon::before, :host .ids-switch__input:checked:disabled + .ids-switch__icon::before {
  background-color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-switch--on-brand .ids-switch__input:disabled + .ids-switch__icon {
  background: transparent;
  border-color: var(--ids_color_contrast_onBrand_primary_medium);
}
:host .ids-switch--on-brand .ids-switch__input:disabled + .ids-switch__icon::before {
  background-color: var(--ids_color_contrast_onBrand_primary_medium);
}
:host .ids-switch--on-brand .ids-switch__input[aria-pressed=true] + .ids-switch__icon, :host .ids-switch--on-brand .ids-switch__input:checked + .ids-switch__icon {
  background: var(--ids_color_contrast_onBrand_primary);
  border-color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-switch--on-brand .ids-switch__input[aria-pressed=true] + .ids-switch__icon::before, :host .ids-switch--on-brand .ids-switch__input:checked + .ids-switch__icon::before {
  background-color: var(--ids_color_action_primary_base);
}
:host .ids-switch--on-brand .ids-switch__input[aria-pressed=true]:disabled + .ids-switch__icon, :host .ids-switch--on-brand .ids-switch__input:checked:disabled + .ids-switch__icon {
  background: var(--ids_color_contrast_onBrand_primary_medium);
  border-color: var(--ids_color_contrast_onBrand_primary_soft);
}
:host .ids-switch--on-brand .ids-switch__input[aria-pressed=true]:disabled + .ids-switch__icon::before, :host .ids-switch--on-brand .ids-switch__input:checked:disabled + .ids-switch__icon::before {
  background: var(--ids_color_contrast_onBrand_primary_strong);
}
:host .ids-table {
  border: 0;
  border-collapse: collapse;
  border-spacing: 0;
  position: relative;
  width: 100%;
  /*
    Quando a table não tem dados a exibir, é colocado uma tr com a classe ids-table__no-data-row e
    dentro uma td com a mensagem de que não tem registros. No handoff, essa mensagem está alinhada a
    esquerda, porém na table com dados, a TD tem o texto centralizado.
    Foi feito isso para garantir o texto a esquerda quando não tem dados a exibir.
  */
}
:host .ids-table th {
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  width: var(--ids_size_general_72x);
  background-color: var(--ids_color_bg_variant_01);
  color: var(--ids_color_text_heading_01);
  font: var(--ids_textStyle_f02_s16_h24_wbd);
  border-bottom: var(--ids_size_general_2x) solid var(--ids_color_border_medium);
  height: var(--ids_size_general_48x);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .ids-table th:hover {
  background-color: var(--ids_color_bg_variant_02);
  color: var(--ids_color_text_heading_01);
}
:host .ids-table th:active {
  background-color: var(--ids_color_action_neutral_base);
  color: var(--ids_color_action_primary_contrast);
}
:host .ids-table th:first-child {
  border-top-left-radius: var(--ids_size_cornerRadius_table);
}
:host .ids-table th:last-child {
  border-top-right-radius: var(--ids_size_cornerRadius_table);
}
:host .ids-table th:not(.ids-sort) {
  padding: 0 var(--ids_spacing_4x);
}
:host .ids-table td {
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  width: var(--ids_size_general_72x);
  background-color: var(--ids_color_bg_base);
  color: var(--ids_color_text_body_02);
  font: var(--ids_textStyle_f02_s16_h24_wrg);
  height: var(--ids_size_general_48x);
  padding: var(--ids_size_general_8x) var(--ids_size_general_24x);
}
:host .ids-table .ids-table__cell--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .ids-table th,
:host .ids-table td {
  min-width: var(--ids_size_general_48x);
  position: relative;
}
:host .ids-table th .ids-checkbox,
:host .ids-table td .ids-checkbox {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
:host .ids-table th .ids-checkbox__input,
:host .ids-table td .ids-checkbox__input {
  outline-offset: -0.0625rem;
}
:host .ids-table--compact td {
  height: var(--ids_size_general_40x);
  padding: var(--ids_size_general_8x) var(--ids_size_general_16x);
}
:host .ids-table--comfortable td {
  height: var(--ids_size_general_64x);
  padding: var(--ids_size_general_8x) var(--ids_size_general_24x);
}
:host .ids-table tfoot td, :host .ids-table__footer-cell {
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  width: var(--ids_size_general_72x);
  background-color: var(--ids_color_bg_variant_01);
  color: var(--ids_color_text_heading_01);
  font: var(--ids_textStyle_f02_s16_h24_wbd);
  border-top: var(--ids_size_general_2x) solid var(--ids_color_border_medium);
}
:host .ids-table tfoot td:hover, :host .ids-table__footer-cell:hover {
  background-color: var(--ids_color_bg_variant_02);
  color: var(--ids_color_text_heading_01);
}
:host .ids-table tfoot td:active, :host .ids-table__footer-cell:active {
  background-color: var(--ids_color_action_neutral_base);
  color: var(--ids_color_action_primary_contrast);
}
:host .ids-table--solid-border td, :host .ids-table--full-border td,
:host .ids-table .ids-table__row--full-border td {
  border: var(--ids_size_general_1x) solid var(--ids_color_border_medium);
}
:host .ids-table--horizontal-border td,
:host .ids-table .ids-table__row--horizontal-border td {
  border-bottom: var(--ids_size_general_1x) solid var(--ids_color_border_medium);
}
:host .ids-table .ids-table__header-row--horizontal-border th {
  border-bottom: var(--ids_size_general_2x) solid var(--ids_color_border_medium);
}
:host .ids-table--no-border th, :host .ids-table--no-border td,
:host .ids-table .ids-table__header-row--no-border th,
:host .ids-table .ids-table__header-row--no-border td,
:host .ids-table .ids-table__footer-row--no-border th,
:host .ids-table .ids-table__footer-row--no-border td,
:host .ids-table .ids-table__row--no-border th,
:host .ids-table .ids-table__row--no-border td {
  border: 0;
}
:host .ids-table .ids-table__header-row--no-background th:not(:hover, :active),
:host .ids-table .ids-table__footer-row--no-background td:not(:hover, :active),
:host .ids-table .ids-table__row--no-background td {
  background-color: transparent;
}
:host .ids-table tbody tr:hover td {
  background-color: var(--ids_color_bg_variant_02);
}
:host .ids-table--zebra-style tr:nth-child(even):not(:hover) td {
  background-color: var(--ids_color_bg_variant_01);
}
:host .ids-table--loading {
  display: flex;
  flex-direction: column;
  gap: var(--ids_spacing_5x);
}
:host .ids-table--loading thead,
:host .ids-table--loading tbody,
:host .ids-table--loading tfoot {
  display: none;
}
:host .ids-table--loading .ids-shimmer {
  height: var(--ids_size_general_40x);
}
:host .ids-table__no-data-row td {
  text-align: left;
}
:host .ids-table-sticky {
  position: sticky;
}
:host .ids-table-sticky-border-elem-left {
  border-right: var(--ids_size_general_1x) solid var(--ids_color_border_medium);
}
:host .ids-table-sticky-border-elem-right {
  border-left: var(--ids_size_general_1x) solid var(--ids_color_border_medium);
}
:host .ids-table-wrapper__table {
  overflow: auto;
}
:host .ids-table-wrapper--outline {
  border: var(--ids_size_border_medium) solid var(--ids_color_border_medium);
  border-radius: var(--ids_size_cornerRadius_table);
}
:host .ids-table-wrapper--outline .ids-table--full-border tr:last-of-type td, :host .ids-table-wrapper--outline .ids-table--solid-border tr:last-of-type td {
  border-bottom: 0;
}
:host .ids-table-wrapper--outline .ids-table--full-border td, :host .ids-table-wrapper--outline .ids-table--solid-border td {
  border-left: 0;
  border-top: 0;
}
:host .ids-table-wrapper--outline .ids-table--full-border td:last-of-type, :host .ids-table-wrapper--outline .ids-table--solid-border td:last-of-type {
  border-right: 0;
}
:host .ids-tag {
  background-color: var(--ids_color_feedback_neutral);
  border: var(--ids_size_border_small) solid var(--ids_color_feedback_neutral);
  border-radius: var(--ids_size_cornerRadius_tags_01);
  box-sizing: border-box;
  color: var(--ids_color_feedback_neutral_contrast);
  display: inline-block;
  font: var(--ids_textStyle_f02_s12_h18_wrg);
  height: var(--ids_size_general_22x);
  padding: var(--ids_size_general_1x) var(--ids_spacing_2x);
  vertical-align: baseline;
  white-space: nowrap;
}
:host .ids-tag.-on-brand {
  background-color: var(--ids_color_bg_base);
  border-color: var(--ids_color_bg_base);
  color: var(--ids_color_feedback_neutral);
}
:host .ids-tag.-error {
  background-color: var(--ids_color_feedback_error);
  border-color: var(--ids_color_feedback_error);
  color: var(--ids_color_feedback_error_contrast);
}
:host .ids-tag.-warning {
  background-color: var(--ids_color_feedback_alert);
  border-color: var(--ids_color_feedback_alert);
  color: var(--ids_color_feedback_alert_contrast);
}
:host .ids-tag.-success {
  background-color: var(--ids_color_feedback_success);
  border-color: var(--ids_color_feedback_success);
  color: var(--ids_color_feedback_success_contrast);
}
:host .ids-tag.-outline {
  background-color: transparent;
  border-color: currentcolor;
  color: var(--ids_color_feedback_neutral);
}
:host .ids-tag.-outline.-on-brand {
  border-color: var(--ids_color_contrast_onBrand_primary);
  color: var(--ids_color_contrast_onBrand_primary);
}
:host .ids-tag.-outline.-error {
  color: var(--ids_color_feedback_error);
}
:host .ids-tag.-outline.-warning {
  color: var(--ids_color_feedback_alert);
}
:host .ids-tag.-outline.-success {
  color: var(--ids_color_feedback_success);
}
@media (min-width: 64rem) {
  :host .ids-tag {
    font: var(--ids_textStyle_f02_s14_h20_wrg);
    height: var(--ids_size_general_24x);
  }
}
:host .ids-tooltip-wrapper,
:host .ids-tooltip-wrapper.ids-icon-button,
:host button.ids-tooltip-wrapper.ids-icon-button {
  position: relative;
}
:host .ids-tooltip-wrapper .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip {
  bottom: 100%;
  left: 50%;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1;
}
:host .ids-tooltip-wrapper .ids-tooltip--end,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--end,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--end {
  left: auto;
  right: calc(50% - var(--ids_size_general_10x));
}
:host .ids-tooltip-wrapper .ids-tooltip--start,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--start,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--start {
  left: calc(50% - var(--ids_size_general_10x));
}
:host .ids-tooltip-wrapper .ids-tooltip--bottom,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--bottom,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--bottom {
  bottom: auto;
  top: 100%;
}
:host .ids-tooltip-wrapper .ids-tooltip--left, :host .ids-tooltip-wrapper .ids-tooltip--right,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right {
  bottom: 50%;
  transform: translateY(50%);
}
:host .ids-tooltip-wrapper .ids-tooltip--left.ids-tooltip--start, :host .ids-tooltip-wrapper .ids-tooltip--right.ids-tooltip--start,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left.ids-tooltip--start,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right.ids-tooltip--start,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left.ids-tooltip--start,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right.ids-tooltip--start {
  bottom: auto;
  top: calc(50% - var(--ids_size_general_10x));
}
:host .ids-tooltip-wrapper .ids-tooltip--left,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--left {
  left: auto;
  right: 100%;
}
:host .ids-tooltip-wrapper .ids-tooltip--right,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--right {
  left: 100%;
}
:host .ids-tooltip-wrapper .ids-tooltip--end, :host .ids-tooltip-wrapper .ids-tooltip--start,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--end,
:host .ids-tooltip-wrapper.ids-icon-button .ids-tooltip--start,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--end,
:host button.ids-tooltip-wrapper.ids-icon-button .ids-tooltip--start {
  transform: initial;
}
:host .ids-tooltip-wrapper:hover:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper:hover:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper:hover:not(.-click) + * .ids-tooltip, :host .ids-tooltip-wrapper.focus-visible:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper.focus-visible:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper.focus-visible:not(.-click) + * .ids-tooltip, :host .ids-tooltip-wrapper:focus-visible:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper:focus-visible:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper:focus-visible:not(.-click) + * .ids-tooltip, :host .ids-tooltip-wrapper:not(.-click) > *:hover .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *:hover + .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *:hover + * .ids-tooltip, :host .ids-tooltip-wrapper:not(.-click) > *.focus-visible .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *.focus-visible + .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *.focus-visible + * .ids-tooltip, :host .ids-tooltip-wrapper:not(.-click) > *:focus-visible .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *:focus-visible + .ids-tooltip,
:host .ids-tooltip-wrapper:not(.-click) > *:focus-visible + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:hover:not(.-click) + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.focus-visible:not(.-click) + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:focus-visible:not(.-click) + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:hover + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *.focus-visible + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button:not(.-click) > *:focus-visible + * .ids-tooltip {
  opacity: 1;
  pointer-events: auto;
}
:host .ids-tooltip-wrapper.-click > *[aria-expanded=true] .ids-tooltip,
:host .ids-tooltip-wrapper.-click > *[aria-expanded=true] + .ids-tooltip,
:host .ids-tooltip-wrapper.-click > *[aria-expanded=true] + * .ids-tooltip, :host .ids-tooltip-wrapper.-click > *:focus:not([aria-expanded=false]) .ids-tooltip,
:host .ids-tooltip-wrapper.-click > *:focus:not([aria-expanded=false]) + .ids-tooltip,
:host .ids-tooltip-wrapper.-click > *:focus:not([aria-expanded=false]) + * .ids-tooltip, :host .ids-tooltip-wrapper.-click[aria-expanded=true] .ids-tooltip,
:host .ids-tooltip-wrapper.-click[aria-expanded=true] + .ids-tooltip,
:host .ids-tooltip-wrapper.-click[aria-expanded=true] + * .ids-tooltip, :host .ids-tooltip-wrapper.-click:focus:not([aria-expanded=false]) .ids-tooltip,
:host .ids-tooltip-wrapper.-click:focus:not([aria-expanded=false]) + .ids-tooltip,
:host .ids-tooltip-wrapper.-click:focus:not([aria-expanded=false]) + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] + * .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) + .ids-tooltip,
:host .ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *[aria-expanded=true] + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click > *:focus:not([aria-expanded=false]) + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click[aria-expanded=true] + * .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) + .ids-tooltip,
:host button.ids-tooltip-wrapper.ids-icon-button.-click:focus:not([aria-expanded=false]) + * .ids-tooltip {
  opacity: 1;
  pointer-events: auto;
}
:host .ids-tracker {
  all: unset;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  all: revert;
  box-sizing: border-box;
  margin: 0;
  padding-left: 0;
  gap: var(--ids_spacing_3x);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
:host .js-no-flexbox-gap .ids-tracker {
  margin: calc(var(--ids_spacing_3x) / -2) !important;
}
:host .js-no-flexbox-gap .ids-tracker > * {
  padding: calc(var(--ids_spacing_3x) / 2) !important;
}
@media (min-width: 48rem) {
  :host .ids-tracker {
    flex-direction: row;
  }
}
:host .ids-tracker--vertical {
  flex-direction: column;
}
@keyframes fade-in {
  0% {
    opacity: var(--ids_motion_opacity_0);
  }
  100% {
    opacity: var(--ids_motion_opacity_100)/100;
  }
}
@keyframes fade-out {
  0% {
    opacity: var(--ids_motion_opacity_100)/100;
  }
  100% {
    opacity: var(--ids_motion_opacity_0);
  }
}
@keyframes up-initial {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes down-initial {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes initial-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
@keyframes initial-down {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
:host .ids-motion-pattern-fade-in {
  animation-duration: var(--ids_motion_time_fast_02);
  animation-name: fade-in;
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
}
:host .ids-motion-pattern-fade-in-up {
  animation-duration: var(--ids_motion_time_slow_01);
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
  animation-name: fade-in, up-initial;
}
:host .ids-motion-pattern-fade-in-down {
  animation-duration: var(--ids_motion_time_slow_01);
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
  animation-name: fade-in, down-initial;
}
:host .ids-motion-pattern-fade-in-slow {
  animation-duration: var(--ids_motion_time_moderate_02);
  animation-name: fade-in;
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
}
:host .ids-motion-pattern-fade-out {
  animation-duration: var(--ids_motion_time_fast_02);
  animation-name: fade-out;
  animation-timing-function: var(--ids_motion_easing_effective_accelerate_standard);
}
:host .ids-motion-pattern-fade-out-up {
  animation-duration: var(--ids_motion_time_fast_03);
  animation-timing-function: var(--ids_motion_easing_effective_accelerate_standard);
  animation-name: fade-out, initial-up;
}
:host .ids-motion-pattern-fade-out-down {
  animation-duration: var(--ids_motion_time_fast_03);
  animation-timing-function: var(--ids_motion_easing_effective_accelerate_standard);
  animation-name: fade-out, initial-down;
}
:host .ids-motion-pattern-fade-out-slow {
  animation-duration: var(--ids_motion_time_moderate_02);
  animation-name: fade-out;
  animation-timing-function: var(--ids_motion_easing_effective_accelerate_standard);
}
@keyframes scale-up {
  0% {
    transform: scale(var(--ids_motion_scale_0));
  }
  100% {
    transform: scale(var(--ids_motion_scale_100)/100);
  }
}
@keyframes scale-down {
  0% {
    transform: scale(var(--ids_motion_scale_100)/100);
  }
  100% {
    transform: scale(var(--ids_motion_scale_0));
  }
}
:host .ids-motion-pattern-scale-up {
  animation-duration: var(--ids_motion_time_fast_03);
  animation-name: scale-up;
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
}
:host .ids-motion-pattern-scale-up-bouncing {
  animation-duration: var(--ids_motion_time_moderate_02);
  animation-name: scale-up;
  animation-timing-function: var(--ids_motion_easing_vivid_decelerate_back);
}
:host .ids-motion-pattern-scale-down {
  animation-duration: var(--ids_motion_time_fast_03);
  animation-name: scale-down;
  animation-timing-function: var(--ids_motion_easing_effective_accelerate_standard);
}
:host .ids-motion-pattern-scale-down-bouncing {
  animation-duration: var(--ids_motion_time_moderate_02);
  animation-name: scale-down;
  animation-timing-function: var(--ids_motion_easing_vivid_accelerate_back);
}
:host .ids-motion-pattern-shake {
  animation-delay: 0s, var(--ids_motion_time_fast_03), calc(var(--ids_motion_time_fast_03) + var(--ids_motion_time_fast_02));
  animation-duration: var(--ids_motion_time_fast_03), var(--ids_motion_time_fast_02), var(--ids_motion_time_fast_02);
  animation-name: move-right, move-left, move-back;
  animation-timing-function: var(--ids_motion_easing_effective_standard);
}
@keyframes move-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(var(--ids_size_general_10x));
  }
}
@keyframes move-left {
  0% {
    transform: translateX(var(--ids_size_general_10x));
  }
  100% {
    transform: translateX(-11px);
  }
}
@keyframes move-back {
  0% {
    transform: translateX(-11px);
  }
  100% {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./node_modules/@ids/styles/scss/functions/_tokens-handler.scss","webpack://./node_modules/@ids/styles/scss/functions/_unit-transform.scss","webpack://./node_modules/@ids/styles/scss/helpers/styles-elements.scss","webpack://./node_modules/@ids/styles/scss/mixins/_media-query.scss","webpack://./node_modules/@ids/styles/scss/mixins/_motion.scss","webpack://./node_modules/@ids/styles/scss/utils/reset.scss","webpack://./node_modules/@ids/styles/scss/utils/reboot.scss","webpack://./node_modules/@ids/styles/scss/utils/background.scss","webpack://./node_modules/@ids/styles/scss/utils/border.scss","webpack://./node_modules/@ids/styles/scss/utils/typography.scss","webpack://./node_modules/@ids/styles/scss/utils/color.scss","webpack://./node_modules/@ids/styles/scss/styles.scss","webpack://./node_modules/@ids/styles/scss/utils/opacity.scss","webpack://./node_modules/@ids/styles/scss/utils/spacing.scss","webpack://./node_modules/@ids/styles/scss/utils/layout.scss","webpack://./node_modules/@ids/styles/scss/mixins/_layout.scss","webpack://./node_modules/@ids/styles/scss/utils/text-align.scss","webpack://./node_modules/@ids/styles/scss/components/chart.scss","webpack://./node_modules/@ids/styles/scss/components/form-field.scss","webpack://./node_modules/@ids/styles/scss/components/snackbar.scss","webpack://./node_modules/@ids/styles/scss/components/table.scss","webpack://./node_modules/@ids/styles/scss/components/tooltip-wrapper.scss","webpack://./node_modules/@ids/styles/scss/helpers/_a11y.scss","webpack://./node_modules/@ids/styles/scss/mixins/_reset.scss","webpack://./node_modules/@ids/styles/scss/mixins/_attributes.scss","webpack://./node_modules/@ids/styles/scss/mixins/_selectors.scss","webpack://./node_modules/@ids/tokens/tokens.scss","webpack://./node_modules/@ids/styles/scss/mixins/_display.scss","webpack://./node_modules/@ids/styles/scss/mixins/_flex.scss","webpack://./node_modules/@ids/styles/scss/utils/animation.scss","webpack://./node_modules/@ids/styles/scss/components/banner-highlight.scss","webpack://./node_modules/@ids/styles/scss/mixins/_support.scss","webpack://./node_modules/@ids/styles/scss/components/brand.scss","webpack://./node_modules/@ids/styles/scss/components/bottom-sheet.scss","webpack://./node_modules/@ids/styles/scss/components/box-field.scss","webpack://./node_modules/@ids/styles/scss/components/calendar.scss","webpack://./node_modules/@ids/styles/scss/components/card-base.scss","webpack://./node_modules/@ids/styles/scss/components/card.scss","webpack://./node_modules/@ids/styles/scss/mixins/_border.scss","webpack://./node_modules/@ids/styles/scss/components/checkbox.scss","webpack://./node_modules/@ids/styles/scss/mixins/components/_input-for-selectors.scss","webpack://./node_modules/@ids/styles/scss/components/datepicker.scss","webpack://./node_modules/@ids/styles/scss/components/divider.scss","webpack://./node_modules/@ids/styles/scss/components/form-selection.scss","webpack://./node_modules/@ids/styles/scss/components/icon.scss","webpack://./node_modules/@ids/styles/scss/components/image.scss","webpack://./node_modules/@ids/styles/scss/components/input.scss","webpack://./node_modules/@ids/styles/scss/components/link.scss","webpack://./node_modules/@ids/styles/scss/components/listbox.scss","webpack://./node_modules/@ids/styles/scss/components/modal.scss","webpack://./node_modules/@ids/styles/scss/components/overlay.scss","webpack://./node_modules/@ids/styles/scss/components/password.scss","webpack://./node_modules/@ids/styles/scss/components/radio-button.scss","webpack://./node_modules/@ids/styles/scss/components/slider.scss","webpack://./node_modules/@ids/styles/scss/components/switch.scss","webpack://./node_modules/@ids/styles/scss/mixins/components/_table.scss","webpack://./node_modules/@ids/styles/scss/components/tag.scss","webpack://./node_modules/@ids/styles/scss/mixins/components/_tag.scss","webpack://./node_modules/@ids/styles/scss/components/tracker.scss","webpack://./node_modules/@ids/styles/scss/mixins/_animations.scss","webpack://./node_modules/@ids/styles/scss/motion/fading.scss","webpack://./node_modules/@ids/styles/scss/motion/scaling.scss","webpack://./node_modules/@ids/styles/scss/motion/shake.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACU,0CAAA;ECDV;;GAAA;ECAA;;GAAA;ECAA,+CAAA;ECAA;;GAAA;ECAA,qEAAA;EAEA;;GAAA;ECFA,qBAAA;EASA,kFAAA;EAiGA,0BAAA;EAkBA,2BAAA;EAUA,oEAAA;EASA,0DAAA;EAKA,oCAAA;EAKA,mDAAA;EAKA,yCAAA;EAQA,iFAAA;ECtKA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;EAAA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;ECAA;;GAAA;EHAA;;GAAA;EIAA;;GAAA;ECAA;;GAAA;EdAA,+CAAA;EAAA,+CAAA;EeAA,+CAAA;EfAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EgBAA,gDAAA;EhBAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,+CAAA;EiBAA,qEAAA;EjBAA,+CAAA;EkBAA,gDAAA;ECAA,gDAAA;EACA,kDAAA;EnBDA,+CAAA;EHGU,kDAAA;AAoFV;AuB7EA;EACE,sBAAA;EACA,oBAAA;EACA,eAAA;AvB+EF;AGzFA;EACE,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;EACA,oBAAA;AH2FF;AGxFA;EqBKE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AxBiEF;AwBhHE;ErBcF;IsBdE,qBAAA;EzBoHA;EyBlHA;IACE,qBAAA;EzBoHF;AACF;A0B3EE;EACE;IDvCA,qBAAA;EzBqHF;AACF;A0BhFE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExB0HF;AACF;AyBvHE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBwHF;AACF;AGvHA;EACE,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;AHyHF;AMzJA;;;EAGE,sBAAA;EACA,SAAA;EACA,UAAA;AN2JF;AMvJA;;EAEE,gBAAA;EACA,UAAA;ANyJF;AMtJA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkFE,SAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ANwJF;AMpJA;;;;;;;;;;;;;;EAcE,SAAA;ANsJF;AMlJA;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,6BAAA;ANmJF;AM/IA;;;;;EAKE,wCAAA;ANiJF;AM7IA;EACE,iCAAA;UAAA,8BAAA;AN+IF;AM3IA;EACE,eAAA;AN6IF;AMzIA;EACE,eAAA;AN2IF;AMvIA;;;;EAIE,aAAA;ANyIF;AMrIA;EACE;IACE,0BAAA;IACA,4BAAA;IACA,qBAAA;IACA,2BAAA;ENuIF;AACF;AMjIA;EACE;IACE,aAAA;ENmIF;AACF;AMhIA;EACE;IACE,aAAA;ENkIF;AACF;AOzTA;EACE,oCoB0DuB;EpBzDvB,0CoBsV8B;A3B3BhC;AOxTA;EACE,0CoBmU8B;A3BThC;AOvTA;EACE,0CoB8T8B;A3BLhC;AOtTA;EACE,0CoB0T8B;A3BFhC;AOrTA;EACE,0CoBqT8B;A3BEhC;AQtUA;EACE,+CAAA;ARwUF;AQpUA;EACE,qDAAA;ARsUF;AQlUA;EACE,qDAAA;ARoUF;AQhUA;EACE,wDAAA;ARkUF;AQ9TA;EACE,0DAAA;ARgUF;AQ5TA;EACE,yDAAA;AR8TF;ASxVA;EACE,uDAAA;EACA,8BAAA;EACA,sDAAA;AT0VF;AStVA;EACE,uDAAA;EACA,8BAAA;EACA,0DAAA;ATwVF;ASpVA;EACE,6DAAA;EACA,uDAAA;EACA,8BAAA;ATsVF;ASlVA;EACE,uDAAA;EACA,2DAAA;EACA,8BAAA;AToVF;AShVA;EACE,uDAAA;EACA,4DAAA;EACA,8BAAA;ATkVF;AS9UA;EACE,8BAAA;EACA,qDAAA;ATgVF;AS5UA;EACE,8BAAA;EACA,yDAAA;AT8UF;AS1UA;EACE,4DAAA;EACA,8BAAA;AT4UF;ASxUA;EACE,0DAAA;EACA,8BAAA;AT0UF;AStUA;EACE,2DAAA;EACA,8BAAA;ATwUF;ASpUA;EACE,8BAAA;EACA,qDAAA;ATsUF;ASlUA;EACE,8BAAA;EACA,yDAAA;AToUF;AShUA;EACE,4DAAA;EACA,8BAAA;ATkUF;AS9TA;EACE,0DAAA;EACA,8BAAA;ATgUF;AS5TA;EACE,2DAAA;EACA,8BAAA;AT8TF;AS1TA;EACE,qDAAA;AT4TF;ASxTA;EACE,uDAAA;AT0TF;AStTA;EACE,uDAAA;ATwTF;ASpTA;EACE,gEAAA;ATsTF;ASlTA;EACE,gEAAA;AToTF;AShTA;EACE,uBAAA;ATkTF;AS9SA;EACE,2BAAA;ATgTF;AS5SA;EACE,8BAAA;AT8SF;AS1SA;EACE,4BAAA;AT4SF;ASxSA;EACE,6BAAA;AT0SF;AUvbA;EACE,kDAAA;EACA,qDAAA;AVybF;AUvbE;EACE,qDAAA;AVybJ;AUtbE;EACE,iDAAA;AVwbJ;AUrbE;EACE,2DAAA;AVubJ;AUhbA;EACE,qDAAA;AVkbF;AUhbE;EACE,iDAAA;AVkbJ;AU/aE;EACE,2DAAA;AVibJ;AU5aA;EACE,kDAAA;EACA,qDAAA;AV8aF;AU5aE;EACE,qDAAA;AV8aJ;AU3aE;EACE,iDAAA;AV6aJ;AU1aE;EACE,2DAAA;AV4aJ;AUzaE;EACE,qDAAA;AV2aJ;AUxaE;EACE,qDAAA;AV0aJ;AUxaI;EACE,qDAAA;AV0aN;AUtaE;EACE,qDAAA;AVwaJ;AUtaI;EACE,qDAAA;AVwaN;AUpaE;EACE,sDAAA;AVsaJ;AUpaI;EACE,sDAAA;AVsaN;AUhaA;EACE,kDAAA;EACA,qDAAA;AVkaF;AUhaE;EACE,2DAAA;AVkaJ;AU/ZE;EACE,qDAAA;AViaJ;AU9ZE;EACE,qDAAA;AVgaJ;AU7ZE;EACE,qDAAA;AV+ZJ;AU5ZE;EACE,qDAAA;AV8ZJ;AUzZA;EACE,uCiB1D0B;EjB2D1B,qDAAA;AV2ZF;AUzZE;EACE,qDAAA;AV2ZJ;AUxZE;EACE,gDiBMiC;A3BoZrC;AUpZA;EACE,kDAAA;EACA,qDAAA;AVsZF;AUpZE;EACE,2DAAA;AVsZJ;AU/YA;EACE,kDAAA;EACA,qDAAA;AViZF;AU/YE;EACE,2DAAA;AViZJ;AU5YA;EACE,+CAAA;EACA,qDAAA;AV8YF;AU5YE;EACE,qDAAA;AV8YJ;AU3YE;EACE,+CAAA;AV6YJ;AU1YE;EACE,2DAAA;AV4YJ;AUzYE;EACE,qDAAA;AV2YJ;AUzYI;EACE,qDAAA;AV2YN;AUvYE;EACE,qDAAA;AVyYJ;AUvYI;EACE,qDAAA;AVyYN;AUrYE;EACE,qDAAA;AVuYJ;AUrYI;EACE,qDAAA;AVuYN;AUjYA;EACE,wCiBzB2B;EjB0B3B,0CiB2J8B;A3BwOhC;AUjYE;EACE,qDAAA;AVmYJ;AUhYE;EACE,uDAAA;AVkYJ;AU/XE;EACE,mDAAA;AViYJ;AU9XE;EACE,iDAAA;AVgYJ;AU7XE;EACE,iDAAA;AV+XJ;AU5XE;EACE,2DAAA;AV8XJ;AU3XE;EACE,0DAAA;AV6XJ;AU1XE;EACE,qDAAA;AV4XJ;AU1XI;EACE,qDAAA;AV4XN;AUxXE;EACE,qDAAA;AV0XJ;AUxXI;EACE,qDAAA;AV0XN;AUtXE;EACE,qDAAA;AVwXJ;AUtXI;EACE,qDAAA;AVwXN;AUpXE;EACE,qDAAA;AVsXJ;AUpXI;EACE,qDAAA;AVsXN;AUhXA;EACE,gDAAA;AVkXF;AU9WA;EACE,iDAAA;AVgXF;AU5WA;EACE,gDAAA;AV8WF;AUxWA;EACE,mDAAA;AV0WF;AUpWA;EACE,sDAAA;AVsWF;AUhWA;EACE,gDAAA;AVkWF;AU5VA;EACE,gDAAA;AV8VF;AUxVA;EACE,8CAAA;AV0VF;AUpVA;EACE,iDAAA;AVsVF;AUhVA;EACE,qDAAA;AVkVF;AU5UA;EACE,kDAAA;AV8UF;AUxUA;EACE,qDAAA;AV0UF;AUpUA;EACE,kDAAA;AVsUF;AUhUA;EACE,qDAAA;AVkUF;AU5TA;EACE,kDAAA;AV8TF;AUxTA;EACE,qDAAA;AV0TF;AUpTA;EACE,kDAAA;AVsTF;AUhTA;EACE,0DAAA;AVkTF;AU5SA;EACE,uDAAA;AV8SF;AUxSA;EACE,yDAAA;AV0SF;AUpSA;EACE,sDAAA;AVsSF;AUhSA;EACE,0DAAA;AVkSF;AU5RA;EACE,uDAAA;AV8RF;AUxRA;EACE,yDAAA;AV0RF;AUpRA;EACE,sDAAA;AVsRF;AUhRA;EACE,0DAAA;AVkRF;AU5QA;EACE,uDAAA;AV8QF;AW3rBA;EACE,kDAAA;AX6rBF;AWzrBA;EACE,kDAAA;AX2rBF;AWvrBA;EACE,+CAAA;AXyrBF;AWrrBA;EACE,+CAAA;AXurBF;AWnrBA;EACE,iDAAA;AXqrBF;A4BlrBQ;EACE,yDAAA;EACA,yBAAA;A5BorBV;A4BtrBQ;EACE,yDAAA;EACA,wBAAA;A5BwrBV;A4B1rBQ;EACE,yDAAA;EACA,wBAAA;A5B4rBV;A4B9rBQ;EACE,yDAAA;EACA,gCAAA;A5BgsBV;A4BlsBQ;EACE,yDAAA;EACA,+BAAA;A5BosBV;A4BtsBQ;EACE,yDAAA;EACA,+BAAA;A5BwsBV;A4B1sBQ;EACE,yDAAA;EACA,wBAAA;A5B4sBV;A4B9sBQ;EACE,yDAAA;EACA,8BAAA;A5BgtBV;A4BltBQ;EACE,yDAAA;EACA,6BAAA;A5BotBV;A4BttBQ;EACE,yDAAA;EACA,yBAAA;A5BwtBV;AI5pBE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5BktBV;AACF;AIlqBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5BwtBV;AACF;AIxqBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5B8tBV;AACF;AI9qBE;EwBnDQ;IACE,yDAAA;IACA,gCAAA;E5BouBV;AACF;AIprBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5B0uBV;AACF;AI1rBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5BgvBV;AACF;AIhsBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5BsvBV;AACF;AItsBE;EwBnDQ;IACE,yDAAA;IACA,8BAAA;E5B4vBV;AACF;AI5sBE;EwBnDQ;IACE,yDAAA;IACA,6BAAA;E5BkwBV;AACF;AIltBE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5BwwBV;AACF;AIxtBE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5B8wBV;AACF;AI9tBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5BoxBV;AACF;AIpuBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5B0xBV;AACF;AI1uBE;EwBnDQ;IACE,yDAAA;IACA,gCAAA;E5BgyBV;AACF;AIhvBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5BsyBV;AACF;AItvBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5B4yBV;AACF;AI5vBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5BkzBV;AACF;AIlwBE;EwBnDQ;IACE,yDAAA;IACA,8BAAA;E5BwzBV;AACF;AIxwBE;EwBnDQ;IACE,yDAAA;IACA,6BAAA;E5B8zBV;AACF;AI9wBE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5Bo0BV;AACF;AIpxBE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5B00BV;AACF;AI1xBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5Bg1BV;AACF;AIhyBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5Bs1BV;AACF;AItyBE;EwBnDQ;IACE,yDAAA;IACA,gCAAA;E5B41BV;AACF;AI5yBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5Bk2BV;AACF;AIlzBE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5Bw2BV;AACF;AIxzBE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5B82BV;AACF;AI9zBE;EwBnDQ;IACE,yDAAA;IACA,8BAAA;E5Bo3BV;AACF;AIp0BE;EwBnDQ;IACE,yDAAA;IACA,6BAAA;E5B03BV;AACF;AI10BE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5Bg4BV;AACF;AIh1BE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5Bs4BV;AACF;AIt1BE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5B44BV;AACF;AI51BE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5Bk5BV;AACF;AIl2BE;EwBnDQ;IACE,yDAAA;IACA,gCAAA;E5Bw5BV;AACF;AIx2BE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5B85BV;AACF;AI92BE;EwBnDQ;IACE,yDAAA;IACA,+BAAA;E5Bo6BV;AACF;AIp3BE;EwBnDQ;IACE,yDAAA;IACA,wBAAA;E5B06BV;AACF;AI13BE;EwBnDQ;IACE,yDAAA;IACA,8BAAA;E5Bg7BV;AACF;AIh4BE;EwBnDQ;IACE,yDAAA;IACA,6BAAA;E5Bs7BV;AACF;AIt4BE;EwBnDQ;IACE,yDAAA;IACA,yBAAA;E5B47BV;AACF;A6Bj7Bc;EACE,yDAAA;EACA,8BAAA;A7Bm7BhB;A6Br7Bc;EACE,yDAAA;EACA,sCAAA;A7Bu7BhB;A6Bz7Bc;EACE,yDAAA;EACA,iCAAA;A7B27BhB;A6B77Bc;EACE,yDAAA;EACA,yCAAA;A7B+7BhB;A6Bj8Bc;EACE,yDAAA;EACA,4BAAA;A7Bm8BhB;A6Br8Bc;EACE,yDAAA;EACA,0BAAA;A7Bu8BhB;A6Bz8Bc;EACE,yDAAA;EACA,kCAAA;A7B28BhB;A6B78Bc;EACE,yDAAA;EACA,uBAAA;A7B+8BhB;A6Bj9Bc;EACE,yDAAA;EACA,uBAAA;A7Bm9BhB;A6Br9Bc;EACE,yDAAA;EACA,yBAAA;A7Bu9BhB;A6Bz9Bc;EACE,yDAAA;EACA,yBAAA;A7B29BhB;A6B77BY;EACE,yDAAA;EACA,yBAAA;A7B+7Bd;A6Bj8BY;EACE,yDAAA;EACA,sCAAA;A7Bm8Bd;A6Br8BY;EACE,yDAAA;EACA,oCAAA;A7Bu8Bd;A6Bz8BY;EACE,yDAAA;EACA,kCAAA;A7B28Bd;A6B78BY;EACE,yDAAA;EACA,yCAAA;A7B+8Bd;A6Bj9BY;EACE,yDAAA;EACA,wCAAA;A7Bm9Bd;A6Br9BY;EACE,yDAAA;EACA,wCAAA;A7Bu9Bd;A6Bz9BY;EACE,yDAAA;EACA,kCAAA;A7B29Bd;A6B79BY;EACE,yDAAA;EACA,gCAAA;A7B+9Bd;A6Bj+BY;EACE,yDAAA;EACA,8BAAA;A7Bm+Bd;A6Br+BY;EACE,yDAAA;EACA,gCAAA;A7Bu+Bd;A6Bz+BY;EACE,yDAAA;EACA,+BAAA;A7B2+Bd;A6B7+BY;EACE,yDAAA;EACA,iCAAA;A7B++Bd;A6Bj/BY;EACE,yDAAA;EACA,+BAAA;A7Bm/Bd;A6Br/BY;EACE,yDAAA;EACA,6BAAA;A7Bu/Bd;A6Bz/BY;EACE,yDAAA;EACA,+BAAA;A7B2/Bd;A6B7/BY;EACE,yDAAA;EACA,8BAAA;A7B+/Bd;A6BjgCY;EACE,yDAAA;EACA,oCAAA;A7BmgCd;A6BrgCY;EACE,yDAAA;EACA,kCAAA;A7BugCd;A6BzgCY;EACE,yDAAA;EACA,gCAAA;A7B2gCd;A6B7gCY;EACE,yDAAA;EACA,uCAAA;A7B+gCd;A6BjhCY;EACE,yDAAA;EACA,sCAAA;A7BmhCd;A6BrhCY;EACE,yDAAA;EACA,sCAAA;A7BuhCd;A6BzhCY;EACE,yDAAA;EACA,iCAAA;A7B2hCd;AIxhCE;EyBhBc;IACE,yDAAA;IACA,8BAAA;E7B2iChB;AACF;AI9hCE;EyBhBc;IACE,yDAAA;IACA,sCAAA;E7BijChB;AACF;AIpiCE;EyBhBc;IACE,yDAAA;IACA,iCAAA;E7BujChB;AACF;AI1iCE;EyBhBc;IACE,yDAAA;IACA,yCAAA;E7B6jChB;AACF;AIhjCE;EyBhBc;IACE,yDAAA;IACA,4BAAA;E7BmkChB;AACF;AItjCE;EyBhBc;IACE,yDAAA;IACA,0BAAA;E7BykChB;AACF;AI5jCE;EyBhBc;IACE,yDAAA;IACA,kCAAA;E7B+kChB;AACF;AIlkCE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7BqlChB;AACF;AIxkCE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7B2lChB;AACF;AI9kCE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7BimChB;AACF;AIplCE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7BumChB;AACF;AI1lCE;EyBMY;IACE,yDAAA;IACA,yBAAA;E7BulCd;AACF;AIhmCE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B6lCd;AACF;AItmCE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BmmCd;AACF;AI5mCE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BymCd;AACF;AIlnCE;EyBMY;IACE,yDAAA;IACA,yCAAA;E7B+mCd;AACF;AIxnCE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7BqnCd;AACF;AI9nCE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7B2nCd;AACF;AIpoCE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BioCd;AACF;AI1oCE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7BuoCd;AACF;AIhpCE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7B6oCd;AACF;AItpCE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7BmpCd;AACF;AI5pCE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BypCd;AACF;AIlqCE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7B+pCd;AACF;AIxqCE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BqqCd;AACF;AI9qCE;EyBMY;IACE,yDAAA;IACA,6BAAA;E7B2qCd;AACF;AIprCE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BirCd;AACF;AI1rCE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7BurCd;AACF;AIhsCE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7B6rCd;AACF;AItsCE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BmsCd;AACF;AI5sCE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7BysCd;AACF;AIltCE;EyBMY;IACE,yDAAA;IACA,uCAAA;E7B+sCd;AACF;AIxtCE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7BqtCd;AACF;AI9tCE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B2tCd;AACF;AIpuCE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7BiuCd;AACF;AI1uCE;EyBhBc;IACE,yDAAA;IACA,8BAAA;E7B6vChB;AACF;AIhvCE;EyBhBc;IACE,yDAAA;IACA,sCAAA;E7BmwChB;AACF;AItvCE;EyBhBc;IACE,yDAAA;IACA,iCAAA;E7BywChB;AACF;AI5vCE;EyBhBc;IACE,yDAAA;IACA,yCAAA;E7B+wChB;AACF;AIlwCE;EyBhBc;IACE,yDAAA;IACA,4BAAA;E7BqxChB;AACF;AIxwCE;EyBhBc;IACE,yDAAA;IACA,0BAAA;E7B2xChB;AACF;AI9wCE;EyBhBc;IACE,yDAAA;IACA,kCAAA;E7BiyChB;AACF;AIpxCE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7BuyChB;AACF;AI1xCE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7B6yChB;AACF;AIhyCE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7BmzChB;AACF;AItyCE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7ByzChB;AACF;AI5yCE;EyBMY;IACE,yDAAA;IACA,yBAAA;E7ByyCd;AACF;AIlzCE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B+yCd;AACF;AIxzCE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BqzCd;AACF;AI9zCE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7B2zCd;AACF;AIp0CE;EyBMY;IACE,yDAAA;IACA,yCAAA;E7Bi0Cd;AACF;AI10CE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7Bu0Cd;AACF;AIh1CE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7B60Cd;AACF;AIt1CE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7Bm1Cd;AACF;AI51CE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7By1Cd;AACF;AIl2CE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7B+1Cd;AACF;AIx2CE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7Bq2Cd;AACF;AI92CE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7B22Cd;AACF;AIp3CE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7Bi3Cd;AACF;AI13CE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7Bu3Cd;AACF;AIh4CE;EyBMY;IACE,yDAAA;IACA,6BAAA;E7B63Cd;AACF;AIt4CE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7Bm4Cd;AACF;AI54CE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7By4Cd;AACF;AIl5CE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7B+4Cd;AACF;AIx5CE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7Bq5Cd;AACF;AI95CE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7B25Cd;AACF;AIp6CE;EyBMY;IACE,yDAAA;IACA,uCAAA;E7Bi6Cd;AACF;AI16CE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7Bu6Cd;AACF;AIh7CE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B66Cd;AACF;AIt7CE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7Bm7Cd;AACF;AI57CE;EyBhBc;IACE,yDAAA;IACA,8BAAA;E7B+8ChB;AACF;AIl8CE;EyBhBc;IACE,yDAAA;IACA,sCAAA;E7Bq9ChB;AACF;AIx8CE;EyBhBc;IACE,yDAAA;IACA,iCAAA;E7B29ChB;AACF;AI98CE;EyBhBc;IACE,yDAAA;IACA,yCAAA;E7Bi+ChB;AACF;AIp9CE;EyBhBc;IACE,yDAAA;IACA,4BAAA;E7Bu+ChB;AACF;AI19CE;EyBhBc;IACE,yDAAA;IACA,0BAAA;E7B6+ChB;AACF;AIh+CE;EyBhBc;IACE,yDAAA;IACA,kCAAA;E7Bm/ChB;AACF;AIt+CE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7By/ChB;AACF;AI5+CE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7B+/ChB;AACF;AIl/CE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7BqgDhB;AACF;AIx/CE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7B2gDhB;AACF;AI9/CE;EyBMY;IACE,yDAAA;IACA,yBAAA;E7B2/Cd;AACF;AIpgDE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7BigDd;AACF;AI1gDE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BugDd;AACF;AIhhDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7B6gDd;AACF;AIthDE;EyBMY;IACE,yDAAA;IACA,yCAAA;E7BmhDd;AACF;AI5hDE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7ByhDd;AACF;AIliDE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7B+hDd;AACF;AIxiDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BqiDd;AACF;AI9iDE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7B2iDd;AACF;AIpjDE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7BijDd;AACF;AI1jDE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7BujDd;AACF;AIhkDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7B6jDd;AACF;AItkDE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7BmkDd;AACF;AI5kDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BykDd;AACF;AIllDE;EyBMY;IACE,yDAAA;IACA,6BAAA;E7B+kDd;AACF;AIxlDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BqlDd;AACF;AI9lDE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7B2lDd;AACF;AIpmDE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BimDd;AACF;AI1mDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BumDd;AACF;AIhnDE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7B6mDd;AACF;AItnDE;EyBMY;IACE,yDAAA;IACA,uCAAA;E7BmnDd;AACF;AI5nDE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7BynDd;AACF;AIloDE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B+nDd;AACF;AIxoDE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7BqoDd;AACF;AI9oDE;EyBhBc;IACE,yDAAA;IACA,8BAAA;E7BiqDhB;AACF;AIppDE;EyBhBc;IACE,yDAAA;IACA,sCAAA;E7BuqDhB;AACF;AI1pDE;EyBhBc;IACE,yDAAA;IACA,iCAAA;E7B6qDhB;AACF;AIhqDE;EyBhBc;IACE,yDAAA;IACA,yCAAA;E7BmrDhB;AACF;AItqDE;EyBhBc;IACE,yDAAA;IACA,4BAAA;E7ByrDhB;AACF;AI5qDE;EyBhBc;IACE,yDAAA;IACA,0BAAA;E7B+rDhB;AACF;AIlrDE;EyBhBc;IACE,yDAAA;IACA,kCAAA;E7BqsDhB;AACF;AIxrDE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7B2sDhB;AACF;AI9rDE;EyBhBc;IACE,yDAAA;IACA,uBAAA;E7BitDhB;AACF;AIpsDE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7ButDhB;AACF;AI1sDE;EyBhBc;IACE,yDAAA;IACA,yBAAA;E7B6tDhB;AACF;AIhtDE;EyBMY;IACE,yDAAA;IACA,yBAAA;E7B6sDd;AACF;AIttDE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7BmtDd;AACF;AI5tDE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BytDd;AACF;AIluDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7B+tDd;AACF;AIxuDE;EyBMY;IACE,yDAAA;IACA,yCAAA;E7BquDd;AACF;AI9uDE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7B2uDd;AACF;AIpvDE;EyBMY;IACE,yDAAA;IACA,wCAAA;E7BivDd;AACF;AI1vDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7BuvDd;AACF;AIhwDE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7B6vDd;AACF;AItwDE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7BmwDd;AACF;AI5wDE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7BywDd;AACF;AIlxDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7B+wDd;AACF;AIxxDE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7BqxDd;AACF;AI9xDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7B2xDd;AACF;AIpyDE;EyBMY;IACE,yDAAA;IACA,6BAAA;E7BiyDd;AACF;AI1yDE;EyBMY;IACE,yDAAA;IACA,+BAAA;E7BuyDd;AACF;AIhzDE;EyBMY;IACE,yDAAA;IACA,8BAAA;E7B6yDd;AACF;AItzDE;EyBMY;IACE,yDAAA;IACA,oCAAA;E7BmzDd;AACF;AI5zDE;EyBMY;IACE,yDAAA;IACA,kCAAA;E7ByzDd;AACF;AIl0DE;EyBMY;IACE,yDAAA;IACA,gCAAA;E7B+zDd;AACF;AIx0DE;EyBMY;IACE,yDAAA;IACA,uCAAA;E7Bq0Dd;AACF;AI90DE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7B20Dd;AACF;AIp1DE;EyBMY;IACE,yDAAA;IACA,sCAAA;E7Bi1Dd;AACF;AI11DE;EyBMY;IACE,yDAAA;IACA,iCAAA;E7Bu1Dd;AACF;Aat7DA;EACE,4CAAA;Abw7DF;Aap7DA;EACE,2CAAA;Abs7DF;Aal7DA;EACE,6CAAA;Abo7DF;Aah7DA;EACE,6CAAA;Abk7DF;Aa96DA;EACE,2CAAA;Abg7DF;Acr8DA;EACE,4BAAA;EACA,6BAAA;Adu8DF;Acn8DA;EACE,qBAAA;Adq8DF;Acj8DA;EACE,0BAAA;EACA,2BAAA;Adm8DF;Ac/7DA;EACE,4BAAA;EACA,yBAAA;Adi8DF;Ac77DA;EACE,yBAAA;Ad+7DF;Ac37DA;EACE,4BAAA;Ad67DF;Acz7DA;EACE,0BAAA;Ad27DF;Acv7DA;EACE,2BAAA;Ady7DF;Acr7DA;EACE,yCAAA;Adu7DF;Acn7DA;EACE,8CAAA;EACA,+CAAA;Adq7DF;Acj7DA;EACE,gDAAA;EACA,6CAAA;Adm7DF;Ac/6DA;EACE,6CAAA;Adi7DF;Ac76DA;EACE,gDAAA;Ad+6DF;Ac36DA;EACE,8CAAA;Ad66DF;Acz6DA;EACE,+CAAA;Ad26DF;Acv6DA;EACE,yCAAA;Ady6DF;Acr6DA;EACE,8CAAA;EACA,+CAAA;Adu6DF;Acn6DA;EACE,gDAAA;EACA,6CAAA;Adq6DF;Acj6DA;EACE,6CAAA;Adm6DF;Ac/5DA;EACE,gDAAA;Adi6DF;Ac75DA;EACE,8CAAA;Ad+5DF;Ac35DA;EACE,+CAAA;Ad65DF;Acz5DA;EACE,yCAAA;Ad25DF;Acv5DA;EACE,8CAAA;EACA,+CAAA;Ady5DF;Acr5DA;EACE,gDAAA;EACA,6CAAA;Adu5DF;Acn5DA;EACE,6CAAA;Adq5DF;Acj5DA;EACE,gDAAA;Adm5DF;Ac/4DA;EACE,8CAAA;Adi5DF;Ac74DA;EACE,+CAAA;Ad+4DF;Ac34DA;EACE,yCAAA;Ad64DF;Acz4DA;EACE,8CAAA;EACA,+CAAA;Ad24DF;Acv4DA;EACE,gDAAA;EACA,6CAAA;Ady4DF;Acr4DA;EACE,6CAAA;Adu4DF;Acn4DA;EACE,gDAAA;Adq4DF;Acj4DA;EACE,8CAAA;Adm4DF;Ac/3DA;EACE,+CAAA;Adi4DF;Ac73DA;EACE,yCAAA;Ad+3DF;Ac33DA;EACE,8CAAA;EACA,+CAAA;Ad63DF;Acz3DA;EACE,gDAAA;EACA,6CAAA;Ad23DF;Acv3DA;EACE,6CAAA;Ady3DF;Acr3DA;EACE,gDAAA;Adu3DF;Acn3DA;EACE,8CAAA;Adq3DF;Acj3DA;EACE,+CAAA;Adm3DF;Ac/2DA;EACE,yCAAA;Adi3DF;Ac72DA;EACE,8CAAA;EACA,+CAAA;Ad+2DF;Ac32DA;EACE,gDAAA;EACA,6CAAA;Ad62DF;Acz2DA;EACE,6CAAA;Ad22DF;Acv2DA;EACE,gDAAA;Ady2DF;Acr2DA;EACE,8CAAA;Adu2DF;Acn2DA;EACE,+CAAA;Adq2DF;Acj2DA;EACE,yCAAA;Adm2DF;Ac/1DA;EACE,8CAAA;EACA,+CAAA;Adi2DF;Ac71DA;EACE,gDAAA;EACA,6CAAA;Ad+1DF;Ac31DA;EACE,6CAAA;Ad61DF;Acz1DA;EACE,gDAAA;Ad21DF;Acv1DA;EACE,8CAAA;Ady1DF;Acr1DA;EACE,+CAAA;Adu1DF;Acn1DA;EACE,0CAAA;Adq1DF;Acj1DA;EACE,+CAAA;EACA,gDAAA;Adm1DF;Ac/0DA;EACE,iDAAA;EACA,8CAAA;Adi1DF;Ac70DA;EACE,8CAAA;Ad+0DF;Ac30DA;EACE,iDAAA;Ad60DF;Acz0DA;EACE,+CAAA;Ad20DF;Acv0DA;EACE,gDAAA;Ady0DF;Acr0DA;EACE,0CAAA;Adu0DF;Acn0DA;EACE,+CAAA;EACA,gDAAA;Adq0DF;Acj0DA;EACE,iDAAA;EACA,8CAAA;Adm0DF;Ac/zDA;EACE,8CAAA;Adi0DF;Ac7zDA;EACE,iDAAA;Ad+zDF;Ac3zDA;EACE,+CAAA;Ad6zDF;AczzDA;EACE,gDAAA;Ad2zDF;AcvzDA;EACE,0CAAA;AdyzDF;AcrzDA;EACE,+CAAA;EACA,gDAAA;AduzDF;AcnzDA;EACE,iDAAA;EACA,8CAAA;AdqzDF;AcjzDA;EACE,8CAAA;AdmzDF;Ac/yDA;EACE,iDAAA;AdizDF;Ac7yDA;EACE,+CAAA;Ad+yDF;Ac3yDA;EACE,gDAAA;Ad6yDF;AczyDA;EACE,oBAAA;Ad2yDF;AcvyDA;EACE,yBAAA;EACA,0BAAA;AdyyDF;AcryDA;EACE,2BAAA;EACA,wBAAA;AduyDF;AcnyDA;EACE,wBAAA;AdqyDF;AcjyDA;EACE,2BAAA;AdmyDF;Ac/xDA;EACE,yBAAA;AdiyDF;Ac7xDA;EACE,0BAAA;Ad+xDF;Ac3xDA;EACE,wCAAA;Ad6xDF;AczxDA;EACE,6CAAA;EACA,8CAAA;Ad2xDF;AcvxDA;EACE,+CAAA;EACA,4CAAA;AdyxDF;AcrxDA;EACE,4CAAA;AduxDF;AcnxDA;EACE,+CAAA;AdqxDF;AcjxDA;EACE,6CAAA;AdmxDF;Ac/wDA;EACE,8CAAA;AdixDF;Ac7wDA;EACE,wCAAA;Ad+wDF;Ac3wDA;EACE,6CAAA;EACA,8CAAA;Ad6wDF;AczwDA;EACE,+CAAA;EACA,4CAAA;Ad2wDF;AcvwDA;EACE,4CAAA;AdywDF;AcrwDA;EACE,+CAAA;AduwDF;AcnwDA;EACE,6CAAA;AdqwDF;AcjwDA;EACE,8CAAA;AdmwDF;Ac/vDA;EACE,wCAAA;AdiwDF;Ac7vDA;EACE,6CAAA;EACA,8CAAA;Ad+vDF;Ac3vDA;EACE,+CAAA;EACA,4CAAA;Ad6vDF;AczvDA;EACE,4CAAA;Ad2vDF;AcvvDA;EACE,+CAAA;AdyvDF;AcrvDA;EACE,6CAAA;AduvDF;AcnvDA;EACE,8CAAA;AdqvDF;AcjvDA;EACE,wCAAA;AdmvDF;Ac/uDA;EACE,6CAAA;EACA,8CAAA;AdivDF;Ac7uDA;EACE,+CAAA;EACA,4CAAA;Ad+uDF;Ac3uDA;EACE,4CAAA;Ad6uDF;AczuDA;EACE,+CAAA;Ad2uDF;AcvuDA;EACE,6CAAA;AdyuDF;AcruDA;EACE,8CAAA;AduuDF;AcnuDA;EACE,wCAAA;AdquDF;AcjuDA;EACE,6CAAA;EACA,8CAAA;AdmuDF;Ac/tDA;EACE,+CAAA;EACA,4CAAA;AdiuDF;Ac7tDA;EACE,4CAAA;Ad+tDF;Ac3tDA;EACE,+CAAA;Ad6tDF;AcztDA;EACE,6CAAA;Ad2tDF;AcvtDA;EACE,8CAAA;AdytDF;AcrtDA;EACE,wCAAA;AdutDF;AcntDA;EACE,6CAAA;EACA,8CAAA;AdqtDF;AcjtDA;EACE,+CAAA;EACA,4CAAA;AdmtDF;Ac/sDA;EACE,4CAAA;AditDF;Ac7sDA;EACE,+CAAA;Ad+sDF;Ac3sDA;EACE,6CAAA;Ad6sDF;AczsDA;EACE,8CAAA;Ad2sDF;AcvsDA;EACE,wCAAA;AdysDF;AcrsDA;EACE,6CAAA;EACA,8CAAA;AdusDF;AcnsDA;EACE,+CAAA;EACA,4CAAA;AdqsDF;AcjsDA;EACE,4CAAA;AdmsDF;Ac/rDA;EACE,+CAAA;AdisDF;Ac7rDA;EACE,6CAAA;Ad+rDF;Ac3rDA;EACE,8CAAA;Ad6rDF;AczrDA;EACE,yCAAA;Ad2rDF;AcvrDA;EACE,8CAAA;EACA,+CAAA;AdyrDF;AcrrDA;EACE,gDAAA;EACA,6CAAA;AdurDF;AcnrDA;EACE,6CAAA;AdqrDF;AcjrDA;EACE,gDAAA;AdmrDF;Ac/qDA;EACE,8CAAA;AdirDF;Ac7qDA;EACE,+CAAA;Ad+qDF;Ac3qDA;EACE,yCAAA;Ad6qDF;AczqDA;EACE,8CAAA;EACA,+CAAA;Ad2qDF;AcvqDA;EACE,gDAAA;EACA,6CAAA;AdyqDF;AcrqDA;EACE,6CAAA;AduqDF;AcnqDA;EACE,gDAAA;AdqqDF;AcjqDA;EACE,8CAAA;AdmqDF;Ac/pDA;EACE,+CAAA;AdiqDF;Ac7pDA;EACE,yCAAA;Ad+pDF;Ac3pDA;EACE,8CAAA;EACA,+CAAA;Ad6pDF;AczpDA;EACE,gDAAA;EACA,6CAAA;Ad2pDF;AcvpDA;EACE,6CAAA;AdypDF;AcrpDA;EACE,gDAAA;AdupDF;AcnpDA;EACE,8CAAA;AdqpDF;AcjpDA;EACE,+CAAA;AdmpDF;Aej7EA;EAlBE,sBAAA;EACA,cAAA;EACA,WAAA;Afs8EF;Aej7EA;ECEE,gBAAA;EACA,iBAAA;AhBk7EF;AIt3EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhB45EZ;AACF;AI53EE;EW/DF;ICUQ,gBAXO;IAYP,+CACE;EhBo7ER;AACF;AIl4EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBw6EZ;AACF;AIx4EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhB86EZ;AACF;AI94EE;EW/DF;ICUQ,gBAXO;IAYP,6CACE;EhBs8ER;AACF;AIp5EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhB07EZ;AACF;AI15EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBg8EZ;AACF;AIh6EE;EY5CE;IASQ,gBA7BG;IA8BH,6CACE;EhBs8EZ;AACF;AIt6EE;EW/DF;ICUQ,gBAXO;IAYP,+CACE;EhB89ER;AACF;AI56EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBk9EZ;AACF;AIl7EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBw9EZ;AACF;AIx7EE;EY5CE;IASQ,gBA7BG;IA8BH,6CACE;EhB89EZ;AACF;AI97EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBo+EZ;AACF;AIp8EE;EW/DF;ICUQ,iBAXO;IAYP,+CACE;EhB4/ER;AACF;AI18EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBg/EZ;AACF;AIh9EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBs/EZ;AACF;AIt9EE;EY5CE;IASQ,gBA7BG;IA8BH,6CACE;EhB4/EZ;AACF;AI59EE;EY5CE;IASQ,gBA7BG;IA8BH,+CACE;EhBkgFZ;AACF;AIl+EE;EY5CE;IASQ,iBA7BG;IA8BH,+CACE;EhBwgFZ;AACF;AIx+EE;EW1DF;IC6DM,kDAFe;IAGf,mDAHe;EhB4+EnB;AACF;AI9+EE;EW1DF;IC6DM,kDAFe;IAGf,mDAHe;EhBk/EnB;AACF;AIp/EE;EW1DF;IC6DM,gDAFe;IAGf,iDAHe;EhBw/EnB;AACF;AI1/EE;EW1DF;IC6DM,kDAFe;IAGf,mDAHe;EhB8/EnB;AACF;AIhgFE;EW1DF;IC6DM,kDAFe;IAGf,mDAHe;EhBogFnB;AACF;Ae3jFA;EA3BE,aAAA;EACA,SAAA;EACA,WAAA;AfylFF;Ae3jFA;EC8EE,sCAAA;EACA,gDAAA;AhBg/EF;AI/gFE;EWhDF;ICsFQ,sCACE;IAOF,gDAAA;EhBs+EN;AACF;AIrhFE;EWhDF;ICsFQ,sCACE;IAOF,iDAAA;EhB4+EN;AACF;AI3hFE;EWhDF;ICsFQ,sCACE;IAOF,iDAAA;EhBk/EN;AACF;AIjiFE;EWhDF;ICsFQ,sCACE;IAOF,iDAAA;EhBw/EN;AACF;AgBn+EM;EACE,sCAAA;EACA,gDAAA;AhBq+ER;AgBv+EM;EACE,sCAAA;EACA,gDAAA;AhBy+ER;AI/iFE;EYoEI;IAUQ,sCACE;IAIF,gDAAA;EhBi+EZ;AACF;AgBz8EI;EAGE,sCAAA;EACA,gDAAA;AhBy8EN;AIzjFE;EY4GE;IAaQ,sCAAA;EhBo8EV;AACF;AI9jFE;EY4GE;IAaQ,sCAAA;EhBy8EV;AACF;AInkFE;EY4GE;IAaQ,sCAAA;EhB88EV;AACF;AIxkFE;EY4GE;IAaQ,sCAAA;EhBm9EV;AACF;AgBj+EI;EAGE,sCAAA;EACA,gDAAA;AhBi+EN;AIjlFE;EY4GE;IAaQ,sCAAA;EhB49EV;AACF;AItlFE;EY4GE;IAaQ,sCAAA;EhBi+EV;AACF;AI3lFE;EY4GE;IAaQ,sCAAA;EhBs+EV;AACF;AIhmFE;EY4GE;IAaQ,sCAAA;EhB2+EV;AACF;AgBz/EI;EAGE,sCAAA;EACA,iDAAA;AhBy/EN;AIzmFE;EY4GE;IAaQ,sCAAA;EhBo/EV;AACF;AI9mFE;EY4GE;IAaQ,sCAAA;EhBy/EV;AACF;AInnFE;EY4GE;IAaQ,sCAAA;EhB8/EV;AACF;AIxnFE;EY4GE;IAaQ,sCAAA;EhBmgFV;AACF;AevqFA;;EAtCE,aAAA;EACA,SAAA;EACA,WAAA;EAwCA,gCYuOqB;EZtOrB,sBAAA;Af0qFF;AevqFA;EACE,qCAAA;AfyqFF;AetqFA;EACE,qCAAA;AfwqFF;AerqFA;EACE,+BYsNoB;A3Bi9EtB;AI9oFE;EW1BF;IAII,gCYqNmB;E3Bm9ErB;AACF;AerqFA;EACE,gCYyNqB;A3B88EvB;AenqFA;EAEE,iBAAA;AfoqFF;AgB37EI;EAGE,iDAAA;AhB27EN;AgB97EI;EAGE,iDAAA;AhB87EN;AgBj8EI;EAGE,iDAAA;AhBi8EN;AgBp8EI;EAGE,iDAAA;AhBo8EN;AgBv8EI;EAGE,iDAAA;AhBu8EN;Ae3qFA;EAvEE,qBAAA;EACA,SAAA;EACA,WAAA;AfqvFF;Ae3qFA;EA5EE,qBAAA;EACA,SAAA;EACA,WAAA;Af0vFF;AgB5hFI;EAEE,uBAAA;AhB6hFN;AgB1hFI;EAEI,oBARO;AhBmiFf;AgBliFI;EAEE,uBAAA;AhBmiFN;AgBhiFI;EAEI,oBARO;AhByiFf;AgBxiFI;EAEE,uBAAA;AhByiFN;AgBtiFI;EAEI,oBARO;AhB+iFf;AgB9iFI;EAEE,uBAAA;AhB+iFN;AgB5iFI;EAEI,oBARO;AhBqjFf;AgBpjFI;EAEE,uBAAA;AhBqjFN;AgBljFI;EAEI,oBARO;AhB2jFf;AIhtFE;EY+KQ;IACE,uBAAA;EhBoiFV;EgBjiFQ;IACE,oBAbe;EhBgjFzB;AACF;AgBlkFI;EAEE,uBAAA;AhBmkFN;AgBhkFI;EAEI,oBARO;AhBykFf;AI9tFE;EY+KQ;IACE,uBAAA;EhBkjFV;EgB/iFQ;IACE,oBAbe;EhB8jFzB;AACF;AgBhlFI;EAEE,uBAAA;AhBilFN;AgB9kFI;EAEI,oBARO;AhBulFf;AI5uFE;EY+KQ;IACE,uBAAA;EhBgkFV;EgB7jFQ;IACE,oBAbe;EhB4kFzB;AACF;AgB9lFI;EAEE,uBAAA;AhB+lFN;AgB5lFI;EAEI,oBARO;AhBqmFf;AI1vFE;EY+KQ;IACE,uBAAA;EhB8kFV;EgB3kFQ;IACE,oBAbe;EhB0lFzB;AACF;AgB5mFI;EAEE,uBAAA;AhB6mFN;AgB1mFI;EAEI,oBARO;AhBmnFf;AIxwFE;EY+KQ;IACE,uBAAA;EhB4lFV;EgBzlFQ;IACE,oBAbe;EhBwmFzB;AACF;AIhxFE;EY+KQ;IACE,uBAAA;EhBomFV;EgBjmFQ;IACE,oBAbe;EhBgnFzB;AACF;AgBloFI;EAEE,wBAAA;AhBmoFN;AgBhoFI;EAEI,qBARO;AhByoFf;AI9xFE;EY+KQ;IACE,uBAAA;EhBknFV;EgB/mFQ;IACE,oBAbe;EhB8nFzB;AACF;AItyFE;EY+KQ;IACE,uBAAA;EhB0nFV;EgBvnFQ;IACE,oBAbe;EhBsoFzB;AACF;AgBxpFI;EAEE,wBAAA;AhBypFN;AgBtpFI;EAEI,qBARO;AhB+pFf;AIpzFE;EY+KQ;IACE,uBAAA;EhBwoFV;EgBroFQ;IACE,oBAbe;EhBopFzB;AACF;AI5zFE;EY+KQ;IACE,uBAAA;EhBgpFV;EgB7oFQ;IACE,oBAbe;EhB4pFzB;AACF;AgB9qFI;EAEE,wBAAA;AhB+qFN;AgB5qFI;EAMI,qBAZO;AhBqrFf;AI10FE;EY+KQ;IACE,uBAAA;EhB8pFV;EgB3pFQ;IACE,oBAbe;EhB0qFzB;AACF;AIl1FE;EY+KQ;IACE,uBAAA;EhBsqFV;EgBnqFQ;IACE,oBAbe;EhBkrFzB;AACF;AI11FE;EYiMM;IAEE,uBAAA;EhB2pFR;EgBxpFM;IAEE,oBARS;EhBiqFjB;EgBhqFM;IAEE,uBAAA;EhBiqFR;EgB9pFM;IAEE,oBARS;EhBuqFjB;EgBtqFM;IAEE,uBAAA;EhBuqFR;EgBpqFM;IAEE,oBARS;EhB6qFjB;EgB5qFM;IAEE,uBAAA;EhB6qFR;EgB1qFM;IAEE,oBARS;EhBmrFjB;AACF;AIp3FE;EYiMM;IAEE,uBAAA;EhBqrFR;EgBlrFM;IAEE,oBARS;EhB2rFjB;EgB1rFM;IAEE,uBAAA;EhB2rFR;EgBxrFM;IAEE,oBARS;EhBisFjB;EgBhsFM;IAEE,uBAAA;EhBisFR;EgB9rFM;IAEE,oBARS;EhBusFjB;EgBtsFM;IAEE,uBAAA;EhBusFR;EgBpsFM;IAEE,oBARS;EhB6sFjB;EgB5sFM;IAEE,uBAAA;EhB6sFR;EgB1sFM;IAEE,oBARS;EhBmtFjB;EgBltFM;IAEE,uBAAA;EhBmtFR;EgBhtFM;IAEE,oBARS;EhBytFjB;EgBxtFM;IAEE,uBAAA;EhBytFR;EgBttFM;IAEE,oBARS;EhB+tFjB;EgB9tFM;IAEE,uBAAA;EhB+tFR;EgB5tFM;IAEE,oBARS;EhBquFjB;AACF;AIt6FE;EYiMM;IAEE,uBAAA;EhBuuFR;EgBpuFM;IAEE,oBARS;EhB6uFjB;EgB5uFM;IAEE,uBAAA;EhB6uFR;EgB1uFM;IAEE,oBARS;EhBmvFjB;EgBlvFM;IAEE,uBAAA;EhBmvFR;EgBhvFM;IAEE,oBARS;EhByvFjB;EgBxvFM;IAEE,uBAAA;EhByvFR;EgBtvFM;IAEE,oBARS;EhB+vFjB;EgB9vFM;IAEE,uBAAA;EhB+vFR;EgB5vFM;IAEE,oBARS;EhBqwFjB;EgBpwFM;IAEE,uBAAA;EhBqwFR;EgBlwFM;IAEE,oBARS;EhB2wFjB;EgB1wFM;IAEE,uBAAA;EhB2wFR;EgBxwFM;IAEE,oBARS;EhBixFjB;EgBhxFM;IAEE,uBAAA;EhBixFR;EgB9wFM;IAEE,oBARS;EhBuxFjB;EgBtxFM;IAEE,uBAAA;EhBuxFR;EgBpxFM;IAEE,oBARS;EhB6xFjB;EgB5xFM;IAEE,wBAAA;EhB6xFR;EgB1xFM;IAEE,qBARS;EhBmyFjB;EgBlyFM;IAEE,wBAAA;EhBmyFR;EgBhyFM;IAEE,qBARS;EhByyFjB;EgBxyFM;IAEE,wBAAA;EhByyFR;EgBtyFM;IAEE,qBARS;EhB+yFjB;AACF;AIh/FE;EYiMM;IAEE,uBAAA;EhBizFR;EgB9yFM;IAEE,oBARS;EhBuzFjB;EgBtzFM;IAEE,uBAAA;EhBuzFR;EgBpzFM;IAEE,oBARS;EhB6zFjB;EgB5zFM;IAEE,uBAAA;EhB6zFR;EgB1zFM;IAEE,oBARS;EhBm0FjB;EgBl0FM;IAEE,uBAAA;EhBm0FR;EgBh0FM;IAEE,oBARS;EhBy0FjB;EgBx0FM;IAEE,uBAAA;EhBy0FR;EgBt0FM;IAEE,oBARS;EhB+0FjB;EgB90FM;IAEE,uBAAA;EhB+0FR;EgB50FM;IAEE,oBARS;EhBq1FjB;EgBp1FM;IAEE,uBAAA;EhBq1FR;EgBl1FM;IAEE,oBARS;EhB21FjB;EgB11FM;IAEE,uBAAA;EhB21FR;EgBx1FM;IAEE,oBARS;EhBi2FjB;EgBh2FM;IAEE,uBAAA;EhBi2FR;EgB91FM;IAEE,oBARS;EhBu2FjB;EgBt2FM;IAEE,wBAAA;EhBu2FR;EgBp2FM;IAEE,qBARS;EhB62FjB;EgB52FM;IAEE,wBAAA;EhB62FR;EgB12FM;IAEE,qBARS;EhBm3FjB;EgBl3FM;IAEE,wBAAA;EhBm3FR;EgBh3FM;IAEE,qBARS;EhBy3FjB;AACF;AI1jGE;EYiMM;IAEE,uBAAA;EhB23FR;EgBx3FM;IAEE,oBARS;EhBi4FjB;EgBh4FM;IAEE,uBAAA;EhBi4FR;EgB93FM;IAEE,oBARS;EhBu4FjB;EgBt4FM;IAEE,uBAAA;EhBu4FR;EgBp4FM;IAEE,oBARS;EhB64FjB;EgB54FM;IAEE,uBAAA;EhB64FR;EgB14FM;IAEE,oBARS;EhBm5FjB;EgBl5FM;IAEE,uBAAA;EhBm5FR;EgBh5FM;IAEE,oBARS;EhBy5FjB;EgBx5FM;IAEE,uBAAA;EhBy5FR;EgBt5FM;IAEE,oBARS;EhB+5FjB;EgB95FM;IAEE,uBAAA;EhB+5FR;EgB55FM;IAEE,oBARS;EhBq6FjB;EgBp6FM;IAEE,uBAAA;EhBq6FR;EgBl6FM;IAEE,oBARS;EhB26FjB;EgB16FM;IAEE,uBAAA;EhB26FR;EgBx6FM;IAEE,oBARS;EhBi7FjB;EgBh7FM;IAEE,wBAAA;EhBi7FR;EgB96FM;IAEE,qBARS;EhBu7FjB;EgBt7FM;IAEE,wBAAA;EhBu7FR;EgBp7FM;IAEE,qBARS;EhB67FjB;EgB57FM;IAEE,wBAAA;EhB67FR;EgB17FM;IAEE,qBARS;EhBm8FjB;AACF;Ae7nGA;EACE,aAAA;Af+nGF;A8BlsGA;EACE,UAtBW;A9B0tGb;A8BjsGA;EACE,UAzBa;EA0Bb,wDAAA;A9BmsGF;A8B/rGA;EACE,UA/Ba;A9BguGf;A8B9rGA;EACE,UApCW;EAqCX,wDAAA;A9BgsGF;A8B5rGA;EACE,6CAAA;A9B8rGF;A8B3rGA;EACE,8CAAA;A9B6rGF;A8B1rGA;EACE,wDAAA;A9B4rGF;A8BxrGA;EACE,+BAAA;A9B0rGF;A8BvrGA;EACE,gCAAA;A9ByrGF;A8BtrGA;EACE,+EAAA;EACA,oDAAA;A9BwrGF;A8BrrGA;;;;;;EAME,yDAAA;EACA,0BAAA;EACA,yDAAA;EACA,2BAAA;A9BurGF;AiBzwGA;EACE,6BAAA;AjB2wGF;AiBvwGA;EACE,0BAAA;AjBywGF;AiBrwGA;EACE,8BAAA;AjBuwGF;AiBnwGA;EACE,2BAAA;AjBqwGF;AiBjwGA;EACE,4BAAA;AjBmwGF;AiB/vGA;EACE,4BAAA;AjBiwGF;A+B9xGA;EACE,mBAAA;EACA,0CJiFwB;EIhFxB,SAAA;EACA,mDJgQ8B;EI/P9B,oCJsDuB;EIrDvB,aAAA;EACA,0CJ6U8B;EI5U9B,uCJkSqB;EIjSrB,oCJiRqB;EIhRrB,WAAA;A/BgyGF;A0B9wGa;EAsCT,eAAA;A1B2uGJ;AgCnxGE;ENEW;IAhBT,4CAAA;E1BqyGF;E0BpyGE;IKAA,0CJ0EsB;E3B6tGxB;AACF;A0BlyGE;EKNE,0CJ0EsB;A3BiuG1B;A0B5xGa;EAsCT,eAAA;A1ByvGJ;AgCjyGE;ENEW;IAhBT,4CAAA;E1BmzGF;E0BlzGE;IKAA,0CJ0EsB;E3B2uGxB;AACF;A0BhzGE;EKNE,0CJ0EsB;A3B+uG1B;A0B1yGa;EAsCT,eAAA;A1BuwGJ;AgC/yGE;ENEW;IAhBT,4CAAA;E1Bi0GF;E0Bh0GE;IKAA,0CJ0EsB;E3ByvGxB;AACF;A0B9zGE;EKNE,0CJ0EsB;A3B6vG1B;A0BxzGa;EAsCT,eAAA;A1BqxGJ;AgC7zGE;ENEW;IAhBT,4CAAA;E1B+0GF;E0B90GE;IKAA,0CJ0EsB;E3BuwGxB;AACF;A0B50GE;EKNE,0CJ0EsB;A3B2wG1B;A+Bl1GE;EACE,aAAA;EACA,OAAA;EACA,yCJuQmB;EItQnB,0CJsQmB;EIrQnB,gBAAA;A/Bo1GJ;A+Bj1GE;EACE,0CJ4T4B;A3BuhGhC;A+Bh1GE;EACE,0CJkDgB;A3BgyGpB;A+B/0GE;EACE,0DJNgC;A3Bu1GpC;AIzxGE;E2BzFF;IAqCI,0CJiT4B;E3BgiG9B;E+B/0GE;IACE,0CJ+S0B;E3BkiG9B;AACF;AiC53GA;EACE,6BAAA;EACA,yCNsRoB;EMrRpB,mCNgSqB;EM/RrB,eAAA;EACA,kCN8RqB;A3BgmGvB;AiC53GE;EACE,mCNwRmB;EMvRnB,kCNuRmB;A3BumGvB;AiC33GE;EACE,mCN0RmB;EMzRnB,kCNyRmB;A3BomGvB;AiC13GE;EACE,mCNyRmB;EMxRnB,kCNwRmB;A3BomGvB;AiCz3GE;EACE,kCN4RmB;A3B+lGvB;AiCz3GI;EACE,kCNmRiB;A3BwmGvB;AiCx3GI;EACE,cAAA;AjC03GN;AiCv3GI;EACE,YAAA;AjCy3GN;AiCr3GE;EACE,kBAAA;EACA,mCN0OkB;A3B6oGtB;AiCr3GI;EAEE,mCNwOgB;A3B8oGtB;AiCl3GE;EACE,gDNoCsB;A3Bg1G1B;AiCj3GE;EACE,0CN4BgB;A3Bu1GpB;AkCv6GA;EACE,0DPqHkC;A3BozGpC;AkCt6GA;EAEE,+EAAA;EACA,iCAAA;EACA,WAAA;AlCu6GF;AkCr6GE;EACE,0CPqEgB;EOpEhB,0EAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AlCu6GJ;AkCp6GE;EVEA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAuGA,eAAA;EAGA,UAAA;EAGA,yBAAA;UAAA,iBAAA;EUlHE,sDPD4B;EOE5B,YAAA;EACA,0CPoQmB;EOnQnB,eAAA;EACA,cAAA;EAGA,kCPwPkB;EOvPlB,mEAAA;EACA,0CPoPkB;EOnPlB,kCPsQmB;A3BmqGvB;AwBv8GE;EUiBA;ITjBA,qBAAA;EzB28GA;EyBz8GA;IACE,qBAAA;EzB28GF;AACF;A0Bl6GE;EACE;IDvCA,qBAAA;EzB48GF;AACF;A0Bv6GE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBi9GF;AACF;AyB98GE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzB+8GF;AACF;AkC/7GE;EACE,aAAA;EACA,8BAAA;EACA,6FAAA;AlCi8GJ;AkC97GE;EACE,mBAAA;EACA,aAAA;EACA,OAAA;EACA,0CP6S4B;EO5S5B,8BAAA;AlCg8GJ;AkC97GI;EACE,0CPyS0B;A3BupGhC;AkC57GE;ETTA,gCEgPqB;EOpOnB,aAAA;EACA,oCPuOmB;A3BstGvB;AyBx8GW;EAwBL,yDAAA;AzBm7GN;AyBj7GM;EACE,wDAAA;AzBm7GR;AkCh8GE;EACE,OAAA;EACA,gBAAA;EACA,sCAAA;AlCk8GJ;AkCh8GI;EACE,2CP8NiB;A3BouGvB;AkC57GM;EACE,WAAA;EACA,cAAA;EACA,mCPwOe;A3BstGvB;AkC37GM;EACE,0CPEY;EODZ,SAAA;EACA,iFAAA;EACA,eAAA;EACA,WAAA;AlC67GR;AmCxgHA;EXaE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EWhBA,mBAAA;EACA,gDRyEwB;EQxExB,yEAAA;EACA,kDRiP6B;EQhP7B,8CRUiC;EQTjC,aAAA;EACA,uCRsRqB;EQrRrB,kBAAA;AnC4gHF;AmC1gHE;EXCA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EWzBE,6BAAA;EACA,kDRsO2B;EQrO3B,iDR7B4B;EQ8B5B,cAAA;EACA,OAAA;EACA,0CR6T4B;EQ5T5B,0CRmPkB;EQlPlB,gEAAA;AnCihHJ;AwB9iHE;EWkBA;IVlBA,qBAAA;EzBkjHA;EyBhjHA;IACE,qBAAA;EzBkjHF;AACF;A0BzgHE;EACE;IDvCA,qBAAA;EzBmjHF;AACF;A0B9gHE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBwjHF;AACF;AyBrjHE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBsjHF;AACF;AmCviHE;EXbA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EWUE,sEAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AnC2iHJ;AmCziHI;;EAEE,yCR2PiB;A3BgzGvB;AmCviHE;EX3BA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EWwBE,kBAAA;EACA,sEAAA;AnC2iHJ;AmCxiHE;EACE,sDRnC4B;EQoC5B,qDRkE+B;EQjE/B,uCR+DwB;A3B2+G5B;AmCtiHI;;EAEE,sBAAA;AnCwiHN;AkBvmHE;EACE,qDAAA;EACA,kFAAA;AlBymHJ;AkBvmHI;EACE,2DAAA;EACA,8BAAA;EACA,sDAAA;AlBymHN;AkBtmHI;;;EAGE,sDAAA;AlBwmHN;AkBrmHI;;;EAGE,yDAAA;AlBumHN;AkBpmHI;EACE,qDAAA;AlBsmHN;AoC3mHA;EZEE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAuGA,eAAA;EAGA,UAAA;EAGA,yBAAA;UAAA,iBAAA;EYrIA,mBAAA;EACA,oCT6DuB;ES5DvB,0CTqV8B;ESpV9B,cAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EAaA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;ApCynHF;AwBjpHE;EYiBF;IXjBE,qBAAA;EzBqpHA;EyBnpHA;IACE,qBAAA;EzBqpHF;AACF;A0B5mHE;EACE;IDvCA,qBAAA;EzBspHF;AACF;A0BjnHE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExB2pHF;AACF;AyBxpHE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBypHF;AACF;AoChpHE;EAdA,+CTmCkC;ESlClC,mBAAA;EACA,YAAA;ApCiqHF;AgCrpHE;EITF;IVLI,4CAAA;E1BuqHF;E0BtqHE;IUmBA,gDTuDsB;IStDtB,oCT0BqB;ISzBrB,iBAAA;EpCspHF;AACF;A0BtqHE;EUaE,gDTuDsB;EStDtB,oCT0BqB;ESzBrB,iBAAA;ApC4pHJ;AoCzpHE;EACE,0CTyCgB;ESxChB,4CToEsB;ESnEtB,uBAAA;EACA,wCTuOkB;EStOlB,cAAA;EACA,kBAAA;ApC2pHJ;AoCzpHI;EAjCF,+CTmCkC;ESlClC,mBAAA;EACA,YAAA;ApC6rHF;AgCjrHE;EIWA;IVzBE,4CAAA;E1BmsHF;E0BlsHE;IUsCE,gDTgCoB;IS/BpB,4CT2DoB;E3BomHxB;AACF;A0BjsHE;EUgCI,gDTgCoB;ES/BpB,4CT2DoB;A3BymH1B;AoChqHE;EACE,sDTtC4B;ESuC5B,+CTvDgC;A3BytHpC;AoChqHI;EAhDF,+CTmCkC;ESlClC,mBAAA;EACA,YAAA;ApCmtHF;AgCvsHE;EI8BA;IV5CE,4CAAA;E1BytHF;E0BxtHE;IUqDE,yDTnE6B;ISoE7B,gDTwD+B;E3B8mHnC;AACF;A0BvtHE;EU+CI,yDTnE6B;ESoE7B,gDTwD+B;A3BmnHrC;AoCtqHA;EZrDE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAqFA,cAAA;EYnCA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;ApC2qHF;AoCzqHE;;EZ7DA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EA8FA,mBAAA;EYtHA,mBAAA;EACA,oCT6DuB;ES5DvB,0CTqV8B;ESpV9B,cAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;ApCiwHF;AoCnrHE;EACE,0CTgQ4B;ES/P5B,qBAAA;ApCqrHJ;AoClrHE;EACE,uBAAA;EACA,mBAAA;ApCorHJ;AoCjrHE;EAGE,YAAA;ApCirHJ;AoC9qHE;EA9BF;IA+BI,uCAAA;IAEA,uBAAA;IACA,oBAAA;EpCgrHF;AACF;AqC5xHA;EACE,oCV+EkB;EU9ElB,uEAAA;EACA,mDViQ8B;A3B6hHhC;AqC5xHE;EAEE,qDVciC;A3B+wHrC;AqC1xHE;EACE,gFAAA;ArC4xHJ;AqCzxHE;EACE,gDVnB4B;EUoB5B,kFAAA;EACA,+CVbgC;A3BwyHpC;AqCzxHI;EAEE,mDVrB6B;A3B+yHnC;AqCtxHE;EACE,kDVlB8B;EUmB9B,oFAAA;ArCwxHJ;AqCtxHI;EAEE,qDVnB+B;A3B0yHrC;AsCpzHA;EACE,oCX6EkB;EW5ElB,uEAAA;EACA,mDX+P8B;EYlL5B,uEAAA;AvC0uHJ;AsCnzHE;EACE,YAAA;AtCqzHJ;A0BlyHa;EAsCT,eAAA;A1B+vHJ;AgCvyHE;ENEW;IAhBT,4CAAA;E1ByzHF;E0BxzHE;IYAA,qDXOiC;E3BozHnC;AACF;A0BtzHE;EYNE,qDXOiC;A3BwzHrC;A0BhzHa;EAsCT,eAAA;A1B6wHJ;AgCrzHE;ENEW;IAhBT,4CAAA;E1Bu0HF;E0Bt0HE;IYAA,qDXOiC;E3Bk0HnC;AACF;A0Bp0HE;EYNE,qDXOiC;A3Bs0HrC;A0B9zHa;EAsCT,eAAA;A1B2xHJ;AgCn0HE;ENEW;IAhBT,4CAAA;E1Bq1HF;E0Bp1HE;IYAA,qDXOiC;E3Bg1HnC;AACF;A0Bl1HE;EYNE,qDXOiC;A3Bo1HrC;A0B50Ha;EAsCT,eAAA;A1ByyHJ;AgCj1HE;ENEW;IAhBT,4CAAA;E1Bm2HF;E0Bl2HE;IYAA,qDXOiC;E3B81HnC;AACF;A0Bh2HE;EYNE,qDXOiC;A3Bk2HrC;AsCt2HE;ECiEE,gFAAA;AvCwyHJ;AsCr2HE;EACE,0CX8DsB;A3ByyH1B;AsCp2HE;EACE,gDX9B4B;EW+B5B,+CXvBgC;EY8EhC,kFAAA;AvCgzHJ;A0Br2Ha;EAsCT,eAAA;A1Bk0HJ;AgC12HE;ENEW;IAhBT,4CAAA;E1B43HF;E0B33HE;IYkBE,mDXhC6B;E3B44HjC;AACF;A0Bz3HE;EYYI,mDXhC6B;A3Bg5HnC;A0Bn3Ha;EAsCT,eAAA;A1Bg1HJ;AgCx3HE;ENEW;IAhBT,4CAAA;E1B04HF;E0Bz4HE;IYkBE,mDXhC6B;E3B05HjC;AACF;A0Bv4HE;EYYI,mDXhC6B;A3B85HnC;A0Bj4Ha;EAsCT,eAAA;A1B81HJ;AgCt4HE;ENEW;IAhBT,4CAAA;E1Bw5HF;E0Bv5HE;IYkBE,mDXhC6B;E3Bw6HjC;AACF;A0Br5HE;EYYI,mDXhC6B;A3B46HnC;A0B/4Ha;EAsCT,eAAA;A1B42HJ;AgCp5HE;ENEW;IAhBT,4CAAA;E1Bs6HF;E0Br6HE;IYkBE,mDXhC6B;E3Bs7HjC;AACF;A0Bn6HE;EYYI,mDXhC6B;A3B07HnC;AsCt5HE;EACE,kDX7B8B;EY0E9B,oFAAA;AvC42HJ;A0Bj6Ha;EAsCT,eAAA;A1B83HJ;AgCt6HE;ENEW;IAhBT,4CAAA;E1Bw7HF;E0Bv7HE;IY4BE,qDX9B+B;E3B47HnC;AACF;A0Br7HE;EYsBI,qDX9B+B;A3Bg8HrC;A0B/6Ha;EAsCT,eAAA;A1B44HJ;AgCp7HE;ENEW;IAhBT,4CAAA;E1Bs8HF;E0Br8HE;IY4BE,qDX9B+B;E3B08HnC;AACF;A0Bn8HE;EYsBI,qDX9B+B;A3B88HrC;A0B77Ha;EAsCT,eAAA;A1B05HJ;AgCl8HE;ENEW;IAhBT,4CAAA;E1Bo9HF;E0Bn9HE;IY4BE,qDX9B+B;E3Bw9HnC;AACF;A0Bj9HE;EYsBI,qDX9B+B;A3B49HrC;A0B38Ha;EAsCT,eAAA;A1Bw6HJ;AgCh9HE;ENEW;IAhBT,4CAAA;E1Bk+HF;E0Bj+HE;IY4BE,qDX9B+B;E3Bs+HnC;AACF;A0B/9HE;EYsBI,qDX9B+B;A3B0+HrC;AwCt/HA;EACE,mBAAA;EACA,2CbkB8B;EajB9B,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,uCb+RqB;Ea9RrB,sCb8RqB;Ea7RrB,kBAAA;AxCw/HF;AwCt/HE;EhBSA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EAWA,gBAAA;EACA,SAAA;EiB/DA,gBAAA;EAEA,6BAAA;EAEA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AzC+gIF;AwBrhIE;EgBUA;IfVA,qBAAA;EzByhIA;EyBvhIA;IACE,qBAAA;EzByhIF;AACF;A0Bh/HE;EACE;IDvCA,qBAAA;EzB0hIF;AACF;A0Br/HE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExB+hIF;AACF;AyB5hIE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzB6hIF;AACF;AyCtiIE;EACE,mBAAA;AzCwiIJ;AwCliIE;EACE,yBAAA;AxCoiIJ;AwCjiIE;EACE,iCAAA;AxCmiIJ;AwChiIE;EACE,sCb2HuB;A3Bu6H3B;AwC9hII;EACE,sCbsHqB;A3B06H3B;AwC5hIE;EACE,+CbagC;A3BihIpC;AwC3hIE;EACE,mBAAA;AxC6hIJ;AwC1hIE;EACE,8CbnB+B;A3B+iInC;AwCvhII;EACE,2CbrD0B;A3B8kIhC;AwCthII;EACE,8CbrD6B;A3B6kInC;A0C3kIE;EACE,iBAAA;A1C6kIJ;A0C1kIE;ElBcA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EkBjBE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,8BfmTa;A3B2xHjB;A0C5kII;EACE,mBAAA;A1C8kIN;A0C3kII;EACE,kBAAA;A1C6kIN;A0C1kII;EAhBF;IAiBI,iFAAA;E1C6kIJ;AACF;A0C1kIE;ElBPA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EA4EA,cAAA;AxBsgIF;A0C9kII;EAHF;IAII,sDAAA;E1CilIJ;AACF;AIvhIE;EsCzFF;IAmCI,iCf6Ra;E3BozHf;AACF;A2CtnIA;EnBoBE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EA8DA,SAAA;EAGA,cAAA;EAEA,SAAA;EeXE,gFAAA;EI9EF,WAAA;A3C6nIF;A2C3nIE;EJmEI,2CAlBW;AvC6kIjB;A2C1nIE;EJ+DI,0CAlBW;AvCglIjB;A2CxnIE;EJ8DI,0CZ2BkB;A3BkiIxB;A2CvnIE;EJ0DI,4CZmCoB;A3B6hI1B;A2CtnIE;EJsDI,kDZjF0B;A3BopIhC;A2CtnII;EJmDE,qDZ7E6B;A3BmpInC;A2CpnIE;EJ8CI,6CZuEqB;A3BkgI3B;A2CnnIE;EJ0CI,8DZiDsC;A3B2hI5C;A2CnnII;EJuCE,4DZgDoC;A3B+hI1C;A2ClnII;EJmCE,8DZkDsC;A3BgiI5C;AmBnpIA;EKQE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;ELXA,iCAAA;EACA,mCAAA;EACA,mCAAA;EACA,oCAAA;EACA;;;;KAAA;EAKA,+BAAA;EACA;;;;;KAAA;EAOA,qBAAA;EACA,4FAAA;EACA,aAAA;EACA,0BQ2Re;ER1Rf,oEAAA;EACA,0CQ6OoB;ER5OpB,gBAAA;EACA,WAAA;AnBspIF;AmBppIE;EMxCA,qBAAA;EN2CE,mCQmRa;ERlRb,wDAAA;AnBqpIJ;AyB/rIE;EACE,qBAAA;AzBisIJ;A0BvpIE;EACE;IDvCA,qBAAA;EzBisIF;AACF;AmB1pIE;EACE,mCQ8Qa;A3B84HjB;AmBxpIE;EKjCA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EL8BE,qBAAA;EACA,4FAAA;EACA,aAAA;EACA,oEAAA;EACA,kBAAA;AnB4pIJ;AmB1pII;EAEE,gBAAA;AnB2pIN;AmBvpIE;EKhDA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EL6CE,gBAAA;EACA,2CQpD4B;ERqD5B,cAAA;EACA,0CQ6Q4B;ER5Q5B,kDAAA;EACA,6GAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+EAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;AnB2pIJ;AmBxpIE;EKlEA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;ELgEE,iBAAA;EACA,2CQvE4B;ERwE5B,0CQ6P4B;ER5P5B,2BQkOa;ERjOb,cAAA;EACA,oBAAA;EACA,kBAAA;AnB2pIJ;AmBzpII;EACE,gHACE;AnB0pIR;AmBlpIE;EKxFA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;ELsFE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;AnBqpIJ;A0B7uIa;EP2FP,uBAAA;AnBqpIN;AmBjpII;EACE,uBAAA;AnBmpIN;AmB/oIE;EK7GA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EL0GE,qBAAA;EACA,4FAAA;EACA,aAAA;EACA,OAAA;EACA,oEAAA;EACA,sFAAA;AnBmpIJ;AmBhpIE;EKxHA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;ELqHE,uBAAA;EACA,2CQ5H4B;ER6H5B,aAAA;EACA,0CQqM4B;ERpM5B,mBAAA;AnBopIJ;AmBjpIE;EACE,qDAAA;EACA,0DAAA;AnBmpIJ;AmB7oIQ;EAEE,UAAA;AnB8oIV;AmBxoIQ;EAIE,aAAA;AnBuoIV;AmBjoIE;EACE,0DAAA;AnBmoIJ;AmBjoII;EACE,SAAA;EACA,uBAAA;EACA,iCQ0FgB;A3ByiItB;AmB9nII;EACE,0CQ2J0B;A3Bq+HhC;AmB7nII;EACE,0CQ8J0B;A3Bi+HhC;AmB3nIE;EACE,kBAAA;AnB6nIJ;AmB3nII;;;EAGE,uBAAA;AnB6nIN;AmB1nII;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;AnB4nIN;AmBznII;;EAEE,kBAAA;AnB2nIN;AmBxnII;EACE,eAAA;EACA,gBAAA;AnB0nIN;AmBvnII;EACE,iBAAA;EACA,oFAAA;EACA,kLACE;AnBwnIR;AmB9mIM;EACE,cAAA;EACA,0CQ2GwB;A3BqgIhC;AmB7mIM;EACE,0CQ8GwB;ER7GxB,iBAAA;AnB+mIR;AmB91IE;EACE,wFAAA;EACA,uBAAA;EACA,+EAAA;EACA,6BAAA;AnBg2IJ;AmBp2IE;EACE,wFAAA;EACA,uBAAA;EACA,+EAAA;EACA,6BAAA;AnBs2IJ;AmB12IE;EACE,wFAAA;EACA,uBAAA;EACA,+EAAA;EACA,6BAAA;AnB42IJ;AyBv2IE;ENuPA;IMrPE,2BAAA;IAEA,0CAAA;EzBw2IF;AACF;AmBhnIM;EACE,uDQ/NyB;A3Bi1IjC;AmB9mII;EACE,mBAAA;AnBgnIN;AmB7mII;;;;;;EAME,+CQzO8B;A3Bw1IpC;AmB1mII;EACE,sCQ3IqB;A3BuvI3B;AmBzmII;;EAEE,yDAAA;EAEA,0CAAA;AnB0mIN;AmBtmIE;EACE,qBAAA;AnBwmIJ;AmBpmII;EACE,gBAAA;AnBsmIN;AmBpmIM;EACE,gBAAA;AnBsmIR;AmBnmIM;EACE,6FAAA;AnBqmIR;AmBhmIE;EACE,mBAAA;AnBkmIJ;AmBhmII;EACE,uCQhDgB;A3BkpItB;AmB/lII;EACE,cAAA;AnBimIN;AmB9lII;;EAEE,mBAAA;AnBgmIN;AmB7lII;EACE,gBAAA;EACA,0CQzDgB;A3BwpItB;AmB7lIM;EACE,sBAAA;AnB+lIR;AmB1lIM;EACE,2CQ9De;ER+Df,wCQ/De;A3B2pIvB;AmBzlIM;EACE,mCQnEe;A3B8pIvB;AmBxlIM;;EAEE,gBAAA;AnB0lIR;A4C57IA;EACE,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,+BjBoRoB;EiBnRpB,kBAAA;A5C87IF;A4C57IE;;;EAGE,gBAAA;A5C87IJ;A4C57II;;;EACE,gBAAA;EACA,iBAAA;EACA,8CAAA;A5Cg8IN;A4C57IE;EAIE,cAAA;EAEA,yCjB0PkB;A3BgsItB;A4Cv7IE;EACE,cAAA;A5Cy7IJ;A4Ct7IE;EACE,+CjBgBgC;EiBfhC,mBAAA;A5Cw7IJ;A4Cr7IE;EACE,iBAAA;A5Cu7IJ;A4Cp7IE;EACE,gDjBmFiC;A3Bm2IrC;A4Cn7IE;EACE,cAAA;EACA,yBAAA;A5Cq7IJ;A6Cr+IA;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;EACA,sClBiY0B;EkBhY1B,6BAAA;EACA,mCAAA;EACA,kBAAA;EACA,+CAAA;EACA,uBAAA;EACA,iBAAA;EACA,uClBoRqB;EkBnRrB,sClBmRqB;EkBlRrB,kCAAA;EACA,uBAAA;A7Cu+IF;A6Cr+IE;EACE,2ClBrB4B;A3B4/IhC;A6Cp+IE;EACE,6ClBb8B;A3Bm/IlC;A6Cn+IE;EACE,2ClBL4B;A3B0+IhC;A6Cl+IE;EACE,wClB+GyB;A3Bq3I7B;A6Cj+IE;EACE,sClB2HuB;A3Bw2I3B;A6Ch+IE;EACE,4ClB+F6B;A3Bm4IjC;A6C/9IE;EACE,sClB2GuB;A3Bs3I3B;A6C99IE;EACE,gDlB+EiC;A3Bi5IrC;A6C79IE;EACE,qClBmVuB;EkBlVvB,uClByOmB;EkBxOnB,sClBwOmB;A3BuvIvB;A6C59IE;EACE,qClB+UuB;EkB9UvB,uClB0OmB;EkBzOnB,sClByOmB;A3BqvIvB;A6C39IE;EACE,sClB0UwB;EkBzUxB,uClBwOmB;EkBvOnB,sClBuOmB;A3BsvIvB;A8C9hJA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;A9CgiJF;A8C9hJE;ErBmBA,iBAAA;AzB8gJF;AyB5gJE;EqBrBA;IrBuBE,qBAAA;IAEA,kBAAA;IAEA,yBAAA;EzB4gJF;AACF;A8CniJE;ErBcA,iBAAA;AzBwhJF;AyBthJE;EqBhBA;IrBkBE,gCAAA;IAEA,kBAAA;IAEA,yBAAA;EzBshJF;AACF;A8CxiJE;ErBSA,iBAAA;AzBkiJF;AyBhiJE;EqBXA;IrBaE,uBAAA;IAEA,kBAAA;IAEA,yBAAA;EzBgiJF;AACF;A8C7iJE;ErBIA,kBAAA;AzB4iJF;AyB1iJE;EqBNA;IrBQE,gCAAA;IAEA,kBAAA;IAEA,yBAAA;EzB0iJF;AACF;A8CljJE;ErBDA,iBAAA;AzBsjJF;AyBpjJE;EqBDA;IrBGE,qBAAA;IAEA,kBAAA;IAEA,yBAAA;EzBojJF;AACF;A+CplJA;EvBkBE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EuB3CA,wDAAA;EAEA,+EAAA;EACA,4FAAA;EACA,iDpBb8B;EoBc9B,8CpBciC;EoBbjC,0CpBkV8B;EoBjV9B,qBAAA;EACA,0CpBqQoB;EoBpQpB,qCpBiTe;EoBhTf,iBAAA;EACA,8BAAA;A/C2lJF;AwB1mJE;EuBCF;ItBDE,qBAAA;EzB8mJA;EyB5mJA;IACE,qBAAA;EzB8mJF;AACF;A0BrkJE;EACE;IDvCA,qBAAA;EzB+mJF;AACF;A0B1kJE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBonJF;AACF;AyBjnJE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBknJF;AACF;A+ClnJE;EACE,8CpBK+B;EoBJ/B,0CpBqU4B;A3B+yIhC;A+ClnJI;EACE,0CpBiU0B;A3BmzIhC;A+CjnJI;EACE,+CpBqB8B;A3B8lJpC;A0BjnJa;EqBGT,uCpBuQmB;EoBtQnB,gBAAA;A/CinJJ;A0BrnJa;EqBQT,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A/CgnJJ;A+C5mJW;EAEP,uDpBF6B;EoBG7B,+CpBCgC;EoBAhC,YAAA;A/C6mJJ;A+CzmJW;EAMP,8DAAA;EAEA,gBAAA;EAGA,cAAA;EAEA,eAAA;EAEA,aAAA;EAGA,yFAAA;A/C+lJJ;A+C5lJE;EAEE,0CpB8Q4B;EoB7Q5B,0EAAA;EACA,kCpBiPa;A3B42IjB;A+C1lJE;EAEE,4CpBiT8B;A3B0yIlC;A+CxlJE;EAEE,kBAAA;A/CylJJ;A+CtlJE;EAxFF;IAyFI,gBAAA;IACA,YAAA;E/CylJF;AACF;AgDvrJA;ExBqBE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAwHA,0BAAA;EwBhJA,sCrBsEyB;EqBrEzB,0CrBsV8B;EqBrV9B,kBAAA;EACA,oBAAA;EACA,oBAAA;AhD4rJF;AwBjsJE;EwBFF;IvBEE,qBAAA;EzBqsJA;EyBnsJA;IACE,qBAAA;EzBqsJF;AACF;A0B5pJE;EACE;IDvCA,qBAAA;EzBssJF;AACF;A0BjqJE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExB2sJF;AACF;AyBxsJE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBysJF;AACF;AgDntJE;EAEE,yCrBkE0B;A3BkpJ9B;AgDjtJE;EACE,0CrBuU4B;A3B44IhC;AgDhtJE;EACE,0CrBqU4B;A3B64IhC;AgD/sJE;EACE,gBAAA;AhDitJJ;AgD5sJE;EACE,cAAA;AhD8sJJ;AgD3sJE;EACE,gDrB4FiC;A3BinJrC;AiD9uJA;EACE,0CtBgFkB;EsB/ElB,4FAAA;EAEA,qJACE;EAEF,gBAAA;EACA,WAAA;AjD6uJF;AiD3uJE;EACE,4FAAA;EACA,oIACE;AjD4uJN;AiDvuJA;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;AjDyuJF;AiDvuJE;EACE,yCtB+PkB;A3B0+ItB;AiDvuJI;EACE,gBAAA;EACA,sCtB2PgB;A3B8+ItB;AkD5vJA;EACE,aAAA;EACA,kBAAA;EACA,gBANiB;EAOjB,gBARU;AlDswJZ;AkD5vJE;EACE,gCAAA;EAEA,WAAA;AlD6vJJ;AkD1vJE;EAZF;IAaI,gBAfS;ElD4wJX;EkD3vJE;IACE,gCAAA;ElD6vJJ;AACF;AkDzvJA;E1BVE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;E0BOA,0CvB+CkB;EuB9ClB,yCvBqPoB;EuBpPpB,oCvByBuB;EuBxBvB,wBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,0CvBiT8B;EuBhT9B,gBAAA;EACA,eAAA;EACA,gBAtCU;EAuCV,gBAAA;AlD6vJF;AkD3vJE;EACE,yFAAA;AlD6vJJ;AkD1vJE;E1B9BA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;E0B2BE,0BAAA;EACA,gBAAA;AlD8vJJ;AkD1vJA;E1BtCE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;ECiBA,0BEoRe;EuBjQf,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,8BvB8Pe;EuB7Pf,mCvB8Pe;A3BggJjB;AyBnxJW;EAwBL,mDAAA;AzB8vJN;AyB5vJM;EACE,kDAAA;AzB8vJR;AkDlwJE;E1BhDA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAUA,SAAA;E0BmCE,0CvBkQ4B;A3BqgJhC;AkDpwJE;EACE,0CvB4Q4B;EuB3Q5B,iCvBkPa;A3BohJjB;AkDlwJA;E1B5DE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EewDE,4EAAA;EdvCF,0BEqRe;EuB3Of,0CvBLkB;EuBMlB,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BvBwOe;EuBvOf,kBAAA;AlDswJF;AyBnzJW;EAwBL,mDAAA;AzB8xJN;AyB5xJM;EACE,kDAAA;AzB8xJR;AkD1wJE;EACE,mBAAA;EAGA,4DAAA;AlD0wJJ;AkDzwJI;;;EAGE,OAAA;AlD2wJN;AkDtwJE;EAzBF;IA0BI,mBAAA;ElDywJF;AACF;AkDvwJE;EACE;IA9BJ;MA+BM,mBAAA;IlD0wJF;EACF;AACF;AmD73JA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;AnD+3JF;AmD53JA;EACE,gExBewC;EwBdxC,aAAA;EACA,aAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;AnD83JF;AmD53JE;EACE,6BAAA;EACA,oBAAA;AnD83JJ;AmD13JM;EACE,mBAAA;AnD43JR;AmD13JQ;EACE,UAAA;AnD43JV;AoD15JA;EACE,6BAAA;EACA,YAAA;EACA,wBAAA;EACA,mCzBmSqB;EyBlSrB,aAAA;EACA,gEAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;ApD45JF;AoD15JE;EACE,6BAAA;EACA,cAAA;ApD45JJ;AoDx5JA;EACE,qBAAA;EACA,sBAAA;ApD05JF;AyBh6JE;E2BQA;I3BNE,2BAAA;IAEA,0CAAA;EzBi6JF;AACF;AoD15JE;EACE,2CzBN4B;EyBO5B,qCzBmSa;A3BynJjB;AoDz5JE;EACE,0CzBwT4B;A3BmmJhC;AoDx5JE;E3BSA,0BEoRe;EyB1Rb,aAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;ApDy5JJ;AyBn5JW;EAwBL,mDAAA;AzB83JN;AyB53JM;EACE,kDAAA;AzB83JR;AoD55JE;EACE,mBAAA;EACA,6BAAA;EACA,yEAAA;EACA,wDzB0NiC;EyBzNjC,2CzB3B4B;EyB4B5B,aAAA;EACA,0CzB8S4B;EyB7S5B,mCzBoPmB;EyBnPnB,uBAAA;EACA,oBAAA;EACA,kCzB6OmB;A3BirJvB;AoD55JI;EACE,sDzBpC0B;EyBqC1B,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mCzB6NiB;EyB5NjB,kCzB4NiB;A3BksJvB;AoD35JI;EACE,4CzB+CoB;EyB9CpB,2CzB0MmB;A3BmtJzB;AoD15JI;EACE,yBAAA;EACA,iFAAA;ApD45JN;AoDv5JI;EACE,6BAAA;EACA,0CzB0BkB;A3B+3JxB;AoDv5JM;EACE,0CzBuBgB;EyBtBhB,aAAA;ApDy5JR;AoDr5JI;EACE,+CzBvC8B;A3B87JpC;AoDl5JI;EACE,kDAAA;EACA,gDzB8B+B;A3Bs3JrC;AoDl5JM;EACE,2DzB2B6B;A3By3JrC;AoDj5JM;EACE,yBAAA;EACA,mDAAA;ApDm5JR;AoD/4JI;EACE,gDzBiB+B;A3Bg4JrC;AoD74JM;EACE,8DzBcoC;EyBbpC,gDzBW6B;A3Bo4JrC;AoD74JQ;EACE,+DzBUkC;A3Bq4J5C;AoD34JM;EACE,uDzBKoC;A3Bw4J5C;AoDx4JM;EACE,uDzBH6B;A3B64JrC;AoDx4JQ;EACE,uDzBN2B;EyBO3B,aAAA;ApD04JV;AqD7gKA;EACE,mBAAA;EACA,2C1BkB8B;E0BjB9B,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,uC1B+RqB;E0B9RrB,sC1B8RqB;E0B7RrB,kBAAA;ArD+gKF;AqD7gKE;E7BSA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EAWA,gBAAA;EACA,SAAA;EiB/DA,gBAAA;EAEA,6BAAA;EAEA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AzCsiKF;AwB5iKE;E6BUA;I5BVA,qBAAA;EzBgjKA;EyB9iKA;IACE,qBAAA;EzBgjKF;AACF;A0BvgKE;EACE;IDvCA,qBAAA;EzBijKF;AACF;A0B5gKE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBsjKF;AACF;AyBnjKE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBojKF;AACF;AyC7jKE;EACE,mBAAA;AzC+jKJ;AqDzjKE;EACE,+BAAA;ArD2jKJ;AqDxjKE;EACE,sC1B+HuB;A3B27J3B;AqDvjKE;EACE,+C1BuBgC;E0BtBhC,mBAAA;ArDyjKJ;AqDtjKE;EACE,gCAAA;ArDwjKJ;AqDpjKI;EACE,sC1BiHqB;A3Bq8J3B;AqDljKE;EACE,8C1BhB+B;A3BokKnC;AqDhjKI;EACE,2C1BjD0B;A3BmmKhC;AqD/iKI;EACE,8C1BjD6B;A3BkmKnC;AqD7iKE;EACE,sC1B8FuB;A3Bi9J3B;AsDrkKA;E9BZE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;E8BbA,4DAAA;EAEA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,kC3B6OoB;E2B5OpB,0C3BuOoB;E2BtOpB,sDAnCyB;EAoCzB,sEAAA;EACA,WAAA;AtD4kKF;AwBznKE;E8B+BF;I7B/BE,qBAAA;EzB6nKA;EyB3nKA;IACE,qBAAA;EzB6nKF;AACF;A0BplKE;EACE;IDvCA,qBAAA;EzB8nKF;AACF;A0BzlKE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBmoKF;AACF;AyBhoKE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBioKF;AACF;AsDnmKE;EApBA,mDA3BoB;EA4BpB,kC3B0PoB;E2BpOlB,8C3BqDoB;A3BgjKxB;AsDlmKE;EA1BA,mDA3BoB;EA4BpB,kC3B0PoB;E2B9NlB,sgBACE;AtDmmKN;AsDrlKE;EA5CA,mDA3BoB;EA4BpB,kC3B0PoB;E2B5MlB,6CAAA;AtDulKJ;AsDplKE;EA/DA,gBAAA;EACA,sD3BpB8B;E2BqB9B,SAAA;EACA,eAAA;EACA,gBAfoB;EAgBpB,oEAAA;EACA,+RAAA;EACA,+FAhBA;EAiBA,0CAAA;EAAA,kCAAA;EACA,kC3BwQqB;A3B84JvB;AsD5lKE;EAnEA,gBAAA;EACA,sD3BpB8B;E2BqB9B,SAAA;EACA,eAAA;EACA,gBAfoB;EAgBpB,oEAAA;EACA,+RAAA;EACA,+FAhBA;EAiBA,uCAAA;EAAA,kCAAA;EACA,kC3BwQqB;E2B3MnB,gLACE;AtDqmKN;AsDjmKE;EAGE,yD3B7F+B;E2B8F/B,UAAA;AtDimKJ;AsD9lKE;EAGE,yD3BpG+B;A3BksKnC;AsD3lKE;EACE,yDAAA;EAEA,oBAAA;AtD4lKJ;AsD1lKI;EACE,gBAAA;AtD4lKN;AsDzlKI;EACE,gBAAA;AtD2lKN;AsDxlKI;EAGE,kBAAA;AtDwlKN;AsDrlKI;EACE,YAAA;AtDulKN;AsDnlKE;EACE,kDAAA;EACA,mIAAA;AtDqlKJ;AoB9sKA;EACE;IACE,SAAA;IACA,oCOqOmB;E3B2+JrB;EoB7sKA;IACE,kCAAA;IACA,sCOiOqB;E3B8+JvB;AACF;AoB5sKA;EACE;IACE,kCAAA;IACA,sCO0NqB;E3Bo/JvB;EoB3sKA;IACE,SAAA;IACA,oCOoNmB;E3By/JrB;AACF;AoB1sKA;EACE,8BAAA;EACA,2BAAA;EAEA,mBAAA;EACA,6CO+H2B;EP9H3B,oDOmO+B;EPlO/B,iDOiIoC;EPhIpC,0CO+S8B;EP9S9B,gCOgPqB;EP/OrB,gBAzCmB;EA0CnB,gBAzCmB;EA0CnB,oCO+OqB;EF5MrB,iEAAA;AzByqKF;AyBxqKE;ELjCE,6QAAA;EACA,aAAA;EACA,8FAAA;EACA,cAAA;EACA,eAAA;ApB4sKJ;AyB3qKE;ELrCE,6QAAA;EACA,aAAA;EACA,8FAAA;EACA,cAAA;EACA,eAAA;ApBmtKJ;AoBhtKE;EACE,2COqGuB;EPpGvB,+COwGgC;A3B0mKpC;AoB/sKE;EACE,6COgFyB;EP/EzB,iDOmFkC;A3B8nKtC;AoB9sKE;EACE,2COmFuB;EPlFvB,+COsFgC;A3B0nKpC;AoB7sKE;EACE,iDO8D6B;EP7D7B,qDOiEsC;A3B8oK1C;AoB5sKE;EACE,oCOKgB;EPJhB,wCOwFyB;A3BsnK7B;AoB3sKE;EA/CF;IAgDI,iBAAA;EpB8sKF;AACF;AuD/xKA;EACE,mBAAA;EACA,oC5B0DuB;E4BzDvB,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,uC5B+RqB;E4B9RrB,sC5B8RqB;E4B7RrB,kBAAA;AvDiyKF;AuD/xKE;E/BSA,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EAmBA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EAWA,gBAAA;EACA,SAAA;EiB/DA,gBAAA;EAEA,6BAAA;EAEA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EcSE,SAAA;AvDgzKJ;AwB/zKE;E+BUA;I9BVA,qBAAA;EzBm0KA;EyBj0KA;IACE,qBAAA;EzBm0KF;AACF;A0B1xKE;EACE;IDvCA,qBAAA;EzBo0KF;AACF;A0B/xKE;EACE;IFvCA,yDAAA;IACA,0BAAA;ExBy0KF;AACF;AyBt0KE;ECkCE;IDhCA,sCAAA;IAEA,qDAAA;EzBu0KF;AACF;AyCh1KE;EACE,mBAAA;AzCk1KJ;AuDz0KE;EACE,uBAAA;EACA,+EAAA;EACA,0C5BoQmB;E4BnQnB,aAAA;EACA,sBAAA;EACA,mC5BsQmB;E4BrQnB,QAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iDAAA;EACA,kC5BqQmB;A3BskKvB;AuDz0KI;EACE,gD5Bd0B;E4Be1B,kBAAA;EACA,WAAA;EACA,mC5BuPiB;E4BtPjB,gC5B2OgB;E4B1OhB,kBAAA;EACA,iDAAA;EACA,kC5BmPiB;A3BwlKvB;AuDt0KI;EACE,uBAAA;EACA,uD5B4E+B;A3B4vKrC;AuDt0KM;EACE,qD5ByE6B;A3B+vKrC;AuDn0KE;EAEE,gD5B9D4B;E4B+D5B,kD5B/D4B;A3Bm4KhC;AuDl0KI;EACE,qD5B8D+B;E4B7D/B,kDAAA;AvDo0KN;AuDh0KE;EACE,mD5BxB6B;E4ByB7B,mBAAA;AvDk0KJ;AuDh0KI;EACE,iD5B5B2B;A3B81KjC;AuD9zKE;EAEE,iD5BlC6B;E4BmC7B,mD5BnC6B;A3Bk2KjC;AuD7zKI;EACE,2D5B0C+B;A3BqxKrC;AuD3zKE;EACE,uBAAA;EACA,8D5BsCwC;A3BuxK5C;AuD3zKI;EACE,kE5BmCsC;A3B0xK5C;AuDzzKE;EAEE,qD5B2BiC;E4B1BjC,uD5B0BiC;A3BgyKrC;AuDxzKI;EACE,sD5BzG0B;A3Bm6KhC;AuDtzKE;EAEE,4D5BmBwC;E4BlBxC,4D5BiBsC;A3BsyK1C;AuDrzKI;EACE,4D5BgBsC;A3BuyK5C;AqBl6KA;EACE,SAAA;EACA,yBAAA;EACA,iBAAA;EAGA,kBAAA;EACA,WAAA;EA2HA;;;;;GAAA;ArB6yKF;AqBt6KE;EmCEA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kC7B0RqB;E6B7SrB,gD7BqFwB;E6BpFxB,uC7BoD0B;E6BnD1B,0C7BuV8B;ENxU5B,8EAfiB;EAgBjB,mCMqRmB;ENpRnB,gBAAA;EACA,uBAAA;EACA,mBAAA;ArB66KJ;AwD97KE;EACE,gD7BoFsB;E6BnFtB,uC7B+CwB;A3Bi5K5B;AwD77KE;EACE,sD7BW4B;E6BV5B,+C7BNgC;A3Bq8KpC;AwD16KE;EACE,0D7B0O0B;A3BksK9B;AwDz6KE;EACE,2D7BsO0B;A3BqsK9B;AqBz7KI;EACE,gCAAA;ArB27KN;AqBv7KE;EmCZA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kC7B0RqB;E6BpRrB,0C7BwDkB;ENlDhB,oCMkCqB;ENjCrB,0CM0T4B;ENzT5B,mCMsQmB;ENrQnB,+DAAA;ArB47KJ;AqBz7KE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ArB27KJ;AqBx7KE;;EAEE,sCM0PmB;ENzPnB,kBAAA;ArB07KJ;AqBx7KI;;EACE,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ArB27KN;AqBz7KM;;EACE,0BAAA;ArB47KR;AqBv7KE;EACE,mCMuOmB;ENtOnB,+DAAA;ArBy7KJ;AqBt7KE;EACE,mCMwOmB;ENvOnB,+DAAA;ArBw7KJ;AqBr7KE;EmCvDA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kC7B0RqB;E6B7SrB,gD7BqFwB;E6BpFxB,uC7BoD0B;E6BnD1B,0C7BuV8B;EN7Q5B,2EA1EiB;ArBogLrB;AwDlgLE;EACE,gD7BoFsB;E6BnFtB,uC7B+CwB;A3Bq9K5B;AwDjgLE;EACE,sD7BW4B;E6BV5B,+C7BNgC;A3BygLpC;AqB/7KE;;EAGE,uEA/EU;ArB+gLd;AqB77KE;;EAEE,8EApFU;ArBmhLd;AqB57KE;EACE,8EAzFiB;ArBuhLrB;AqBv7KI;;;;;;;EACE,SAAA;ArB+7KN;AqB37KE;;;EAGE,6BAAA;ArB67KJ;AqB17KE;EACE,gDMrBsB;A3Bi9K1B;AqBx7KI;EACE,gDM9BoB;A3Bw9K1B;AqBt7KE;EACE,aAAA;EACA,sBAAA;EACA,0BMyMa;A3B+uKjB;AqBt7KI;;;EAGE,aAAA;ArBw7KN;AqBr7KI;EACE,mCMkKiB;A3BqxKvB;AqB76KE;EACE,gBAAA;ArB+6KJ;AqB36KA;EACE,gBAAA;ArB66KF;AqB16KA;EACE,6EApJY;ArBgkLd;AqBz6KA;EACE,4EAxJY;ArBmkLd;AqBv6KE;EACE,cAAA;ArBy6KJ;AqBt6KE;EACE,0EAAA;EACA,iDMsG0B;A3Bk0K9B;AqBn6KQ;EACE,gBAAA;ArBq6KV;AqBl6KQ;EACE,cAAA;EACA,aAAA;ArBo6KV;AqBj6KQ;EACE,eAAA;ArBm6KV;AyDvlLA;EACE,mD9BoK2B;E8BnK3B,4EAAA;EACA,mD9B8P8B;E8B7P9B,sBAAA;EACA,iD9BoKoC;E8BnKpC,qBAAA;EACA,0C9B+U8B;E8B9U9B,mC9BuRqB;E8BtRrB,yDAAA;EACA,wBAAA;EACA,mBAAA;AzDylLF;AyDvlLE;ECbA,0C/BiFkB;E+BhFlB,sC/BgFkB;E+B/ElB,wC/BmK2B;A3Bo8K7B;AyDxlLE;EACE,iD9BmIuB;E8BlIvB,6C9BkIuB;E8BjIvB,+C9BqIgC;A3Bq9KpC;AyDvlLE;EACE,iD9BqIuB;E8BpIvB,6C9BoIuB;E8BnIvB,+C9BuIgC;A3Bk9KpC;AyDtlLE;EACE,mD9B+GyB;E8B9GzB,+C9B8GyB;E8B7GzB,iD9BiHkC;A3Bu+KtC;AyDrlLE;EACE,6BAAA;EACA,0BAAA;EACA,wC9B+HyB;A3Bw9K7B;AyDrlLI;EACE,uD9BoF+B;E8BnF/B,gD9BmF+B;A3BogLrC;AyDplLI;EACE,sC9BuGqB;A3B++K3B;AyDnlLI;EACE,sC9B2GqB;A3B0+K3B;AyDllLI;EACE,wC9BuFuB;A3B6/K7B;AyDhlLE;EA1DF;IA2DI,0C9B6R4B;I8B5R5B,mC9BoOmB;E3B+2KrB;AACF;AsBpoLA;;;EAGE,kBAAA;AtBsoLF;AsBpoLE;;;EACE,YAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;AtBwoLJ;AsBtoLI;;;EACE,UAAA;EACA,8CAAA;AtB0oLN;AsBvoLI;;;EACE,6CAAA;AtB2oLN;AsBxoLI;;;EACE,YAAA;EACA,SAAA;AtB4oLN;AsBzoLI;;;;;EAEE,WAAA;EACA,0BAAA;AtB8oLN;AsB5oLM;;;;;EACE,YAAA;EACA,4CAAA;AtBkpLR;AsB9oLI;;;EACE,UAAA;EACA,WAAA;AtBkpLN;AsB/oLI;;;EACE,UAAA;AtBmpLN;AsBhpLI;;;;;EAEE,kBAAA;AtBqpLN;AsBhtLE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,UAAA;EACA,oBAAA;AtBgwLJ;AsBpwLE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,UAAA;EACA,oBAAA;AtBoyLJ;A2D1yLA;EnCmBE,UAAA;EAIA,0EAAA;EACA,WAAA;EACA,sBAAA;EA2CA,SAAA;EACA,eAAA;EC3BA,0BEqRe;EgC3Tf,aAAA;EACA,sBAAA;EACA,8BAAA;A3DgzLF;AyB1wLW;EAwBL,mDAAA;AzBqvLN;AyBnvLM;EACE,mDAAA;AzBqvLR;AInuLE;EuDzFF;IASI,mBAAA;E3DuzLF;AACF;A2DrzLE;EACE,sBAAA;A3DuzLJ;A4D1zLE;EACE;IACE,oCjCmOiB;E3BylLrB;E4DzzLE;IACE,0CCNQ;E7Di0LZ;AACF;A4Dl0LE;EACE;IACE,0CCFQ;E7Ds0LZ;E4Dj0LE;IACE,oCjC+NiB;E3BomLrB;AACF;A4D7zLE;EACE;IACE,2BAAA;E5D+zLJ;E4D5zLE;IACE,wBAAA;E5D8zLJ;AACF;A4Dr0LE;EACE;IACE,4BAAA;E5Du0LJ;E4Dp0LE;IACE,wBAAA;E5Ds0LJ;AACF;A4D70LE;EACE;IACE,wBAAA;E5D+0LJ;E4D50LE;IACE,4BAAA;E5D80LJ;AACF;A4Dr1LE;EACE;IACE,wBAAA;E5Du1LJ;E4Dp1LE;IACE,2BAAA;E5Ds1LJ;AACF;A6Dj2LE;EACE,kDlCyLsB;EkCxLtB,uBAAA;EACA,iFlCgN8C;A3BmpLlD;A6Dh2LE;EA1BA,kDlCmNwB;EkClNxB,iFlCsOgD;EkC1M9C,mCAAA;A7Dk2LJ;A6D/1LE;EAhCA,kDlCmNwB;EkClNxB,iFlCsOgD;EkCpM9C,qCAAA;A7Di2LJ;A6D91LE;EACE,sDlC0K0B;EkCzK1B,uBAAA;EACA,iFlC8L8C;A3BkqLlD;A6D71LE;EACE,kDlCiKsB;EkChKtB,wBAAA;EACA,iFlCqL8C;A3B0qLlD;A6D51LE;EA7CA,kDlC0MwB;EkCzMxB,iFlC8NgD;EkC/K9C,oCAAA;A7D81LJ;A6D31LE;EAnDA,kDlC0MwB;EkCzMxB,iFlC8NgD;EkCzK9C,sCAAA;A7D61LJ;A6D11LE;EACE,sDlCkJ0B;EkCjJ1B,wBAAA;EACA,iFlCmK8C;A3ByrLlD;A4D/5LE;EACE;IACE,2CAAA;E5Di6LJ;E4D95LE;IACE,iDAAA;E5Dg6LJ;AACF;A4Dv6LE;EACE;IACE,iDAAA;E5Dy6LJ;E4Dt6LE;IACE,2CAAA;E5Dw6LJ;AACF;A8Dv6LE;EACE,kDnCwMsB;EmCvMtB,wBAAA;EACA,iFnC8N8C;A3B2sLlD;A8Dt6LE;EACE,sDnCoM0B;EmCnM1B,wBAAA;EACA,yEnCgOsC;A3BwsL1C;A8Dr6LE;EACE,kDnC4LsB;EmC3LtB,0BAAA;EACA,iFnC+M8C;A3BwtLlD;A8Dp6LE;EACE,sDnCwL0B;EmCvL1B,0BAAA;EACA,yEnCkNsC;A3BotL1C;A+Dl8LA;EAKE,0HACE;EAGF,kHAAA;EACA,gDAAA;EACA,sEpCuNqC;A3BsuLvC;A4Dl6LE;EACE;IACE,wBAAA;E5Do6LJ;E4Dj6LE;IACE,kDAAA;E5Dm6LJ;AACF;A4D16LE;EACE;IACE,kDAAA;E5D46LJ;E4Dz6LE;IACE,4BAAA;E5D26LJ;AACF;A4Dl7LE;EACE;IACE,4BAAA;E5Do7LJ;E4Dj7LE;IACE,wBAAA;E5Dm7LJ;AACF","sourcesContent":[":host {\n  @import \"~@ids/tokens/itau_bba/tokens.css\";\n  @import \"@ids/styles/scss/styles\";\n  @import \"@ids/styles/css/components/text/text.css\";\n}\n","/*\n** Voxel Foundation Module Handler\n*/\n@use '../functions/unit-transform' as *;\n@use 'sass:string';\n@use 'sass:list';\n@use 'sass:meta';\n@use 'sass:map';\n\n/// filtra os valores de um mapa para outro mapa, recebe duas entradas,\n/// os valores em um mapa e uma string com o texto que deve ser filtrado\n/// @param {Map} $map - Mapa para filtrar\n/// @param {String} $string - Texto para referencia do filtro\n/// @return {Map or Null} - Mapa com as variaveis do filtro\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   $margin-top: map-by-string($margins, \"top\")\n///   // $margin-top: (\"top\": \"1rem\")\n@function map-by-string($map, $string) {\n  $map-string: () !default;\n\n  @each $key, $value in $map {\n    @if (string.index($key, $string) != null) {\n      $map-string: map.merge($map-string, ($key: $value));\n    }\n  }\n\n  @if (length($map-string) != 0) {\n    @return $map-string;\n  }\n\n  @return null;\n}\n\n/// Recebe uma string e quebra por um separador,\n/// retorna o elemento do vetor correspondente ao índice enviado\n/// @param {String} $string - String para quebrar\n/// @param {String} $separator - Separador\n/// @param {Number} $position - Posição para retornar\n/// @return {String} - Parte da string\n/// @example scss\n///   $back: \"background-color-red\"\n///   p {\n///     background-color: string-key-split($back, \"-\", 2);\n///   }\n///   // background-color: red\n@function string-key-split($string, $separator, $position) {\n  $split-arr: ();\n  $index: str-index($string, $separator);\n\n  @while $index != null {\n    $item: string.slice($string, 1, $index - 1);\n    $split-arr: list.append($split-arr, $item);\n    $string: string.slice($string, $index + 1);\n    $index : string.index($string, $separator);\n  }\n\n  $split-arr: append($split-arr, $string);\n\n  @return list.nth($split-arr, $position);\n}\n\n/// Retorna o maior número absoluto de um mapa\n/// @param {Map} $map - Mapa de numeros\n/// @return {Number} - Maior numero\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   div {\n///     margin: get-max($margins)rem;\n///   }\n///   // margin: 2rem\n@function get-max($map) {\n  $list: ();\n\n  @each $key, $value in $map {\n    $list: list.append($list, strip-unit($value));\n  }\n\n  @return max($list...);\n}\n\n/// Retorna o menor número absoluto de um mapa\n/// @param {Map} $map - Mapa de numeros\n/// @return {Number} - Menor numero\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   div {\n///     margin: get-min($margins)rem;\n///   }\n///   // margin: 0.5rem\n@function get-min($map) {\n  $list: ();\n\n  @each $key, $value in $map {\n    $list: list.append($list, strip-unit($value));\n  }\n\n  @return min($list...);\n}\n\n/// Recebe uma chave e um mapa, retorna a chave subsequente\n/// @param {Map} $map - Mapa para filtrar\n/// @param {String} $string - Texto para referencia\n/// @return {Map or Null} - string | null\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   div {\n///     margin: map.get($margins,map-next-value($margins, \"top\"));\n///   }\n///   // margin: 1.5rem\n@function map-next-value($map, $string) {\n  $index: list.index(map.keys($map), $string) + 1;\n\n  @if list.length(map.keys($map)) >= $index {\n    @return list.nth(map.keys($map), $index);\n  }\n\n  @return null;\n}\n\n/// Recebe uma chave e um mapa, retorna a chave anterior\n/// @param {Map} $map - Mapa para filtrar\n/// @param {String} $string - Texto para referencia\n/// @return {Map or String} - string | null\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   div {\n///     margin: map.get($margins,map-prev-value($margins, \"top\"));\n///   }\n///   // margin: 1.5rem\n@function map-prev-value($map, $string) {\n  $index: list.index(map.keys($map), $string) - 1;\n\n  @if list.length(map.keys($map)) <= $index {\n    @return list.nth(map.keys($map), $index);\n  }\n\n  @return null;\n}\n\n/// Retorna o inverso de um mapa\n/// @param {Map} $map - Mapa para inverter\n/// @return {Map or Null} - Map | null\n/// @example scss\n///   $margins: (\"top\": \"1rem\", \"right\": \"1.5rem\", \"bottom\": \"0.5rem\", \"left\": \"2rem\");\n///   $reverse: map-reverse($margins)\n///   // $reverse:  (\"left\": \"2rem\", \"bottom\": \"0.5rem\", \"right\": \"1.5rem\", \"top\": \"1rem\")\n@function map-reverse($map) {\n  $result: null;\n\n  @if meta.type-of($map) == 'map' {\n    $keys: map.keys($map);\n    $map-reversed: ();\n\n    @for $i from length($keys) through 1 {\n      $map-reversed: map.merge(\n        $map-reversed,\n        (list.nth($keys, $i): map.get($map, list.nth($keys, $i)))\n      );\n    }\n\n    @if meta.type-of($map-reversed) == 'map' {\n      $result: $map-reversed;\n    }\n  }\n\n  @return $result;\n}\n\n/// substitui todas substrings por um novo valor (reclace all)\n/// @author Kitty Giraudel\n/// @param {String} $string - string inicial\n/// @param {String} $search - substring para substituir\n/// @param {String} $replace ('') - novo valor\n/// @return {String} - string atualizada\n/// @example str-reclace(ids-padding-xs, '-', '_') // -> ids_padding_xs\n@function str-replace($string, $search, $replace: '') {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return\n      str-slice($string, 1, $index - 1)\n      + $replace\n      + str-replace(\n        str-slice($string, $index + str-length($search)),\n        $search,\n        $replace\n      );\n  }\n\n  @return $string;\n}\n","/*\n** Voxel Foundation Formats\n*/\n@use 'sass:math';\n@use 'sass:meta';\n\n/// convert valores para rem\n/// @param {Number} $number - Número para converter\n/// @param {context} $context - Base para a conversão\n/// @return {Number} - valor em rem\n/// @example scss - Retorna um valor convertido para rem\n///   margin: rem(32);\n///   // margin: 2rem\n@function rem($number, $context: 16) {\n  @if math.is-unitless($number) == false {\n    $number: strip-unit($number);\n  }\n\n  @return math.div($number, $context) * 1rem;\n}\n\n/// Remove a unidade de um numero\n/// @param {Number} $number - Número para remover a unidade\n/// @return {Number} - número sem unidade\n/// @example scss - Remove a unidade de um número\n///   $margin: 32px;\n///   div {\n///    margin: rem(strip-unit($margin), 16);\n///   }\n///   // margin: 2rem\n@function strip-unit($number) {\n  @if meta.type-of($number) == 'number' and math.is-unitless($number) == false {\n    @return math.div($number, ($number * 0 + 1));\n  }\n\n  @return $number;\n}\n","/* stylelint-disable declaration-no-important */\n@use '../mixins/reset' as *;\n\n.ids-reset-element {\n  background: none;\n  background-color: none;\n  border: 0;\n  color: inherit;\n  cursor: inherit;\n  font: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  text-transform: none;\n}\n\n.ids-reset-input {\n  @include reset-input;\n}\n\n.ids-dummy-width {\n  left: 0 !important;\n  margin: 0 !important;\n  max-width: 100vw !important;\n  opacity: 0 !important;\n  padding: 0 !important;\n  pointer-events: none !important;\n  position: fixed !important;\n  visibility: hidden !important;\n  white-space: nowrap !important;\n  width: auto !important;\n}","/*\n** Voxel Foundation Media Query Mixins\n*/\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use 'sass:string';\n@use 'sass:meta';\n@use 'sass:map';\n\n/// Lista de breakpoints simplificados\n/// @type Map\n/// @group module-mixins\n/// @example scss\n///   xs: $ids_layout_breakpoint_xs,\n///   sm: $ids_layout_breakpoint_sm,\n///   md: $ids_layout_breakpoint_md,\n///   lg: $ids_layout_breakpoint_lg,\n///   xl: $ids_layout_breakpoint_xl\n$breakpoints: (\n  xs: $ids_layout_breakpoint_xs,\n  sm: $ids_layout_breakpoint_sm,\n  md: $ids_layout_breakpoint_md,\n  lg: $ids_layout_breakpoint_lg,\n  xl: $ids_layout_breakpoint_xl\n) !default;\n\n/// Gera @media com padrões dos tokens\n/// @todo implementar forma de troca de @media em diferentes temas\n/// @todo *implement a way to exchange @media on different topics*\n/// @param {token} $from [false] - min-width\n/// @param {token} $until [false] - max-width\n/// @param {all | print | screen | speech} $media-type [all] - Media Types\n/// @group module-mixins\n/// @example scss\n///   @include media-q(sm) {\n///     width: rem(10);\n///   }\n///   /* output: @media screen and (min-width: 48rem) {\n///     width: rem(10);\n///   }*/\n@mixin media-q (\n  $from: false,\n  $until: false,\n  $pointer: false,\n  $media-type: all,\n  $features: false\n) {\n  $min-width: 0;\n  $max-width: 0;\n  $media-pointer: '';\n  $media-query: '';\n  $media-features: '';\n\n  @if $from {\n    @if meta.type-of($from) == number {\n      $min-width: rem($from);\n    }\n\n    @else {\n      $min-width: map.get($breakpoints, $from);\n    }\n  }\n\n  @if $until {\n    @if meta.type-of($until) == number {\n      $max-width: rem($until);\n    }\n\n    @else {\n      $max-width:  map.get($breakpoints, $until) - 0.01rem;\n    }\n  }\n\n  @if $min-width != 0 {\n    $media-query: '#{$media-query} and (min-width: #{$min-width})';\n  }\n\n  @if $max-width != 0 {\n    $media-query: '#{$media-query} and (max-width: #{$max-width})';\n  }\n\n  @if ($pointer and $media-query != '') {\n    $media-pointer: ', (pointer: #{$pointer})';\n  }\n\n  @if ($media-type == 'all' and $media-query != '') {\n    $media-type: '';\n    $media-query: string.slice(string.unquote($media-query), 6);\n  }\n\n  @if ($features and $media-query != '') {\n    $media-features: ', (#{$features})';\n  }\n\n  @media #{$media-type + $media-query + $media-pointer + $media-features} {\n    @content;\n  }\n}\n","/* stylelint-disable plugin/no-low-performance-animation-properties */\n\n/*\n** Voxel Foundation Motion Mixins\n*/\n@use '../functions/unit-transform' as *;\n\n// TO-DO: adicionar parametro de prop para o transição\n\n/// mixin de animação de transição, determina os valores padrões\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include motion-transition('small')\n///   }\n///   //output: transition: all ease 0.5s\n@mixin motion-transition($size, ) {\n  @if $size == 'small' {\n    transition: all ease 0.5s;\n  }\n\n  @else if $size == 'medium' {\n    transition: all ease 0.5s;\n  }\n\n  @else if $size == 'big' {\n    transition: all ease 1s;\n  }\n\n  @else if $size == 'large' {\n    transition: all ease 2s;\n  }\n\n  @else if $size == 'extra-large' {\n    transition: all ease 2s;\n  }\n}\n\n/// Determina alturas máximas padrões\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include motion-max-height('small')\n///   }\n///   //output: max-height: rem(200);\n@mixin motion-max-height($size) {\n  @if $size == 'small' {\n    max-height: rem(200);\n  }\n\n  @else if $size == 'medium' {\n    max-height: rem(500);\n  }\n\n  @else if $size == 'big' {\n    max-height: rem(1000);\n  }\n\n  @else if $size == 'large' {\n    max-height: rem(2000);\n  }\n\n  @else if $size == 'extra-large' {\n    max-height: rem(4000);\n  }\n}\n","/* Box sizing rules */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Remove default padding, list styles on ul, ol elements with a class attribute */\nul,\nol {\n  list-style: none;\n  padding: 0;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  border: 0;\n  font: inherit;\n  font-size: 100%;\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline;\n}\n\n/* Remove default margin */\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul,\nol,\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\n/* Set core body defaults */\nbody {\n  // restaura o valor de height: 100% do internet banking\n  height: initial;\n  line-height: 1.5;\n  min-height: 100vh;\n  scroll-behavior: smooth;\n  text-rendering: optimizespeed;\n}\n\n/* Do not apply blue highlight on active elements on mobile Chrome */\ninput,\ntextarea,\nbutton,\nselect,\na {\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* A elements that don't have a class get default styles */\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\n/* Make images easier to work with */\nimg {\n  max-width: 100%;\n}\n\n/* Natural flow and rhythm in articles by default */\narticle > * + * {\n  margin-top: 1em;\n}\n\n/* Inherit fonts for inputs and buttons */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* Remove all animations and transitions for people that prefer not to see them */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms;\n    animation-iteration-count: 1;\n    scroll-behavior: auto;\n    transition-duration: 0.01ms;\n  }\n}\n\n// Em navegadores que não suportam :focus-visible, aplicam o outline no focus.\n// Este reset serve para tirar o outline quando o navegador não tem suporte,\n// mas está sendo usado o polyfill https://github.com/WICG/focus-visible\n@supports not selector(:focus-visible) {\n  .js-focus-visible :focus:not(.focus-visible) {\n    outline: none;\n  }\n}\n\n@supports not selector(:popover-open) {\n  [popover]:not(.\\:popover-open) {\n    display: none;\n  }\n}\n","/*\n** Voxel Foundation Reboot\n*/\n@use '@ids/tokens/tokens' as *;\n\nbody {\n  color: $ids_color_text_body_01;\n  font: $ids_textStyle_f02_s16_h24_wrg;\n}\n\nh1 {\n  font: $ids_textStyle_f01_s24_h32_wbd;\n}\n\nh2 {\n  font: $ids_textStyle_f01_s20_h28_wrg;\n}\n\nh3 {\n  font: $ids_textStyle_f01_s20_h28_wrg;\n}\n\nh4 {\n  font: $ids_textStyle_f01_s16_h24_wbd;\n}\n","/*\n** Voxel Foundation Background\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-bg\n.ids-color-bg-base {\n  background: $ids_color_bg_base !important;\n}\n\n/// @group module-bg\n.ids-color-bg-variant-01 {\n  background: $ids_color_bg_variant_01 !important;\n}\n\n/// @group module-bg\n.ids-color-bg-variant-02 {\n  background: $ids_color_bg_variant_02 !important;\n}\n\n/// @group module-bg\n.ids-color-bg-brand-primary {\n  background: $ids_color_bg_brand_primary !important;\n}\n\n/// @group module-bg\n.ids-color-bg-brand-secondary {\n  background: $ids_color_bg_brand_secondary !important;\n}\n\n/// @group module-bg\n.ids-color-bg-brand-gradient {\n  background: $ids_color_bg_brand_gradient !important;\n}\n","/*\n** Voxel Foundation Border\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-border\n.ids-border {\n  border-color: $ids_color_border_medium !important;\n  border-style: solid !important;\n  border-width: $ids_size_border_medium !important;\n}\n\n/// @group module-border\n.ids-border-top {\n  border-color: $ids_color_border_medium !important;\n  border-style: solid !important;\n  border-top-width: $ids_size_border_medium !important;\n}\n\n/// @group module-border\n.ids-border-bottom {\n  border-bottom-width: $ids_size_border_medium !important;\n  border-color: $ids_color_border_medium !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-left {\n  border-color: $ids_color_border_medium !important;\n  border-left-width: $ids_size_border_medium !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-right {\n  border-color: $ids_color_border_medium !important;\n  border-right-width: $ids_size_border_medium !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-small {\n  border-style: solid !important;\n  border-width: $ids_size_border_small !important;\n}\n\n/// @group module-border\n.ids-border-small-top {\n  border-style: solid !important;\n  border-top-width: $ids_size_border_small !important;\n}\n\n/// @group module-border\n.ids-border-small-bottom {\n  border-bottom-width: $ids_size_border_small !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-small-left {\n  border-left-width: $ids_size_border_small !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-small-right {\n  border-right-width: $ids_size_border_small !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-large {\n  border-style: solid !important;\n  border-width: $ids_size_border_large !important;\n}\n\n/// @group module-border\n.ids-border-large-top {\n  border-style: solid !important;\n  border-top-width: $ids_size_border_large !important;\n}\n\n/// @group module-border\n.ids-border-large-bottom {\n  border-bottom-width: $ids_size_border_large !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-large-left {\n  border-left-width: $ids_size_border_large !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-large-right {\n  border-right-width: $ids_size_border_large !important;\n  border-style: solid !important;\n}\n\n/// @group module-border\n.ids-border-color-soft {\n  border-color: $ids_color_border_soft !important;\n}\n\n/// @group module-border\n.ids-border-color-medium {\n  border-color: $ids_color_border_medium !important;\n}\n\n/// @group module-border\n.ids-border-color-strong {\n  border-color: $ids_color_border_strong !important;\n}\n\n/// @group module-border\n.ids-border-radius-layout-01 {\n  border-radius: $ids_size_cornerRadius_layout_01 !important;\n}\n\n/// @group module-border\n.ids-border-radius-layout-02 {\n  border-radius: $ids_size_cornerRadius_layout_02 !important;\n}\n\n/// @group module-border\n.ids-no-border {\n  border: none !important;\n}\n\n/// @group module-border\n.ids-no-border-top {\n  border-top: none !important;\n}\n\n/// @group module-border\n.ids-no-border-bottom {\n  border-bottom: none !important;\n}\n\n/// @group module-border\n.ids-no-border-left {\n  border-left: none !important;\n}\n\n/// @group module-border\n.ids-no-border-right {\n  border-right: none !important;\n}\n","/*\n** Voxel Foundation Typography\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-typography\n.ids-insight {\n  color: $ids_color_text_heading_01 !important;\n  font: $ids_textStyle_f01_s24_h32_wrg !important;\n\n  &.-bold {\n    font: $ids_textStyle_f01_s24_h32_wbd !important;\n  }\n\n  &.-variant {\n    color: $ids_color_text_highlight !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n}\n\n/// @group module-typography\n/// /// @deprecated estilo depreciado desde a versão 1.32.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-overline-text {\n  font: $ids_textStyle_f02_s16_h24_wrg !important;\n\n  &.-variant {\n    color: $ids_color_text_highlight !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n}\n\n/// @group module-typography\n.ids-title {\n  color: $ids_color_text_heading_01 !important;\n  font: $ids_textStyle_f01_s32_h48_wrg !important;\n\n  &.-bold {\n    font: $ids_textStyle_f01_s32_h48_wbd !important;\n  }\n\n  &.-variant {\n    color: $ids_color_text_highlight !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n\n  &.-small {\n    font: $ids_textStyle_f02_s24_h32_wrg !important;\n  }\n\n  &.-large {\n    font: $ids_textStyle_f01_s40_h64_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f01_s40_h64_wbd !important;\n    }\n  }\n\n  &.-xlarge {\n    font: $ids_textStyle_f01_s48_h80_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f01_s48_h80_wbd !important;\n    }\n  }\n\n  &.-xxlarge {\n    font: $ids_textStyle_f01_s64_h100_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f01_s64_h100_wbd !important;\n    }\n  }\n}\n\n/// @group module-typography\n.ids-subtitle {\n  color: $ids_color_text_heading_02 !important;\n  font: $ids_textStyle_f02_s24_h32_wrg !important;\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n\n  &.-small {\n    font: $ids_textStyle_f02_s16_h24_wrg !important;\n  }\n\n  &.-large {\n    font: $ids_textStyle_f02_s32_h48_wrg !important;\n  }\n\n  &.-xlarge {\n    font: $ids_textStyle_f02_s40_h64_wrg !important;\n  }\n\n  &.-xxlarge {\n    font: $ids_textStyle_f02_s48_h80_wrg !important;\n  }\n}\n\n/// @group module-typography\n.ids-section-title {\n  color: $ids_color_text_heading_01;\n  font: $ids_textStyle_f01_s20_h28_wrg !important;\n\n  &.-small {\n    font: $ids_textStyle_f01_s16_h24_wbd !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary;\n  }\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.32.0. Usar a classe .ids-section-title em seu lugar.\n.ids-section-title-1 {\n  color: $ids_color_text_heading_01 !important;\n  font: $ids_textStyle_f01_s20_h28_wrg !important;\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.32.0. Usar as variante -small\n/// da classe .ids-section-title em seu lugar.\n.ids-section-title-2 {\n  color: $ids_color_text_heading_01 !important;\n  font: $ids_textStyle_f01_s16_h24_wbd !important;\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n}\n\n/// @group module-typography\n.ids-body-text {\n  color: $ids_color_text_body_01 !important;\n  font: $ids_textStyle_f02_s16_h24_wrg !important;\n\n  &.-bold {\n    font: $ids_textStyle_f02_s16_h24_wbd !important;\n  }\n\n  &.-variant {\n    color: $ids_color_text_body_02 !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n\n  &.-xsmall {\n    font: $ids_textStyle_f02_s12_h18_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s12_h18_wbd !important;\n    }\n  }\n\n  &.-small {\n    font: $ids_textStyle_f02_s14_h20_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s14_h20_wbd !important;\n    }\n  }\n\n  &.-large {\n    font: $ids_textStyle_f02_s18_h26_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s18_h26_wbd !important;\n    }\n  }\n}\n\n/// @group module-typography\n.ids-label {\n  color: $ids_color_feedback_neutral;\n  font: $ids_textStyle_f02_s16_h24_wrg;\n\n  &.-bold {\n    font: $ids_textStyle_f02_s16_h24_wbd !important;\n  }\n\n  &.-information {\n    color: $ids_color_feedback_information !important;\n  }\n\n  &.-success {\n    color: $ids_color_feedback_success !important;\n  }\n\n  &.-alert {\n    color: $ids_color_feedback_alert !important;\n  }\n\n  &.-error {\n    color: $ids_color_feedback_error !important;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary !important;\n  }\n\n  &.-disabled {\n    color: $ids_color_action_disabled_variant !important;\n  }\n\n  &.-xsmall {\n    font: $ids_textStyle_f02_s12_h18_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s12_h18_wbd !important;\n    }\n  }\n\n  &.-small {\n    font: $ids_textStyle_f02_s14_h20_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s14_h20_wbd !important;\n    }\n  }\n\n  &.-large {\n    font: $ids_textStyle_f02_s20_h26_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s20_h26_wbd !important;\n    }\n  }\n\n  &.-xlarge {\n    font: $ids_textStyle_f02_s24_h32_wrg !important;\n\n    &.-bold {\n      font: $ids_textStyle_f02_s24_h32_wbd !important;\n    }\n  }\n}\n\n/// @group module-typography\n.ids-text-icon-small {\n  font: $ids_textStyle_icon_small !important;\n}\n\n/// @group module-typography\n.ids-text-icon {\n  font: $ids_textStyle_icon_medium !important;\n}\n\n/// @group module-typography\n.ids-text-icon-large {\n  font: $ids_textStyle_icon_large !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-title-01 {\n  font: $ids_textStyle_title_01_base !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-title-01-variant {\n  font: $ids_textStyle_title_01_variant !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-section-01 {\n  font: $ids_textStyle_section_01 !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-section-02 {\n  font: $ids_textStyle_section_02 !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-overline {\n  font: $ids_textStyle_overline !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-subtitle-01 {\n  font: $ids_textStyle_subtitle_01 !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-insight {\n  font: $ids_textStyle_insight_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-insight-bold {\n  font: $ids_textStyle_insight_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-body-01 {\n  font: $ids_textStyle_body_01_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-body-01-bold {\n  font: $ids_textStyle_body_01_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-body-02 {\n  font: $ids_textStyle_body_02_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-body-02-bold {\n  font: $ids_textStyle_body_02_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-caption {\n  font: $ids_textStyle_caption_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-caption-bold {\n  font: $ids_textStyle_caption_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-xsmall {\n  font: $ids_textStyle_label_xsmall_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-xsmall-bold {\n  font: $ids_textStyle_label_xsmall_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-small {\n  font: $ids_textStyle_label_small_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-small-bold {\n  font: $ids_textStyle_label_small_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-medium {\n  font: $ids_textStyle_label_medium_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-medium-bold {\n  font: $ids_textStyle_label_medium_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-large {\n  font: $ids_textStyle_label_large_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-large-bold {\n  font: $ids_textStyle_label_large_bold !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-xlarge {\n  font: $ids_textStyle_label_xlarge_regular !important;\n}\n\n/// @group module-typography\n/// @deprecated estilo depreciado desde a versão 1.2.0. A nova família de text styles\n/// deve ser utilizada em seu lugar.\n.ids-text-label-xlarge-bold {\n  font: $ids_textStyle_label_xlarge_bold !important;\n}","/*\n** Voxel Foundation Colors\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-colors\n.ids-color-text-heading-1 {\n  color: $ids_color_text_heading_01 !important;\n}\n\n/// @group module-colors\n.ids-color-text-heading-2 {\n  color: $ids_color_text_heading_02 !important;\n}\n\n/// @group module-colors\n.ids-color-text-body-1 {\n  color: $ids_color_text_body_01 !important;\n}\n\n/// @group module-colors\n.ids-color-text-body-2 {\n  color: $ids_color_text_body_02 !important;\n}\n\n/// @group module-colors\n.ids-color-text-highlight {\n  color: $ids_color_text_highlight !important;\n}\n","/*\n** Public Foundation CSS API\n*/\n\n// Tokens\n@forward '@ids/tokens/tokens';\n\n// Functions\n@forward 'functions/list';\n@forward 'functions/map';\n@forward 'functions/tokens-handler';\n@forward 'functions/unit-transform';\n\n// Helpers\n@forward 'helpers/a11y';\n@forward 'helpers/styles-elements';\n\n// Mixins\n@forward 'mixins/attributes';\n@forward 'mixins/selectors';\n@forward 'mixins/media-query';\n@forward 'mixins/motion';\n@forward 'mixins/support';\n\n// Configurations & Layout\n@forward 'utils/reset';\n@forward 'utils/reboot';\n@forward 'utils/background';\n@forward 'utils/border';\n@forward 'utils/typography';\n@forward 'utils/color';\n@forward 'utils/display';\n@forward 'utils/flex';\n@forward 'utils/opacity';\n@forward 'utils/spacing';\n@forward 'utils/layout';\n@forward 'utils/animation';\n@forward 'utils/text-align';\n\n// Global Components\n@forward 'components/banner-highlight';\n@forward 'components/brand';\n@forward 'components/bottom-sheet';\n@forward 'components/box-field';\n@forward 'components/chart';\n@forward 'components/calendar';\n@forward 'components/card-base';\n@forward 'components/card';\n@forward 'components/chart';\n@forward 'components/checkbox';\n@forward 'components/datepicker';\n@forward 'components/divider';\n@forward 'components/form-field';\n@forward 'components/form-selection';\n@forward 'components/icon';\n@forward 'components/image';\n@forward 'components/input';\n@forward 'components/link';\n@forward 'components/listbox';\n@forward 'components/modal';\n@forward 'components/overlay';\n@forward 'components/password';\n@forward 'components/radio-button';\n@forward 'components/slider';\n@forward 'components/snackbar';\n@forward 'components/switch';\n@forward 'components/table';\n@forward 'components/tag';\n@forward 'components/tooltip-wrapper';\n@forward 'components/tracker';\n\n// Animations\n@forward 'motion/fading';\n@forward 'motion/scaling';\n@forward 'motion/shake';\n\n","/*\n** Voxel Foundation Opacity\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-opacity\n.ids-opacity-empty {\n  opacity: $ids_opacity_empty !important;\n}\n\n/// @group module-opacity\n.ids-opacity-soft {\n  opacity: $ids_opacity_soft !important;\n}\n\n/// @group module-opacity\n.ids-opacity-medium {\n  opacity: $ids_opacity_medium !important;\n}\n\n/// @group module-opacity\n.ids-opacity-strong {\n  opacity: $ids_opacity_strong !important;\n}\n\n/// @group module-opacity\n.ids-opacity-none {\n  opacity: $ids_opacity_none !important;\n}\n","/*\n** Voxel Foundation Spacing\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-spacing\n.ids-margin-auto {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n/// @group module-spacing\n.ids-p-0 {\n  padding: 0 !important;\n}\n\n/// @group module-spacing\n.ids-px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/// @group module-spacing\n.ids-py-0 {\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n}\n\n/// @group module-spacing\n.ids-pt-0 {\n  padding-top: 0 !important;\n}\n\n/// @group module-spacing\n.ids-pb-0 {\n  padding-bottom: 0 !important;\n}\n\n/// @group module-spacing\n.ids-pl-0 {\n  padding-left: 0 !important;\n}\n\n/// @group module-spacing\n.ids-pr-0 {\n  padding-right: 0 !important;\n}\n\n/// @group module-spacing\n.ids-p-1 {\n  padding: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-px-1 {\n  padding-left: $ids_spacing_1x !important;\n  padding-right: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-py-1 {\n  padding-bottom: $ids_spacing_1x !important;\n  padding-top: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-pt-1 {\n  padding-top: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-pb-1 {\n  padding-bottom: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-pl-1 {\n  padding-left: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-pr-1 {\n  padding-right: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-p-2 {\n  padding: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-px-2 {\n  padding-left: $ids_spacing_2x !important;\n  padding-right: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-py-2 {\n  padding-bottom: $ids_spacing_2x !important;\n  padding-top: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-pt-2 {\n  padding-top: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-pb-2 {\n  padding-bottom: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-pl-2 {\n  padding-left: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-pr-2 {\n  padding-right: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-p-3 {\n  padding: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-px-3 {\n  padding-left: $ids_spacing_3x !important;\n  padding-right: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-py-3 {\n  padding-bottom: $ids_spacing_3x !important;\n  padding-top: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-pt-3 {\n  padding-top: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-pb-3 {\n  padding-bottom: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-pl-3 {\n  padding-left: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-pr-3 {\n  padding-right: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-p-4 {\n  padding: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-px-4 {\n  padding-left: $ids_spacing_4x !important;\n  padding-right: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-py-4 {\n  padding-bottom: $ids_spacing_4x !important;\n  padding-top: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-pt-4 {\n  padding-top: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-pb-4 {\n  padding-bottom: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-pl-4 {\n  padding-left: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-pr-4 {\n  padding-right: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-p-5 {\n  padding: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-px-5 {\n  padding-left: $ids_spacing_5x !important;\n  padding-right: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-py-5 {\n  padding-bottom: $ids_spacing_5x !important;\n  padding-top: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-pt-5 {\n  padding-top: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-pb-5 {\n  padding-bottom: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-pl-5 {\n  padding-left: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-pr-5 {\n  padding-right: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-p-6 {\n  padding: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-px-6 {\n  padding-left: $ids_spacing_6x !important;\n  padding-right: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-py-6 {\n  padding-bottom: $ids_spacing_6x !important;\n  padding-top: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-pt-6 {\n  padding-top: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-pb-6 {\n  padding-bottom: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-pl-6 {\n  padding-left: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-pr-6 {\n  padding-right: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-p-7 {\n  padding: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-px-7 {\n  padding-left: $ids_spacing_8x !important;\n  padding-right: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-py-7 {\n  padding-bottom: $ids_spacing_8x !important;\n  padding-top: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-pt-7 {\n  padding-top: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-pb-7 {\n  padding-bottom: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-pl-7 {\n  padding-left: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-pr-7 {\n  padding-right: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-p-8 {\n  padding: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-px-8 {\n  padding-left: $ids_spacing_10x !important;\n  padding-right: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-py-8 {\n  padding-bottom: $ids_spacing_10x !important;\n  padding-top: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-pt-8 {\n  padding-top: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-pb-8 {\n  padding-bottom: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-pl-8 {\n  padding-left: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-pr-8 {\n  padding-right: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-p-9 {\n  padding: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-px-9 {\n  padding-left: $ids_spacing_12x !important;\n  padding-right: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-py-9 {\n  padding-bottom: $ids_spacing_12x !important;\n  padding-top: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-pt-9 {\n  padding-top: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-pb-9 {\n  padding-bottom: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-pl-9 {\n  padding-left: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-pr-9 {\n  padding-right: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-p-10 {\n  padding: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-px-10 {\n  padding-left: $ids_spacing_14x !important;\n  padding-right: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-py-10 {\n  padding-bottom: $ids_spacing_14x !important;\n  padding-top: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-pt-10 {\n  padding-top: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-pb-10 {\n  padding-bottom: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-pl-10 {\n  padding-left: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-pr-10 {\n  padding-right: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-m-0 {\n  margin: 0 !important;\n}\n\n/// @group module-spacing\n.ids-mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n/// @group module-spacing\n.ids-my-0 {\n  margin-bottom: 0 !important;\n  margin-top: 0 !important;\n}\n\n/// @group module-spacing\n.ids-mt-0 {\n  margin-top: 0 !important;\n}\n\n/// @group module-spacing\n.ids-mb-0 {\n  margin-bottom: 0 !important;\n}\n\n/// @group module-spacing\n.ids-ml-0 {\n  margin-left: 0 !important;\n}\n\n/// @group module-spacing\n.ids-mr-0 {\n  margin-right: 0 !important;\n}\n\n/// @group module-spacing\n.ids-m-1 {\n  margin: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-mx-1 {\n  margin-left: $ids_spacing_1x !important;\n  margin-right: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-my-1 {\n  margin-bottom: $ids_spacing_1x !important;\n  margin-top: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-mt-1 {\n  margin-top: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-mb-1 {\n  margin-bottom: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-ml-1 {\n  margin-left: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-mr-1 {\n  margin-right: $ids_spacing_1x !important;\n}\n\n/// @group module-spacing\n.ids-m-2 {\n  margin: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-mx-2 {\n  margin-left: $ids_spacing_2x !important;\n  margin-right: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-my-2 {\n  margin-bottom: $ids_spacing_2x !important;\n  margin-top: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-mt-2 {\n  margin-top: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-mb-2 {\n  margin-bottom: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-ml-2 {\n  margin-left: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-mr-2 {\n  margin-right: $ids_spacing_2x !important;\n}\n\n/// @group module-spacing\n.ids-m-3 {\n  margin: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-mx-3 {\n  margin-left: $ids_spacing_3x !important;\n  margin-right: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-my-3 {\n  margin-bottom: $ids_spacing_3x !important;\n  margin-top: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-mt-3 {\n  margin-top: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-mb-3 {\n  margin-bottom: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-ml-3 {\n  margin-left: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-mr-3 {\n  margin-right: $ids_spacing_3x !important;\n}\n\n/// @group module-spacing\n.ids-m-4 {\n  margin: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-mx-4 {\n  margin-left: $ids_spacing_4x !important;\n  margin-right: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-my-4 {\n  margin-bottom: $ids_spacing_4x !important;\n  margin-top: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-mt-4 {\n  margin-top: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-mb-4 {\n  margin-bottom: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-ml-4 {\n  margin-left: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-mr-4 {\n  margin-right: $ids_spacing_4x !important;\n}\n\n/// @group module-spacing\n.ids-m-5 {\n  margin: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-mx-5 {\n  margin-left: $ids_spacing_5x !important;\n  margin-right: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-my-5 {\n  margin-bottom: $ids_spacing_5x !important;\n  margin-top: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-mt-5 {\n  margin-top: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-mb-5 {\n  margin-bottom: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-ml-5 {\n  margin-left: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-mr-5 {\n  margin-right: $ids_spacing_5x !important;\n}\n\n/// @group module-spacing\n.ids-m-6 {\n  margin: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-mx-6 {\n  margin-left: $ids_spacing_6x !important;\n  margin-right: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-my-6 {\n  margin-bottom: $ids_spacing_6x !important;\n  margin-top: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-mt-6 {\n  margin-top: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-mb-6 {\n  margin-bottom: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-ml-6 {\n  margin-left: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-mr-6 {\n  margin-right: $ids_spacing_6x !important;\n}\n\n/// @group module-spacing\n.ids-m-7 {\n  margin: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-mx-7 {\n  margin-left: $ids_spacing_8x !important;\n  margin-right: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-my-7 {\n  margin-bottom: $ids_spacing_8x !important;\n  margin-top: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-mt-7 {\n  margin-top: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-mb-7 {\n  margin-bottom: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-ml-7 {\n  margin-left: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-mr-7 {\n  margin-right: $ids_spacing_8x !important;\n}\n\n/// @group module-spacing\n.ids-m-8 {\n  margin: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-mx-8 {\n  margin-left: $ids_spacing_10x !important;\n  margin-right: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-my-8 {\n  margin-bottom: $ids_spacing_10x !important;\n  margin-top: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-mt-8 {\n  margin-top: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-mb-8 {\n  margin-bottom: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-ml-8 {\n  margin-left: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-mr-8 {\n  margin-right: $ids_spacing_10x !important;\n}\n\n/// @group module-spacing\n.ids-m-9 {\n  margin: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-mx-9 {\n  margin-left: $ids_spacing_12x !important;\n  margin-right: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-my-9 {\n  margin-bottom: $ids_spacing_12x !important;\n  margin-top: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-mt-9 {\n  margin-top: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-mb-9 {\n  margin-bottom: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-ml-9 {\n  margin-left: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-mr-9 {\n  margin-right: $ids_spacing_12x !important;\n}\n\n/// @group module-spacing\n.ids-m-10 {\n  margin: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-mx-10 {\n  margin-left: $ids_spacing_14x !important;\n  margin-right: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-my-10 {\n  margin-bottom: $ids_spacing_14x !important;\n  margin-top: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-mt-10 {\n  margin-top: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-mb-10 {\n  margin-bottom: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-ml-10 {\n  margin-left: $ids_spacing_14x !important;\n}\n\n/// @group module-spacing\n.ids-mr-10 {\n  margin-right: $ids_spacing_14x !important;\n}\n","/*\n** Voxel Foundation Layout\n*/\n@use '@ids/tokens/tokens' as *;\n@use '../mixins/layout' as *;\n@use '../mixins/media-query' as *;\n\n@mixin ids-container {\n  box-sizing: border-box;\n  margin: 0 auto;\n  width: 100%;\n}\n\n@mixin ids-row {\n  display: grid;\n  margin: 0;\n  width: 100%;\n}\n\n@mixin ids-col {\n  grid-column-end: auto;\n  margin: 0;\n  width: auto;\n}\n\n/// @group module-layout\n[class*='ids-container'] {\n  @include ids-container;\n}\n\n/// @group module-layout\n.ids-container {\n  @include create-container();\n}\n\n/// @group module-layout\n.ids-container-fluid {\n  @include create-container-fluid();\n}\n\n/// @group module-layout\n[class*='ids-row'] {\n  @include ids-row;\n}\n\n/// @group module-layout\n.ids-row {\n  @include create-row();\n  @include create-row-max();\n  @include create-row-fixed();\n}\n\n[class*='ids-grid-'],\n.ids-grid {\n  @include ids-row;\n\n  gap: $ids_size_general_16x;\n  grid-auto-columns: 1fr;\n}\n\n.ids-grid-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.ids-grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.ids-grid-small {\n  gap: $ids_size_general_8x;\n\n  @include media-q($from: xs) {\n    gap: $ids_size_general_12x;\n  }\n}\n\n.ids-grid-large {\n  gap: $ids_size_general_32x;\n}\n\n/// @group module-layout\n.ids-no-gutters {\n  // stylelint-disable-next-line declaration-no-important -- helper\n  gap: 0 !important;\n}\n\n.ids-gutters {\n  @include create-gutters();\n}\n\n/// @group module-layout\n[class*='ids-col-'] {\n  @include ids-col;\n}\n\n/// @group module-layout\n.ids-col {\n  @include ids-col;\n  @include create-columns();\n}\n\n.ids-col-auto {\n  grid-row: 1 / 2;\n}","/*\n** Voxel Foundation Containers Mixins\n*/\n@use '@ids/tokens/tokens' as tokens;\n@use '../functions/list' as *;\n@use '../functions/tokens-handler' as *;\n@use '../functions/unit-transform' as *;\n@use './media-query' as *;\n@use 'sass:meta';\n@use 'sass:list';\n@use 'sass:map';\n\n$tokens-map: meta.module-variables(tokens);\n\n/// Gera containers responsivos\n/// @group module-internal\n/// @example scss\n///   .ids-container {\n///     @include create-container();\n///   }\n///   /* output:\n///   .ids-container {\n///     ...\n///     @media (min-width: 48rem){}\n///     @media (min-width: 64rem){}\n///     @media (min-width: 80rem){}\n///     @media (min-width: 100rem){}\n///   }\n/// */\n@mixin create-container() {\n  $containers: map-by-string($tokens-map, 'ids-layout-container');\n  $padding: map-by-string($tokens-map, 'ids-layout-padding');\n\n  max-width: list.nth(map.values($containers), 1);\n  padding: 0 list.nth(map.values($padding), 1);\n\n  @each $key, $container in $containers {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @if (list.index(map.keys($containers), 'ids-layout-container-#{$breakpoint}') != 1) {\n      @include media-q($from: $breakpoint, $media-type: 'screen') {\n        max-width: $container;\n        padding:\n          0 var(\n            --ids_layout_padding_#{$breakpoint},\n            map.get($padding, 'ids-layout-padding-#{$breakpoint}')\n          );\n      }\n    }\n\n    &-#{$breakpoint} {\n      @each $key, $container-second in $containers {\n        $breakpoint-second: string-key-split($key, '-', 4);\n\n        @if (\n          list.index(map.keys($containers), 'ids-layout-container-#{$breakpoint}') >=\n          list.index(map.keys($containers), 'ids-layout-container-#{$breakpoint-second}')\n        ) {\n          @include media-q($from: $breakpoint-second, $media-type: 'screen') {\n            max-width: $container-second;\n            padding:\n              0 var(\n                --ids_layout_padding_#{$breakpoint},\n                map.get($padding, 'ids-layout-padding-#{$breakpoint-second}')\n              );\n          }\n        }\n      }\n    }\n  }\n}\n\n/// Gera containers responsivos com o mesmo padding para todos os lados\n/// @group module-internal\n/// @todo renomear ou remover e usar os helpers de padding\n/// @example scss\n///   .ids-container-fluid {\n///     @include create-container-fluid();\n///   }\n///   /* output:\n///   .ids-container-fluid {\n///     ...\n///     @media (min-width: 48rem){}\n///     @media (min-width: 64rem){}\n///     @media (min-width: 80rem){}\n///     @media (min-width: 100rem){}\n///   }\n/// */\n@mixin create-container-fluid() {\n  $paddings: map-by-string($tokens-map, 'ids-layout-padding');\n\n  @each $key, $padding in $paddings {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @include media-q($from: $breakpoint, $media-type: 'screen') {\n      $paddingValue: var(--ids_layout_padding_#{$breakpoint}, $padding);\n\n      padding-left: $paddingValue;\n      padding-right: $paddingValue;\n    }\n  }\n}\n\n/// Gera rows responsivos. A quantidade de colunas é baseada nos tokens\n/// $ids_layout_columns\n/// @group module-internal\n/// @example scss\n///   .ids-row {\n///     @include create-row();\n///   }\n///   /* output:\n///   .ids-row {\n///     ...\n///     @media (min-width: 48rem){}\n///     @media (min-width: 64rem){}\n///     @media (min-width: 80rem){}\n///     @media (min-width: 100rem){}\n///   }\n/// */\n@mixin create-row() {\n  $rows: map-by-string($tokens-map, 'ids-layout-columns');\n  $gutters: map-by-string($tokens-map, 'ids-layout-gutter');\n  $minGutterKey: --#{str-replace(list.nth(map.keys($gutters), 1), '-', '_')};\n\n  gap: var($minGutterKey, #{get-min($gutters)}rem);\n  grid-template-columns: repeat(get-min($rows), minmax(0, 1fr));\n\n  @each $key, $row in $rows {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @if (list.index(map.keys($rows), 'ids-layout-columns-#{$breakpoint}') != 1) {\n      @include media-q($from: $breakpoint, $media-type: 'screen') {\n        gap:\n          var(\n            --ids_layout_gutter_#{$breakpoint},\n            map.get(\n              $gutters,\n              'ids-layout-gutter-#{$breakpoint}'\n            )\n          );\n        grid-template-columns: repeat($row, minmax(0, 1fr));\n      }\n    }\n  }\n}\n\n/// Gera rows responsivos com número máximo de colunas. A quantidade de colunas\n/// é baseada nos tokens $ids_layout_columns\n/// @group module-internal\n/// @example scss\n///   .ids-row {\n///     @include create-row-max();\n///   }\n///   /* output: .ids-row-8 {...} .ids-row-fixed-4 {...} */\n@mixin create-row-max() {\n  $rows: map-by-string($tokens-map, 'ids-layout-columns');\n  $gutters: map-by-string($tokens-map, 'ids-layout-gutter');\n  $minGutterKey: --#{str-replace(list.nth(map.keys($gutters), 1), '-', '_')};\n\n  @each $key, $row in $rows {\n    // gera .ids-row-4 .ids-row-8\n    @if (get-max($rows) > $row) {\n      &-#{$row} {\n        gap: var($minGutterKey, #{get-min($gutters)}rem);\n        grid-template-columns: repeat(get-min($rows), minmax(0, 1fr));\n\n        @each $key, $row-point in $rows {\n          $breakpoint: string-key-split($key, '-', 4);\n\n          @if (($row-point <= $row) and (list.index(map.keys($rows),\n          'ids-layout-columns-#{$breakpoint}') != 1)) {\n            @include media-q($from: $breakpoint, $media-type: 'screen') {\n              gap:\n                var(\n                  --ids_layout_gutter_#{$breakpoint},\n                  map.get($gutters, 'ids-layout-gutter-#{$breakpoint}')\n                );\n              grid-template-columns: repeat($row-point, minmax(0, 1fr));\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/// Gera rows não responsivos, com número fixo de colunas. A quantidade de\n/// colunas é baseada nos tokens $ids_layout_columns\n/// @group module-internal\n/// @example scss\n///   .ids-row {\n///     @include create-row-fixed();\n///   }\n///   /* output: .ids-row-fixed-12 {...} .ids-row-fixed-8 {...} ... */\n@mixin create-row-fixed() {\n  $rows: map-by-string($tokens-map, 'ids-layout-columns');\n  $rowList: list-remove-duplicate(map.values($rows));\n  $gutters: map-by-string($tokens-map, 'ids-layout-gutter');\n  $minGutterKey: --#{str-replace(list.nth(map.keys($gutters), 1), '-', '_')};\n\n  // gera .ids-row-fixed-4, ids-row-fixed-8...\n  @each $row in $rowList {\n    &-fixed-#{$row} {\n      $gutters: map-by-string($tokens-map, 'ids-layout-gutter');\n\n      gap: var($minGutterKey, #{get-min($gutters)}rem);\n      grid-template-columns: repeat($row, minmax(0, 1fr));\n\n      // cria media-query para gap responsivo, baseado em tokens\n      @each $key, $gutter in $gutters {\n        $breakpoint: string-key-split($key, '-', 4);\n\n        // ignora tamanho xs, pois esse já é padrão\n        @if (list.index(map.keys($rows), 'ids-layout-columns-#{$breakpoint}') != 1) {\n          @include media-q($from: $breakpoint, $media-type: 'screen') {\n            gap: var(--ids_layout_gutter_#{$breakpoint}, $gutter);\n          }\n        }\n      }\n    }\n  }\n}\n\n/// Gera colunas e offsets responsivos e não responsivos\n/// @group module-internal\n/// @example scss\n///   .ids-col {\n///     @include create-columns();\n///   }\n///   /* output:\n///   .ids-column-1,\n///     [class*='ids-row-fixed'] .ids-column-1 {\n///     ...\n///     @media (min-width: 48rem){}\n///     @media (min-width: 64rem){}\n///     @media (min-width: 80rem){}\n///     @media (min-width: 100rem){}\n///   }\n/// */\n@mixin create-columns() {\n  $columns: map-by-string($tokens-map, 'ids-layout-columns');\n\n  // gera ids-col-[1,2,3...] ids-col-offset-[1,2,3...]\n  @for $i from 1 through get-max($columns) {\n    &-#{$i},\n    [class*='ids-row-fixed'] &-#{$i} {\n      grid-column-end: span $i;\n    }\n\n    &-offset-#{$i} {\n      @if $i < get-max($columns) {\n        grid-column-start: $i;\n      }\n\n      @else {\n        grid-column-start: $i;\n      }\n    }\n\n    // gera as media-queries para as colunas responsivas para terem a mesma\n    // proporção em todas as resoluções\n    @each $key, $column in map-reverse($columns) {\n      $breakpoint: string-key-split($key, '-', 4);\n\n      @if $i > $column and map-next-value($columns, 'ids-layout-columns-#{$breakpoint}') {\n        @include media-q(\n          $until: $breakpoint,\n          $media-type: 'screen'\n        ) {\n          &-#{$i} {\n            grid-column-end: span $column;\n          }\n\n          &-offset-#{$i} {\n            grid-column-start: $column;\n          }\n        }\n      }\n    }\n  }\n\n  // gera ids-col{-offset}-[xs,sm,md...]-[1,2,3...]\n  @each $key, $column in $columns {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @include media-q($from: $breakpoint, $media-type: 'screen') {\n      @for $i from 1 through $column {\n        &-#{$breakpoint}-#{$i},\n        [class*='ids-row-fixed'] &-#{$breakpoint}-#{$i} {\n          grid-column-end: span $i;\n        }\n\n        &-offset-#{$breakpoint}-#{$i},\n        [class*='ids-row-fixed'] &-offset-#{$breakpoint}-#{$i} {\n          grid-column-start: $i;\n        }\n      }\n    }\n  }\n}\n\n/// Gera gutters não responsivos\n/// @group module-internal\n/// @example scss\n///   .ids-gutters {\n///     @include create-gutters();\n///   }\n///   /* output:\n///   .ids-gutters-sm {\n///     gap: var(--ids_layout_gutter_sm, 1rem);\n///   }*/\n@mixin create-gutters() {\n  $gutters: map-by-string($tokens-map, 'ids-layout-gutter');\n\n  // gera &-(xs/sm/md/lg/xl)\n  @each $key, $gutter in $gutters {\n    &-#{string-key-split($key, '-', 4)} {\n      $breakpoint: string-key-split($key, '-', 4);\n      // stylelint-disable-next-line declaration-no-important -- helper\n      gap: var(--ids_layout_gutter_#{$breakpoint}, #{$gutter}) !important;\n    }\n  }\n}\n","/*\n** Voxel Foundation Text Align\n*/\n@use '@ids/tokens/tokens' as *;\n\n// stylelint-disable declaration-no-important -- helper\n\n/// @group module-text-align\n.ids-text-align-center {\n  text-align: center !important;\n}\n\n/// @group module-text-align\n.ids-text-align-end {\n  text-align: end !important;\n}\n\n/// @group module-text-align\n.ids-text-align-justify {\n  text-align: justify !important;\n}\n\n/// @group module-text-align\n.ids-text-align-left {\n  text-align: left !important;\n}\n\n/// @group module-text-align\n.ids-text-align-right {\n  text-align: right !important;\n}\n\n/// @group module-text-align\n.ids-text-align-start {\n  text-align: start !important;\n}\n","/* stylelint-disable declaration-no-important */\n@use '@ids/tokens/tokens' as *;\n\n.ids-chart {\n  .apexcharts-tooltip {\n    background-color: $ids_color_bg_base !important;\n    border: $ids_size_border_small solid $ids_color_border_soft !important;\n\n    .apexcharts-tooltip-title {\n      background-color: $ids_color_bg_variant_02 !important;\n      border-bottom: none !important;\n      color: $ids_color_action_neutral_base !important;\n    }\n\n    .apexcharts-tooltip-text-z-label,\n    .apexcharts-tooltip-text-x-label,\n    .apexcharts-tooltip-text-y-label {\n      color: $ids_color_action_neutral_base !important;\n    }\n\n    .apexcharts-tooltip-text-z-value,\n    .apexcharts-tooltip-text-x-value,\n    .apexcharts-tooltip-text-y-value {\n      color: $ids_color_action_neutral_variant !important;\n    }\n\n    .apexcharts-tooltip-series-group {\n      background-color: $ids_color_bg_base !important;\n    }\n\n  }\n}\n","/* stylelint-disable no-descending-specificity */\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/reset' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/attributes' as *;\n\n@mixin float-label {\n  .ids-form-field__label {\n    bottom: calc(100% - var(--ids-form-field-label-min-height) - $ids_size_general_8x);\n    pointer-events: initial;\n    /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n    transition: bottom 175ms ease;\n  }\n}\n\n.ids-form-field {\n  @include reset;\n\n  --ids-form-field-text-width: #{rem(0)};\n  --ids-form-field-prefix-width: #{rem(0)};\n  --ids-form-field-suffix-width: #{rem(0)};\n  --ids-form-field-container-gap: #{rem(0)};\n  --ids-form-field-input-padding-right:\n    calc(\n      var(--ids-form-field-suffix-width) +\n      var(--ids-form-field-container-gap)\n    );\n  --ids-form-field-label-lines: 1;\n  --ids-form-field-label-min-height:\n    calc(\n      var(--ids-form-field-label-lines) *\n      #{rem(20)} +\n      #{rem(11)}\n    );\n\n  align-items: flex-end;\n  border-radius: $ids_size_cornerRadius_tooltip $ids_size_cornerRadius_tooltip 0 0;\n  display: grid;\n  gap: $ids_spacing_1x;\n  min-height: calc(rem(59) + var(--ids-form-field-label-min-height));\n  outline-offset: $ids_size_general_3x;\n  overflow: hidden;\n  width: 100%;\n\n  .ids-input {\n    @include remove-outline();\n\n    padding-left: $ids_spacing_2x;\n    padding-right: var(--ids-form-field-input-padding-right);\n  }\n\n  .ids-form-message {\n    padding-left: $ids_spacing_2x;\n  }\n\n\n  &__container {\n    @include reset;\n\n    align-items: flex-end;\n    border-radius: $ids_size_cornerRadius_tooltip $ids_size_cornerRadius_tooltip 0 0;\n    display: flex;\n    min-height: calc(rem(35) + var(--ids-form-field-label-min-height));\n    position: relative;\n\n    &::before {\n      // remove o before que havia em versões antigas\n      content: initial;\n    }\n  }\n\n  &__label {\n    @include reset;\n\n    bottom: rem(6);\n    color: $ids_color_action_neutral_base;\n    display: block;\n    font: $ids_textStyle_f02_s14_h20_wrg;\n    min-height: var(--ids-form-field-label-min-height);\n    padding: $ids_size_general_8x var(--ids-form-field-input-padding-right) rem(3) $ids_spacing_2x;\n    pointer-events: none;\n    position: absolute;\n    text-align: start;\n    /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n    transition: bottom 250ms ease;\n    width: 100%;\n    z-index: 1;\n  }\n\n  &__prefix {\n    @include reset;\n\n    // não utilize margin-bottom, pois não funciona em aparelhos antigos quando absolute\n    bottom: rem(13);\n    color: $ids_color_action_neutral_base;\n    font: $ids_textStyle_f02_s16_h24_wrg;\n    left: $ids_spacing_2x;\n    line-height: 1;\n    pointer-events: none;\n    position: absolute;\n\n    + .ids-input {\n      padding-left:\n        calc(\n          $ids_size_general_8x +\n          var(--ids-form-field-prefix-width) +\n          $ids_size_general_4x\n        );\n    }\n  }\n\n  &__suffix {\n    @include reset;\n\n    // não utilize margin-bottom, pois não funciona em aparelhos antigos quando absolute\n    bottom: rem(10);\n    display: inline-flex;\n    line-height: 1;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n\n    @include where(button) {\n      pointer-events: initial;\n    }\n\n    // o has deve estar separado, pois não funciona em navegadores antigos\n    &:has(button) {\n      pointer-events: initial;\n    }\n  }\n\n  &__content {\n    @include reset;\n\n    align-items: flex-end;\n    border-radius: $ids_size_cornerRadius_tooltip $ids_size_cornerRadius_tooltip 0 0;\n    display: grid;\n    flex: 1;\n    min-height: calc(rem(35) + var(--ids-form-field-label-min-height));\n    padding-top: calc(var(--ids-form-field-label-min-height) + $ids_size_general_8x);\n  }\n\n  &__status-message {\n    @include reset;\n\n    align-items: flex-start;\n    color: $ids_color_action_neutral_base;\n    display: flex;\n    font: $ids_textStyle_f02_s14_h20_wrg;\n    min-height: rem(20);\n  }\n\n  &--suffix {\n    --ids-form-field-container-gap: #{$ids_spacing_2x};\n    --ids-form-field-suffix-width: #{$ids_size_general_24x};\n\n    // esconde sufixos padrões quando o form-field já aplicou um sufixo\n    .ids-input {\n      // esconde seta de inputs com <datalist>\n      &[list] {\n        &::-webkit-list-button,\n        &::-webkit-calendar-picker-indicator {\n          opacity: 0;\n        }\n      }\n\n      // esconde os botões de limpar e de pesquisa\n      &[type='search'] {\n        &::-webkit-search-decoration,\n        &::-webkit-search-cancel-button,\n        &::-webkit-search-results-button,\n        &::-webkit-search-results-decoration {\n          display: none;\n        }\n      }\n    }\n  }\n\n  &--button-suffix {\n    --ids-form-field-suffix-width: #{$ids_size_general_48x};\n\n    .ids-form-field__suffix {\n      bottom: 0;\n      pointer-events: initial;\n      right: $ids_size_general_1x;\n    }\n  }\n\n  &--large {\n    .ids-form-field__label {\n      font: $ids_textStyle_f02_s14_h20_wrg;\n    }\n\n    .ids-input {\n      font: $ids_textStyle_f02_s24_h32_wbd;\n    }\n  }\n\n  &--center {\n    text-align: center;\n\n    .ids-form-field__container,\n    .ids-form-field__content,\n    .ids-form-field__status-message {\n      justify-content: center;\n    }\n\n    .ids-form-field__content {\n      flex: none;\n      max-width: 100%;\n      position: relative;\n      width: fit-content;\n    }\n\n    .ids-form-field__label,\n    .ids-input {\n      text-align: center;\n    }\n\n    .ids-form-field__label {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .ids-input {\n      min-width: rem(40);\n      padding-right: calc($ids_size_general_8x + var(--ids-form-field-suffix-width));\n      width:\n        calc(\n          var(--ids-form-field-text-width) +\n          $ids_size_general_16x +\n          var(--ids-form-field-prefix-width) +\n          $ids_size_general_4x +\n          var(--ids-form-field-suffix-width)\n        );\n    }\n\n    &.ids-form-field--large {\n      .ids-form-field__prefix {\n        bottom: rem(8);\n        font: $ids_textStyle_f02_s16_h24_wrg;\n      }\n\n      .ids-input {\n        font: $ids_textStyle_f02_s32_h48_wrg;\n        padding-bottom: 0;\n      }\n    }\n  }\n\n  &--focus:not(.ids-form-field--disabled) {\n    @include float-label;\n  }\n\n  &--value {\n    @include float-label;\n  }\n\n  &--placeholder {\n    @include float-label;\n  }\n\n  &--visible-focus:not(.ids-form-field--disabled) {\n    @include outline;\n  }\n\n  &--disabled {\n    &:not(.ids-form-field--center) {\n      .ids-form-field__container {\n        background-color: $ids_color_action_disabled_base;\n      }\n    }\n\n    .ids-input {\n      background: inherit;\n    }\n\n    .ids-icon,\n    .ids-form-field__label,\n    .ids-form-field__suffix,\n    .ids-form-field__prefix,\n    .ids-form-field__status-message,\n    .ids-form-field__status-message .ids-form-message {\n      color: $ids_color_action_disabled_variant;\n    }\n  }\n\n  &--error {\n    .ids-form-field__label {\n      color: $ids_color_feedback_error;\n    }\n\n    .ids-input,\n    .ids-input:not(:read-only:where(input, textarea), :disabled):focus {\n      --ids-input-border-color: #{$ids_color_feedback_error};\n\n      caret-color: var(--ids-input-border-color);\n    }\n  }\n\n  &--no-message {\n    min-height: rem(61);\n  }\n\n  &--no-border {\n    .ids-input:not(:focus) {\n      border-bottom: 0;\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      &[aria-expanded='true'] {\n        box-shadow: 0 0 rem(2) 0 rgb(86 80 76 / 16%), 0 rem(2) rem(8) 0 rgb(86 80 76 / 16%);\n      }\n    }\n  }\n\n  &--no-label {\n    min-height: initial;\n\n    .ids-input {\n      padding-top: $ids_size_general_1x;\n    }\n\n    .ids-form-field__content {\n      padding-top: 0;\n    }\n\n    .ids-form-field__content,\n    .ids-form-field__container {\n      min-height: rem(36);\n    }\n\n    &.ids-form-field--no-message:not(.ids-form-field--no-border) {\n      min-height: rem(48);\n      padding-bottom: $ids_size_general_6x;\n\n      .ids-input {\n        padding-top: rem(7);\n      }\n    }\n\n    &.ids-form-field--no-border {\n      .ids-input {\n        padding-bottom: $ids_size_general_12x;\n        padding-top: $ids_size_general_12x;\n      }\n\n      .ids-form-field__suffix {\n        bottom: $ids_size_general_12x;\n      }\n\n      .ids-form-field__content,\n      .ids-form-field__container {\n        min-height: rem(48);\n      }\n    }\n  }\n}\n","/* stylelint-disable plugin/no-low-performance-animation-properties */\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/attributes' as *;\n\n$snackbar-max-width: rem(720);\n$snackbar-min-width: rem(272);\n$snackbar-animation-in: ids-snackbar-fade-in $ids_motion_time_slow_01\n  $ids_motion_easing_effective_decelerate_standard;\n$snackbar-animation-out: ids-snackbar-fade-out $ids_motion_time_fast_03\n  $ids_motion_easing_effective_accelerate_standard calc(var(--ids-snackbar-duration) - 0.18s);\n\n@keyframes ids-snackbar-fade-in {\n  from {\n    bottom: 0;\n    opacity: $ids_motion_opacity_0;\n  }\n\n  to {\n    bottom: var(--ids-snackbar-bottom);\n    opacity: $ids_motion_opacity_100;\n  }\n}\n\n@keyframes ids-snackbar-fade-out {\n  from {\n    bottom: var(--ids-snackbar-bottom);\n    opacity: $ids_motion_opacity_100;\n  }\n\n  to {\n    bottom: 0;\n    opacity: $ids_motion_opacity_0;\n  }\n}\n\n.ids-snackbar {\n  --ids-snackbar-bottom: rem(24);\n  --ids-snackbar-duration: 4s;\n\n  align-items: center;\n  background: $ids_color_feedback_neutral;\n  border-radius: $ids_size_cornerRadius_snackbar;\n  color: $ids_color_feedback_neutral_contrast;\n  font: $ids_textStyle_f02_s14_h20_wrg;\n  gap: $ids_size_general_12x;\n  max-width: $snackbar-max-width;\n  min-width: $snackbar-min-width;\n  padding: $ids_size_general_16x;\n\n  @include popover-open {\n    animation: $snackbar-animation-in, $snackbar-animation-out;\n    display: flex;\n    inset: auto $ids_size_general_24x var(--ids-snackbar-bottom) $ids_size_general_24x;\n    margin: 0 auto;\n    position: fixed;\n  }\n\n  &.-warning {\n    background: $ids_color_feedback_alert;\n    color: $ids_color_feedback_alert_contrast;\n  }\n\n  &.-success {\n    background: $ids_color_feedback_success;\n    color: $ids_color_feedback_success_contrast;\n  }\n\n  &.-error {\n    background: $ids_color_feedback_error;\n    color: $ids_color_feedback_error_contrast;\n  }\n\n  &.-information {\n    background: $ids_color_feedback_information;\n    color: $ids_color_feedback_information_contrast;\n  }\n\n  &.-on-brand {\n    background: $ids_color_bg_base;\n    color: $ids_color_feedback_neutral;\n  }\n\n  @media screen and (min-width: rem(1024)) {\n    max-width: rem(1600);\n  }\n}\n","/* stylelint-disable no-descending-specificity */\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/components/table' as *;\n\n$header-cell-border: $ids_size_general_2x solid $ids_color_border_medium;\n$cell-border: $ids_size_general_1x solid $ids_color_border_medium;\n\n.ids-table {\n  border: 0;\n  border-collapse: collapse;\n  border-spacing: 0;\n  // precisei colocar position pois no safari, quando o th,td tem position relative, não estava renderizando nenhuma borda\n  // o th,td tem position relative por conta do checkbox\n  position: relative;\n  width: 100%;\n\n  th {\n    @include th;\n\n    border-bottom: $header-cell-border;\n    height: $ids_size_general_48x;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &:not(.ids-sort) {\n      padding: 0 $ids_spacing_4x;\n    }\n  }\n\n  td {\n    @include td;\n\n    color: $ids_color_text_body_02;\n    font: $ids_textStyle_f02_s16_h24_wrg;\n    height: $ids_size_general_48x;\n    padding: $ids_size_general_8x $ids_size_general_24x;\n  }\n\n  .ids-table__cell--truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  th,\n  td {\n    min-width: $ids_size_general_48x;\n    position: relative;\n\n    .ids-checkbox {\n      height: 100%;\n      left: 0;\n      position: absolute;\n      top: 0;\n      width: 100%;\n\n      &__input {\n        outline-offset: rem(-1);\n      }\n    }\n  }\n\n  &--compact td {\n    height: $ids_size_general_40x;\n    padding: $ids_size_general_8x $ids_size_general_16x;\n  }\n\n  &--comfortable td {\n    height: $ids_size_general_64x;\n    padding: $ids_size_general_8x $ids_size_general_24x;\n  }\n\n  tfoot td,\n  &__footer-cell {\n    @include common-cell-attrs;\n    @include title-cell;\n\n    border-top: $header-cell-border;\n  }\n\n  &--solid-border td,\n  &--full-border td,\n  .ids-table__row--full-border td {\n    border: $cell-border;\n  }\n\n  &--horizontal-border td,\n  .ids-table__row--horizontal-border td {\n    border-bottom: $cell-border;\n  }\n\n  .ids-table__header-row--horizontal-border th {\n    border-bottom: $header-cell-border;\n  }\n\n  &--no-border,\n  .ids-table__header-row--no-border,\n  .ids-table__footer-row--no-border,\n  .ids-table__row--no-border {\n    th, td {\n      border: 0;\n    }\n  }\n\n  .ids-table__header-row--no-background th:not(:hover, :active),\n  .ids-table__footer-row--no-background td:not(:hover, :active),\n  .ids-table__row--no-background td {\n    background-color: transparent;\n  }\n\n  tbody tr:hover td {\n    background-color: $ids_color_bg_variant_02;\n  }\n\n  &--zebra-style {\n    tr:nth-child(even):not(:hover) td {\n      background-color: $ids_color_bg_variant_01;\n    }\n  }\n\n  &--loading {\n    display: flex;\n    flex-direction: column;\n    gap: $ids_spacing_5x;\n\n    thead,\n    tbody,\n    tfoot {\n      display: none;\n    }\n\n    .ids-shimmer {\n      height: $ids_size_general_40x;\n    }\n  }\n\n  /*\n    Quando a table não tem dados a exibir, é colocado uma tr com a classe ids-table__no-data-row e\n    dentro uma td com a mensagem de que não tem registros. No handoff, essa mensagem está alinhada a\n    esquerda, porém na table com dados, a TD tem o texto centralizado.\n    Foi feito isso para garantir o texto a esquerda quando não tem dados a exibir.\n  */\n  &__no-data-row td {\n    text-align: left;\n  }\n}\n\n.ids-table-sticky {\n  position: sticky;\n}\n\n.ids-table-sticky-border-elem-left {\n  border-right: $cell-border;\n}\n\n.ids-table-sticky-border-elem-right {\n  border-left: $cell-border;\n}\n\n.ids-table-wrapper {\n  &__table {\n    overflow: auto;\n  }\n\n  &--outline {\n    border: $ids_size_border_medium solid $ids_color_border_medium;\n    border-radius: $ids_size_cornerRadius_table;\n\n    .ids-table {\n      &--full-border,\n      &--solid-border {\n        tr:last-of-type td {\n          border-bottom: 0;\n        }\n\n        td {\n          border-left: 0;\n          border-top: 0;\n        }\n\n        td:last-of-type {\n          border-right: 0;\n        }\n      }\n    }\n  }\n}\n","/* stylelint-disable no-descending-specificity */\n/* stylelint-disable selector-no-qualifying-type */\n@use '@ids/tokens/tokens' as *;\n\n$ids_tooltip_arrow_width: $ids_size_general_10x;\n\n@mixin _ids-open-tooltip {\n  .ids-tooltip,\n  + .ids-tooltip,\n  + * .ids-tooltip {\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n.ids-tooltip-wrapper,\n.ids-tooltip-wrapper.ids-icon-button,\nbutton.ids-tooltip-wrapper.ids-icon-button {\n  position: relative;\n\n  .ids-tooltip {\n    bottom: 100%;\n    left: 50%;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    transform: translateX(-50%);\n    white-space: nowrap;\n    z-index: 1;\n\n    &--end {\n      left: auto;\n      right: calc(50% - #{$ids_tooltip_arrow_width});\n    }\n\n    &--start {\n      left: calc(50% - #{$ids_tooltip_arrow_width});\n    }\n\n    &--bottom {\n      bottom: auto;\n      top: 100%;\n    }\n\n    &--left,\n    &--right {\n      bottom: 50%;\n      transform: translateY(50%);\n\n      &.ids-tooltip--start {\n        bottom: auto;\n        top: calc(50% - #{$ids_tooltip_arrow_width});\n      }\n    }\n\n    &--left {\n      left: auto;\n      right: 100%;\n    }\n\n    &--right {\n      left: 100%;\n    }\n\n    &--end,\n    &--start {\n      transform: initial;\n    }\n  }\n\n  // para tooltip de hover\n  &:hover:not(.-click),\n  &.focus-visible:not(.-click),\n  &:focus-visible:not(.-click),\n  &:not(.-click) > *:hover,\n  &:not(.-click) > *.focus-visible,\n  &:not(.-click) > *:focus-visible {\n    @include _ids-open-tooltip;\n  }\n\n  // o aria-expanded='true' é usado para mostrar pelo JavaScript\n  &.-click > *[aria-expanded='true'],\n  &.-click > *:focus:not([aria-expanded='false']),\n  &.-click[aria-expanded='true'],\n  &.-click:focus:not([aria-expanded='false']) {\n    @include _ids-open-tooltip;\n  }\n}","@use '../functions/unit-transform' as *;\n\n%ids-form-focus-visible {\n  margin-left: rem(-3);\n  margin-right: rem(-3);\n  padding-left: rem(3);\n  padding-right: rem(3);\n  width: calc(100% + #{rem(6)});\n}\n\n.ids-sr-only {\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n  position: fixed;\n}\n","@use './selectors' as *;\n@use './attributes' as *;\n\n@mixin reset-outline() {\n  // remove outline para qualquer aparelho mobile\n  @media (pointer: coarse) {\n    @include remove-outline();\n  }\n\n  // propriedade que o unset removeu\n  @include focus-visible() {\n    @include outline(true);\n    /* stylelint-disable-next-line declaration-no-important */\n    outline: revert !important;\n  }\n}\n\n/// Utilize para resetar elementos dos componentes\n/// Não utilize diretamente em elementos com outras propriedades para fazer reset.\n/// @group module-mixins\n@mixin reset {\n  // o unset tira todas propriedades, inclusive do user-agent, caso o navegador\n  // não tenha suporte para revert o unset será aplicado e algumas propriedades\n  // terão de serem reaplicas, como display table\n  all: unset;\n  // a propriedade está duplicada, pois navegadores mais antigos não suportam o revert\n  // serve para tirar as alterações dos outros códigos e retornar ao do user-agent\n  // após isso é necessário remover outras propriedades como margin: 0\n  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */\n  all: revert;\n  box-sizing: border-box;\n}\n\n/// Utilize para resetar headings e parágrafos\n/// p, h1, h2, h3...\n/// @group module-mixins\n@mixin reset-text {\n  @include reset;\n\n  // remove propriedade que o revert recolocou\n  margin: 0;\n}\n\n/// Utilize para resetar inputs de texto\n/// @group module-mixins\n@mixin reset-input {\n  @include reset;\n\n  // remove propriedade que o revert recolocou\n  background: transparent;\n  border: 0;\n  display: block;\n  width: 100%;\n\n  @include reset-outline();\n}\n\n/// Utilize para resetar inputs de texto\n/// @group module-mixins\n@mixin reset-selector {\n  @include reset-input;\n\n  // remove propriedade que o revert recolocou\n  appearance: none;\n  margin: 0;\n}\n\n/// Utilize para resetar ul, ol\n/// @group module-mixins\n@mixin reset-list {\n  @include reset;\n\n  // remove propriedade que o revert recolocou\n  margin: 0;\n  padding-left: 0;\n}\n\n/// Utilize para resetar li\n/// @group module-mixins\n@mixin reset-list-item {\n  @include reset;\n\n  // remove propriedade que o revert recolocou\n  list-style-type: none;\n}\n\n/// Utilize para resetar hr\n/// @group module-mixins\n@mixin reset-hr {\n  @include reset;\n\n  // remove propriedade que o revert recolocou\n  border: 0;\n\n  // propriedade que o unset removeu\n  display: block;\n  // remove propriedade que o revert recolocou\n  margin: 0;\n}\n\n/// Utilize para resetar div, section, article, main\n/// @group module-mixins\n@mixin reset-div {\n  @include reset;\n\n  // propriedade que o unset removeu\n  display: block;\n}\n\n/// Utilize para resetar table\n/// @group module-mixins\n@mixin reset-table {\n  @include reset;\n\n  // propriedade que o unset removeu\n  display: table;\n}\n\n/// Utilize para resetar td e th\n/// @group module-mixins\n@mixin reset-table-cell {\n  @include reset;\n\n  // propriedade que o unset removeu\n  display: table-cell;\n}\n\n/// Utilize para resetar elementos de botões\n/// @group module-mixins\n@mixin reset-button {\n  @include reset;\n\n  // propriedade que o unset removeu\n  cursor: pointer;\n\n  // remove propriedade que o revert recolocou\n  padding: 0;\n\n  // para todos botões, não permite seleção de texto\n  user-select: none;\n\n  @include reset-outline();\n}\n\n/// Utilize para resetar link\n/// @group module-mixins\n@mixin reset-link {\n  @include reset;\n\n  // propriedade que o unset removeu\n  text-decoration: underline;\n\n  @include reset-outline();\n}\n","@use 'sass:selector' as *;\n@use 'sass:math' as *;\n@use './selectors' as *;\n\n@mixin remove-outline($force: true) {\n  outline: 0 #{if($force, '!important', '')};\n\n  &:focus {\n    outline: 0 #{if($force, '!important', '')};\n  }\n\n  @include focus-visible() {\n    outline: 0 #{if($force, '!important', '')};\n  }\n}\n\n@mixin outline($force: false) {\n  @media (pointer: fine) {\n    // cor para Firefox\n    outline: 5px auto Highlight #{if($force, '!important', '')};\n    // stylelint-disable-next-line declaration-block-no-duplicate-properties\n    outline: 5px auto -webkit-focus-ring-color #{if($force, '!important', '')};\n  }\n}\n\n/// Adiciona variáveis para aspect ratio, caso não seja compatível com o navegador\n@mixin aspect-ratio($x: 1, $y: 1) {\n  $ratio: div($x, $y);\n\n  aspect-ratio: #{$x} / #{$y};\n\n  @supports not (aspect-ratio: 1 / 1) {\n    // esta variável é consumida pela função applyAspectRatioVariables\n    --ids-aspect-ratio: #{$ratio};\n    // esta variável é preenchida pela função applyAspectRatioVariables\n    --ids-height: auto;\n\n    height: var(--ids-height);\n  }\n}\n\n@mixin gap(\n  $gap, $force: false,\n  $internal: false,\n  $fallback: false,\n  $usePadding: false,\n  $useWhiteSpace: false) {\n  gap: $gap;\n\n  @at-root #{nest('.js-no-flexbox-gap', &)} {\n    @if $fallback {\n      @content;\n    }\n\n    @else if $internal {\n      > * {\n        margin: calc(#{$gap} / 2) #{if($force, '!important', '')};\n\n        &:first-child {\n          margin-left: 0 #{if($force, '!important', '')};\n        }\n\n        &:last-child {\n          margin-right: 0 #{if($force, '!important', '')};\n        }\n      }\n    }\n\n    @else if $useWhiteSpace {\n      white-space: pre;\n    }\n\n    @else {\n      margin: calc(#{$gap} / -2) #{if($force, '!important', '')};\n\n      > * {\n        #{if($usePadding, 'padding', 'margin')}: calc(#{$gap} / 2) #{if($force, '!important', '')};\n      }\n    }\n  }\n}\n\n@mixin popover-open {\n  /* stylelint-disable-next-line selector-pseudo-class-no-unknown */\n  &:popover-open {\n    @content;\n  }\n\n  &.\\:popover-open {\n    @content;\n  }\n}\n","@use './support' as *;\n@use 'sass:selector' as *;\n\n/// Aplica as propriedades informadas no `hover` e `focus-visible`\n/// apenas em plataformas Desktop, e em elementos que não estejam\n/// desabilitados.\n/// @group module-mixins\n/// @example scss\n///   button {\n///     @include hover() {\n///       background-color: red;\n///     }\n///   }\n///\n@mixin hover() {\n  @include ids-only-for-desktop() {\n    // precisa ser dessa forma por causa do ':host' dos botões\n    /* stylelint-disable selector-not-notation */\n    &:hover:not(:disabled):not([aria-disabled='true']),\n    &:focus-visible:not(:disabled):not([aria-disabled='true']) {\n      @content;\n    }\n  }\n\n  &:active:not(:disabled):not([aria-disabled='true']) {\n    @content;\n  }\n}\n\n/// Navegadores antigos como Chrome 83 não funcionam o :where, então o mixin faz\n/// da forma antiga colocando a tag antes do seletor.\n@mixin where($tags...) {\n  @each $tag in $tags {\n    @at-root #{unify(&, #{$tag})} {\n      @content;\n    }\n  }\n}\n\n/// Usa o polyfill https://github.com/WICG/focus-visible para aplicar focus-visible\n/// em qualquer aparelho com ou sem suporte.\n/// @group module-mixins\n/// @example scss\n///   button {\n///     @include focus-visible() {\n///       background-color: red;\n///     }\n///   }\n///\n@mixin focus-visible() {\n  @media (pointer: fine) {\n    &:focus-visible,\n    &:focus.focus-visible {\n      @content;\n    }\n  }\n}\n\n/// Aplica efeitos de hover em elementos clicáveis\n/// @group module-mixins\n/// @example scss\n///   .card {\n///     background-color: blue;\n///\n///     @include tabbable-hover() {\n///      background-color: red;\n///   }\n///   /* button.card:hover { background-color: red; } */\n///\n@mixin tabbable-hover() {\n  @include where(button, a, input, '.-hover') {\n    cursor: pointer;\n\n    @include hover() {\n      @content;\n    }\n  }\n}\n","$ids_color_action_primary_base: var(--ids_color_action_primary_base) !default;\n$ids_color_action_primary_base_soft: var(--ids_color_action_primary_base_soft) !default;\n$ids_color_action_primary_base_medium: var(--ids_color_action_primary_base_medium) !default;\n$ids_color_action_primary_base_strong: var(--ids_color_action_primary_base_strong) !default;\n$ids_color_action_primary_variant: var(--ids_color_action_primary_variant) !default;\n$ids_color_action_primary_variant_soft: var(--ids_color_action_primary_variant_soft) !default;\n$ids_color_action_primary_variant_medium: var(--ids_color_action_primary_variant_medium) !default;\n$ids_color_action_primary_variant_strong: var(--ids_color_action_primary_variant_strong) !default;\n$ids_color_action_primary_contrast: var(--ids_color_action_primary_contrast) !default;\n$ids_color_action_primary_contrast_soft: var(--ids_color_action_primary_contrast_soft) !default;\n$ids_color_action_primary_contrast_medium: var(--ids_color_action_primary_contrast_medium) !default;\n$ids_color_action_primary_contrast_strong: var(--ids_color_action_primary_contrast_strong) !default;\n$ids_color_action_secondary_base: var(--ids_color_action_secondary_base) !default;\n$ids_color_action_secondary_base_soft: var(--ids_color_action_secondary_base_soft) !default;\n$ids_color_action_secondary_base_medium: var(--ids_color_action_secondary_base_medium) !default;\n$ids_color_action_secondary_base_strong: var(--ids_color_action_secondary_base_strong) !default;\n$ids_color_action_secondary_variant: var(--ids_color_action_secondary_variant) !default;\n$ids_color_action_secondary_variant_soft: var(--ids_color_action_secondary_variant_soft) !default;\n$ids_color_action_secondary_variant_medium: var(--ids_color_action_secondary_variant_medium) !default;\n$ids_color_action_secondary_variant_strong: var(--ids_color_action_secondary_variant_strong) !default;\n$ids_color_action_secondary_contrast: var(--ids_color_action_secondary_contrast) !default;\n$ids_color_action_secondary_contrast_soft: var(--ids_color_action_secondary_contrast_soft) !default;\n$ids_color_action_secondary_contrast_medium: var(--ids_color_action_secondary_contrast_medium) !default;\n$ids_color_action_secondary_contrast_strong: var(--ids_color_action_secondary_contrast_strong) !default;\n$ids_color_action_neutral_base: var(--ids_color_action_neutral_base) !default;\n$ids_color_action_neutral_base_soft: var(--ids_color_action_neutral_base_soft) !default;\n$ids_color_action_neutral_base_medium: var(--ids_color_action_neutral_base_medium) !default;\n$ids_color_action_neutral_base_strong: var(--ids_color_action_neutral_base_strong) !default;\n$ids_color_action_neutral_variant: var(--ids_color_action_neutral_variant) !default;\n$ids_color_action_neutral_variant_soft: var(--ids_color_action_neutral_variant_soft) !default;\n$ids_color_action_neutral_variant_medium: var(--ids_color_action_neutral_variant_medium) !default;\n$ids_color_action_neutral_variant_strong: var(--ids_color_action_neutral_variant_strong) !default;\n$ids_color_action_neutral_contrast: var(--ids_color_action_neutral_contrast) !default;\n$ids_color_action_neutral_contrast_soft: var(--ids_color_action_neutral_contrast_soft) !default;\n$ids_color_action_neutral_contrast_medium: var(--ids_color_action_neutral_contrast_medium) !default;\n$ids_color_action_neutral_contrast_strong: var(--ids_color_action_neutral_contrast_strong) !default;\n$ids_color_action_neutral_onPrimary_base: var(--ids_color_action_neutral_onPrimary_base) !default;\n$ids_color_action_neutral_onPrimary_base_soft: var(--ids_color_action_neutral_onPrimary_base_soft) !default;\n$ids_color_action_neutral_onPrimary_base_medium: var(--ids_color_action_neutral_onPrimary_base_medium) !default;\n$ids_color_action_neutral_onPrimary_base_strong: var(--ids_color_action_neutral_onPrimary_base_strong) !default;\n$ids_color_action_neutral_onPrimary_variant: var(--ids_color_action_neutral_onPrimary_variant) !default;\n$ids_color_action_neutral_onPrimary_variant_soft: var(--ids_color_action_neutral_onPrimary_variant_soft) !default;\n$ids_color_action_neutral_onPrimary_variant_medium: var(--ids_color_action_neutral_onPrimary_variant_medium) !default;\n$ids_color_action_neutral_onPrimary_variant_strong: var(--ids_color_action_neutral_onPrimary_variant_strong) !default;\n$ids_color_action_neutral_onPrimary_contrast: var(--ids_color_action_neutral_onPrimary_contrast) !default;\n$ids_color_action_neutral_onPrimary_contrast_soft: var(--ids_color_action_neutral_onPrimary_contrast_soft) !default;\n$ids_color_action_neutral_onPrimary_contrast_medium: var(--ids_color_action_neutral_onPrimary_contrast_medium) !default;\n$ids_color_action_neutral_onPrimary_contrast_strong: var(--ids_color_action_neutral_onPrimary_contrast_strong) !default;\n$ids_color_action_disabled_base: var(--ids_color_action_disabled_base) !default;\n$ids_color_action_disabled_base_soft: var(--ids_color_action_disabled_base_soft) !default;\n$ids_color_action_disabled_base_medium: var(--ids_color_action_disabled_base_medium) !default;\n$ids_color_action_disabled_base_strong: var(--ids_color_action_disabled_base_strong) !default;\n$ids_color_action_disabled_variant: var(--ids_color_action_disabled_variant) !default;\n$ids_color_action_disabled_variant_soft: var(--ids_color_action_disabled_variant_soft) !default;\n$ids_color_action_disabled_variant_medium: var(--ids_color_action_disabled_variant_medium) !default;\n$ids_color_action_disabled_variant_strong: var(--ids_color_action_disabled_variant_strong) !default;\n$ids_color_text_heading_01: var(--ids_color_text_heading_01) !default;\n$ids_color_text_heading_01_soft: var(--ids_color_text_heading_01_soft) !default;\n$ids_color_text_heading_01_medium: var(--ids_color_text_heading_01_medium) !default;\n$ids_color_text_heading_01_strong: var(--ids_color_text_heading_01_strong) !default;\n$ids_color_text_heading_02: var(--ids_color_text_heading_02) !default;\n$ids_color_text_heading_02_soft: var(--ids_color_text_heading_02_soft) !default;\n$ids_color_text_heading_02_medium: var(--ids_color_text_heading_02_medium) !default;\n$ids_color_text_heading_02_strong: var(--ids_color_text_heading_02_strong) !default;\n$ids_color_text_body_01: var(--ids_color_text_body_01) !default;\n$ids_color_text_body_01_soft: var(--ids_color_text_body_01_soft) !default;\n$ids_color_text_body_01_medium: var(--ids_color_text_body_01_medium) !default;\n$ids_color_text_body_01_strong: var(--ids_color_text_body_01_strong) !default;\n$ids_color_text_body_02: var(--ids_color_text_body_02) !default;\n$ids_color_text_body_02_soft: var(--ids_color_text_body_02_soft) !default;\n$ids_color_text_body_02_medium: var(--ids_color_text_body_02_medium) !default;\n$ids_color_text_body_02_strong: var(--ids_color_text_body_02_strong) !default;\n$ids_color_text_highlight: var(--ids_color_text_highlight) !default;\n$ids_color_text_highlight_soft: var(--ids_color_text_highlight_soft) !default;\n$ids_color_text_highlight_medium: var(--ids_color_text_highlight_medium) !default;\n$ids_color_text_highlight_strong: var(--ids_color_text_highlight_strong) !default;\n$ids_color_text_link_base: var(--ids_color_text_link_base) !default;\n$ids_color_text_link_base_soft: var(--ids_color_text_link_base_soft) !default;\n$ids_color_text_link_base_medium: var(--ids_color_text_link_base_medium) !default;\n$ids_color_text_link_base_strong: var(--ids_color_text_link_base_strong) !default;\n$ids_color_text_link_variant: var(--ids_color_text_link_variant) !default;\n$ids_color_text_link_variant_soft: var(--ids_color_text_link_variant_soft) !default;\n$ids_color_text_link_variant_medium: var(--ids_color_text_link_variant_medium) !default;\n$ids_color_text_link_variant_strong: var(--ids_color_text_link_variant_strong) !default;\n$ids_color_bg_base: var(--ids_color_bg_base) !default;\n$ids_color_bg_base_soft: var(--ids_color_bg_base_soft) !default;\n$ids_color_bg_base_medium: var(--ids_color_bg_base_medium) !default;\n$ids_color_bg_base_strong: var(--ids_color_bg_base_strong) !default;\n$ids_color_bg_variant_01: var(--ids_color_bg_variant_01) !default;\n$ids_color_bg_variant_01_soft: var(--ids_color_bg_variant_01_soft) !default;\n$ids_color_bg_variant_01_medium: var(--ids_color_bg_variant_01_medium) !default;\n$ids_color_bg_variant_01_strong: var(--ids_color_bg_variant_01_strong) !default;\n$ids_color_bg_variant_02: var(--ids_color_bg_variant_02) !default;\n$ids_color_bg_variant_02_soft: var(--ids_color_bg_variant_02_soft) !default;\n$ids_color_bg_variant_02_medium: var(--ids_color_bg_variant_02_medium) !default;\n$ids_color_bg_variant_02_strong: var(--ids_color_bg_variant_02_strong) !default;\n$ids_color_bg_brand_primary: var(--ids_color_bg_brand_primary) !default;\n$ids_color_bg_brand_primary_soft: var(--ids_color_bg_brand_primary_soft) !default;\n$ids_color_bg_brand_primary_medium: var(--ids_color_bg_brand_primary_medium) !default;\n$ids_color_bg_brand_primary_strong: var(--ids_color_bg_brand_primary_strong) !default;\n$ids_color_bg_brand_secondary: var(--ids_color_bg_brand_secondary) !default;\n$ids_color_bg_brand_secondary_soft: var(--ids_color_bg_brand_secondary_soft) !default;\n$ids_color_bg_brand_secondary_medium: var(--ids_color_bg_brand_secondary_medium) !default;\n$ids_color_bg_brand_secondary_strong: var(--ids_color_bg_brand_secondary_strong) !default;\n$ids_color_bg_brand_gradient: var(--ids_color_bg_brand_gradient) !default;\n$ids_color_bg_shimmer_gradient: var(--ids_color_bg_shimmer_gradient) !default;\n$ids_color_bg_shimmer_gradient_onLight: var(--ids_color_bg_shimmer_gradient_onLight) !default;\n$ids_color_bg_shimmer_gradient_onDark: var(--ids_color_bg_shimmer_gradient_onDark) !default;\n$ids_color_border_soft: var(--ids_color_border_soft) !default;\n$ids_color_border_soft_soft: var(--ids_color_border_soft_soft) !default;\n$ids_color_border_soft_medium: var(--ids_color_border_soft_medium) !default;\n$ids_color_border_soft_strong: var(--ids_color_border_soft_strong) !default;\n$ids_color_border_medium: var(--ids_color_border_medium) !default;\n$ids_color_border_medium_soft: var(--ids_color_border_medium_soft) !default;\n$ids_color_border_medium_medium: var(--ids_color_border_medium_medium) !default;\n$ids_color_border_medium_strong: var(--ids_color_border_medium_strong) !default;\n$ids_color_border_strong: var(--ids_color_border_strong) !default;\n$ids_color_border_strong_soft: var(--ids_color_border_strong_soft) !default;\n$ids_color_border_strong_medium: var(--ids_color_border_strong_medium) !default;\n$ids_color_border_strong_strong: var(--ids_color_border_strong_strong) !default;\n$ids_color_contrast_onLight: var(--ids_color_contrast_onLight) !default;\n$ids_color_contrast_onLight_soft: var(--ids_color_contrast_onLight_soft) !default;\n$ids_color_contrast_onLight_medium: var(--ids_color_contrast_onLight_medium) !default;\n$ids_color_contrast_onLight_strong: var(--ids_color_contrast_onLight_strong) !default;\n$ids_color_contrast_onDark: var(--ids_color_contrast_onDark) !default;\n$ids_color_contrast_onDark_soft: var(--ids_color_contrast_onDark_soft) !default;\n$ids_color_contrast_onDark_medium: var(--ids_color_contrast_onDark_medium) !default;\n$ids_color_contrast_onDark_strong: var(--ids_color_contrast_onDark_strong) !default;\n$ids_color_contrast_onBrand_primary: var(--ids_color_contrast_onBrand_primary) !default;\n$ids_color_contrast_onBrand_primary_soft: var(--ids_color_contrast_onBrand_primary_soft) !default;\n$ids_color_contrast_onBrand_primary_medium: var(--ids_color_contrast_onBrand_primary_medium) !default;\n$ids_color_contrast_onBrand_primary_strong: var(--ids_color_contrast_onBrand_primary_strong) !default;\n$ids_color_contrast_onBrand_secondary: var(--ids_color_contrast_onBrand_secondary) !default;\n$ids_color_contrast_onBrand_secondary_soft: var(--ids_color_contrast_onBrand_secondary_soft) !default;\n$ids_color_contrast_onBrand_secondary_medium: var(--ids_color_contrast_onBrand_secondary_medium) !default;\n$ids_color_contrast_onBrand_secondary_strong: var(--ids_color_contrast_onBrand_secondary_strong) !default;\n$ids_color_feedback_information: var(--ids_color_feedback_information) !default;\n$ids_color_feedback_information_soft: var(--ids_color_feedback_information_soft) !default;\n$ids_color_feedback_information_medium: var(--ids_color_feedback_information_medium) !default;\n$ids_color_feedback_information_strong: var(--ids_color_feedback_information_strong) !default;\n$ids_color_feedback_information_contrast: var(--ids_color_feedback_information_contrast) !default;\n$ids_color_feedback_information_contrast_soft: var(--ids_color_feedback_information_contrast_soft) !default;\n$ids_color_feedback_information_contrast_medium: var(--ids_color_feedback_information_contrast_medium) !default;\n$ids_color_feedback_information_contrast_strong: var(--ids_color_feedback_information_contrast_strong) !default;\n$ids_color_feedback_success: var(--ids_color_feedback_success) !default;\n$ids_color_feedback_success_soft: var(--ids_color_feedback_success_soft) !default;\n$ids_color_feedback_success_medium: var(--ids_color_feedback_success_medium) !default;\n$ids_color_feedback_success_strong: var(--ids_color_feedback_success_strong) !default;\n$ids_color_feedback_success_contrast: var(--ids_color_feedback_success_contrast) !default;\n$ids_color_feedback_success_contrast_soft: var(--ids_color_feedback_success_contrast_soft) !default;\n$ids_color_feedback_success_contrast_medium: var(--ids_color_feedback_success_contrast_medium) !default;\n$ids_color_feedback_success_contrast_strong: var(--ids_color_feedback_success_contrast_strong) !default;\n$ids_color_feedback_error: var(--ids_color_feedback_error) !default;\n$ids_color_feedback_error_soft: var(--ids_color_feedback_error_soft) !default;\n$ids_color_feedback_error_medium: var(--ids_color_feedback_error_medium) !default;\n$ids_color_feedback_error_strong: var(--ids_color_feedback_error_strong) !default;\n$ids_color_feedback_error_contrast: var(--ids_color_feedback_error_contrast) !default;\n$ids_color_feedback_error_contrast_soft: var(--ids_color_feedback_error_contrast_soft) !default;\n$ids_color_feedback_error_contrast_medium: var(--ids_color_feedback_error_contrast_medium) !default;\n$ids_color_feedback_error_contrast_strong: var(--ids_color_feedback_error_contrast_strong) !default;\n$ids_color_feedback_alert: var(--ids_color_feedback_alert) !default;\n$ids_color_feedback_alert_soft: var(--ids_color_feedback_alert_soft) !default;\n$ids_color_feedback_alert_medium: var(--ids_color_feedback_alert_medium) !default;\n$ids_color_feedback_alert_strong: var(--ids_color_feedback_alert_strong) !default;\n$ids_color_feedback_alert_contrast: var(--ids_color_feedback_alert_contrast) !default;\n$ids_color_feedback_alert_contrast_soft: var(--ids_color_feedback_alert_contrast_soft) !default;\n$ids_color_feedback_alert_contrast_medium: var(--ids_color_feedback_alert_contrast_medium) !default;\n$ids_color_feedback_alert_contrast_strong: var(--ids_color_feedback_alert_contrast_strong) !default;\n$ids_color_feedback_neutral: var(--ids_color_feedback_neutral) !default;\n$ids_color_feedback_neutral_soft: var(--ids_color_feedback_neutral_soft) !default;\n$ids_color_feedback_neutral_medium: var(--ids_color_feedback_neutral_medium) !default;\n$ids_color_feedback_neutral_strong: var(--ids_color_feedback_neutral_strong) !default;\n$ids_color_feedback_neutral_contrast: var(--ids_color_feedback_neutral_contrast) !default;\n$ids_color_feedback_neutral_contrast_soft: var(--ids_color_feedback_neutral_contrast_soft) !default;\n$ids_color_feedback_neutral_contrast_medium: var(--ids_color_feedback_neutral_contrast_medium) !default;\n$ids_color_feedback_neutral_contrast_strong: var(--ids_color_feedback_neutral_contrast_strong) !default;\n$ids_color_chart_01: var(--ids_color_chart_01) !default;\n$ids_color_chart_02: var(--ids_color_chart_02) !default;\n$ids_color_chart_03: var(--ids_color_chart_03) !default;\n$ids_color_chart_04: var(--ids_color_chart_04) !default;\n$ids_color_chart_05: var(--ids_color_chart_05) !default;\n$ids_color_chart_06: var(--ids_color_chart_06) !default;\n$ids_color_chart_07: var(--ids_color_chart_07) !default;\n$ids_color_chart_08: var(--ids_color_chart_08) !default;\n$ids_layout_breakpoint_xs: 20rem;\n$ids_layout_breakpoint_sm: 48rem;\n$ids_layout_breakpoint_md: 64rem;\n$ids_layout_breakpoint_lg: 80rem;\n$ids_layout_breakpoint_xl: 100rem;\n$ids_layout_container_xs: 48rem;\n$ids_layout_container_sm: 64rem;\n$ids_layout_container_md: 64rem;\n$ids_layout_container_lg: 80rem;\n$ids_layout_container_xl: 100rem;\n$ids_layout_columns_xs: 4;\n$ids_layout_columns_sm: 8;\n$ids_layout_columns_md: 12;\n$ids_layout_columns_lg: 12;\n$ids_layout_columns_xl: 12;\n$ids_layout_gutter_xs: 1rem;\n$ids_layout_gutter_sm: 1rem;\n$ids_layout_gutter_md: 2rem;\n$ids_layout_gutter_lg: 2rem;\n$ids_layout_gutter_xl: 2rem;\n$ids_layout_padding_xs: 1.5rem;\n$ids_layout_padding_sm: 1.5rem;\n$ids_layout_padding_md: 3rem;\n$ids_layout_padding_lg: 3.5rem;\n$ids_layout_padding_xl: 4.5rem;\n$ids_motion_time_fast_01: var(--ids_motion_time_fast_01) !default;\n$ids_motion_time_fast_02: var(--ids_motion_time_fast_02) !default;\n$ids_motion_time_fast_03: var(--ids_motion_time_fast_03) !default;\n$ids_motion_time_moderate_01: var(--ids_motion_time_moderate_01) !default;\n$ids_motion_time_moderate_02: var(--ids_motion_time_moderate_02) !default;\n$ids_motion_time_moderate_03: var(--ids_motion_time_moderate_03) !default;\n$ids_motion_time_slow_01: var(--ids_motion_time_slow_01) !default;\n$ids_motion_time_slow_02: var(--ids_motion_time_slow_02) !default;\n$ids_motion_time_slow_03: var(--ids_motion_time_slow_03) !default;\n$ids_motion_time_superslow_01: var(--ids_motion_time_superslow_01) !default;\n$ids_motion_time_superslow_02: var(--ids_motion_time_superslow_02) !default;\n$ids_motion_time_superslow_03: var(--ids_motion_time_superslow_03) !default;\n$ids_motion_delay_fast_01: var(--ids_motion_delay_fast_01) !default;\n$ids_motion_delay_fast_02: var(--ids_motion_delay_fast_02) !default;\n$ids_motion_delay_moderate_01: var(--ids_motion_delay_moderate_01) !default;\n$ids_motion_delay_moderate_02: var(--ids_motion_delay_moderate_02) !default;\n$ids_motion_delay_moderate_03: var(--ids_motion_delay_moderate_03) !default;\n$ids_motion_delay_moderate_04: var(--ids_motion_delay_moderate_04) !default;\n$ids_motion_delay_slow_01: var(--ids_motion_delay_slow_01) !default;\n$ids_motion_easing_effective_linear: var(--ids_motion_easing_effective_linear) !default;\n$ids_motion_easing_effective_standard: var(--ids_motion_easing_effective_standard) !default;\n$ids_motion_easing_effective_01: var(--ids_motion_easing_effective_01) !default;\n$ids_motion_easing_effective_02: var(--ids_motion_easing_effective_02) !default;\n$ids_motion_easing_effective_accelerate_standard: var(--ids_motion_easing_effective_accelerate_standard) !default;\n$ids_motion_easing_effective_accelerate_01: var(--ids_motion_easing_effective_accelerate_01) !default;\n$ids_motion_easing_effective_accelerate_02: var(--ids_motion_easing_effective_accelerate_02) !default;\n$ids_motion_easing_effective_decelerate_standard: var(--ids_motion_easing_effective_decelerate_standard) !default;\n$ids_motion_easing_effective_decelerate_01: var(--ids_motion_easing_effective_decelerate_01) !default;\n$ids_motion_easing_effective_decelerate_02: var(--ids_motion_easing_effective_decelerate_02) !default;\n$ids_motion_easing_vivid_standard: var(--ids_motion_easing_vivid_standard) !default;\n$ids_motion_easing_vivid_01: var(--ids_motion_easing_vivid_01) !default;\n$ids_motion_easing_vivid_accelerate_on: var(--ids_motion_easing_vivid_accelerate_on) !default;\n$ids_motion_easing_vivid_accelerate_back: var(--ids_motion_easing_vivid_accelerate_back) !default;\n$ids_motion_easing_vivid_decelerate_on: var(--ids_motion_easing_vivid_decelerate_on) !default;\n$ids_motion_easing_vivid_decelerate_back: var(--ids_motion_easing_vivid_decelerate_back) !default;\n$ids_motion_opacity_0: var(--ids_motion_opacity_0) !default;\n$ids_motion_opacity_100: var(--ids_motion_opacity_100) !default;\n$ids_motion_scale_0: var(--ids_motion_scale_0) !default;\n$ids_motion_scale_100: var(--ids_motion_scale_100) !default;\n$ids_motion_repeat_none: var(--ids_motion_repeat_none) !default;\n$ids_motion_repeat_1x: var(--ids_motion_repeat_1x) !default;\n$ids_motion_repeat_2x: var(--ids_motion_repeat_2x) !default;\n$ids_motion_repeat_3x: var(--ids_motion_repeat_3x) !default;\n$ids_motion_repeat_loop: var(--ids_motion_repeat_loop) !default;\n$ids_opacity_empty: var(--ids_opacity_empty) !default;\n$ids_opacity_soft: var(--ids_opacity_soft) !default;\n$ids_opacity_medium: var(--ids_opacity_medium) !default;\n$ids_opacity_strong: var(--ids_opacity_strong) !default;\n$ids_opacity_none: var(--ids_opacity_none) !default;\n$ids_size_cornerRadius_button: var(--ids_size_cornerRadius_button) !default;\n$ids_size_cornerRadius_smallButton: var(--ids_size_cornerRadius_smallButton) !default;\n$ids_size_cornerRadius_tags_01: var(--ids_size_cornerRadius_tags_01) !default;\n$ids_size_cornerRadius_tags_02: var(--ids_size_cornerRadius_tags_02) !default;\n$ids_size_cornerRadius_fab: var(--ids_size_cornerRadius_fab) !default;\n$ids_size_cornerRadius_tooltip: var(--ids_size_cornerRadius_tooltip) !default;\n$ids_size_cornerRadius_card_01: var(--ids_size_cornerRadius_card_01) !default;\n$ids_size_cornerRadius_card_02: var(--ids_size_cornerRadius_card_02) !default;\n$ids_size_cornerRadius_layout_01: var(--ids_size_cornerRadius_layout_01) !default;\n$ids_size_cornerRadius_layout_02: var(--ids_size_cornerRadius_layout_02) !default;\n$ids_size_cornerRadius_passwordCode: var(--ids_size_cornerRadius_passwordCode) !default;\n$ids_size_cornerRadius_snackbar: var(--ids_size_cornerRadius_snackbar) !default;\n$ids_size_cornerRadius_table: var(--ids_size_cornerRadius_table) !default;\n$ids_size_border_small: var(--ids_size_border_small) !default;\n$ids_size_border_medium: var(--ids_size_border_medium) !default;\n$ids_size_border_large: var(--ids_size_border_large) !default;\n$ids_size_padding_passwordCode_topDown: var(--ids_size_padding_passwordCode_topDown) !default;\n$ids_size_padding_passwordCode_leftRight: var(--ids_size_padding_passwordCode_leftRight) !default;\n$ids_size_general_1x: var(--ids_size_general_1x) !default;\n$ids_size_general_2x: var(--ids_size_general_2x) !default;\n$ids_size_general_3x: var(--ids_size_general_3x) !default;\n$ids_size_general_4x: var(--ids_size_general_4x) !default;\n$ids_size_general_5x: var(--ids_size_general_5x) !default;\n$ids_size_general_6x: var(--ids_size_general_6x) !default;\n$ids_size_general_7x: var(--ids_size_general_7x) !default;\n$ids_size_general_8x: var(--ids_size_general_8x) !default;\n$ids_size_general_10x: var(--ids_size_general_10x) !default;\n$ids_size_general_12x: var(--ids_size_general_12x) !default;\n$ids_size_general_14x: var(--ids_size_general_14x) !default;\n$ids_size_general_16x: var(--ids_size_general_16x) !default;\n$ids_size_general_18x: var(--ids_size_general_18x) !default;\n$ids_size_general_20x: var(--ids_size_general_20x) !default;\n$ids_size_general_22x: var(--ids_size_general_22x) !default;\n$ids_size_general_24x: var(--ids_size_general_24x) !default;\n$ids_size_general_28x: var(--ids_size_general_28x) !default;\n$ids_size_general_30x: var(--ids_size_general_30x) !default;\n$ids_size_general_32x: var(--ids_size_general_32x) !default;\n$ids_size_general_36x: var(--ids_size_general_36x) !default;\n$ids_size_general_40x: var(--ids_size_general_40x) !default;\n$ids_size_general_44x: var(--ids_size_general_44x) !default;\n$ids_size_general_48x: var(--ids_size_general_48x) !default;\n$ids_size_general_52x: var(--ids_size_general_52x) !default;\n$ids_size_general_56x: var(--ids_size_general_56x) !default;\n$ids_size_general_60x: var(--ids_size_general_60x) !default;\n$ids_size_general_64x: var(--ids_size_general_64x) !default;\n$ids_size_general_68x: var(--ids_size_general_68x) !default;\n$ids_size_general_72x: var(--ids_size_general_72x) !default;\n$ids_size_general_76x: var(--ids_size_general_76x) !default;\n$ids_size_general_80x: var(--ids_size_general_80x) !default;\n$ids_size_general_84x: var(--ids_size_general_84x) !default;\n$ids_size_general_88x: var(--ids_size_general_88x) !default;\n$ids_size_general_92x: var(--ids_size_general_92x) !default;\n$ids_size_general_96x: var(--ids_size_general_96x) !default;\n$ids_size_general_100x: var(--ids_size_general_100x) !default;\n$ids_size_general_104x: var(--ids_size_general_104x) !default;\n$ids_size_general_108x: var(--ids_size_general_108x) !default;\n$ids_size_general_112x: var(--ids_size_general_112x) !default;\n$ids_size_general_116x: var(--ids_size_general_116x) !default;\n$ids_size_general_120x: var(--ids_size_general_120x) !default;\n$ids_size_general_124x: var(--ids_size_general_124x) !default;\n$ids_size_general_128x: var(--ids_size_general_128x) !default;\n$ids_size_general_132x: var(--ids_size_general_132x) !default;\n$ids_size_general_136x: var(--ids_size_general_136x) !default;\n$ids_size_general_140x: var(--ids_size_general_140x) !default;\n$ids_spacing_1x: var(--ids_spacing_1x) !default;\n$ids_spacing_2x: var(--ids_spacing_2x) !default;\n$ids_spacing_3x: var(--ids_spacing_3x) !default;\n$ids_spacing_4x: var(--ids_spacing_4x) !default;\n$ids_spacing_5x: var(--ids_spacing_5x) !default;\n$ids_spacing_6x: var(--ids_spacing_6x) !default;\n$ids_spacing_8x: var(--ids_spacing_8x) !default;\n$ids_spacing_10x: var(--ids_spacing_10x) !default;\n$ids_spacing_12x: var(--ids_spacing_12x) !default;\n$ids_spacing_14x: var(--ids_spacing_14x) !default;\n$ids_textStyle_f01_s16_h24_wbd: var(--ids_textStyle_f01_s16_h24_wbd) !default;\n$ids_textStyle_f01_s20_h28_wrg: var(--ids_textStyle_f01_s20_h28_wrg) !default;\n$ids_textStyle_f01_s24_h32_wbd: var(--ids_textStyle_f01_s24_h32_wbd) !default;\n$ids_textStyle_f01_s24_h32_wrg: var(--ids_textStyle_f01_s24_h32_wrg) !default;\n$ids_textStyle_f01_s32_h48_wbd: var(--ids_textStyle_f01_s32_h48_wbd) !default;\n$ids_textStyle_f01_s32_h48_wrg: var(--ids_textStyle_f01_s32_h48_wrg) !default;\n$ids_textStyle_f01_s40_h64_wbd: var(--ids_textStyle_f01_s40_h64_wbd) !default;\n$ids_textStyle_f01_s40_h64_wrg: var(--ids_textStyle_f01_s40_h64_wrg) !default;\n$ids_textStyle_f01_s48_h80_wbd: var(--ids_textStyle_f01_s48_h80_wbd) !default;\n$ids_textStyle_f01_s48_h80_wrg: var(--ids_textStyle_f01_s48_h80_wrg) !default;\n$ids_textStyle_f01_s64_h100_wbd: var(--ids_textStyle_f01_s64_h100_wbd) !default;\n$ids_textStyle_f01_s64_h100_wrg: var(--ids_textStyle_f01_s64_h100_wrg) !default;\n$ids_textStyle_f02_s12_h18_wbd: var(--ids_textStyle_f02_s12_h18_wbd) !default;\n$ids_textStyle_f02_s12_h18_wrg: var(--ids_textStyle_f02_s12_h18_wrg) !default;\n$ids_textStyle_f02_s14_h20_wbd: var(--ids_textStyle_f02_s14_h20_wbd) !default;\n$ids_textStyle_f02_s14_h20_wrg: var(--ids_textStyle_f02_s14_h20_wrg) !default;\n$ids_textStyle_f02_s16_h24_wbd: var(--ids_textStyle_f02_s16_h24_wbd) !default;\n$ids_textStyle_f02_s16_h24_wrg: var(--ids_textStyle_f02_s16_h24_wrg) !default;\n$ids_textStyle_f02_s18_h26_wbd: var(--ids_textStyle_f02_s18_h26_wbd) !default;\n$ids_textStyle_f02_s18_h26_wrg: var(--ids_textStyle_f02_s18_h26_wrg) !default;\n$ids_textStyle_f02_s20_h26_wbd: var(--ids_textStyle_f02_s20_h26_wbd) !default;\n$ids_textStyle_f02_s20_h26_wrg: var(--ids_textStyle_f02_s20_h26_wrg) !default;\n$ids_textStyle_f02_s24_h32_wbd: var(--ids_textStyle_f02_s24_h32_wbd) !default;\n$ids_textStyle_f02_s24_h32_wrg: var(--ids_textStyle_f02_s24_h32_wrg) !default;\n$ids_textStyle_f02_s32_h48_wrg: var(--ids_textStyle_f02_s32_h48_wrg) !default;\n$ids_textStyle_f02_s40_h64_wrg: var(--ids_textStyle_f02_s40_h64_wrg) !default;\n$ids_textStyle_f02_s48_h80_wrg: var(--ids_textStyle_f02_s48_h80_wrg) !default;\n$ids_textStyle_title_01_base: var(--ids_textStyle_title_01_base) !default;\n$ids_textStyle_title_01_variant: var(--ids_textStyle_title_01_variant) !default;\n$ids_textStyle_section_01: var(--ids_textStyle_section_01) !default;\n$ids_textStyle_section_02: var(--ids_textStyle_section_02) !default;\n$ids_textStyle_overline: var(--ids_textStyle_overline) !default;\n$ids_textStyle_subtitle_01: var(--ids_textStyle_subtitle_01) !default;\n$ids_textStyle_insight_regular: var(--ids_textStyle_insight_regular) !default;\n$ids_textStyle_insight_bold: var(--ids_textStyle_insight_bold) !default;\n$ids_textStyle_body_01_regular: var(--ids_textStyle_body_01_regular) !default;\n$ids_textStyle_body_01_bold: var(--ids_textStyle_body_01_bold) !default;\n$ids_textStyle_body_02_regular: var(--ids_textStyle_body_02_regular) !default;\n$ids_textStyle_body_02_bold: var(--ids_textStyle_body_02_bold) !default;\n$ids_textStyle_body_link_01_regular: var(--ids_textStyle_body_link_01_regular) !default;\n$ids_textStyle_body_link_01_bold: var(--ids_textStyle_body_link_01_bold) !default;\n$ids_textStyle_body_link_01_xbold: var(--ids_textStyle_body_link_01_xbold) !default;\n$ids_textStyle_body_link_02_regular: var(--ids_textStyle_body_link_02_regular) !default;\n$ids_textStyle_body_link_02_bold: var(--ids_textStyle_body_link_02_bold) !default;\n$ids_textStyle_body_link_02_xbold: var(--ids_textStyle_body_link_02_xbold) !default;\n$ids_textStyle_caption_regular: var(--ids_textStyle_caption_regular) !default;\n$ids_textStyle_caption_bold: var(--ids_textStyle_caption_bold) !default;\n$ids_textStyle_caption_link_regular: var(--ids_textStyle_caption_link_regular) !default;\n$ids_textStyle_caption_link_bold: var(--ids_textStyle_caption_link_bold) !default;\n$ids_textStyle_caption_link_xbold: var(--ids_textStyle_caption_link_xbold) !default;\n$ids_textStyle_label_xsmall_regular: var(--ids_textStyle_label_xsmall_regular) !default;\n$ids_textStyle_label_xsmall_bold: var(--ids_textStyle_label_xsmall_bold) !default;\n$ids_textStyle_label_small_regular: var(--ids_textStyle_label_small_regular) !default;\n$ids_textStyle_label_small_bold: var(--ids_textStyle_label_small_bold) !default;\n$ids_textStyle_label_medium_regular: var(--ids_textStyle_label_medium_regular) !default;\n$ids_textStyle_label_medium_bold: var(--ids_textStyle_label_medium_bold) !default;\n$ids_textStyle_label_large_regular: var(--ids_textStyle_label_large_regular) !default;\n$ids_textStyle_label_large_bold: var(--ids_textStyle_label_large_bold) !default;\n$ids_textStyle_label_xlarge_regular: var(--ids_textStyle_label_xlarge_regular) !default;\n$ids_textStyle_label_xlarge_bold: var(--ids_textStyle_label_xlarge_bold) !default;\n$ids_textStyle_icon_small: var(--ids_textStyle_icon_small) !default;\n$ids_textStyle_icon_medium: var(--ids_textStyle_icon_medium) !default;\n$ids_textStyle_icon_large: var(--ids_textStyle_icon_large) !default;\n$ids_textStyle_icon_xLarge: var(--ids_textStyle_icon_xLarge) !default;\n","@use '@ids/tokens/tokens' as tokens;\n@use '../functions/tokens-handler' as *;\n@use './media-query' as *;\n@use 'sass:meta';\n@use 'sass:list';\n@use 'sass:map';\n\n$tokens-map: meta.module-variables(tokens);\n$displays: 'block', 'flex', 'grid', 'inline-block', 'inline-flex', 'inline-grid', 'none',\n  'table-cell', 'table-row', 'table';\n\n/// Gera classes de display\n/// @group module-internal\n/// @example scss\n///   .ids-d {\n///     @include create-display();\n///   }\n///   /* output:\n///   @media screen and (max-width: 99.99rem){.ids-d-xl-none{display:none !important}}\n///   @media screen and (max-width: 99.99rem){.ids-d-xl-inline{display:inline !important}}\n///   @media screen and (max-width: 99.99rem){.ids-d-xl-inline-block{display:inline-block !important}}\n///   ...\n///   }\n/// */\n@mixin create-display() {\n  $breakpoints: map-by-string($tokens-map, 'ids-layout-breakpoint');\n\n  @each $key, $breakpoint in map.keys($breakpoints) {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @each $display in $displays {\n      @if (list.index(map.keys($breakpoints), 'ids-layout-breakpoint-#{$breakpoint}') == 1) {\n        &-#{$display} {\n          /* stylelint-disable-next-line declaration-no-important */\n          display: #{$display} !important;\n        }\n      }\n\n      @else {\n        @include media-q(\n          $from: $breakpoint,\n          $media-type: 'screen'\n        ) {\n          &-#{$breakpoint}-#{$display} {\n            /* stylelint-disable-next-line declaration-no-important */\n            display: #{$display} !important;\n          }\n        }\n      }\n    }\n  }\n}","@use '@ids/tokens/tokens' as tokens;\n@use '../functions/tokens-handler' as *;\n@use './media-query' as *;\n@use 'sass:meta';\n@use 'sass:list';\n@use 'sass:map';\n\n$tokens-map: meta.module-variables(tokens);\n$properties: (\n  'flex': (\n    'direction': ('row', 'row-reverse', 'column', 'column-reverse'),\n    'wrap': ('nowrap', 'wrap', 'wrap-reverse'),\n    'grow': ('0', '1'),\n    'shrink': ('0', '1'),\n    'fill': '1 1 auto',\n  ),\n  'justify-content': (\n    'start': 'flex-start', 'end': 'flex-end', 'center': 'center',\n    'between': 'space-between', 'around': 'space-around',\n    'evenly': 'space-evenly',\n  ),\n  'align-items': (\n    'start': 'flex-start', 'end': 'flex-end', 'center': 'center',\n    'baseline': 'baseline', 'stretch': 'stretch',\n  ),\n  'align-self': (\n    'start': 'flex-start', 'end': 'flex-end', 'center': 'center',\n    'baseline': 'baseline', 'stretch': 'stretch',\n  ),\n  'align-content': (\n    'start': 'flex-start', 'end': 'flex-end', 'center': 'center',\n    'between': 'space-between', 'around': 'space-around',\n    'evenly': 'space-evenly', 'stretch': 'stretch',\n  ),\n);\n\n@mixin create-flex-helpers() {\n  $breakpoints: map-by-string($tokens-map, 'ids-layout-breakpoint');\n\n  @each $key, $breakpoint in map.keys($breakpoints) {\n    $breakpoint: string-key-split($key, '-', 4);\n\n    @each $property in map.keys($properties) {\n      @each $key, $value in map.get($properties, $property) {\n        @if type-of($value: $value) == 'list' {\n          @each $value in $value {\n            @if (list.index(map.keys($breakpoints), 'ids-layout-breakpoint-#{$breakpoint}') == 1) {\n              $class-name: '';\n\n              @if ($value == '0') or ($value == '1') {\n                $class-name: #{$property}-#{$key}-#{$value};\n              }\n\n              @else {\n                $class-name: #{$property}-#{$value};\n              }\n\n              &-#{$class-name} {\n                /* stylelint-disable-next-line declaration-no-important */\n                #{$property}-#{$key}: #{$value} !important;\n              }\n            }\n\n            @else {\n              $class-name: '';\n\n              @if ($value == '0') or ($value == '1') {\n                $class-name: #{$property}-#{$breakpoint}-#{$key}-#{$value};\n              }\n\n              @else {\n                $class-name: #{$property}-#{$breakpoint}-#{$value};\n              }\n\n              @include media-q(\n                $from: $breakpoint,\n                $media-type: 'screen'\n              ) {\n                &-#{$class-name} {\n                  /* stylelint-disable-next-line declaration-no-important */\n                  #{$property}-#{$key}: #{$value} !important;\n                }\n              }\n            }\n          }\n        }\n\n        @else {\n          @if (list.index(map.keys($breakpoints), 'ids-layout-breakpoint-#{$breakpoint}') == 1) {\n            &-#{$property}-#{$key} {\n              /* stylelint-disable-next-line declaration-no-important */\n              #{$property}: #{$value} !important;\n            }\n          }\n\n          @else {\n            @include media-q(\n              $from: $breakpoint,\n              $media-type: 'screen'\n            ) {\n              &-#{$property}-#{$breakpoint}-#{$key} {\n                /* stylelint-disable-next-line declaration-no-important */\n                #{$property}: #{$value} !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}","// # tokens - foundation\n$time_moderate_200ms: 200ms;\n$time_moderate_250ms: 250ms;\n$time_moderate_275ms: 275ms;\n$time_slow_300ms: 300ms;\n$time_slow_350ms: 350ms;\n$time_slow_375ms: 375ms;\n$time_slow_1s: 1000ms;\n$time_slow_2s: 2000ms;\n\n$ids_ease_in: cubic-bezier(0.42, 0, 1, 1);\n$ids_ease_out: cubic-bezier(0, 0, 0.58, 1);\n$ids_ease_inOut: cubic-bezier(0.42, 0, 0.58, 1);\n\n$ids_fade_0: 0;\n$ids_fade_100: 1;\n\n$ids_scale_small_none: 0;\n$ids_scale_large_100: 100%;\n\n// # tokens - varejo\n$ids_time_productive_moderate: $time_moderate_200ms;\n$ids_time_productive_moderate_input: $time_moderate_250ms;\n$ids_time_productive_moderate_output: $time_moderate_275ms;\n\n$ids_time_expressive_fast: $time_slow_300ms;\n$ids_time_expressive_fast_input: $time_slow_350ms;\n$ids_time_expressive_fast_output: $time_slow_375ms;\n\n\n// # animações\n\n// ## fade\n\n// ### fade in\n.ids-animation-fade-in-start {\n  opacity: $ids_fade_0;\n}\n\n.ids-animation-fade-in-moderate-end {\n  opacity: $ids_fade_100;\n  transition: opacity $ids_time_productive_moderate $ids_ease_inOut;\n}\n\n// ### fade out\n.ids-animation-fade-out-start {\n  opacity: $ids_fade_100;\n}\n\n.ids-animation-fade-out-moderate-output-end {\n  opacity: $ids_fade_0;\n  transition: opacity $ids_time_productive_moderate_output $ids_ease_inOut;\n}\n\n// ## scale\n.ids-animation-scale-x-down {\n  transform: scaleX(var(--ids-scale-x-down, $ids_scale_small_none));\n}\n\n.ids-animation-scale-x-up {\n  transform: scaleX(var(--ids-scale-x-up, $ids_scale_large_100));\n}\n\n.ids-animation-time-transform-slow {\n  transition: transform $time_slow_2s $ids_ease_out;\n}\n\n// ## width - prefira voxel-animation-scale-x se não houver bordas arredondadas\n.ids-animation-width-down {\n  width: var(--ids-width-down, $ids_scale_small_none);\n}\n\n.ids-animation-width-up {\n  width: var(--ids-width-up, $ids_scale_large_100);\n}\n\n.ids-animation-time-width-slow {\n  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n  transition: width $time_slow_2s $ids_ease_out;\n}\n\n.ids-motion-none,\n.ids-motion-none::before,\n.ids-motion-none::after,\n.ids-motion-none *,\n.ids-motion-none *::before,\n.ids-motion-none *::after {\n  /* stylelint-disable-next-line declaration-no-important */\n  animation: none !important;\n  /* stylelint-disable-next-line declaration-no-important */\n  transition: none !important;\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/media-query' as *;\n\n.ids-banner-highlight {\n  align-items: center;\n  background: $ids_color_bg_variant_01;\n  border: 0;\n  border-radius: $ids_size_cornerRadius_card_02;\n  color: $ids_color_text_body_01;\n  display: flex;\n  font: $ids_textStyle_f02_s12_h18_wrg;\n  min-height: $ids_size_general_68x;\n  padding: $ids_size_general_16x;\n  width: 100%;\n\n  @include tabbable-hover() {\n    background: $ids_color_bg_variant_02;\n  }\n\n  &__container {\n    display: grid;\n    flex: 1;\n    padding-left: $ids_size_general_16x;\n    padding-right: $ids_size_general_16x;\n    text-align: left;\n  }\n\n  &__title {\n    font: $ids_textStyle_f02_s14_h20_wbd;\n  }\n\n  &--on-variant {\n    background-color: $ids_color_bg_base;\n  }\n\n  &--on-brand {\n    background-color: $ids_color_action_neutral_contrast;\n  }\n\n  @include media-q($from: sm) {\n    font: $ids_textStyle_f02_s14_h20_wrg;\n\n    &__title {\n      font: $ids_textStyle_f02_s16_h24_wbd;\n    }\n  }\n}\n","/// Determina seção apenas para internet Explorer\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include ids-only-for-ie {\n///       background-color: blue\n///     }\n///   }\n///   //output: será exibido background-color: blue apenas no Internet Explorer\n@mixin ids-only-for-ie {\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    @content;\n  }\n}\n\n@mixin voxel-only-for-ie {\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    @content;\n  }\n}\n\n/// Determina seção de código apenas para desktop\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include ids-only-for-desktop {\n///       background-color: blue\n///     }\n///   }\n///   //output: será exibido background-color: blue apenas no desktop\n@mixin ids-only-for-desktop {\n  @media (hover: hover) and (pointer: fine) {\n    @content;\n  }\n}\n\n@mixin voxel-only-for-desktop {\n  @media (hover: hover) and (pointer: fine) {\n    @content;\n  }\n}\n\n/// Determina seção de código apenas para firefox\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include ids-only-for-firefox {\n///       background-color: blue\n///     }\n///   }\n///   //output: será exibido background-color: blue apenas no firefox\n@mixin ids-only-for-firefox {\n  // stylelint-disable-next-line\n  @media all and (min--moz-device-pixel-ratio: 0) {\n    @content;\n  }\n}\n\n@mixin voxel-only-for-firefox {\n  // stylelint-disable-next-line\n  @media all and (min--moz-device-pixel-ratio: 0) {\n    @content;\n  }\n}\n\n/// Determina seção de código apenas para safari\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include ids-only-for-safari {\n///       background-color: blue\n///     }\n///   }\n///   //output: será exibido background-color: blue apenas no safari\n@mixin ids-only-for-safari {\n  // stylelint-disable-next-line\n  @media not all and (min-resolution: .001dpcm) {\n    @content;\n  }\n}\n\n@mixin voxel-only-for-safari {\n  // stylelint-disable-next-line\n  @media not all and (min-resolution: .001dpcm) {\n    @content;\n  }\n}\n\n/// Determina seção de código apenas para iOS\n/// @group module-mixins\n/// @example scss\n///   div {\n///     @include ids-only-for-ios {\n///       background-color: blue\n///     }\n///   }\n///   //output: será exibido background-color: blue apenas no iOS\n@mixin ids-only-for-ios {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n\n@mixin voxel-only-for-ios {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n\n.ids-brand {\n  background-color: transparent;\n  border-radius: $ids_size_general_8x;\n  height: $ids_size_general_32x;\n  max-width: none;\n  width: $ids_size_general_32x;\n\n  &.-small {\n    height: $ids_size_general_24x;\n    width: $ids_size_general_24x;\n  }\n\n  &.-large {\n    height: $ids_size_general_48x;\n    width: $ids_size_general_48x;\n  }\n\n  &.-xlarge {\n    height: $ids_size_general_64x;\n    width: $ids_size_general_64x;\n  }\n\n  &.-horizontal {\n    width: $ids_size_general_96x;\n\n    &.-small {\n      width: $ids_size_general_72x;\n    }\n\n    &.-large {\n      width: rem(168);\n    }\n\n    &.-xlarge {\n      width: rem(192);\n    }\n  }\n\n  &.-rounded {\n    border-radius: 50%;\n    padding: $ids_size_general_2x;\n\n    &.-large,\n    &.-xlarge {\n      padding: $ids_size_general_4x;\n    }\n  }\n\n  &.-variant {\n    background-color: $ids_color_bg_variant_01;\n  }\n\n  &.-on-brand {\n    background-color: $ids_color_bg_base;\n  }\n\n}","@use '@ids/tokens/tokens' as *;\n@use '../mixins/attributes' as *;\n@use '../mixins/reset' as *;\n\n.ids-bottom-sheet-backdrop {\n  background-color: $ids_color_contrast_onLight_medium;\n}\n\n.ids-bottom-sheet {\n  // TODO: Pensar em uma forma de utilizar uma animação mais performática\n  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */\n  transition: height 250ms ease-out;\n  width: 100%;\n\n  &__content {\n    background-color: $ids_color_bg_base;\n    border-radius: $ids_size_general_16x $ids_size_general_16x 0 0;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &__toggle-indicator {\n    @include reset-button;\n\n    background-color: $ids_color_action_neutral_base;\n    border: none;\n    border-radius: $ids_size_general_16x;\n    cursor: pointer;\n    display: block;\n    // Necessário definir esse token (5x) para altura para que o foco seja corretamente\n    // exibido ao expandir o action sheet com o Talkback ativado\n    height: $ids_size_general_5x;\n    margin: $ids_size_general_8x auto $ids_size_general_12x;\n    outline-offset: $ids_size_general_3x;\n    width: $ids_size_general_44x;\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 $ids_size_general_8x $ids_size_general_12x $ids_size_general_24x;\n  }\n\n  &__presentation {\n    align-items: center;\n    display: flex;\n    flex: 1;\n    font: $ids_textStyle_f02_s16_h24_wrg;\n    justify-content: space-between;\n\n    > * {\n      font: $ids_textStyle_f02_s16_h24_wrg;\n    }\n  }\n\n  &__footer {\n    @include gap($ids_size_general_16x, true);\n\n    display: flex;\n    padding: $ids_size_general_24x;\n  }\n\n  &__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 $ids_size_general_24x;\n\n    &:last-child {\n      padding-bottom: $ids_size_general_24x;\n    }\n\n    // TODO: Verificar esse caso de uso e remover\n    // A rolagem fica por trás do footer e compromete a experiência\n    &--suspended-footer {\n      &::after {\n        content: '';\n        display: block;\n        height: $ids_size_general_96x;\n      }\n\n      + .ids-bottom-sheet__footer {\n        background-color: $ids_color_bg_base;\n        bottom: 0;\n        outline: $ids_size_border_small solid $ids_color_action_disabled_base;\n        position: fixed;\n        width: 100%;\n      }\n    }\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/reset' as *;\n\n@mixin _hasSuffix {\n  // &:has(.ids-box-field__suffix:not(:empty)),\n  &--suffix {\n    @content;\n  }\n}\n\n.ids-box-field {\n  @include reset;\n\n  align-items: center;\n  background-color: $ids_color_bg_variant_01;\n  border: $ids_size_border_small solid $ids_color_border_medium;\n  border-radius: $ids_size_cornerRadius_button;\n  color: $ids_color_action_neutral_variant;\n  display: flex;\n  min-height: $ids_size_general_48x;\n  position: relative;\n\n  input:not(.ids-box-field__input),\n  &__input {\n    @include reset-input;\n\n    background-color: transparent;\n    border-radius: $ids_size_cornerRadius_button;\n    caret-color: $ids_color_action_primary_base;\n    color: inherit;\n    flex: 1;\n    font: $ids_textStyle_f02_s16_h24_wrg;\n    outline-offset: $ids_size_general_1x;\n    padding: $ids_size_general_10x $ids_size_general_16x;\n  }\n\n  &__prefix {\n    @include reset;\n\n    left: calc(#{$ids_size_general_16x} + #{$ids_size_border_small});\n    line-height: 1;\n    pointer-events: none;\n    position: absolute;\n\n    + input:not(.ids-box-field__input),\n    + .ids-box-field__input {\n      padding-left: $ids_size_general_48x;\n    }\n  }\n\n  &__suffix {\n    @include reset;\n\n    position: absolute;\n    right: calc(#{$ids_size_general_8x} + #{$ids_size_border_small});\n  }\n\n  &--on-brand {\n    background-color: $ids_color_action_neutral_base;\n    border-color: $ids_color_contrast_onDark_medium;\n    color: $ids_color_contrast_onDark;\n  }\n\n  @include _hasSuffix {\n    input:not(.ids-box-field__input),\n    .ids-box-field__input {\n      padding-right: rem(60);\n    }\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/reset' as *;\n\n@mixin _day {\n  align-items: center;\n  color: $ids_color_text_body_02;\n  font: $ids_textStyle_f02_s16_h24_wrg;\n  height: rem(40);\n  line-height: 1;\n  text-align: center;\n  vertical-align: middle;\n  width: rem(40);\n}\n\n@mixin _day-disabled {\n  color: $ids_color_action_disabled_variant;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.ids-calendar-day {\n  @include reset-button;\n  @include _day;\n\n  background: none;\n  border-color: transparent;\n  border-radius: rem(4);\n  border-style: solid;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    @include _day-disabled;\n  }\n\n  @include hover() {\n    background-color: $ids_color_bg_variant_02;\n    color: $ids_color_text_body_01;\n    font-weight: bold;\n  }\n\n  &--current {\n    background-color: $ids_color_bg_base;\n    border-color: $ids_color_border_medium;\n    border-radius: rem(500);\n    border-width: $ids_size_general_2x;\n    height: rem(40);\n    position: relative;\n\n    &:disabled,\n    &[aria-disabled='true'] {\n      @include _day-disabled;\n    }\n\n    @include hover() {\n      background-color: $ids_color_bg_variant_01;\n      border-color: $ids_color_border_strong;\n    }\n  }\n\n  &--selected {\n    background-color: $ids_color_action_neutral_base;\n    color: $ids_color_action_primary_contrast;\n\n    &:disabled,\n    &[aria-disabled='true'] {\n      @include _day-disabled;\n    }\n\n    @include hover() {\n      background-color: $ids_color_action_primary_variant;\n      color: $ids_color_contrast_onBrand_primary;\n    }\n  }\n}\n\n.ids-calendar {\n  @include reset-table;\n\n  border-collapse: separate;\n  border-spacing: 0;\n  opacity: 1;\n  width: 100%;\n\n  th,\n  td {\n    @include reset-table-cell;\n    @include _day;\n  }\n\n  th {\n    font: $ids_textStyle_f02_s16_h24_wbd;\n    text-decoration: none;\n  }\n\n  tr, td {\n    background-color: white;\n    vertical-align: top;\n  }\n\n  &:disabled,\n  &[aria-disabled='true'],\n  &--out-focus {\n    opacity: .2;\n  }\n\n  @media (min-width: 360px) {\n    border-spacing: 0 $ids_spacing_1x;\n    // o border spacint gera espaçamentos externos que são removidos com margem negativa\n    margin-bottom: rem(-4);\n    margin-top: rem(-4);\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n\n/// @warn deprecated\n.ids-card-base {\n  background: $ids_color_bg_base;\n  border: $ids_size_border_small solid $ids_color_border_soft;\n  border-radius: $ids_size_cornerRadius_card_01;\n\n  &:active,\n  &:hover {\n    background: $ids_color_action_neutral_base_soft;\n  }\n\n  &--selected {\n    border: $ids_size_border_medium solid $ids_color_action_primary_base;\n  }\n\n  &--primary {\n    background: $ids_color_action_primary_base;\n    border: $ids_size_border_small solid $ids_color_action_primary_variant;\n    color: $ids_color_action_primary_contrast;\n\n    &:active,\n    &:hover {\n      background: $ids_color_action_primary_variant;\n    }\n  }\n\n  &--secondary {\n    background: $ids_color_action_secondary_base;\n    border: $ids_size_border_small solid $ids_color_action_secondary_variant;\n\n    &:active,\n    &:hover {\n      background: $ids_color_action_secondary_variant;\n    }\n  }\n}\n","@use 'sass:selector' as *;\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/border' as *;\n\n.ids-card {\n  background: $ids_color_bg_base;\n  border: $ids_size_border_small solid $ids_color_border_soft;\n  border-radius: $ids_size_cornerRadius_card_01;\n\n  @include ids-generate-border($intensity: soft);\n\n  &.-no-border {\n    border: none;\n  }\n\n  @include tabbable-hover() {\n    background: $ids_color_action_neutral_base_soft;\n  }\n\n  &.-selected {\n    @include ids-generate-border($width: medium, $color: primary);\n  }\n\n  &.-variant {\n    background: $ids_color_bg_variant_01;\n  }\n\n  &.-primary {\n    background: $ids_color_action_primary_base;\n    color: $ids_color_action_primary_contrast;\n\n    @include ids-generate-border($color: primary, $intensity: strong);\n\n    @include tabbable-hover() {\n      background: $ids_color_action_primary_variant;\n    }\n  }\n\n  &.-secondary {\n    background: $ids_color_action_secondary_base;\n\n    @include ids-generate-border($color: secondary, $intensity: strong);\n\n    @include tabbable-hover() {\n      background: $ids_color_action_secondary_variant;\n    }\n  }\n}","@use '@ids/tokens/tokens' as *;\n\n/// Gera uma borda com as propriedades do .ids-divider\n/// @group module-mixins\n@mixin ids-generate-border(\n  $border: all,\n  $width: small,\n  $intensity: medium,\n  $color: neutral,\n  $override: false,\n) {\n  $border-color: $ids_color_border_medium;\n\n  @if $color == neutral {\n    @if $intensity == soft {\n      $border-color: $ids_color_border_soft;\n    }\n\n    @if $intensity == strong {\n      $border-color: $ids_color_border_strong;\n    }\n  }\n\n  @else if $color == primary {\n    $border-color: $ids_color_action_primary_base;\n\n    @if $intensity == strong {\n      $border-color: $ids_color_action_primary_variant;\n    }\n  }\n\n  @else if $color == secondary {\n    $border-color: $ids_color_action_secondary_base;\n\n    @if $intensity == strong {\n      $border-color: $ids_color_action_secondary_variant;\n    }\n  }\n\n  @else if $color == error {\n    $border-color: $ids_color_feedback_error;\n  }\n\n  @else if $color == success {\n    $border-color: $ids_color_feedback_success;\n  }\n\n  @else if $color == on-brand {\n    $border-color: $ids_color_contrast_onBrand_primary_medium;\n\n    @if $intensity == soft {\n      $border-color: $ids_color_contrast_onBrand_primary_soft;\n    }\n\n    @else if $intensity == strong {\n      $border-color: $ids_color_contrast_onBrand_primary_strong;\n    }\n  }\n\n  $border-width: map-get((\n    small: $ids_size_border_small,\n    medium: $ids_size_border_medium,\n    regular: $ids_size_border_medium,\n    large: $ids_size_border_large,\n    bold: $ids_size_border_large,\n  ), $width);\n\n  $border-attribute: map-get((\n    all: border,\n    top: border-top,\n    right: border-right,\n    bottom: border-bottom,\n    left: border-left,\n  ), $border);\n\n  @if $override {\n    @if $width != small {\n      #{$border-attribute}-width: $border-width;\n    }\n\n    @if $intensity != medium or $color != neutral {\n      #{$border-attribute}-color: $border-color;\n    }\n  }\n\n  @else {\n    #{$border-attribute}: $border-width solid $border-color;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/components/input-for-selectors' as *;\n@use '../mixins/reset' as *;\n\n.ids-checkbox {\n  align-items: center;\n  color: $ids_color_action_neutral_base;\n  display: inline-flex;\n  font-size: 0;\n  justify-content: center;\n  line-height: 0;\n  min-height: $ids_size_general_48x;\n  min-width: $ids_size_general_48x;\n  position: relative;\n\n  &__input {\n    @include reset-selector;\n    @include input-for-selectors;\n  }\n\n  &__icon::before {\n    content: 'checkbox_vazio';\n  }\n\n  &__input:indeterminate + .ids-checkbox__icon::before {\n    content: 'checkbox_indeterminado';\n  }\n\n  &--invalid .ids-checkbox__icon {\n    color: $ids_color_feedback_error;\n  }\n\n  &__input[aria-invalid='true'] {\n    + .ids-checkbox__icon {\n      color: $ids_color_feedback_error;\n    }\n  }\n\n  &__input:disabled + .ids-checkbox__icon {\n    color: $ids_color_action_disabled_variant;\n  }\n\n  &__input:checked + .ids-checkbox__icon::before {\n    content: 'checkbox';\n  }\n\n  &__input:not(:disabled):hover + .ids-checkbox__icon {\n    color: $ids_color_action_neutral_variant;\n  }\n\n  &__input:indeterminate:not(:disabled),\n  &__input:checked:not(:disabled) {\n    + .ids-checkbox__icon {\n      color: $ids_color_action_primary_base;\n    }\n\n    &:hover + .ids-checkbox__icon {\n      color: $ids_color_action_primary_variant;\n    }\n  }\n}\n","@mixin input-for-selectors {\n  appearance: none;\n  // remove fundo preto do input no iOS\n  background-color: transparent;\n  // remove bordas arredondadas no iOS\n  border-radius: 0;\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n}\n\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/media-query' as *;\n@use '../mixins/reset' as *;\n@use '../functions/unit-transform' as *;\n\n.ids-datepicker {\n  .ids-form-field {\n    overflow: initial;\n  }\n\n  &__controller {\n    @include reset;\n\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    padding: $ids_spacing_2x;\n\n    > *:first-child {\n      min-width: rem(122);\n    }\n\n    > *:last-child {\n      min-width: rem(84);\n    }\n\n    @media (min-width: 360px) {\n      padding: $ids_spacing_2x rem(24) $ids_spacing_2x $ids_spacing_4x;\n    }\n  }\n\n  &__body {\n    @include reset-div;\n\n    @media (min-width: 360px) {\n      padding: 0 $ids_spacing_4x $ids_spacing_4x;\n    }\n  }\n\n  @include media-q(md) {\n    margin-top: $ids_spacing_4x;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/reset' as *;\n@use '../mixins/border' as *;\n\n.ids-divider {\n  @include reset-hr;\n  @include ids-generate-border($border: bottom);\n\n  width: 100%;\n\n  &.-regular {\n    @include ids-generate-border($width: medium, $override: true);\n  }\n\n  &.-bold {\n    @include ids-generate-border($width: large, $override: true);\n\n  }\n\n  &.-soft {\n    @include ids-generate-border($intensity: soft, $override: true);\n  }\n\n  &.-strong {\n    @include ids-generate-border($intensity: strong, $override: true);\n  }\n\n  &.-primary {\n    @include ids-generate-border($color: primary, $override: true);\n\n    &.-strong {\n      @include ids-generate-border($color: primary, $intensity: strong, $override: true);\n    }\n  }\n\n  &.-error {\n    @include ids-generate-border($color: error, $override: true);\n  }\n\n  &.-on-brand {\n    @include ids-generate-border($color: on-brand, $override: true);\n\n    &.-soft {\n      @include ids-generate-border($color: on-brand, $intensity: soft, $override: true);\n    }\n\n    &.-strong {\n      @include ids-generate-border($color: on-brand, $intensity: strong, $override: true);\n    }\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n\n.ids-form-selection {\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  gap: $ids_size_general_8x;\n  position: relative;\n\n  .ids-checkbox,\n  .ids-radio-button,\n  .ids-switch {\n    position: static;\n\n    &__input {\n      left: - rem(3);\n      outline-offset: 0;\n      width: calc(100% + $ids_size_general_6x);\n    }\n  }\n\n  &__label {\n    // atributo inserido por conta da variação --rtl inserida para o switch ficar com a label a\n    // esquerda, e o switch a direita, quando tinha \"?\" ou \"!\" na label, mudava a direção do texto\n    // para saber mais: https://www.w3.org/International/articles/inline-bidi-markup/\n    direction: ltr;\n    // evita do foco visível do TalkBack colar no texto\n    padding-right: $ids_size_general_3x;\n  }\n\n  &__input {\n    line-height: 1;\n  }\n\n  &--disabled {\n    color: $ids_color_action_disabled_variant;\n    cursor: not-allowed;\n  }\n\n  &--invalid {\n    font-weight: bold;\n  }\n\n  &--on-brand {\n    color: $ids_color_contrast_onBrand_primary;\n  }\n\n  &--rtl {\n    direction: rtl;\n    justify-content: flex-end;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n\n.ids-icon {\n  align-items: center;\n  color: inherit;\n  display: inline-flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  font: $ids_textStyle_icon_medium;\n  font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n  font-style: normal;\n  font-variant-ligatures: discretionary-ligatures;\n  justify-content: center;\n  letter-spacing: 0;\n  min-height: $ids_size_general_24x;\n  min-width: $ids_size_general_24x;\n  text-rendering: optimizelegibility;\n  text-transform: initial;\n\n  &--primary {\n    color: $ids_color_action_primary_base;\n  }\n\n  &--secondary {\n    color: $ids_color_action_secondary_base;\n  }\n\n  &--neutral {\n    color: $ids_color_action_neutral_base;\n  }\n\n  &--success {\n    color: $ids_color_feedback_success;\n  }\n\n  &--alert {\n    color: $ids_color_feedback_alert;\n  }\n\n  &--information {\n    color: $ids_color_feedback_information;\n  }\n\n  &--error {\n    color: $ids_color_feedback_error;\n  }\n\n  &--on-brand {\n    color: $ids_color_contrast_onBrand_primary;\n  }\n\n  &--small {\n    font: $ids_textStyle_icon_small;\n    min-height: $ids_size_general_16x;\n    min-width: $ids_size_general_16x;\n  }\n\n  &--large {\n    font: $ids_textStyle_icon_large;\n    min-height: $ids_size_general_32x;\n    min-width: $ids_size_general_32x;\n  }\n\n  &--xlarge {\n    font: $ids_textStyle_icon_xLarge;\n    min-height: $ids_size_general_48x;\n    min-width: $ids_size_general_48x;\n  }\n}\n","@use '../mixins/attributes' as *;\n\n.ids-image {\n  height: auto;\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: cover;\n  object-position: center;\n  width: 100%;\n\n  &.one-by-one,\n  &.-square {\n    @include aspect-ratio(1, 1);\n  }\n\n  &.-two-by-three,\n  &.-portrait {\n    @include aspect-ratio(2, 3);\n  }\n\n  &.-three-by-two,\n  &.-landscape {\n    @include aspect-ratio(3, 2);\n  }\n\n  &.-sixteen-by-nine,\n  &.-widescreen {\n    @include aspect-ratio(16, 9);\n  }\n\n  &.-three-by-one,\n  &.-panoramic {\n    @include aspect-ratio(3, 1);\n  }\n}\n","@use 'sass:selector' as *;\n@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/reset' as *;\n\n.ids-input {\n  @include reset-input;\n\n  --ids-input-border-color: #{$ids_color_border_medium};\n\n  border-bottom: $ids_size_border_small solid var(--ids-input-border-color);\n  border-radius: $ids_size_cornerRadius_tooltip $ids_size_cornerRadius_tooltip 0 0;\n  caret-color: $ids_color_action_primary_base;\n  color: $ids_color_action_neutral_variant;\n  font: $ids_textStyle_f02_s20_h26_wrg;\n  min-height: rem(35);\n  outline-offset: $ids_size_general_3x;\n  padding-bottom: $ids_spacing_2x;\n  text-align: start;\n  transition: border-color 250ms;\n\n  option {\n    color: $ids_color_action_neutral_variant;\n    font: $ids_textStyle_f02_s16_h24_wrg;\n\n    &:checked {\n      font: $ids_textStyle_f02_s16_h24_wbd;\n    }\n\n    &:disabled {\n      color: $ids_color_action_disabled_variant;\n    }\n  }\n\n  @include where(textarea) {\n    min-height: $ids_size_general_52x;\n    resize: vertical;\n  }\n\n  @include where(select) {\n    appearance: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  // &:read-only:where(input, textarea),\n  @at-root #{unify(unify(&, input), ':read-only'), unify(unify(&, textarea), ':read-only')},\n  &:disabled {\n    background-color: $ids_color_action_disabled_base;\n    color: $ids_color_action_disabled_variant;\n    resize: none;\n  }\n\n  // &:not(:read-only:where(input, textarea), :disabled):focus,\n  @at-root #{\n  unify(unify(&, select), ':not(:disabled):focus'),\n  unify(unify(&, div), ':not(:disabled):focus')\n  },\n  &:not(:disabled):not(:read-only):focus,\n  &.-focus {\n    --ids-input-border-color: #{$ids_color_action_primary_base};\n\n    border-bottom: 0;\n\n    // TODO: remover quando quando sair do CSS global de 360\n    border-left: 0;\n    // TODO: remover quando quando sair do CSS global de 360\n    border-right: 0;\n    // TODO: remover quando quando sair do CSS global de 360\n    border-top: 0;\n\n    // foi necessário tirar o border-bottom e duplicar o box-shadow pq no Safari com zoom 4x duplicava a borda\n    box-shadow: inset 0 calc(#{$ids_size_border_small} * -2) var(--ids-input-border-color);\n  }\n\n  &.-small,\n  &--small {\n    font: $ids_textStyle_f02_s16_h24_wrg;\n    padding-bottom: calc($ids_spacing_1x + $ids_size_border_small);\n    padding-top: $ids_spacing_1x;\n  }\n\n  &.-large,\n  &--large {\n    font: $ids_textStyle_label_xlarge_bold;\n  }\n\n  &.-center,\n  &--center {\n    text-align: center;\n  }\n\n  @media (pointer: coarse) {\n    overflow: hidden;\n    resize: none;\n  }\n}\n\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/reset' as *;\n\n.ids-link {\n  @include reset-link;\n\n  color: $ids_color_text_link_base;\n  font: $ids_textStyle_f02_s16_h24_wrg;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n\n  &:hover,\n  &:focus {\n    color: $ids_color_text_link_variant;\n  }\n\n  &.-xsmall {\n    font: $ids_textStyle_f02_s12_h18_wrg;\n  }\n\n  &.-small {\n    font: $ids_textStyle_f02_s14_h20_wrg;\n  }\n\n  &.-bold {\n    font-weight: 700;\n  }\n\n  // negociar com design, pois usamos na doc e provavelmente os usuários usam também\n  // esse link é útil para navegações internas de rolagem de página\n  &.-internal {\n    color: inherit;\n  }\n\n  &.-on-brand {\n    color: $ids_color_contrast_onBrand_primary;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n\n.ids-listbox {\n  background-color: $ids_color_bg_base;\n  border-radius: 0 0 $ids_size_cornerRadius_tags_01 $ids_size_cornerRadius_tags_01;\n  // TODO: pedir pelo token, talvez padronizar para 0.24 o alfa\n  box-shadow:\n    0 0 $ids_size_general_2x 0 rgb(86 80 76 / 16%),\n    0 $ids_size_general_2x $ids_size_general_8x 0 rgb(86 80 76 / 16%);\n  overflow-y: auto;\n  width: 100%;\n\n  &--top {\n    border-radius: $ids_size_cornerRadius_tags_01 $ids_size_cornerRadius_tags_01 0 0;\n    box-shadow:\n      0 0 $ids_size_general_2x 0 rgb(86 80 76 / 16%),\n      0 rem(-2) $ids_size_general_8x 0 rgb(86 80 76 / 16%);\n  }\n}\n\n.ids-listbox-wrapper {\n  box-sizing: content-box;\n  margin: 0 rem(-8);\n  overflow: hidden;\n  padding: 0 $ids_size_general_8x;\n\n  .ids-listbox {\n    margin-bottom: $ids_size_general_8x;\n\n    &--top {\n      margin-bottom: 0;\n      margin-top: $ids_size_general_8x;\n    }\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/media-query' as *;\n@use '../mixins/support' as *;\n@use '../mixins/reset' as *;\n@use '../mixins/selectors' as *;\n@use '../mixins/attributes' as *;\n@use '../mixins/border' as *;\n\n$min-width: 272px;\n$max-height-small: 96vh;\n$max-height: 92vh;\n\n.ids-modal-wrapper {\n  display: flex;\n  isolation: isolate;\n  max-height: $max-height-small;\n  min-width: $min-width;\n\n  &__container {\n    padding: 0 $ids_spacing_2x;\n    // evita que o modal ultrapasse a largura da tela\n    width: 100%;\n  }\n\n  @media (min-width: 360px) {\n    max-height: $max-height;\n\n    &__container {\n      padding: 0 $ids_spacing_6x;\n    }\n  }\n}\n\n.ids-modal {\n  @include reset;\n\n  background-color: $ids_color_bg_base;\n  border-radius: $ids_size_general_8x;\n  color: $ids_color_text_body_01;\n  container-name: idsmodal;\n  container-type: inline-size;\n  display: flex;\n  flex-direction: column;\n  font: $ids_textStyle_f02_s16_h24_wrg;\n  max-height: 100%;\n  max-width: 100%;\n  min-width: $min-width;\n  overflow: hidden;\n\n  &--shadow {\n    box-shadow: 0 $ids_size_general_4x $ids_size_general_8x 0 rgb(0 0 0 / 8%);\n  }\n\n  &__body {\n    @include reset;\n\n    outline-offset: rem(-1);\n    overflow-y: auto;\n  }\n}\n\n.ids-modal-header {\n  @include reset;\n  @include gap($ids_spacing_2x, true);\n\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: $ids_spacing_2x;\n  padding-left: $ids_spacing_3x;\n\n  &__title {\n    @include reset-text;\n\n    font: $ids_textStyle_f01_s20_h28_wrg;\n  }\n\n  &__description {\n    font: $ids_textStyle_f02_s14_h20_wrg;\n    margin-top: $ids_spacing_1x;\n  }\n}\n\n.ids-modal-footer {\n  @include reset;\n  @include ids-generate-border($border: top, $width: medium, $intensity: soft);\n  @include gap($ids_spacing_3x, true);\n\n  background-color: $ids_color_bg_base;\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: flex-end;\n  padding: $ids_spacing_4x;\n  position: relative;\n\n  &--inline {\n    flex-direction: row;\n\n    // força o seletor a ficar mais forte que do angular classe + atributo\n    /* stylelint-disable-next-line selector-no-qualifying-type */\n    > a.ids-main-button,\n    > button.ids-main-button,\n    > * {\n      flex: 1;\n    }\n  }\n\n  // TODO: ver como mudar para rem(552)\n  @container idsmodal (inline-size > 34.5rem) {\n    flex-direction: row;\n  }\n\n  @supports not (container-name: idsmodal) {\n    @media (min-width: rem(600)) {\n      flex-direction: row;\n    }\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n\n.ids-overlay {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1001;\n}\n\n.ids-backdrop {\n  background-color: $ids_color_action_neutral_variant_medium;\n  display: flex;\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n\n  &.-no-bg {\n    background-color: transparent;\n    pointer-events: none;\n\n    // TODO: ver de transferir isso para o modal\n    + * {\n      .ids-modal-wrapper {\n        max-height: initial;\n\n        &__container {\n          padding: 0;\n        }\n      }\n    }\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/attributes' as *;\n\n.ids-input-password {\n  background-color: transparent;\n  border: none;\n  caret-color: transparent;\n  height: $ids_size_general_48x;\n  opacity: 0.01;\n  padding: $ids_size_general_20x $ids_size_general_28x;\n  position: absolute;\n  text-decoration: none;\n  top: 0;\n  width: 100%;\n\n  &::selection {\n    background-color: transparent;\n    color: inherit;\n  }\n}\n\n.ids-password {\n  display: inline-block;\n  vertical-align: middle;\n\n  &.ids-password--visible-focus {\n    @include outline();\n  }\n\n  &__form-message {\n    color: $ids_color_action_neutral_base;\n    padding-bottom: $ids_spacing_1x;\n  }\n\n  &__label {\n    font: $ids_textStyle_f02_s14_h20_wrg;\n  }\n\n  &__container {\n    @include gap($ids_spacing_2x, true);\n\n    display: flex;\n    position: relative;\n    width: fit-content;\n  }\n\n  &__fake-input {\n    align-items: center;\n    background-color: transparent;\n    border: $ids_size_border_small solid $ids_color_border_medium;\n    border-radius: $ids_size_cornerRadius_passwordCode;\n    color: $ids_color_action_neutral_base;\n    display: flex;\n    font: $ids_textStyle_f02_s24_h32_wrg;\n    height: $ids_size_general_48x;\n    justify-content: center;\n    pointer-events: none;\n    width: $ids_size_general_32x;\n\n    &--value::before {\n      background-color: $ids_color_action_neutral_base;\n      border-radius: 50%;\n      content: '';\n      display: block;\n      height: $ids_size_general_12x;\n      width: $ids_size_general_12x;\n    }\n\n    &--error {\n      border-color: $ids_color_border_strong;\n      border-width: $ids_size_border_medium;\n    }\n\n    &--active {\n      border-color: transparent;\n      outline: $ids_size_border_medium solid $ids_color_action_primary_base;\n    }\n  }\n\n  &--disabled {\n    .ids-password__fake-input {\n      background-color: transparent;\n      border-color: $ids_color_border_soft;\n\n      &--active {\n        border-color: $ids_color_border_soft;\n        outline: none;\n      }\n    }\n\n    .ids-password__form-message {\n      color: $ids_color_action_disabled_variant;\n    }\n  }\n\n  &--on-brand {\n    .ids-password__fake-input {\n      border-color: rgba($color: $ids_opacity_strong, $alpha: 80%);\n      color: $ids_color_contrast_onBrand_primary;\n\n      &--value::before {\n        background-color: $ids_color_contrast_onBrand_primary;\n      }\n\n      &--active {\n        border-color: transparent;\n        outline-color: rgba($color: $ids_opacity_strong, $alpha: 80%);\n      }\n    }\n\n    .ids-password__form-message {\n      color: $ids_color_contrast_onBrand_primary;\n    }\n\n    &.ids-password--disabled {\n      .ids-password__fake-input {\n        border-color: $ids_color_contrast_onBrand_primary_medium;\n        color: $ids_color_contrast_onBrand_primary;\n\n        &--active {\n          outline-color: $ids_color_contrast_onBrand_primary_medium;\n        }\n      }\n\n      .ids-password__form-message {\n        color: $ids_color_contrast_onBrand_primary_medium;\n      }\n    }\n\n    &.ids-password--error {\n      .ids-password__fake-input {\n        border-color: $ids_color_contrast_onBrand_primary;\n\n        &--active {\n          border-color: $ids_color_contrast_onBrand_primary;\n          outline: none;\n        }\n      }\n    }\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../mixins/components/input-for-selectors' as *;\n@use '../mixins/reset' as *;\n\n.ids-radio-button {\n  align-items: center;\n  color: $ids_color_action_neutral_base;\n  display: inline-flex;\n  font-size: 0;\n  justify-content: center;\n  line-height: 0;\n  min-height: $ids_size_general_48x;\n  min-width: $ids_size_general_48x;\n  position: relative;\n\n  &__input {\n    @include reset-selector;\n    @include input-for-selectors;\n  }\n\n  &__icon::before {\n    content: 'radio_button_outline';\n  }\n\n  &--invalid .ids-radio-button__icon {\n    color: $ids_color_feedback_error;\n  }\n\n  &__input:disabled + .ids-radio-button__icon {\n    color: $ids_color_action_disabled_variant;\n    cursor: not-allowed;\n  }\n\n  &__input:checked + .ids-radio-button__icon::before {\n    content: 'radio_button_selected';\n  }\n\n  &__input[aria-invalid='true'] {\n    + .ids-radio-button__icon {\n      color: $ids_color_feedback_error;\n    }\n  }\n\n  &__input:not(:disabled):hover + .ids-radio-button__icon {\n    color: $ids_color_action_neutral_variant;\n  }\n\n  &__input:checked:not(:disabled) {\n    + .ids-radio-button__icon {\n      color: $ids_color_action_primary_base;\n    }\n\n    &:hover + .ids-radio-button__icon {\n      color: $ids_color_action_primary_variant;\n    }\n  }\n\n  &--invalid {\n    color: $ids_color_feedback_error;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../functions/unit-transform' as *;\n@use '../mixins/reset' as *;\n\n$slider-track-height: $ids_size_general_8x;\n$slider-track-radius: calc(#{$slider-track-height} / 2);\n\n$slider-thumb-width: $ids_size_general_28x;\n$slider-thumb-height: rem(34);\n$slider-thumb-translate-x:\n  translateX(calc(#{$slider-thumb-width} / -2))\n  translateX(var(--slider-percent));\n\n$slider-container-padding: calc(#{$slider-thumb-height} + #{$ids_spacing_1x});\n$slider-container-height: calc(#{$slider-container-padding} + #{$slider-track-height});\n\n$slider-range-height: $ids_size_general_24x;\n\n@mixin slider-thumb {\n  appearance: none;\n  background-color: $ids_color_action_primary_base;\n  border: 0;\n  cursor: pointer;\n  height: $slider-thumb-height;\n  margin-top: calc(#{$ids_spacing_1x} + #{$slider-track-height});\n  mask-image: url('data:image/svg+xml;utf8,<svg width=\"28\" height=\"34\" viewBox=\"0 0 28 34\" fill=\"black\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28 19.9825C28 27.7241 21.7136 34 13.959 34C6.20439 34 0 27.7241 0 19.9825C0 11 6.99999 7.98663 14 0C21 7.98663 28 11 28 19.9825Z\" /></svg>');\n  transform: $slider-thumb-translate-x;\n  transition: box-shadow 0.2s linear;\n  width: $slider-thumb-width;\n}\n\n@mixin slider-track {\n  border-radius: $slider-track-radius;\n  height: $slider-track-height;\n}\n\n.ids-slider {\n  @include reset-input;\n\n  --slider-color-primary: #{$ids_color_action_primary_base};\n\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  box-sizing: content-box;\n  color: transparent;\n  height: $slider-track-height;\n  outline-offset: $ids_size_general_3x;\n  padding-bottom: $slider-container-padding;\n  padding-top: calc(#{$slider-range-height} + #{$ids_spacing_2x});\n  width: 100%;\n\n  &::-moz-range-track {\n    @include slider-track;\n\n    background-color: $ids_color_border_soft;\n  }\n\n  &::-webkit-slider-runnable-track {\n    @include slider-track;\n\n    background:\n      radial-gradient(\n        circle at calc(var(--slider-percent) - #{$slider-track-radius}),\n        var(--slider-color-primary) calc($slider-track-radius - 0.5px),\n        transparent $slider-track-radius\n      ),\n      linear-gradient(\n        to right,\n        var(--slider-color-primary) 0%,\n        var(--slider-color-primary) calc(var(--slider-percent) - #{$slider-track-radius}),\n        $ids_color_border_soft calc(var(--slider-percent) - #{$slider-track-radius}),\n        $ids_color_border_soft 100%\n      );\n  }\n\n  &::-moz-range-progress {\n    @include slider-track;\n\n    background-color: var(--slider-color-primary);\n  }\n\n  &::-webkit-slider-thumb {\n    @include slider-thumb;\n  }\n\n  &::-moz-range-thumb {\n    @include slider-thumb;\n\n    transform:\n      translateY(calc(#{rem(13)} + #{$slider-track-height} + #{$ids_spacing_1x}))\n      $slider-thumb-translate-x;\n  }\n\n  &:active::-webkit-slider-thumb,\n  &:focus::-webkit-slider-thumb,\n  &:hover::-webkit-slider-thumb {\n    background-color: $ids_color_action_primary_variant;\n    outline: 0;\n  }\n\n  &:active::-moz-range-thumb,\n  &:focus::-moz-range-thumb,\n  &:hover::-moz-range-thumb {\n    background-color: $ids_color_action_primary_variant;\n  }\n\n  &:disabled {\n    --slider-color-primary: #{ids_color_action_disabled_variant};\n\n    pointer-events: none;\n\n    &::-moz-range-thumb {\n      box-shadow: none;\n    }\n\n    &::-webkit-slider-thumb {\n      box-shadow: none;\n    }\n\n    &:focus,\n    &:active,\n    &:hover {\n      color: transparent;\n    }\n\n    &.ids-slider--light {\n      opacity: 0.6;\n    }\n  }\n\n  + .ids-slider-range {\n    margin-top: calc(#{$slider-range-height} * -1);\n    transform: translateY(calc(-1 * #{$slider-container-height} - #{$ids_spacing_2x}));\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/components/input-for-selectors' as *;\n@use '../mixins/reset' as *;\n\n.ids-switch {\n  align-items: center;\n  color: $ids_color_text_body_01;\n  display: inline-flex;\n  font-size: 0;\n  justify-content: center;\n  line-height: 0;\n  min-height: $ids_size_general_48x;\n  min-width: $ids_size_general_48x;\n  position: relative;\n\n  &__input {\n    @include reset-selector;\n    @include input-for-selectors;\n\n    // para switch feito com botão (React)\n    border: 0;\n  }\n\n  &__icon {\n    background: transparent;\n    border: $ids_size_border_small solid $ids_color_action_neutral_base;\n    border-radius: $ids_size_general_14x;\n    display: flex;\n    flex-direction: column;\n    height: $ids_size_general_24x;\n    inset: 0;\n    justify-content: center;\n    pointer-events: none;\n    position: relative;\n    transition: transform 0.2s, background-color 0.2s;\n    width: $ids_size_general_40x;\n\n    &::before {\n      background: $ids_color_action_neutral_base;\n      border-radius: 50%;\n      content: '';\n      height: $ids_size_general_18x;\n      left: $ids_size_general_2x;\n      position: absolute;\n      transition: transform 0.2s, background-color 0.2s;\n      width: $ids_size_general_18x;\n    }\n  }\n\n  &--on-brand {\n    .ids-switch__icon {\n      background: transparent;\n      border-color: $ids_color_contrast_onBrand_primary;\n\n      &::before {\n        background: $ids_color_contrast_onBrand_primary;\n      }\n    }\n  }\n\n  &__input[aria-pressed='true'] + .ids-switch__icon,\n  &__input:checked + .ids-switch__icon {\n    background: $ids_color_action_primary_base;\n    border-color: $ids_color_action_primary_base;\n\n    &::before {\n      background: $ids_color_contrast_onBrand_primary;\n      transform: translateX($ids_size_general_16x);\n    }\n  }\n\n  &__input:disabled + .ids-switch__icon {\n    border-color: $ids_color_action_disabled_base;\n    cursor: not-allowed;\n\n    &::before {\n      background: $ids_color_action_disabled_base;\n    }\n  }\n\n  &__input[aria-pressed='true']:disabled + .ids-switch__icon,\n  &__input:checked:disabled + .ids-switch__icon {\n    background: $ids_color_action_disabled_base;\n    border-color: $ids_color_action_disabled_base;\n\n    &::before {\n      background-color: $ids_color_contrast_onBrand_primary;\n    }\n  }\n\n  &--on-brand .ids-switch__input:disabled + .ids-switch__icon {\n    background: transparent;\n    border-color: $ids_color_contrast_onBrand_primary_medium;\n\n    &::before {\n      background-color: $ids_color_contrast_onBrand_primary_medium;\n    }\n  }\n\n  &--on-brand .ids-switch__input[aria-pressed='true'] + .ids-switch__icon,\n  &--on-brand .ids-switch__input:checked + .ids-switch__icon {\n    background: $ids_color_contrast_onBrand_primary;\n    border-color: $ids_color_contrast_onBrand_primary;\n\n    &::before {\n      background-color: $ids_color_action_primary_base;\n    }\n  }\n\n  &--on-brand .ids-switch__input[aria-pressed='true']:disabled + .ids-switch__icon,\n  &--on-brand .ids-switch__input:checked:disabled + .ids-switch__icon {\n    background: $ids_color_contrast_onBrand_primary_medium;\n    border-color: $ids_color_contrast_onBrand_primary_soft;\n\n    &::before {\n      background: $ids_color_contrast_onBrand_primary_strong;\n    }\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n\n@mixin title-cell {\n  background-color: $ids_color_bg_variant_01;\n  color: $ids_color_text_heading_01;\n  font: $ids_textStyle_f02_s16_h24_wbd;\n\n  &:hover {\n    background-color: $ids_color_bg_variant_02;\n    color: $ids_color_text_heading_01;\n  }\n\n  &:active {\n    background-color: $ids_color_action_neutral_base;\n    color: $ids_color_action_primary_contrast;\n  }\n}\n\n@mixin common-cell-attrs {\n  box-sizing: border-box;\n  text-align: center;\n  vertical-align: middle;\n  width: $ids_size_general_72x;\n}\n\n@mixin td {\n  @include common-cell-attrs;\n\n  background-color: $ids_color_bg_base;\n}\n\n@mixin th {\n  @include common-cell-attrs;\n  @include title-cell;\n\n  &:first-child {\n    border-top-left-radius: $ids_size_cornerRadius_table\n  }\n\n  &:last-child {\n    border-top-right-radius: $ids_size_cornerRadius_table;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/components/tag' as *;\n\n.ids-tag {\n  background-color: $ids_color_feedback_neutral;\n  border: $ids_size_border_small solid $ids_color_feedback_neutral;\n  border-radius: $ids_size_cornerRadius_tags_01;\n  box-sizing: border-box;\n  color: $ids_color_feedback_neutral_contrast;\n  display: inline-block;\n  font: $ids_textStyle_f02_s12_h18_wrg;\n  height: $ids_size_general_22x;\n  padding: $ids_size_general_1x $ids_spacing_2x;\n  vertical-align: baseline;\n  white-space: nowrap;\n\n  &.-on-brand {\n    @include ids-tag--on-brand();\n  }\n\n  &.-error {\n    background-color: $ids_color_feedback_error;\n    border-color: $ids_color_feedback_error;\n    color: $ids_color_feedback_error_contrast;\n  }\n\n  &.-warning {\n    background-color: $ids_color_feedback_alert;\n    border-color: $ids_color_feedback_alert;\n    color: $ids_color_feedback_alert_contrast;\n  }\n\n  &.-success {\n    background-color: $ids_color_feedback_success;\n    border-color: $ids_color_feedback_success;\n    color: $ids_color_feedback_success_contrast;\n  }\n\n  &.-outline {\n    background-color: transparent;\n    border-color: currentcolor;\n    color: $ids_color_feedback_neutral;\n\n    &.-on-brand {\n      border-color: $ids_color_contrast_onBrand_primary;\n      color: $ids_color_contrast_onBrand_primary;\n    }\n\n    &.-error {\n      color: $ids_color_feedback_error;\n    }\n\n    &.-warning {\n      color: $ids_color_feedback_alert;\n    }\n\n    &.-success {\n      color: $ids_color_feedback_success;\n    }\n  }\n\n  @media (min-width: $ids_layout_breakpoint_md) {\n    font: $ids_textStyle_f02_s14_h20_wrg;\n    height: $ids_size_general_24x;\n  }\n}\n","@use '@ids/tokens/tokens' as *;\n\n@mixin ids-tag--on-brand {\n  background-color: $ids_color_bg_base;\n  border-color: $ids_color_bg_base;\n  color: $ids_color_feedback_neutral;\n}\n","@use '@ids/tokens/tokens' as *;\n@use '../mixins/media-query' as *;\n@use '../mixins/reset' as *;\n@use '../mixins/attributes' as *;\n\n.ids-tracker {\n  @include reset-list;\n  @include gap($gap: $ids_spacing_3x, $usePadding: true, $force: true);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @include media-q($from: sm) {\n    flex-direction: row;\n  }\n\n  &--vertical {\n    flex-direction: column;\n  }\n}\n","// Mixin para criar animações de escala\n@mixin create-scale-animation($name, $initialValue, $finalValue) {\n  @keyframes #{$name} {\n    0% {\n      transform: scale($initialValue);\n    }\n\n    100% {\n      transform: scale($finalValue);\n    }\n  }\n}\n\n// Mixin para criar animações de esmaecimento\n@mixin create-fade-animation($name, $initialValue, $finalValue) {\n  @keyframes #{$name} {\n    0% {\n      opacity: $initialValue;\n    }\n\n    100% {\n      opacity: $finalValue;\n    }\n  }\n}\n\n// Mixin para criar animações de movimento vertical\n@mixin create-vertical-movement-animation($name, $initialValue, $finalValue) {\n  @keyframes #{$name} {\n    0% {\n      transform: translateY($initialValue);\n    }\n\n    100% {\n      transform: translateY($finalValue);\n    }\n  }\n}\n\n// Mixin para criar animações de movimento horizontal\n@mixin create-horizontal-movement-animation($name, $initialValue, $finalValue) {\n  @keyframes #{$name} {\n    0% {\n      transform: translateX($initialValue);\n    }\n\n    100% {\n      transform: translateX($finalValue);\n    }\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../mixins/animations' as *;\n\n@mixin slow-01-decel-std {\n  animation-duration: $ids_motion_time_slow_01;\n  animation-timing-function: $ids_motion_easing_effective_decelerate_standard;\n}\n\n@mixin fast-03-accel-std {\n  animation-duration: $ids_motion_time_fast_03;\n  animation-timing-function: $ids_motion_easing_effective_accelerate_standard;\n}\n\n.ids-motion-pattern-fade {\n  $opacity_O: $ids_motion_opacity_0;\n  $opacity_1: $ids_motion_opacity_100 / 100;\n\n  @include create-fade-animation('fade-in', $opacity_O, $opacity_1);\n  @include create-fade-animation('fade-out', $opacity_1, $opacity_O);\n  @include create-vertical-movement-animation('up-initial', 100%, 0);\n  @include create-vertical-movement-animation('down-initial', -100%, 0);\n  @include create-vertical-movement-animation('initial-up', 0, -100%);\n  @include create-vertical-movement-animation('initial-down', 0, 100%);\n\n  &-in {\n    animation-duration: $ids_motion_time_fast_02;\n    animation-name: fade-in;\n    animation-timing-function: $ids_motion_easing_effective_decelerate_standard;\n  }\n\n  &-in-up {\n    @include slow-01-decel-std;\n\n    animation-name: fade-in, up-initial;\n  }\n\n  &-in-down {\n    @include slow-01-decel-std;\n\n    animation-name: fade-in, down-initial;\n  }\n\n  &-in-slow {\n    animation-duration: $ids_motion_time_moderate_02;\n    animation-name: fade-in;\n    animation-timing-function: $ids_motion_easing_effective_decelerate_standard;\n  }\n\n  &-out {\n    animation-duration: $ids_motion_time_fast_02;\n    animation-name: fade-out;\n    animation-timing-function: $ids_motion_easing_effective_accelerate_standard;\n  }\n\n  &-out-up {\n    @include fast-03-accel-std;\n\n    animation-name: fade-out, initial-up;\n  }\n\n  &-out-down {\n    @include fast-03-accel-std;\n\n    animation-name: fade-out, initial-down;\n  }\n\n  &-out-slow {\n    animation-duration: $ids_motion_time_moderate_02;\n    animation-name: fade-out;\n    animation-timing-function: $ids_motion_easing_effective_accelerate_standard;\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../mixins/animations' as *;\n\n.ids-motion-pattern-scale {\n  $scale_0: $ids_motion_scale_0;\n  $scale_1: $ids_motion_scale_100 / 100;\n\n  @include create-scale-animation('scale-up', $scale_0, $scale_1);\n  @include create-scale-animation('scale-down', $scale_1, $scale_0);\n\n  &-up {\n    animation-duration: $ids_motion_time_fast_03;\n    animation-name: scale-up;\n    animation-timing-function: $ids_motion_easing_effective_decelerate_standard;\n  }\n\n  &-up-bouncing {\n    animation-duration: $ids_motion_time_moderate_02;\n    animation-name: scale-up;\n    animation-timing-function: $ids_motion_easing_vivid_decelerate_back;\n  }\n\n  &-down {\n    animation-duration: $ids_motion_time_fast_03;\n    animation-name: scale-down;\n    animation-timing-function: $ids_motion_easing_effective_accelerate_standard;\n  }\n\n  &-down-bouncing {\n    animation-duration: $ids_motion_time_moderate_02;\n    animation-name: scale-down;\n    animation-timing-function: $ids_motion_easing_vivid_accelerate_back;\n  }\n}","@use '@ids/tokens/tokens' as *;\n@use '../mixins/animations' as *;\n\n.ids-motion-pattern-shake {\n  @include create-horizontal-movement-animation('move-right', 0, $ids_size_general_10x);\n  @include create-horizontal-movement-animation('move-left', $ids_size_general_10x, -11px);\n  @include create-horizontal-movement-animation('move-back', -11px, 0);\n\n  animation-delay:\n    0s,\n    $ids_motion_time_fast_03,\n    calc(#{$ids_motion_time_fast_03} + #{$ids_motion_time_fast_02});\n  animation-duration: $ids_motion_time_fast_03, $ids_motion_time_fast_02, $ids_motion_time_fast_02;\n  animation-name: move-right, move-left, move-back;\n  animation-timing-function: $ids_motion_easing_effective_standard;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
